import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Book, Trophy, Zap, X, Pencil, List, Lightbulb, Shuffle, Send, MessageSquare, Mic, Sparkles, Trash2, AlertCircle, Check, RotateCw, RotateCcw, Brush, Play, Volume2, Pause, Radio } from 'lucide-react';
import mammoth from 'mammoth';
import Confetti from 'react-confetti';
import { collection, addDoc, serverTimestamp, increment, doc, 
  getDoc, 
  updateDoc, 
  arrayUnion, 
  arrayRemove  } from 'firebase/firestore';

import { db } from '../../../firebase/firebase'
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { SpeechRecognition } from "@capacitor-community/speech-recognition";
import { 
  getStoredUserName,
} from './Azurechatbot';

import { SecureAPI } from '../config.js';
import { 
  AZURE_OPENAI_ENDPOINT, 
  AZURE_OPENAI_API_KEY as AZURE_DEPLOYMENT_NAME, 
  AZURE_OPENAI_DEPLOYMENT as AZURE_OPENAI_KEY
} from '../azureConfigHelper';

// You'll need to load PDF.js - add this before your component
const loadPDFJS = () => {
  if (typeof window !== 'undefined' && !window.pdfjsLib) {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    };
    document.head.appendChild(script);
  }
};
const validateFile = async (file) => {
  const maxSize = 10 * 1024 * 1024; // 10MB
  
  if (file.size > maxSize) {
    return { valid: false, error: 'File too large (max 10MB)' };
  }
  
  // Warn about legacy .doc format but allow it
  if (file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
    return { 
      valid: true, 
      warning: 'Legacy .doc format may not extract properly. For best results, save as .docx' 
    };
  }
  
  return { valid: true };
};
export default function StudyHub({ 
  autoStartContent,      // ✅ NEW: Receive content from chat
  onContentStarted       // ✅ NEW: Callback when content is loaded
}) {
  const [connectedModules, setConnectedModules] = useState([]);
const moduleRefs = useRef({});

  const [showDeletePopup, setShowDeletePopup] = useState(null); // null or fileType
const [deleteHoverFile, setDeleteHoverFile] = useState(null); // null or fileId
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [activeFlashcards, setActiveFlashcards] = useState(null);
const [timerEnabled, setTimerEnabled] = useState(false);
const [timeElapsed, setTimeElapsed] = useState(0);
const isRecognitionActiveRef = useRef(false);
const [bookmarkedQuestions, setBookmarkedQuestions] = useState([]);
const [showStatsModal, setShowStatsModal] = useState(null);
const [showQuizBuilder, setShowQuizBuilder] = useState(false);
const [quizPromptText, setQuizPromptText] = useState('');
const [isGeneratingQuiz, setIsGeneratingQuiz] = useState(false);
const [generatedQuiz, setGeneratedQuiz] = useState(null);
  const stats = { quizzesCompleted: 12, averageScore: 85, streak: 7 };
const [showAIHosts, setShowAIHosts] = useState(false);
const [isQuizzesLoading, setIsQuizzesLoading] = useState(false);
const [isFlashcardsLoading, setIsFlashcardsLoading] = useState(false);
const [showCreateMenu, setShowCreateMenu] = useState(false);
const [createPromptText, setCreatePromptText] = useState('');
const [isGenerating, setIsGenerating] = useState(false);
const [selectedDifficulty, setSelectedDifficulty] = useState(null); // Changed from 'medium' to null
const [showDifficultyDropdown, setShowDifficultyDropdown] = useState(false);
const difficultyButtonRef = useRef(null);
const dropdownRef = useRef(null);
const generateButtonRef = useRef(null);
const svgRef = useRef(null);
const [createType, setCreateType] = useState(null); // 'quiz' or 'flashcard'
const [animatePlus, setAnimatePlus] = useState(false);
const [svgKey, setSvgKey] = useState(0);
const difficultyBadgeRef = useRef(null); 
const [activeModalGradient, setActiveModalGradient] = useState(null);
const [sessionStart, setSessionStart] = useState(Date.now());
const [showConfetti, setShowConfetti] = useState(false);
const [shuffleMode, setShuffleMode] = useState(true);
const [uploadedFile, setUploadedFile] = useState(null);
const [showUploadOptions, setShowUploadOptions] = useState(false);
const fileInputRef = useRef(null);
const uploadButtonRef = useRef(null);
  const [userName, setUserName] = useState(null);

const [showShuffleModal, setShowShuffleModal] = useState(false);
const [shuffleEnabled, setShuffleEnabled] = useState(false);
const [pendingContent, setPendingContent] = useState(null);
const [pendingType, setPendingType] = useState(null);
// Chat state for Get Help
const [chatMessages, setChatMessages] = useState([]);
const [chatInput, setChatInput] = useState('');
const [isChatLoading, setIsChatLoading] = useState(false);
const chatEndRef = useRef(null);
const [showAIHelp, setShowAIHelp] = useState(false);
const [isAIListening, setIsAIListening] = useState(false);
const [isAIMinimized, setIsAIMinimized] = useState(false);
const [aiConversation, setAiConversation] = useState([]);
const [currentQuizQuestion, setCurrentQuizQuestion] = useState(null); // Track which question user needs help with
const [firestoreService, setFirestoreService] = useState(null);
const [isLoadingContent, setIsLoadingContent] = useState(true);
const [showCongratsModal, setShowCongratsModal] = useState(false);
const [congratsType, setCongratsType] = useState(null);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [itemToDelete, setItemToDelete] = useState(null);
// WITH:
const [aiHelpState, setAiHelpState] = useState('idle'); // 'idle', 'listening', 'speaking'
const [aiResponseText, setAiResponseText] = useState('');
const [refreshStats, setRefreshStats] = useState(0);  // ✅ ADD THIS
const [shufflePreference, setShufflePreference] = useState(() => {
  const saved = localStorage.getItem('studyhub_shuffle_preference');
  return saved === 'true';
});
const [hasCompletedStudyToolOnboarding, setHasCompletedStudyToolOnboarding] = useState(false);

// ============================================
// CHECK FIRESTORE ON MOUNT (if you want to prevent re-showing)
// ============================================

useEffect(() => {
  const checkStudyToolOnboarding = async () => {
    try {
      if (firestoreService?.isReady?.()) {
        const userData = await firestoreService.getUserData();
        const hasCompleted = userData?.settings?.hasCompletedStudyToolOnboarding;
        
        console.log('🔍 Study Tool Onboarding check:', { hasCompleted });
        
        if (!hasCompleted) {
          setShowOnboarding(true);
        } else {
          setShowOnboarding(false);
          setHasCompletedStudyToolOnboarding(true);
        }
      }
    } catch (error) {
      console.error('Error checking Study Tool onboarding status:', error);
      setShowOnboarding(true);
    }
  };

  checkStudyToolOnboarding();
}, [firestoreService]);

const [askedAboutShuffle, setAskedAboutShuffle] = useState(() => {
  const saved = localStorage.getItem('studyhub_dont_ask_shuffle');
  return saved === 'true';
});

const [showReshuffleOption, setShowReshuffleOption] = useState(false);

const [dontAskAgain, setDontAskAgain] = useState(() => {
  const saved = localStorage.getItem('studyhub_dont_ask_shuffle');
  return saved === 'true';
});
const [defaultShufflePreference, setDefaultShufflePreference] = useState(() => {
  const saved = localStorage.getItem('studyhub_shuffle_preference');
  return saved === 'true';
});
const safeStopRecognition = (recognitionRef) => {
  try {
    // ✅ CRITICAL: SET FLAG TO FALSE FIRST
    isRecognitionActiveRef.current = false;
    console.log('🛑 Recognition flag set to FALSE');
    
    if (!recognitionRef?.current) {
      console.log('No recognition to stop');
      return;
    }
    
    // Azure Speech SDK
    if (recognitionRef.current.stopContinuousRecognitionAsync) {
      recognitionRef.current.stopContinuousRecognitionAsync(
        () => console.log('✅ Azure recognition stopped'),
        (err) => console.log(`⚠️ Azure stop error: ${err}`)
      );
    } 
    // Web Speech API
    else if (recognitionRef.current.stop) {
      recognitionRef.current.stop();
      console.log('✅ Web Speech stopped');
    }
    
    // ✅ Wait before clearing ref
    setTimeout(() => {
      if (recognitionRef.current) {
        recognitionRef.current = null;
        console.log('✅ Recognition ref cleared');
      }
    }, 100);
    
  } catch (e) {
    console.log(`⚠️ Recognition stop error: ${e.message}`);
    isRecognitionActiveRef.current = false;
  }
};

const handleStudyToolOnboardingComplete = async () => {
  try {
    console.log('✅ Study Tool Onboarding completed');

    // ✅ Save to Firestore
    if (firestoreService?.isReady?.()) {
      try {
        await firestoreService.updateUserData({
          'settings.hasCompletedStudyToolOnboarding': true,
          'settings.studyToolOnboardingCompletedAt': new Date().toISOString()
        });

        console.log('✅ Study Tool onboarding saved to Firestore');
      } catch (error) {
        console.error('❌ Failed to save Study Tool onboarding to Firestore:', error);
        return;
      }
    }

    // ✅ Update local state
    setHasCompletedStudyToolOnboarding(true);
    setShowOnboarding(false);

  } catch (error) {
    console.error('❌ Study Tool onboarding error:', error);
    setShowOnboarding(false);
  }
};
const IntentionOption = React.memo(({ topic, idx, isCompleted, isSelected, onSelect }) => (
  <button
    onClick={() => onSelect(topic)}
    disabled={isCompleted}
    style={{
      padding: '16px 20px',
      borderRadius: '32px',
      background: isCompleted
        ? 'rgba(255, 255, 255, 0.05)'
        : isSelected
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(255, 255, 255, 0.08)',
      border: `1px solid ${isCompleted
        ? '#ffffff20'
        : isSelected
          ? '#ffffff80'
          : '#ffffff45'}`,
      color: isCompleted ? '#80899aff' : '#ffffff',
      fontSize: '14px',
      fontWeight: '500',
      cursor: isCompleted ? 'not-allowed' : 'pointer',
      transition: 'background 0.2s ease, border-color 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      textAlign: 'left',
      lineHeight: '1.4',
      opacity: isCompleted ? 0.6 : 1,
      position: 'relative',
    }}
    onMouseEnter={(e) => {
      if (!isCompleted) {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
      }
    }}
    onMouseLeave={(e) => {
      if (!isCompleted) {
        e.currentTarget.style.background = isSelected
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(255, 255, 255, 0.08)';
      }
    }}
  >
    <span style={{
      flex: 1,
      textDecoration: isCompleted ? 'line-through' : 'none',
      textDecorationColor: isCompleted ? '#4da9ffff' : 'transparent',
      textDecorationThickness: '2px',
      textUnderlineOffset: '4px'
    }}>
      {topic.label}
    </span>

    {isCompleted ? (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4da9ffff" strokeWidth="3">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    ) : isSelected ? (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    ) : null}
  </button>
), (prev, next) =>
  prev.isSelected === next.isSelected &&
  prev.isCompleted === next.isCompleted &&
  prev.topic.id === next.topic.id
);
const AudioPodcastModal = ({ 
  type,
  title,
  content,
  userName,
  onClose 
}) => {
  const audioQueueRef = useRef(new Map());  // Cache for preloaded audio
const isPreloadingRef = useRef(new Set()); // Track what's being preloaded
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [transcript, setTranscript] = useState([]);
  const [currentStatus, setCurrentStatus] = useState('');
  const [playbackSpeed, setPlaybackSpeed] = useState(1.0);
  const [isAudioLocked, setIsAudioLocked] = useState(false);
  const [suggestedTopics, setSuggestedTopics] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [error, setError] = useState(null);
  
  const shouldStopRef = useRef(false);
  const currentAudioRef = useRef(null);
  const playbackSpeedRef = useRef(playbackSpeed);
  const transcriptEndRef = useRef(null);
  const isPlayingChunkRef = useRef(false);
  const introMusicPlayedRef = useRef(false);
const [isLoadingScript, setIsLoadingScript] = useState(false);
// Create AudioContext (add this at the top with other refs)
const [completedTopics, setCompletedTopics] = useState([]);

// ============================================
// STEP 2: LOAD COMPLETED TOPICS FROM CACHE ON MOUNT
// ============================================
// ADD THIS useEffect:
useEffect(() => {
  loadCompletedTopics();
}, []);

// Initialize AudioContext

// ============================================
// STEP 3: ADD FUNCTIONS TO MANAGE COMPLETED TOPICS
// ============================================
const getCompletedTopicsKey = () => {
  const cardId = title.replace(/\s+/g, '_').toLowerCase();
  return `podcast_completed_topics_${type}_${cardId}`;
};

const loadCompletedTopics = () => {
  try {
    const cacheKey = getCompletedTopicsKey();
    const cached = sessionStorage.getItem(cacheKey);
    
    if (cached) {
      const { topics, timestamp } = JSON.parse(cached);
      
      // Check if cache is less than 24 hours old
      const oneDayMs = 24 * 60 * 60 * 1000;
      if (Date.now() - timestamp < oneDayMs) {
        setCompletedTopics(topics);
        console.log('✅ Loaded completed topics:', topics);
        return;
      }
    }
  } catch (e) {
    console.log('Error loading completed topics:', e);
  }
};

const saveCompletedTopic = (topicId) => {
  try {
    // ✅ ADD TO COMPLETED LIST
    setCompletedTopics(prev => {
      const updated = [...prev, topicId];
      
      // Save to cache
      const cacheKey = getCompletedTopicsKey();
      const cacheData = {
        topics: updated,
        timestamp: Date.now()
      };
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
      console.log('💾 Saved completed topic:', topicId);
      
      return updated;
    });
  } catch (e) {
    console.log('Error saving completed topic:', e);
  }
};

const clearCompletedTopics = () => {
  try {
    const cacheKey = getCompletedTopicsKey();
    sessionStorage.removeItem(cacheKey);
    setCompletedTopics([]);
    console.log('🗑️ Cleared completed topics');
  } catch (e) {
    console.log('Error clearing completed topics:', e);
  }
};

const handleRewind = () => {
  if (currentAudioRef.current && isPlaying && !isPaused) {
    const newTime = Math.max(0, currentAudioRef.current.currentTime - 10);
    currentAudioRef.current.currentTime = newTime;
    console.log(`⏪ Rewound to ${newTime.toFixed(1)}s`);
  }
};

// ============================================
// 2️⃣ FAST FORWARD 30 SECONDS
// ============================================
const handleFastForward = () => {
  if (currentAudioRef.current && isPlaying && !isPaused) {
    const newTime = Math.min(currentAudioRef.current.duration, currentAudioRef.current.currentTime + 30);
    currentAudioRef.current.currentTime = newTime;
    console.log(`⏩ Fast forwarded to ${newTime.toFixed(1)}s`);
  }
};
const smartPreloadAudio = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  
  // ✅ CHECK IF ALREADY CACHED
  if (audioQueueRef.current.has(cacheKey)) {
    console.log(`✅ ${host.toUpperCase()} ALREADY CACHED`);
    return true;
  }

  // ✅ CHECK IF ALREADY PRELOADING
  if (isPreloadingRef.current.has(cacheKey)) {
    console.log(`⏳ ${host.toUpperCase()} PRELOADING, WAITING...`);
    let waitCount = 0;
    const maxWait = 300; // 15 seconds max
    while (isPreloadingRef.current.has(cacheKey) && waitCount < maxWait) {
      await new Promise(resolve => setTimeout(resolve, 50));
      waitCount++;
    }
    if (audioQueueRef.current.has(cacheKey)) {
      console.log(`✅ ${host.toUpperCase()} READY`);
      return true;
    }
    console.log(`⚠️ ${host.toUpperCase()} TIMEOUT`);
    return false;
  }

  isPreloadingRef.current.add(cacheKey);
  console.log(`🔄 PRELOADING ${host.toUpperCase()}...`);

  try {
    const audioBlob = await SecureAPI.callHumeTTSSecure(
      text,
      VOICE_CONFIG[host],
      playbackSpeedRef.current
    );

    const url = URL.createObjectURL(audioBlob);
    audioQueueRef.current.set(cacheKey, { url, text, host, used: false });
    
    console.log(`✅ ${host.toUpperCase()} LOADED`);
    return true;

  } catch (error) {
    console.error(`❌ Preload error for ${host}:`, error);
    return false;
  } finally {
    isPreloadingRef.current.delete(cacheKey);
  }
};

// ============================================
// 2️⃣ INSTANT PLAYBACK FROM CACHE
// ============================================
const playInstantFromCache = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  const cached = audioQueueRef.current.get(cacheKey);

  if (cached && !cached.used) {
    console.log(`⚡⚡⚡ INSTANT ${host.toUpperCase()}`);
    
    setTranscript(prev => [...prev, {
      voice: host,
      text: text,
      timestamp: Date.now()
    }]);

    cached.used = true;
    
    return new Promise((resolve) => {
      const audio = new Audio(cached.url);
      audio.playbackRate = playbackSpeedRef.current;
      
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      
      currentAudioRef.current = audio;

      audio.onended = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        currentAudioRef.current = null;
        resolve(true);
      };

      audio.onerror = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        currentAudioRef.current = null;
        resolve(false);
      };

      audio.play().catch(err => {
        console.error('Play error:', err);
        resolve(false);
      });
    });
  }

  console.log(`❌ ${host.toUpperCase()} NOT CACHED`);
  return false;
};

/**
 * IMPROVED SILENCE TRIMMER: Remove silence from START, END, and BETWEEN speakers
 * This eliminates ALL awkward gaps!
 */
const trimSilence = (buffer, audioContext) => {
  const threshold = 0.01; // 1% volume threshold
  const sampleRate = buffer.sampleRate;
  const channels = buffer.numberOfChannels;
  const channel0 = buffer.getChannelData(0);
  
  // Find first non-silent sample
  let start = 0;
  for (let i = 0; i < channel0.length; i++) {
    if (Math.abs(channel0[i]) > threshold) {
      // NO padding at start - cut right to the sound
      start = i;
      break;
    }
  }
  
  // Find last non-silent sample
  let end = channel0.length;
  for (let i = channel0.length - 1; i >= start; i--) {
    if (Math.abs(channel0[i]) > threshold) {
      // NO padding at end - cut right to the sound
      end = i + 1;
      break;
    }
  }
  
  // Create trimmed buffer
  const trimmedLength = end - start;
  if (trimmedLength <= 0) return buffer; // No trimming needed
  
  const trimmedBuffer = audioContext.createBuffer(channels, trimmedLength, sampleRate);
  
  for (let ch = 0; ch < channels; ch++) {
    const sourceData = buffer.getChannelData(ch);
    const targetData = trimmedBuffer.getChannelData(ch);
    targetData.set(sourceData.slice(start, end));
  }
  
  return trimmedBuffer;
};

/**
 * Convert Blob to AudioBuffer
 */
const blobToAudioBuffer = async (blob, audioContext) => {
  const arrayBuffer = await blob.arrayBuffer();
  return await audioContext.decodeAudioData(arrayBuffer);
};

/**
 * Convert AudioBuffer back to Blob
 */
const audioBufferToBlob = (buffer) => {
  const numberOfChannels = buffer.numberOfChannels;
  const length = buffer.length * numberOfChannels * 2;
  const arrayBuffer = new ArrayBuffer(44 + length);
  const view = new DataView(arrayBuffer);
  const channels = [];
  let offset = 0;
  let pos = 0;

  const setUint16 = (data) => {
    view.setUint16(pos, data, true);
    pos += 2;
  };
  const setUint32 = (data) => {
    view.setUint32(pos, data, true);
    pos += 4;
  };

  // Write WAV header
  setUint32(0x46464952); // "RIFF"
  setUint32(36 + length);
  setUint32(0x45564157); // "WAVE"
  setUint32(0x20746d66); // "fmt "
  setUint32(16);
  setUint16(1); // PCM
  setUint16(numberOfChannels);
  setUint32(buffer.sampleRate);
  setUint32(buffer.sampleRate * numberOfChannels * 2);
  setUint16(numberOfChannels * 2);
  setUint16(16);
  setUint32(0x61746164); // "data"
  setUint32(length);

  for (let i = 0; i < buffer.numberOfChannels; i++) {
    channels.push(buffer.getChannelData(i));
  }

  while (pos < arrayBuffer.byteLength) {
    for (let i = 0; i < numberOfChannels; i++) {
      let sample = Math.max(-1, Math.min(1, channels[i][offset]));
      sample = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
      view.setInt16(pos, sample, true);
      pos += 2;
    }
    offset++;
  }

  return new Blob([arrayBuffer], { type: 'audio/wav' });
};



// ============================================
// 3️⃣ UPDATE speakChunk WITH SILENCE TRIMMING
// ============================================
const speakChunk = async (text, host) => {
  return playAudioSafely(async () => {
    if (shouldStopRef.current || isPlayingChunkRef.current) return false;
    isPlayingChunkRef.current = true;

    return new Promise(async (resolve) => {
      try {
        setTranscript(prev => [...prev, {
          voice: host,
          text: text,
          timestamp: Date.now()
        }]);

        const blob = await SecureAPI.callHumeTTSSecure(
          text,
          VOICE_CONFIG[host],
          playbackSpeedRef.current
        );

        // ✅ Use fresh AudioContext per chunk (like CompaniesLiveStation does)
        let trimmedBlob = blob;
        try {
          const tempContext = new (window.AudioContext || window.webkitAudioContext)();
          const arrayBuffer = await blob.arrayBuffer();
          const audioBuffer = await tempContext.decodeAudioData(arrayBuffer);
          const trimmed = trimSilence(audioBuffer, tempContext);
          trimmedBlob = audioBufferToBlob(trimmed);
          await tempContext.close(); // ✅ CRITICAL: release memory immediately
        } catch (trimError) {
          console.log('Trim failed, using original:', trimError);
        }

        const url = URL.createObjectURL(trimmedBlob);
        const audio = new Audio(url);
        audio.playbackRate = playbackSpeedRef.current;

        if (currentAudioRef.current) {
          currentAudioRef.current.pause();
          currentAudioRef.current.currentTime = 0;
          currentAudioRef.current = null;
        }

        currentAudioRef.current = audio;

        audio.onended = () => {
          URL.revokeObjectURL(url);
          currentAudioRef.current = null;
          isPlayingChunkRef.current = false;
          resolve(true);
        };

        audio.onerror = () => {
          URL.revokeObjectURL(url);
          currentAudioRef.current = null;
          isPlayingChunkRef.current = false;
          resolve(false);
        };

        if (shouldStopRef.current) {
          URL.revokeObjectURL(url);
          isPlayingChunkRef.current = false;
          resolve(false);
          return;
        }

const playPromise = audio.play();
if (playPromise !== undefined) {
  playPromise.catch(err => {
    if (err.name === 'NotAllowedError') {
      // iOS blocked it - try resuming after a tiny delay
      setTimeout(() => {
        audio.play().catch(() => resolve(false));
      }, 100);
    } else {
      resolve(false);
    }
  });
}

      } catch (error) {
        console.error('Chunk TTS Error:', error);
        isPlayingChunkRef.current = false;
        resolve(false);
      }
    });
  });
};
// ✅ IMPROVED: Preload BOTH speakers, play from cache instantly
const parseAndSpeakHosts = async (text) => {
  const emmaMatch = text.match(/Emma:\s*(.+?)(?=James:|$)/s);
  const jamesMatch = text.match(/James:\s*(.+?)$/s);

  const emmaText = emmaMatch ? emmaMatch[1].trim() : null;
  const jamesText = jamesMatch ? jamesMatch[1].trim() : null;

  if (emmaText && jamesText) {
    // ✅ EMMA INSTANT
    const emmaOk = await playInstantFromCache(emmaText, 'emma');
    if (!emmaOk) {
      const chunks = chunkTextForSpeech(emmaText, 50);
      for (const chunk of chunks) {
        if (shouldStopRef.current) return;
        await speakChunk(chunk, 'emma');
      }
    }

    // ✅ JAMES INSTANT
    const jamesOk = await playInstantFromCache(jamesText, 'james');
    if (!jamesOk) {
      const jamesChunks = chunkTextForSpeech(jamesText, 50);
      for (const chunk of jamesChunks) {
        if (shouldStopRef.current) return;
        await speakChunk(chunk, 'james');
      }
    }
    
  } else if (emmaText) {
    const emmaOk = await playInstantFromCache(emmaText, 'emma');
    if (!emmaOk) {
      const chunks = chunkTextForSpeech(emmaText, 100);
      for (const chunk of chunks) {
        if (shouldStopRef.current) return;
        await speakChunk(chunk, 'emma');
      }
    }
  } else if (jamesText) {
    const jamesOk = await playInstantFromCache(jamesText, 'james');
    if (!jamesOk) {
      const chunks = chunkTextForSpeech(jamesText, 100);
      for (const chunk of chunks) {
        if (shouldStopRef.current) return;
        await speakChunk(chunk, 'james');
      }
    }
  }
};


// ============================================
// MAIN PODCAST EXECUTION - WITH LOOKAHEAD PRELOADING
// ============================================

const handleIntentionContinue = async () => {
  if (!selectedIntention) return;
  
  setShowAllSet(true);
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  setShowAllSet(false);
  setShowIntentionModal(false);
  
  shouldStopRef.current = false;
  setIsPlaying(true);
  setTranscript([]);
  
  setIsLoadingScript(true);
  setCurrentStatus('Now playing...');
  
  try {
    console.log('🎬 START: User clicked Continue');
    
    // ============================================
    // ✅ PHASE 1: START ALL TASKS IN PARALLEL
    // ============================================
    
    console.log('🚀 PARALLEL START: Music + Script + First Audio');
    
    // Task 1: Intro music (PLAYS until first audio is ready)
    const musicPromise = playIntroMusic();
    
    // Task 2: Generate script with topic
    const scriptPromise = generatePodcastScriptWithTopic(selectedIntention.label);
    
    // Task 3: Generate suggested topics
    const topicsPromise = generateSuggestedTopics();
    
    // ✅ Wait for all 3 to complete
    const [script, topics] = await Promise.all([scriptPromise, topicsPromise]);
    console.log('✅ Script and topics ready');
    
    // ============================================
    // ✅ PHASE 2: EXTRACT FIRST LINE + PRE-GENERATE AUDIO
    // ============================================
    
    const lines = script.split('\n').filter(line => line.trim());
    console.log(`📝 Script has ${lines.length} lines`);
    
    if (lines.length > 0) {
      const firstLine = lines[0];
      const emmaMatch = firstLine.match(/Emma:\s*(.+)/i);
      
      if (emmaMatch) {
        const firstEmmaText = emmaMatch[1].trim();
        
        console.log('🎙️ Pre-generating first Emma audio WHILE MUSIC PLAYS...');
        
        // ✅ START PRELOADING FIRST EMMA (don't wait)
        const emmaPreloadPromise = smartPreloadAudio(firstEmmaText, 'emma');
        
        // ✅ Also preload first James if exists
        if (lines.length > 1) {
          const secondLine = lines[1];
          const jamesMatch = secondLine.match(/James:\s*(.+)/i);
          if (jamesMatch) {
            console.log('📌 Also preloading first James...');
            void smartPreloadAudio(jamesMatch[1].trim(), 'james');
          }
        }
        
        // ✅ WAIT FOR EMMA TO BE READY
        console.log('⏳ Waiting for Emma audio to be cached...');
        await emmaPreloadPromise;
        console.log('✅ Emma audio READY AND CACHED');
        
        // ============================================
        // ✅ PHASE 3: SMOOTH FADE OUT MUSIC
        // ============================================
        
        console.log('🎵 Fading out intro music to host audio...');
        await fadeOutMusicSmooth(800);
        
      } else {
        // No Emma in first line, just wait for music to finish naturally
        await musicPromise;
      }
    } else {
      // Empty script, wait for music
      await musicPromise;
    }
    
    if (shouldStopRef.current) {
      setIsPlaying(false);
      setIsLoadingScript(false);
      return;
    }
    
    // ============================================
    // ✅ PHASE 4: SETUP + INSTANT PLAYBACK
    // ============================================
    
    setCachedScript(script);
    saveCachedScript(script, 0);
    setSuggestedTopics(topics);
    setIsLoadingScript(false);
    
    console.log('🎙️ READY TO PLAY - STARTING IMMEDIATELY (music faded out)');
    
    // ✅ NOW START PLAYING (first Emma audio is already cached!)
    for (let i = 0; i < lines.length; i++) {
      if (shouldStopRef.current) break;

      while (isPaused && !shouldStopRef.current) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      if (shouldStopRef.current) break;

      setCurrentLineIndex(i);

      const line = lines[i];
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);

      // ✅ LOOKAHEAD: Start preloading next 3 lines
      if (i + 3 < lines.length) {
        for (let j = i + 1; j <= i + 3 && j < lines.length; j++) {
          const lookaheadLine = lines[j];
          const lookaheadEmma = lookaheadLine.match(/Emma:\s*(.+)/i);
          const lookaheadJames = lookaheadLine.match(/James:\s*(.+)/i);
          
          if (lookaheadEmma) {
            void smartPreloadAudio(lookaheadEmma[1].trim(), 'emma');
          }
          if (lookaheadJames) {
            void smartPreloadAudio(lookaheadJames[1].trim(), 'james');
          }
        }
      }

      if (emmaMatch) {
        const jamesLine = lines[i + 1];
        const jamesText = jamesLine?.match(/James:\s*(.+)/i)?.[1] || '';
        
        // Preload James while Emma speaks
        if (jamesText && i + 1 < lines.length) {
          void smartPreloadAudio(jamesText, 'james');
        }
        
        console.log(`Line ${i}: Emma + James`);
        await parseAndSpeakHosts(`Emma: ${emmaMatch[1]}\nJames: ${jamesText}`);
        i++;
      } else if (jamesMatch && !line.match(/Emma:/i)) {
        console.log(`Line ${i}: James`);
        const jamesOk = await playInstantFromCache(jamesMatch[1].trim(), 'james');
        if (!jamesOk) {
          await speakChunk(jamesMatch[1].trim(), 'james');
        }
      }
      
      updateCacheProgress(i);
    }

    clearCache();
    
    if (!shouldStopRef.current) {
      const farewellMessage = userName && userName !== 'Guest' && userName !== 'user'
        ? `That's a wrap for today! See you next time, ${userName}.`
        : `That's a wrap for today! See you next time.`;
      
      await speakChunk(farewellMessage, 'emma');
      await new Promise(resolve => setTimeout(resolve, 500));
      
      saveCompletedTopic(selectedIntention.id);
      
      setCurrentStatus('farewell');
      setShowSuggestions(false);
    }
  } catch (error) {
    console.error('Podcast error:', error);
    setError(`Podcast error: ${error.message}`);
    setIsPlaying(false);
    setIsLoadingScript(false);
  }
};

// ============================================
// 5️⃣ CLEANUP ON UNMOUNT
// ============================================
useEffect(() => {
  return () => {
    console.log('🧹 Cleaning up podcast component...');
    
    // Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // Clear audio queue
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('Error revoking URL:', e);
      }
    });
    audioQueueRef.current.clear();
    
    // Clear preloading
    isPreloadingRef.current.clear();
    
    console.log('✅ Podcast cleanup complete');
  };
}, []);

  // CONFIG
const INTRO_MUSIC_OPTIONS = [
  '/music/intro-outro-15.mp3',
  '/music/intro-outro-8.mp3',
  '/music/intro-outro-3.mp3',
  '/music/intro-outro-17.mp3',
    '/music/intro-outro-22.mp3',
      '/music/intro-outro-10.mp3',
  '/music/intro-outro-5.mp3',
];
// ============================================
// CACHE SUGGESTED TOPICS TO REDUCE API CALLS
// ============================================

// 1️⃣ CREATE CACHE KEY FOR SUGGESTIONS
const getCacheSuggestionsKey = () => {
  // Use cardId or title to create unique cache key
  const cardId = title.replace(/\s+/g, '_').toLowerCase();
  return `podcast_suggestions_${type}_${cardId}`;
};

// 2️⃣ LOAD CACHED SUGGESTIONS
const loadCachedSuggestions = () => {
  const cacheKey = getCacheSuggestionsKey();
  const cached = sessionStorage.getItem(cacheKey);
  
  if (cached) {
    try {
      const { topics, timestamp } = JSON.parse(cached);
      
      // Check if cache is less than 24 hours old (can customize)
      const oneDayMs = 24 * 60 * 60 * 1000;
      if (Date.now() - timestamp < oneDayMs) {
        console.log('✅ Using cached suggestions for:', title);
        return topics;
      }
    } catch (e) {
      console.log('Cache parse error:', e);
    }
  }
  
  return null;
};

// 3️⃣ SAVE SUGGESTIONS TO CACHE
const saveCachedSuggestions = (topics) => {
  const cacheKey = getCacheSuggestionsKey();
  const cacheData = {
    topics,
    timestamp: Date.now()
  };
  
  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
    console.log('💾 Cached suggestions for:', title);
  } catch (e) {
    console.log('Cache save error:', e);
  }
};

// 4️⃣ CLEAR CACHED SUGGESTIONS (if user wants fresh ones)
const clearCachedSuggestions = () => {
  const cacheKey = getCacheSuggestionsKey();
  sessionStorage.removeItem(cacheKey);
  console.log('🗑️ Cleared cached suggestions');
};

// 5️⃣ UPDATE generateSuggestedTopics TO USE CACHE
const generateSuggestedTopics = async () => {
  try {
    // ✅ CHECK CACHE FIRST
    const cachedTopics = loadCachedSuggestions();
    if (cachedTopics) {
      return cachedTopics;
    }

    // If no cache, generate new suggestions
    const prompt = `Based on "${title}", create 3 deep-dive learning areas.

CRITICAL: Each topic MUST be 3-5 words maximum.

Return ONLY 3 titles, one per line, no numbering.

Examples:
- Neural Network Architecture
- Backpropagation Algorithm
- Activation Functions`;

    // ✅ SECURE API CALL - REPLACES OLD FETCH
    const data = await SecureAPI.callAzureOpenAI(
      [
        { role: 'system', content: 'Generate concise 3-5 word learning topics.' },
        { role: 'user', content: prompt }
      ],
      {
        temperature: 0.9,
        max_tokens: 150
      }
    );
    
    const topics = data.choices[0].message.content
      .trim()
      .split('\n')
      .filter(t => t.trim().length > 0)
      .slice(0, 3)
      .map((title, idx) => ({
        id: idx,
        title: title.trim().replace(/^[\d.]+\s*/, ''),
        duration: '4 min'
      }));

    // ✅ SAVE TO CACHE BEFORE RETURNING
    saveCachedSuggestions(topics);
    
    return topics;
  } catch (error) {
    return [
      { id: 0, title: `${title} Foundations`, duration: '4 min' },
      { id: 1, title: `Advanced Concepts`, duration: '4 min' },
      { id: 2, title: `Practical Applications`, duration: '4 min' }
    ];
  }
};


// 7️⃣ HELPER: CACHE KEY FOR DEEP DIVE TOPICS
const getCacheDeepDiveKey = () => {
  const cardId = title.replace(/\s+/g, '_').toLowerCase();
  return `podcast_deepdive_${type}_${cardId}`;
};

// 8️⃣ OPTIONAL: VIEW WHAT'S IN CACHE (FOR DEBUGGING)
const viewCache = () => {
  const suggKey = getCacheSuggestionsKey();
  const deepDiveKey = getCacheDeepDiveKey();
  
  const cachedSugg = sessionStorage.getItem(suggKey);
  const cachedDeepDive = sessionStorage.getItem(deepDiveKey);
  
  console.log('📊 Cache Status:');
  console.log('Suggestions Cache:', cachedSugg ? JSON.parse(cachedSugg) : 'Empty');
  console.log('Deep Dive Cache:', cachedDeepDive ? JSON.parse(cachedDeepDive) : 'Empty');
};


// 2️⃣ ADD FUNCTION TO GET NEXT INTRO MUSIC
const getNextIntroMusic = () => {
  // Get the last used index from localStorage
  const lastIndex = parseInt(localStorage.getItem('podcast_intro_index') || '-1');
  
  // Calculate next index (rotate through options)
  const nextIndex = (lastIndex + 1) % INTRO_MUSIC_OPTIONS.length;
  
  // Save the new index
  localStorage.setItem('podcast_intro_index', nextIndex.toString());
  
  // Return the selected music file
  const selectedMusic = INTRO_MUSIC_OPTIONS[nextIndex];
  console.log(`🎵 Playing intro ${nextIndex + 1}/${INTRO_MUSIC_OPTIONS.length}: ${selectedMusic}`);
  
  return selectedMusic;
};  
 const VOICE_CONFIG = {
  emma: '33045fd9-8010-43f6-b6b0-da3fbf326c29',  // Changed from 'guide' to 'emma'
  james: '41745808-6790-4be4-83db-363e20db7e71'   // Changed from 'companion' to 'james'
};

  // Intention modal state
  const [showIntentionModal, setShowIntentionModal] = useState(false);
  const [selectedIntention, setSelectedIntention] = useState(null);
  const [deepDiveTopics, setDeepDiveTopics] = useState([]);
  const [isLoadingTopics, setIsLoadingTopics] = useState(false);
  const [showAllSet, setShowAllSet] = useState(false);
  const [intentionScrollIndex, setIntentionScrollIndex] = useState(0);
  const [suggestionCount, setSuggestionCount] = useState(null);
const [cachedScript, setCachedScript] = useState(null);
const [currentLineIndex, setCurrentLineIndex] = useState(0);
const [isResuming, setIsResuming] = useState(false);

// ============================================
// ADD CACHE KEY GENERATION
// ============================================
const getCacheKey = (topicTitle) => {
  return `podcast_${type}_${topicTitle.replace(/\s+/g, '_')}`;
};

// ============================================
// LOAD CACHED SCRIPT FROM MEMORY
// ============================================
const loadCachedScript = () => {
  const cacheKey = getCacheKey(title);
  const cached = sessionStorage.getItem(cacheKey);
  
  if (cached) {
    try {
      const { script, lineIndex, timestamp } = JSON.parse(cached);
      
      // Check if cache is less than 1 hour old
      const oneHour = 60 * 60 * 1000;
      if (Date.now() - timestamp < oneHour) {
        setCachedScript(script);
        setCurrentLineIndex(lineIndex);
        setIsResuming(true);
        return true;
      }
    } catch (e) {
      console.log('Cache parse error:', e);
    }
  }
  
  return false;
};

// ============================================
// SAVE SCRIPT TO CACHE
// ============================================
const saveCachedScript = (script, lineIndex = 0) => {
  const cacheKey = getCacheKey(title);
  const cacheData = {
    script,
    lineIndex,
    timestamp: Date.now()
  };
  
  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
  } catch (e) {
    console.log('Cache save error:', e);
  }
};

// ============================================
// UPDATE CACHE PROGRESS
// ============================================
const updateCacheProgress = (lineIndex) => {
  if (cachedScript) {
    saveCachedScript(cachedScript, lineIndex);
  }
};

// ============================================
// CLEAR CACHE
// ============================================
const clearCache = () => {
  const cacheKey = getCacheKey(title);
  sessionStorage.removeItem(cacheKey);
  setCachedScript(null);
  setCurrentLineIndex(0);
  setIsResuming(false);
};

  // ============================================
  // DETECT TOPIC BREADTH
  // ============================================
const detectTopicBreadth = async () => {
  try {
    const prompt = `Analyze this topic: "${title}"

Is this BROAD (many subtopics) or SPECIFIC (focused)?

If BROAD: return "COUNT: 10"
If SPECIFIC: return "COUNT: 5"`;

    // ✅ SECURE API CALL - REPLACES OLD FETCH
    const data = await SecureAPI.callAzureOpenAI(
      [
        { role: 'system', content: 'You are an expert at analyzing topics.' },
        { role: 'user', content: prompt }
      ],
      {
        temperature: 0.7,
        max_tokens: 50
      }
    );

    const response_text = data.choices[0].message.content;
    const countMatch = response_text.match(/COUNT:\s*(\d+)/i);
    const count = countMatch ? parseInt(countMatch[1]) : 5;
    
    setSuggestionCount(count);
  } catch (error) {
    setSuggestionCount(5);
  }
};

// 6️⃣ ALSO UPDATE generateDeepDiveTopics (FOR INTENTION MODAL)
const generateDeepDiveTopics = async () => {
  try {
    // ✅ CHECK CACHE FIRST
    const cachedDeepDive = sessionStorage.getItem(getCacheDeepDiveKey());
    if (cachedDeepDive) {
      try {
        const { topics, timestamp } = JSON.parse(cachedDeepDive);
        const oneDayMs = 24 * 60 * 60 * 1000;
        if (Date.now() - timestamp < oneDayMs) {
          console.log('✅ Using cached deep dive topics');
          setDeepDiveTopics(topics);
          setIsLoadingTopics(false);
          return; // ✅ CRITICAL: Return early to prevent re-render
        }
      } catch (e) {
        console.log('Cache parse error:', e);
      }
    }

    setIsLoadingTopics(true);

    if (suggestionCount === null) {
      await new Promise(resolve => {
        const interval = setInterval(() => {
          if (suggestionCount !== null) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
    }

    const prompt = `Based on "${title}", generate ${suggestionCount} specific learning aspects.

CRITICAL: Each topic MUST be 3-5 words maximum. Be concise.

Format: Return ONLY ${suggestionCount} titles, one per line, no numbering.

Examples for "Photosynthesis":
- Light-Dependent Reactions
- Calvin Cycle Process
- C3 vs C4 Pathways
- Chloroplast Structure
- Rate-Affecting Factors`;

    // ✅ SECURE API CALL - REPLACES OLD FETCH
    const data = await SecureAPI.callAzureOpenAI(
      [
        { role: 'system', content: 'Generate concise 3-5 word learning topics.' },
        { role: 'user', content: prompt }
      ],
      {
        temperature: 0.9,
        max_tokens: 300
      }
    );

    const topics = data.choices[0].message.content
      .trim()
      .split('\n')
      .filter(t => t.trim().length > 0)
      .slice(0, suggestionCount)
      .map((topicTitle, idx) => ({
        id: idx,
        label: topicTitle.trim().replace(/^[\d.]+\s*/, '')
      }));

    // ✅ SAVE DEEP DIVE TOPICS TO CACHE
    const cacheKey = getCacheDeepDiveKey();
    const cacheData = {
      topics,
      timestamp: Date.now()
    };
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
      console.log('💾 Cached deep dive topics');
    } catch (e) {
      console.log('Cache save error:', e);
    }

    setDeepDiveTopics(topics);
  } catch (error) {
    setDeepDiveTopics([
      { id: 0, label: `${title} Fundamentals` },
      { id: 1, label: `Core Concepts` },
      { id: 2, label: `Real-World Applications` },
      { id: 3, label: `Advanced Topics` },
      { id: 4, label: `Common Misconceptions` }
    ]);
  } finally {
    setIsLoadingTopics(false);
  }
};

useEffect(() => {
  detectTopicBreadth();
}, []); // ✅ Keep this as is

useEffect(() => {
  if (suggestionCount !== null) {
    generateDeepDiveTopics();
  }
}, [suggestionCount]); // ✅ Only re-run when suggestionCount changes

  // ============================================
  // INTENTION HANDLERS
  // ============================================
const handleIntentionSelect = (topic) => {
  setSelectedIntention(prev => {
    if (prev?.id === topic.id) return null;
    return topic;
  });
  // ✅ KEY FIX: Don't set any other state that would cause re-render
  // This keeps animation smooth - selection state alone won't re-render the list
};

const handleIntentionSkip = async () => {
  setShowIntentionModal(false);
  setSelectedIntention(null);
  
  shouldStopRef.current = false;
  setIsPlaying(true);
  setTranscript([]);
  
  // ✅ CHECK FOR CACHED SCRIPT
  const hasCachedScript = loadCachedScript();
  
  if (hasCachedScript && cachedScript) {
    // ✅ RESUME LOGIC WITH SMOOTH MUSIC TRANSITION
    setIsLoadingScript(true);
    
    console.log('🔄 Resuming from cached script - SMOOTH MUSIC TRANSITION');
    
    // ============================================
    // PARALLEL: Music + Resume intro generation
    // ============================================
    
    const musicPromise = playIntroMusic();
    const resumeIntroPromise = generateResumeIntro();
    const topicsPromise = generateSuggestedTopics();
    
    // ✅ Wait for all to complete
    const [resumeIntro, topics] = await Promise.all([resumeIntroPromise, topicsPromise]);
    
    if (shouldStopRef.current) {
      setIsPlaying(false);
      setIsLoadingScript(false);
      return;
    }
    
    setSuggestedTopics(topics);
    
    // ✅ PRELOAD FIRST RESUME LINE
    const resumeLines = resumeIntro.split('\n').filter(line => line.trim());
    if (resumeLines.length > 0) {
      const firstLine = resumeLines[0];
      const emmaMatch = firstLine.match(/Emma:\s*(.+)/i);
      
      if (emmaMatch) {
        console.log('🎙️ Pre-generating first resume line...');
        const emmaPreloadPromise = smartPreloadAudio(emmaMatch[1].trim(), 'emma');
        
        // Wait for Emma to be ready
        await emmaPreloadPromise;
        console.log('✅ Resume audio ready');
        
        // ✅ SMOOTH FADE OUT MUSIC
        console.log('🎵 Fading out intro music to resume audio...');
        await fadeOutMusicSmooth(800);
      } else {
        // No Emma, just wait for music
        await musicPromise;
      }
    } else {
      await musicPromise;
    }
    
    setIsLoadingScript(false);
    setCurrentStatus('Now playing...');
    
    // ✅ PLAY RESUME INTRO (music faded out)
    const resumeLines2 = resumeIntro.split('\n').filter(line => line.trim());
    for (const line of resumeLines2) {
      if (shouldStopRef.current) break;
      
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);
      
      if (emmaMatch) {
        await speakChunk(emmaMatch[1].trim(), 'emma');
      } else if (jamesMatch) {
        await speakChunk(jamesMatch[1].trim(), 'james');
      }
      
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    
    // ✅ NOW CONTINUE FROM SAVED LINE INDEX
    const lines = cachedScript.split('\n').filter(line => line.trim());
    
    for (let i = currentLineIndex; i < lines.length; i++) {
      if (shouldStopRef.current) break;

      while (isPaused && !shouldStopRef.current) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      if (shouldStopRef.current) break;

      setCurrentLineIndex(i);

      const line = lines[i];
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);

      if (emmaMatch) {
        const jamesLine = lines[i + 1];
        const jamesText = jamesLine?.match(/James:\s*(.+)/i)?.[1] || '';
        await parseAndSpeakHosts(`Emma: ${emmaMatch[1]}\nJames: ${jamesText}`);
        i++;
      } else if (jamesMatch && !line.match(/Emma:/i)) {
        await speakChunk(jamesMatch[1].trim(), 'james');
      }
      
      updateCacheProgress(i);
    }
    
    clearCache();
    
} else {
    // ============================================
    // ✅ GENERATE NEW SCRIPT WITH SMOOTH TRANSITION
    // ============================================
    
    setIsLoadingScript(true);
    
    console.log('🆕 Generating new script - SMOOTH MUSIC TRANSITION');
    
    // ✅ PHASE 1: START ALL TASKS IN PARALLEL
    
    const musicPromise = playIntroMusic();
    const scriptPromise = generatePodcastScript();
    const topicsPromise = generateSuggestedTopics();
    
    // ✅ Wait for script and topics
    const [script, topics] = await Promise.all([scriptPromise, topicsPromise]);
    
    if (shouldStopRef.current) {
      setIsPlaying(false);
      setIsLoadingScript(false);
      return;
    }
    
    // ✅ PHASE 2: EXTRACT FIRST LINE + PRE-GENERATE AUDIO
    
    const lines = script.split('\n').filter(line => line.trim());
    
    if (lines.length > 0) {
      const firstLine = lines[0];
      const emmaMatch = firstLine.match(/Emma:\s*(.+)/i);
      
      if (emmaMatch) {
        console.log('🎙️ Pre-generating first Emma audio...');
        
        const firstEmmaText = emmaMatch[1].trim();
        const emmaPreloadPromise = smartPreloadAudio(firstEmmaText, 'emma');
        
        // Also preload first James
        if (lines.length > 1) {
          const secondLine = lines[1];
          const jamesMatch = secondLine.match(/James:\s*(.+)/i);
          if (jamesMatch) {
            console.log('📌 Also preloading first James...');
            void smartPreloadAudio(jamesMatch[1].trim(), 'james');
          }
        }
        
        // ✅ WAIT FOR EMMA TO BE READY
        console.log('⏳ Waiting for Emma audio...');
        await emmaPreloadPromise;
        console.log('✅ Emma audio ready');
        
        // ✅ SMOOTH FADE OUT MUSIC
        console.log('🎵 Fading out intro music...');
        await fadeOutMusicSmooth(800);
      } else {
        // No Emma, just wait for music
        await musicPromise;
      }
    } else {
      // Empty script, wait for music
      await musicPromise;
    }
    
    if (shouldStopRef.current) {
      setIsPlaying(false);
      setIsLoadingScript(false);
      return;
    }
    
    // ✅ PHASE 3: SETUP + INSTANT PLAYBACK
    
    setCachedScript(script);
    saveCachedScript(script, 0);
    setSuggestedTopics(topics);
    setIsLoadingScript(false);
    setCurrentStatus('Now playing...');
    
    console.log('🎙️ READY TO PLAY (music faded out)');
    
    // ✅ NOW START PLAYING (first Emma audio is already cached!)
    for (let i = 0; i < lines.length; i++) {
      if (shouldStopRef.current) break;

      while (isPaused && !shouldStopRef.current) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      if (shouldStopRef.current) break;

      setCurrentLineIndex(i);

      const line = lines[i];
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);

      // ✅ LOOKAHEAD: PRELOAD NEXT 2-3 LINES
      if (i + 2 < lines.length) {
        const nextLine = lines[i + 2];
        const nextEmmaMatch = nextLine.match(/Emma:\s*(.+)/i);
        const nextJamesMatch = nextLine.match(/James:\s*(.+)/i);
        
        if (nextEmmaMatch) {
          void smartPreloadAudio(nextEmmaMatch[1].trim(), 'emma');
        }
        if (nextJamesMatch) {
          void smartPreloadAudio(nextJamesMatch[1].trim(), 'james');
        }
      }

      if (emmaMatch) {
        const jamesLine = lines[i + 1];
        const jamesText = jamesLine?.match(/James:\s*(.+)/i)?.[1] || '';
        
        // ✅ PRELOAD JAMES WHILE EMMA SPEAKS
        if (jamesText) {
          void smartPreloadAudio(jamesText, 'james');
        }
        
        await parseAndSpeakHosts(`Emma: ${emmaMatch[1]}\nJames: ${jamesText}`);
        i++;
      } else if (jamesMatch && !line.match(/Emma:/i)) {
        const playedFromCache = await playInstantFromCache(jamesMatch[1].trim(), 'james');
        if (!playedFromCache) {
          await speakChunk(jamesMatch[1].trim(), 'james');
        }
      }
      
      updateCacheProgress(i);
    }
    
    clearCache();
  }
 
  if (!shouldStopRef.current) {
    const farewellMessage = userName && userName !== 'Guest' && userName !== 'user'
      ? `That's a wrap for today! See you next time, ${userName}.`
      : `That's a wrap for today! See you next time.`;
    
    await speakChunk(farewellMessage, 'emma');
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (cachedScript && currentLineIndex > 0) {
      saveCompletedTopic('general_podcast');
    }
    
    setCurrentStatus('farewell');
    setShowSuggestions(false);
  }
};

  // ============================================
  // AUDIO FUNCTIONS
  // ============================================
const stopAllAudio = () => {
  shouldStopRef.current = true;
  isPlayingChunkRef.current = false;
  
  if (currentAudioRef.current) {
    currentAudioRef.current.pause();
    currentAudioRef.current.currentTime = 0;
    currentAudioRef.current.volume = 0;
    currentAudioRef.current.src = '';
    currentAudioRef.current = null;
  }
};
  const playAudioSafely = async (audioFn) => {
    if (isAudioLocked) return false;

    setIsAudioLocked(true);
    try {
      const result = await audioFn();
      return result;
    } catch (error) {
      setError(error.message);
      return false;
    } finally {
      setIsAudioLocked(false);
    }
  };

const playIntroMusic = async () => {
  if (introMusicPlayedRef.current) return;

  return new Promise((resolve) => {
    if (shouldStopRef.current) {
      resolve();
      return;
    }

    const selectedIntroMusic = getNextIntroMusic();
    
    const audio = new Audio(selectedIntroMusic);
    audio.volume = 0.4;
    audio.loop = false;
    currentAudioRef.current = audio;

    const cleanup = () => {
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.src = '';
        if (currentAudioRef.current === audio) {
          currentAudioRef.current = null;
        }
      } catch (e) {}
      introMusicPlayedRef.current = true;
    };

    audio.oncanplaythrough = () => {
      if (shouldStopRef.current) {
        cleanup();
        resolve();
        return;
      }

      audio.play().catch(e => {
        console.log('Auto-play blocked');
        cleanup();
        resolve();
      });
      
      // ✅ CRITICAL: Don't stop music yet!
      // Music will play until first host audio is ready
      // Then we'll fade it out smoothly
      resolve();
    };

    audio.onended = () => {
      cleanup();
    };

    audio.onerror = () => {
      cleanup();
    };
    
    audio.load();
  });
};

// ============================================
// NEW: fadeOutMusicSmooth - Fade to host audio
// ============================================
// Smoothly transition from intro music to host speaking
// No awkward silence or hard cut-off

const fadeOutMusicSmooth = async (fadeOutDuration = 800) => {
  if (!currentAudioRef.current || !currentAudioRef.current.src) {
    console.log('✅ Music already stopped, host audio ready');
    return;
  }

  const audio = currentAudioRef.current;
  const startVolume = audio.volume;
  
  console.log(`🎵 Fading out intro music over ${fadeOutDuration}ms...`);

  return new Promise((resolve) => {
    const steps = 50;
    const volumeStep = startVolume / steps;
    const timeStep = fadeOutDuration / steps;
    let currentStep = 0;

    const fadeInterval = setInterval(() => {
      if (currentStep >= steps || shouldStopRef.current) {
        try {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = 0;
          audio.src = '';
          audio.load();
          if (currentAudioRef.current === audio) {
            currentAudioRef.current = null;
          }
        } catch (e) {}
        
        clearInterval(fadeInterval);
        console.log('✅ Music fade complete, host audio now playing');
        resolve();
        return;
      }

      try {
        if (audio && audio.src) {
          audio.volume = Math.max(0, startVolume - (volumeStep * currentStep));
        }
      } catch (e) {}
      
      currentStep++;
    }, timeStep);
  });
};

  const chunkTextForSpeech = (text, maxLength = 200) => {
    if (text.length <= maxLength) return [text];
    
    const chunks = [];
    const sentences = text.split(/(?<=[.!?])\s+/);
    let currentChunk = '';
    
    for (const sentence of sentences) {
      if (currentChunk.length + sentence.length <= maxLength) {
        currentChunk += (currentChunk ? ' ' : '') + sentence;
      } else {
        if (currentChunk) chunks.push(currentChunk);
        currentChunk = sentence;
      }
    }
    
    if (currentChunk) chunks.push(currentChunk);
    return chunks;
  };
  

const generatePodcastScript = async () => {
  const prompt = `You are Emma and James, hosts of an educational podcast explaining "${title}" to ${userName}.

🎯 YOUR ROLE: Share insights about the TOPIC with natural, conversational speech

✅ USE THESE NATURAL SPEECH PATTERNS (throughout the podcast):

**Thinking Out Loud:**
- "Uhm, so here's what I think..."
- "You know what, let me think about this for a second..."
- "Hmm, that's interesting because..."
- "Wait, hold on, let me explain this better..."
- "Actually, you know what's fascinating here..."

**Friendly Exchanges:**
- "So Emma/James, what do you think about..."
- "That's a really good question, let me break this down..."
- "Yeah, totally, and here's why..."
- "Right, exactly, and building on that..."
- "Oh absolutely, and you know what else..."
- "I mean, think about it this way..."

**Natural Transitions:**
- "Ok, so here's the thing..."
- "Alright, so let's dive into this..."
- "Now, this is where it gets really interesting..."
- "So basically what's happening here is..."
- "And you know what's cool about this..."

**Rhetorical Engagement:**
- "Think about it, right?"
- "I mean, when you really consider it..."
- "Imagine this scenario for a second..."
- "Here's what blows my mind about this..."
- "And this is the part that's really fascinating..."

**Conversational Fillers (use naturally - 8-12 times total):**
- "Uhm"
- "You know"
- "I mean"
- "Actually"
- "Like" (very sparingly)
- "So"
- "Right"
- "Basically"

**SMART FILLER USAGE - Know when to use MORE vs LESS:**

**Use MORE fillers (3-4) when:**
- Explaining complex/abstract concepts
- Thinking through difficult ideas
- Breaking down multi-step processes
- Example: "So the mechanism is, uhm, really intricate. You know, it involves multiple pathways that, like, work together simultaneously."

**Use FEWER fillers (0-1) when:**
- Stating simple facts
- Giving quick answers
- Making clear, direct points
- Example: "The answer is oxygen. Plants release it as a byproduct."

**Balance across conversation:**
- Total: 8-12 fillers across entire 30-35 exchange conversation
- Don't cluster them (spread naturally)
- Both Emma and James use them
- More fillers = casual/thinking; Fewer fillers = confident/clear

**EXAMPLES OF NATURAL VS ROBOTIC:**

❌ ROBOTIC (DON'T DO THIS):
James: How does photosynthesis help the world?
Emma: Photosynthesis converts sunlight into energy. It produces oxygen. This process is essential.

✅ NATURAL (DO THIS):
James: So Emma, what's the key factor that makes photosynthesis so crucial for life on Earth? Because this is really fundamental.
Emma: Yeah, totally, that's a really good question. Ok, so ${userName}, look at it this way - imagine you're a plant sitting in the sun. Uhm, you're basically taking in light energy and converting it into chemical energy that every living thing depends on.

❌ ROBOTIC:
Emma: The Calvin cycle has three phases. First is carbon fixation. Then reduction. Finally regeneration.
James: What happens in carbon fixation?

✅ NATURAL:
Emma: Alright, so the Calvin cycle - this is where it gets really cool. There are three main phases happening here, and they all work together seamlessly.
James: Hmm, ok, so walk me through this. What's actually happening in that first phase?
Emma: Right, so in carbon fixation - and this is the fascinating part - the enzyme RuBisCO is basically grabbing CO2 molecules...

❌ ROBOTIC:
James: Neurons transmit signals.
Emma: They use electrical impulses.

✅ NATURAL:
James: So Emma, when we talk about how neurons actually communicate, what's really happening at that microscopic level?
Emma: Oh, this is fascinating. So basically, neurons are using these electrical impulses to send messages. And here's what's cool - it all happens in milliseconds.

**CONVERSATION FLOW RULES:**

1. **Questions should feel natural:**
   - Add context before asking
   - Use conversational lead-ins
   - Focus on the topic directly
   - Example: "So what makes this so important? Because [context]."

2. **Answers should build naturally:**
   - Acknowledge the question first ("Yeah, great question." "Oh absolutely.")
   - Use transitional phrases ("Ok, so here's the thing..." "Let me break this down...")
   - Be direct and clear ("Actually, here's what makes this work..." "So basically...")

3. **Back-and-forth should flow:**
   - Respond to each other's points ("Right, exactly." "Oh that's interesting.")
   - Build on previous statements ("And building on that..." "And here's what else...")
   - Show active listening ("Mmm, yeah" "That makes sense")

**CRITICAL RULES:**

1. **PERSONALIZE WITH USER'S NAME (2-3 times total - naturally woven in)**
   
   ✅ CORRECT WAY - Speaking TO the user directly:
   - "So ${userName}, when YOU look at it this way..."
   - "${userName}, here's what makes this important FOR YOU..."
   - "And ${userName}, this is where it clicks FOR YOU..."
   - "You know ${userName}, the key insight for YOU is..."
   - "So ${userName}, imagine YOU'RE in this scenario..."
   
   **Rules:**
   - Use name 2-3 times MAXIMUM across entire conversation
   - Always speak TO the user directly (use "you", "your")
   - Both Emma and James can address the user directly

2. **MIX CONVERSATION PATTERNS NATURALLY**
   
   **Pattern A - Background Reaction (use 8-12 times):**
   One person gives short reaction, speaker CONTINUES talking
   
   Emma: "So ${userName}, when YOU look at the first mechanism, it controls energy flow. The second determines where change occurs."
   James: "Yup."
   Emma: "And the third creates the feedback system. Which is why all three matter for YOU."
   
   OR vice versa:
   
   James: "The system has three phases that YOU need to understand. Each one builds on the last."
   Emma: "Right."
   James: "So when YOU skip one, everything breaks down."
   
   **Pattern B - Normal Exchange (use for rest of conversation):**
   Normal back-and-forth, speaker CHANGES
   
   Emma: "This mechanism is complex."
   James: "How so?"
   Emma: "It involves multiple interconnected pathways."
   
   **KEY: MIX THEM INTELLIGENTLY**
   - Use background reactions when speaker is on a roll explaining
   - Use normal exchange when topic shifts or needs elaboration
   - BOTH Emma and James can give background reactions
   - BOTH Emma and James can continue after receiving a reaction
   
   **Short reactions to use:** "Right.", "Yup.", "Yeah.", "Exactly.", "True.", "For sure.", "Makes sense.", "Totally."

3. **SMART GENERALIZATION - Know when to use "you" vs "people"**
   
   **Use "YOU/YOUR" for:**
   - Direct teaching moments (80% of the time)
   - Personal application
   - Examples: "the oxygen YOU breathe", "when YOU see this", "this affects YOUR life"
   
   **Use "PEOPLE/SOCIETY" for:**
   - Historical context
   - Common misconceptions
   - Cultural/societal patterns
   - Scientific discoveries
   - Examples: "people used to think...", "scientists discovered...", "many people misunderstand...", "society evolved to..."
   
   ✅ GOOD GENERALIZATIONS:
   - "You know, people still debate this idea today..."
   - "Historically, people thought the Earth was flat..."
   - "Scientists discovered this pattern in 1950..."
   - "Many people confuse these two concepts..."
   - "Society has changed how we view this..."
   
   ❌ BAD - Should use "you" instead:
   - "This is the oxygen people breathe..." (should be "YOU breathe")
   - "This affects people's daily lives..." (should be "YOUR daily life")
   - "When people see this..." (should be "When YOU see this...")

2. **OPENING (Creative & Natural with Greetings):**
   
   **Choose ONE of these opening styles:**
   
   **Style A - Warm Greeting (10% of time):**
   - Emma: "Hey ${userName}, good morning. So glad you're here to learn about ${title}."
   - James: "Morning. Alright, so let's dive into this together."
   
   OR:
   
   - James: "Good morning ${userName}. So you're curious about ${title}, and we're going to break this down for you."
   - Emma: "Yeah, this is really interesting stuff. Let's get into it."
   
   **Style B - Simple Hello (30% of time):**
   - Emma: "Hey ${userName}. So you want to learn about ${title}, and we've got you covered."
   - James: "Yeah, let's explore this together."
   
   OR:
   
   - James: "Alright ${userName}, so you've chosen ${title}. This is going to be good."
   - Emma: "For sure. Let's break this down for you."
   
   OR:
   
   - Emma: "Hey ${userName}, welcome. So today we're diving into ${title}."
   - James: "Perfect. We'll walk you through everything you need to know."
   
   **Style C - Direct Welcome (30% of time):**
   - Emma: "Hey ${userName}, so today we're deep diving into what ${title} really is about. This is fascinating stuff."
   
   OR:
   
   - James: "Alright ${userName}, so let's explore ${title} together. We're going to show you why this matters."
   
   OR:
   
   - Emma: "Hey ${userName}. So you're curious about ${title}, and we're here to break it all down for you."
   
   **Style D - Jump Right In (30% of time):**
   - Emma: "Alright, so let's talk about ${title}. Here's what we're going to cover today."
   
   OR:
   
   - James: "So ${userName}, let's dive into ${title}. We'll show you why this is so important."
   
   OR:
   
   - Emma: "Okay, so ${title} - this is really cool stuff. Let's explore this together."
   
   **TEAMWORK LANGUAGE - Use throughout:**
   - "Let's explore..."
   - "We're going to show you..."
   - "Let's break this down..."
   - "We'll walk you through..."
   - "Let's dive into..."
   - "We're covering..."
   - "We've got you covered..."
   
   **Rules for opening:**
   - Greetings are TO the user (not between hosts)
   - "Good morning" only 10% of time - keep it fresh and varied
   - Openings should be SUBSTANTIAL - not just 2 words, but full welcoming sentences
   - Hosts work as a TEAM - use "we", "us", "let's" when referring to teaching
   - Keep opening exchange SHORT (2-4 sentences total) before diving into content
   - Vary the style - don't always do the same opening
   - Can mention "InnerLoop Deep Dive" occasionally (10% of time)
   - Sound warm and welcoming, not formal

**CRITICAL AUDIO RULES:**
- NEVER use exclamation marks (!) - use periods (.) ONLY
- MOSTLY talk TO the user with "you/your" (80% of time)
- Use "people/society" ONLY for: history, misconceptions, scientific discoveries, cultural patterns
- AVOID saying "humans" - sounds too clinical and weird
- ✅ TEAMWORK: Use "we/us/let's" when hosts are working together - "let's explore", "we're going to show you", "we'll walk you through"
- ✅ DIRECT: "the oxygen YOU breathe", "when YOU see this", "affects YOUR life"
- ✅ GENERALIZE: "people used to think...", "scientists discovered...", "many people confuse...", "society has evolved..."
- ❌ WRONG: "the oxygen people breathe" (should be YOU), "when someone sees this" (should be YOU)
- ❌ CREEPY: "humans breathe oxygen", "humans need this" (say "people" instead)
- Keep sentences conversational length (not too long, not too short)
- Use SHORT, simple words (avoid complex vocabulary)
- Each speaker: 2-5 sentences per turn
- Sound like a friendly TEAM teaching YOU directly, not individual lecturers
- Vary sentence length for natural rhythm
- NO quotation marks in the actual speech - speak naturally without quotes

**STRUCTURE:**
- Total: 30-35 exchanges
- 8-12 background reactions where speaker continues ("Yup.", "Right.", etc.)
- Mix short responses (1-2 sentences) with longer ones (3-5 sentences)
- Vary who asks questions and who explains
- Let the conversation breathe - it's ok to have thinking moments
- Use natural pauses and transitions
- Don't rush from point to point

**ENGAGEMENT PATTERNS:**

Pattern A (40%): NATURAL QUESTION → ENTHUSIASTIC ANSWER
James: "So Emma, what makes this process so efficient? Because when you look at it, there's so much happening here."
Emma: "Yeah, that's such a good question. Ok, so here's what's fascinating..."

Pattern B (30%): BUILD → AGREE → EXPAND
Emma: "The way these molecules interact is really precise. Each step has to happen in exact order."
James: "Right, exactly. And you know what's cool? The cell has built-in checkpoints..."

Pattern C (20%): DIRECT QUESTION → CLARIFY
James: "Hmm, so when looking at this mechanism, what's actually triggering the whole process?"
Emma: "Ok, good question. Let me break this down..."

Pattern D (10%): SURPRISE → EXPLAIN
Emma: "And here's something that blows my mind about this..."
James: "Oh, wait, what do you mean?"
Emma: "So basically what happens is..."

**THE GOLDEN RULE:**
Sound like two smart friends having a genuine conversation about something they find fascinating - not like you're reading from a textbook or following a script. Be natural, be curious, be engaged. Let the conversation flow organically.

**COMPLETE NATURAL EXAMPLE WITH PERSONALIZATION:**

Emma: "Hey ${userName}, good morning. So glad you're here to learn about photosynthesis."
James: "Morning. Alright, so let's dive into this together."
Emma: "Yeah, this is really interesting stuff."
James: "So Emma, what makes this process so fundamental? Because there's a lot happening here."
Emma: "Yeah, great question. Ok, so ${userName}, imagine YOU'RE a plant sitting in the sun. Uhm, YOU'RE basically taking in light energy and converting it into chemical energy."
James: "Right. And we're going to show you how this happens in two main stages."
Emma: "Exactly. The first is the light-dependent reactions. This is where chlorophyll captures photons."
James: "Hmm, so what's actually happening at the molecular level?"
Emma: "Right, so chlorophyll is, uhm, absorbing light energy and using it to split water molecules. And here's what's cool - oxygen gets released as a byproduct."
James: "Yup."
Emma: "So ${userName}, this is where all the oxygen YOU breathe actually comes from. And, you know, scientists didn't fully understand this process until the 1950s."
James: "Oh, that's incredible. And here's what's fascinating - this has been running for billions of years."
Emma: "Yeah, totally. I mean, without photosynthesis, there would be no oxygen, no food chains, nothing."
James: "Right."
Emma: "And the second stage is the Calvin cycle. It takes carbon dioxide from the air and, you know, converts it into glucose."
James: "So basically it's making food for the plant?"
Emma: "Exactly. And here's something many people don't realize - this whole process is completely self-sustaining."
James: "So ${userName}, when YOU see a tree, YOU'RE looking at this amazing chemical factory that's working non-stop."
Emma: "Right. That's the key insight for YOU here."

**QUALITY CHECKLIST:**
✓ Used "uhm," "you know," "I mean" naturally (8-12 times total)
✓ More fillers for complex ideas, fewer for simple facts
✓ User name mentioned 2-3 times when EXPLAINING (not asking)
✓ Questions have context and curiosity
✓ Answers acknowledge and build
✓ Sounds like real people talking
✓ No robotic listing of facts
✓ Varied sentence lengths
✓ Natural transitions between topics
✓ Shows enthusiasm and genuine interest
✓ Period only - no exclamation marks
✓ Short, simple words throughout`;

  const data = await SecureAPI.callAzureOpenAI(
    [
      { 
        role: 'system', 
        content: `You are Emma and James having a natural conversation about "${title}".

CRITICAL - SOUND LIKE REAL PEOPLE:
- Use "uhm", "you know", "I mean", "actually", "so" naturally (8-12 times TOTAL)
- Can use fillers at START or MIDDLE of sentences
- MORE fillers when explaining complex ideas (3-4 in that section)
- FEWER fillers when stating simple facts (0-1)
- Questions need context: "So what makes this important? Because [reason]."
- Answers acknowledge first: "Yeah, great question." then explain
- Be direct and clear: "Here's what happens..." "So basically..."
- Use 8-12 background reactions: "Yup.", "Right.", "Yeah." (speaker continues after)

PERSONALIZATION:
- Use ${userName ? `"${userName}"` : 'listener name'} 2-3 times MAXIMUM
- MOSTLY speak TO the user: "So ${userName}, when YOU..." (80% of time)
- Use "people/society" ONLY for history, misconceptions, discoveries
- AVOID saying "humans" - sounds clinical and weird
- Makes it feel like a personal 1-on-1 teaching session

OPENING - BE UNPREDICTABLE AND ALIVE:
Pick ONE randomly, NEVER the same pattern twice:

- Drop straight into the topic with genuine excitement: "Ok so ${title} — this is one of those things that once it clicks, you see it everywhere."
- Start mid-thought like the conversation was already happening: "So we were just talking about this before you joined — ${title} is genuinely fascinating."
- Lead with a surprising angle: "Here's the thing about ${title} that most people get completely wrong..."
- Open with a question that makes the listener lean in: "So what actually IS ${title}? Like really, underneath all the textbook stuff?"
- Start with a bold claim: "Honestly, ${title} might be one of the most underrated things to understand."
- Jump in with energy: "Alright, ${title} — we're going deep on this today."
- Use a real-world hook: "So imagine you're trying to explain ${title} to someone who's never heard of it..."

NEVER say:
- "So you're looking into this..."
- "So you want to learn about..."
- "You've chosen..."
- "So you're curious about..."
- "We're here to cover..."
- Any robotic "welcome to" phrasing

TEAMWORK:
- Hosts work as a TEAM - use "we/us/let's" when teaching together
- "Let's explore...", "We're going to show you...", "Let's break this down..."
- Sound like a friendly team, not individual lecturers

NEVER:
- Don't ASK listener questions by name
- Don't use exclamation marks (!) - periods (.) only
- Don't sound robotic or scripted
- Don't cluster fillers together
- Don't use quotation marks in speech - speak naturally
- Don't use "people" for direct teaching (use "you/your" instead)
- Don't say "humans" - sounds creepy (use "people" or "society" instead)
- OK to use "people/society" for history, misconceptions, discoveries

CONVERSATION PATTERNS:
Pattern A (40%): Natural question with context → Enthusiastic answer
Pattern B (30%): Build point → Agree → Expand
Pattern C (20%): Think out loud → Clarify
Pattern D (10%): Surprise → Explain

FOCUS: ${title}
LENGTH: 30-35 exchanges
TONE: Two smart friends teaching the listener
` 
      },
      { role: 'user', content: prompt }
    ],
    {
      temperature: 0.88,
      max_tokens: 1500
    }
  );

  return data.choices[0].message.content;
};

// ============================================
// UPDATE 2: Replace generatePodcastScriptWithTopic function
// ============================================

const generatePodcastScriptWithTopic = async (selectedTopic) => {
  const prompt = `You are Emma and James diving deep into "${selectedTopic}" (part of "${title}") for ${userName}.

🎯 TEACH "${selectedTopic}" - SOUND NATURAL WITH PERSONALIZATION

✅ USE THESE NATURAL SPEECH PATTERNS:

**Thinking Out Loud:**
- "Uhm, so here's what I think..."
- "You know what, let me think about this for a second..."
- "Hmm, that's interesting because..."
- "Wait, hold on, let me explain this better..."
- "Actually, you know what's fascinating here..."

**Friendly Exchanges:**
- "So Emma/James, what do you think about..."
- "That's a really good question, let me break this down..."
- "Yeah, totally, and here's why..."
- "Right, exactly, and building on that..."
- "Oh absolutely, and you know what else..."
- "I mean, think about it this way..."

**Natural Transitions:**
- "Ok, so here's the thing..."
- "Alright, so let's dive into this..."
- "Now, this is where it gets really interesting..."
- "So basically what's happening here is..."
- "And you know what's cool about this..."

**Conversational Fillers (use naturally - 8-12 times total):**
- "Uhm"
- "You know"
- "I mean"
- "Actually"
- "Like" (very sparingly)
- "So"
- "Right"
- "Basically"

**SMART FILLER USAGE:**
- MORE fillers (3-4) when: Explaining complex concepts, thinking through ideas
- FEWER fillers (0-1) when: Stating simple facts, giving direct answers
- Example complex: "So the mechanism is, uhm, really intricate. You know, it involves multiple pathways..."
- Example simple: "The answer is oxygen. Plants release it."

**NATURAL EXAMPLES:**

✅ "Uhm, so here's what I think about ${selectedTopic}..."
✅ "You know what's fascinating? The way this mechanism works is..."
✅ "So basically what's happening here is, uhm, a complete transformation..."
✅ "Think about it, right? This is the key part..."

**OPENING (Natural & Varied with Greetings):**

**Choose ONE of these opening styles:**

**Style A - Warm Greeting (10% of time):**
- Emma: "Hey ${userName}, good morning. So you want to dive deeper into ${selectedTopic}, and we're here for it."
- James: "Morning. Alright, let's explore this together."

OR:

- James: "Good morning ${userName}. So you chose ${selectedTopic}, and we're going to break this down for you."
- Emma: "Yeah, this is really interesting. Let's get into it."

**Style B - Simple Hello (30% of time):**
- Emma: "Hey ${userName}. So you want to explore ${selectedTopic}, and we've got you covered."
- James: "Yeah, let's dive into this."

OR:

- James: "Alright ${userName}, so you've chosen ${selectedTopic}. This is going to be good."
- Emma: "For sure. Let's break this down for you."

**Style C - Direct Welcome (30% of time):**
- Emma: "Hey ${userName}, so let's explore ${selectedTopic} together. This is really interesting stuff."

OR:

- James: "Alright ${userName}, so we're going to break down ${selectedTopic} for you. Here's what makes this fascinating."

**Style D - Jump Right In (30% of time):**
- Emma: "Alright, so let's talk about ${selectedTopic}. We'll show you why this matters."

OR:

- James: "So ${userName}, let's dive into ${selectedTopic}. Here's what we're covering today."

**TEAMWORK LANGUAGE:**
- "Let's explore..."
- "We're going to show you..."
- "We'll walk you through..."
- "Let's break this down..."
- "We've got you covered..."

**Rules:**
- "Good morning" only 10% of time - keeps it fresh
- Openings should be SUBSTANTIAL - full welcoming sentences, not just 2 words
- Greet the USER, not each other
- Hosts work as a TEAM
- Keep opening exchange SHORT (2-4 sentences total)
- Vary the style naturally
- Sound warm and welcoming

**CRITICAL RULES:**

**CRITICAL RULES:**

1. **PERSONALIZE WITH USER'S NAME (2-3 times total)**
   
   ✅ CORRECT - Speaking TO the user directly:
   - "So ${userName}, when YOU look at it this way..."
   - "${userName}, here's what makes this critical FOR YOU..."
   - "And ${userName}, this is where it clicks FOR YOU..."
   
   Use 2-3 times MAX, always speak TO the user with "you/your"

2. **MIX BACKGROUND REACTIONS (8-12 times)**
   
   Speaker continues after short reaction:
   Emma: "So ${userName}, the first phase does X. The second does Y."
   James: "Yup."
   Emma: "And that's why both matter for YOU."
   
   Short reactions: "Right.", "Yup.", "Yeah.", "Exactly.", "True.", "For sure."

3. **SMART GENERALIZATION**
   
   Use "YOU/YOUR" for direct teaching (80% of time):
   - "when YOU see this", "affects YOUR understanding"
   
   Use "PEOPLE/SOCIETY" for context (20% of time):
   - "people used to think...", "scientists discovered...", "many people confuse...", "society has evolved..."
   
   AVOID saying "humans" - sounds clinical and creepy

2. **CONVERSATION FLOW:**
   - Questions have context: "So what makes this so efficient? Because when you look at it..."
   - Answers acknowledge: "Yeah, great question. Ok, so here's what's happening..."
   - Be clear and direct: "Here's how this works..." "So basically..."
   - Build on points: "Right, exactly. And here's what else..."
   - Use background reactions: Speaker continues after "Yup.", "Right.", "Yeah."

4. **CRITICAL AUDIO RULES:**
   - NEVER use exclamation marks (!) - periods (.) ONLY
   - MOSTLY talk TO the user with "you/your" (80% of time)
   - Use "people/society" ONLY for: history, misconceptions, discoveries, cultural patterns
   - AVOID saying "humans" - sounds too clinical and weird
   - ✅ TEAMWORK: Use "we/us/let's" when hosts work together - "let's explore", "we'll show you", "we're covering"
   - ✅ DIRECT: "the oxygen YOU breathe", "when YOU see this", "affects YOUR life"
   - ✅ GENERALIZE: "people used to think...", "scientists discovered...", "many people confuse...", "society evolved..."
   - ❌ WRONG: "the oxygen people breathe" (should be YOU)
   - ❌ CREEPY: "humans need this" (say "people" instead)
   - Short, simple words (avoid complex vocabulary)
   - Each speaker: 2-5 sentences per turn
   - Sound like a friendly TEAM teaching YOU directly
   - Vary sentence length for natural rhythm
   - NO quotation marks in speech - speak naturally

**STRUCTURE:**
- Spontaneous opening (30% mention InnerLoop, 70% dive right in)
- 30-35 exchanges total
- 8-12 background reactions where speaker continues ("Yup.", "Right.", etc.)
- Mix short responses (1-2 sentences) with longer ones (3-5 sentences)
- Vary who asks questions and who explains
- Natural pauses and transitions
- Use "uhm", "you know", "I mean" naturally (8-12 times)
- User name 2-3 times when explaining

**ENGAGEMENT PATTERNS:**

Pattern A (40%): NATURAL QUESTION → ENTHUSIASTIC ANSWER
James: "So Emma, what makes this aspect so critical? Because when you look at it, there's so much depth here."
Emma: "Yeah, that's such a good question. Uhm, so here's what's fascinating..."

Pattern B (30%): BUILD → AGREE → EXPAND
Emma: "The mechanism operates in this specific way. Each component has a distinct role."
James: "Right, exactly. And here's what's cool - the way they interact is..."

Pattern C (20%): DIRECT QUESTION → CLARIFY
James: "Hmm, so when looking at this process, what's actually initiating it?"
Emma: "Ok, good question. Let me break this down..."

Pattern D (10%): SURPRISE → EXPLAIN
Emma: "And here's something that's really fascinating about this..."
James: "Oh, wait, what do you mean?"
Emma: "So basically what happens is..."

**COMPLETE NATURAL EXAMPLE WITH PERSONALIZATION:**

Emma: "Hey ${userName}. So you want to explore ${selectedTopic}, and we've got you covered."
James: "Yeah, let's dive into this."
Emma: "Alright, so let's break this down for you."
James: "So Emma, what's the most critical aspect here? Because when you look at it, there's so much happening."
Emma: "Yeah, that's such a good question. Ok, so ${userName}, look at it this way - the mechanism operates in three distinct phases."
James: "Right."
Emma: "The first phase establishes the foundational structure. Uhm, and this is where everything starts for YOU."
James: "Hmm, ok, so walk me through this. What's actually happening in that first phase?"
Emma: "Right, so in the first phase - and this is the fascinating part - YOU'RE basically seeing the entire system get set up. And, you know, many people don't realize how precise this needs to be."
James: "Yup."
Emma: "I mean, look at it - one small mistake and the whole thing falls apart."
James: "So basically what's happening is a completely coordinated effort?"
Emma: "Yeah, totally. And here's what's cool - each component knows exactly when to activate."
James: "Right."
Emma: "Historically, scientists thought this was random, but now we know it's highly controlled."
James: "So ${userName}, when YOU see this in action, YOU'RE witnessing this incredibly precise dance of molecular interactions."
Emma: "Exactly. That's the key insight for YOU here."

**THE GOLDEN RULE:**
Sound like two smart friends having a genuine conversation about something they find fascinating. Be natural, be curious, be engaged. Let the conversation flow organically. Focus 100% on "${selectedTopic}". Use listener's name 2-3 times to personalize.`;

  const data = await SecureAPI.callAzureOpenAI(
    [
      { 
        role: 'system', 
        content: `You are Emma and James diving deep on "${selectedTopic}".

CRITICAL - SOUND LIKE REAL PEOPLE:
- Use "uhm", "you know", "I mean", "actually", "so" naturally (8-12 times)
- Can use fillers at START or MIDDLE of sentences
- MORE fillers for complex ideas, FEWER for simple facts
- Questions need context and are direct
- Answers acknowledge first, then explain
- Be clear and direct: "Here's what happens..." "So basically..."
- Use 8-12 background reactions: "Yup.", "Right.", "Yeah." (speaker continues after)

PERSONALIZATION:
- Use ${userName ? `"${userName}"` : 'listener name'} 2-3 times MAXIMUM
- MOSTLY speak TO the user: "So ${userName}, when YOU..." (80% of time)
- Use "people/society" ONLY for history, misconceptions, discoveries
- AVOID saying "humans" - sounds clinical and weird
- Makes it a personal 1-on-1 teaching session

OPENING - BE UNPREDICTABLE AND ALIVE:
Pick ONE randomly, NEVER the same pattern:

- Lead with what makes THIS topic specifically interesting: "So ${selectedTopic} — the reason this matters more than people realize is..."
- Start with the payoff: "By the end of this, ${selectedTopic} is going to make a lot more sense than it probably does right now."
- Drop in with energy: "Alright, so ${selectedTopic} — let's actually get into the mechanics of this."
- Hook with a misconception: "So the thing most people get wrong about ${selectedTopic} is..."
- Start conversationally mid-thought: "We were literally just debating the best way to explain ${selectedTopic}..."
- Open with a real-world connection: "So think about the last time ${selectedTopic} actually showed up in something you used or saw..."

NEVER say:
- "So you want to explore..."
- "You've chosen..."
- "We've got you covered..."
- "Let's break this down for you" as an opener
- Any generic welcome phrasing

TEAMWORK:
- Hosts work as a TEAM - use "we/us/let's"
- "Let's explore...", "We'll show you...", "We're covering..."
- Sound like a friendly team teaching together

NEVER:
- Don't ASK listener questions by name
- Don't use exclamation marks (!) - periods (.) only
- Don't sound robotic or scripted
- Don't use quotation marks in speech - speak naturally
- Don't use "people" for direct teaching (use "you/your" instead)
- Don't say "humans" - sounds creepy (use "people" or "society" instead)
- OK to use "people/society" for history, misconceptions, discoveries

CONVERSATION PATTERNS:
Pattern A (40%): Natural question → Enthusiastic answer
Pattern B (30%): Build → Agree → Expand
Pattern C (20%): Think out loud → Clarify
Pattern D (10%): Surprise → Explain

FOCUS: 100% "${selectedTopic}"
LENGTH: 30-35 exchanges
TONE: Two smart friends teaching the listener
` 
      },
      { role: 'user', content: prompt }
    ],
    {
      temperature: 0.88,
      max_tokens: 1500
    }
  );

  return data.choices[0].message.content;
};

// ============================================
// UPDATE 3: Replace generateResumeIntro function
// ============================================

const generateResumeIntro = async () => {
  const prompt = `Emma and James resume teaching "${title}".

✅ SOUND NATURAL - PERSONALIZED RESUME

**Resume naturally:**
- "Alright, so we were explaining..."
- "Ok, so back to what we were talking about..."
- "You know what, let's pick up where we left off..."
- "So we were diving into..."

**Use fillers naturally (3-5 times):**
- "Uhm"
- "You know"
- "I mean"
- "So"
- "Actually"

**Personalization (1 time MAX):**
- "So ${userName}, we were explaining..."
- "${userName}, let's pick up where we left off..."

**Examples:**

Emma: "Okay, so we were explaining the core mechanisms of ${title}. Uhm, the key was how these elements interconnect."
James: "Right."
Emma: "They create feedback loops that, you know, control the outcome."
James: "For sure."
Emma: "I mean, that's the foundation for everything else."
James: "So ${userName}, let's dive deeper into how that actually works."
Emma: "Yeah. You know, that's what really changes your understanding."

OR:

Emma: "Alright, ${userName}, back to ${title}. We covered how the mechanisms interconnect."
James: "And those feedback loops we mentioned?"
Emma: "Yeah."
James: "They're, uhm, critical. So let's explore that deeper."

**RULES:**
- Use ${userName ? `"${userName}"` : 'listener name'} 0-1 times when resuming
- Only when EXPLAINING: "So ${userName}, we were..."
- NEVER asking: "Do you remember, ${userName}?"
- Use fillers 3-5 times ("uhm", "you know", "I mean", "so")
- Keep it SHORT: ~5-6 exchanges total
- NEVER use exclamation marks (!) - periods (.) ONLY
- Sound conversational and natural`;

  try {
    const data = await SecureAPI.callAzureOpenAI(
      [
        { 
          role: 'system', 
          content: `Emma and James resume explaining "${title}".

RESUME NATURALLY:
- "Okay, so we were..." or "Back to..." or just dive in
- No formal "Welcome back"
- Brief and genuine

CRITICAL:
- Use ${userName ? `"${userName}"` : 'listener name'} 0-1 times when explaining
- Use "uhm", "you know", "I mean" naturally (3-5 times)
- Periods only - no exclamation marks
- Sound like real conversation

FOCUS: Resume topic explanation
KEEP SHORT: ~5-6 exchanges for resume intro
` 
        },
        { role: 'user', content: prompt }
      ],
      {
        temperature: 0.85,
        max_tokens: 150
      }
    );

    return data.choices[0].message.content;
  } catch (error) {
    return `Emma: "Okay, so we were explaining the core mechanisms of ${title}. Uhm, the key was understanding how these elements interconnect."
James: "Right."
Emma: "They create feedback loops that, you know, control the outcome."
James: "For sure."
Emma: "I mean, that's the foundation for everything else."
James: "So ${userName}, let's dive deeper into how that works."
Emma: "Yeah."`;
  }
};
// ============================================
// FIX 6: FAST LOADING - UPDATE runPodcast
// ============================================
const runPodcast = async () => {
  try {
    shouldStopRef.current = false;
    setIsPlaying(true);
    setCurrentStatus('Preparing podcast...');
    setTranscript([]);
    setError(null);
    setShowSuggestions(false); // Don't show suggestion cards

    // Generate script and topics in parallel
    const [script, topics] = await Promise.all([
      generatePodcastScript(),
      generateSuggestedTopics()
    ]);

    if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }

    setSuggestedTopics(topics);

    // Play intro music immediately if not played yet
    if (!introMusicPlayedRef.current) {
      setCurrentStatus('Now playing...');
      await playIntroMusic();

      if (shouldStopRef.current) {
        setIsPlaying(false);
        return;
      }
    }

    setCurrentStatus('Now playing...');
    setTranscript([]);

    const lines = script.split('\n').filter(line => line.trim());
    
    for (let i = 0; i < lines.length; i++) {
      if (shouldStopRef.current) break;

      if (isPaused) {
        await new Promise(resolve => {
          const checkInterval = setInterval(() => {
            if (!isPaused || shouldStopRef.current) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
        });
      }

      if (shouldStopRef.current) break;

      const line = lines[i];
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);

      if (emmaMatch) {
        const jamesLine = lines[i + 1];
        const jamesText = jamesLine?.match(/James:\s*(.+)/i)?.[1] || '';
        await parseAndSpeakHosts(`Emma: ${emmaMatch[1]}\nJames: ${jamesText}`);
        i++;
      } else if (jamesMatch && !line.match(/Emma:/i)) {
        await speakChunk(jamesMatch[1].trim(), 'james');
      }

      if (shouldStopRef.current) break;
    }

    if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }
if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }

    // ✅ ADD FAREWELL
    const farewellMessage = userName && userName !== 'Guest' && userName !== 'user'
      ? `That's a wrap for today! See you next time, ${userName}.`
      : `That's a wrap for today! See you next time.`;
    
    // ✅ Speak farewell
    await speakChunk(farewellMessage, 'emma');
    
    // ✅ Wait for audio to finish
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // ✅ Show farewell screen (hide transcript and suggestions)
    setCurrentStatus('farewell');
    setShowSuggestions(false);
    
    // ✅ Modal stays open - user closes manually

  } catch (error) {
    console.error('Podcast error:', error);
    setError(`Podcast error: ${error.message}`);
    alert('Failed to generate podcast. Please try again.');
    setIsPlaying(false);
  }
};
const runPodcastWithTopic = async (selectedTopic) => {
  try {
    shouldStopRef.current = false;
    setIsPlaying(true);
    setCurrentStatus('Preparing podcast...');
    setTranscript([]);
    setError(null);
    setShowSuggestions(false); // Don't show suggestion cards

    // Generate script and topics in parallel
    const [script, topics] = await Promise.all([
      generatePodcastScriptWithTopic(selectedTopic),
      generateSuggestedTopics()
    ]);

    if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }

    setSuggestedTopics(topics);

    // Play intro music immediately if not played yet
    if (!introMusicPlayedRef.current) {
      setCurrentStatus('Now playing...');
      await playIntroMusic();

      if (shouldStopRef.current) {
        setIsPlaying(false);
        return;
      }
    }

    setCurrentStatus('Now playing...');
    setTranscript([]);

    const lines = script.split('\n').filter(line => line.trim());
    
    for (let i = 0; i < lines.length; i++) {
      if (shouldStopRef.current) break;

      if (isPaused) {
        await new Promise(resolve => {
          const checkInterval = setInterval(() => {
            if (!isPaused || shouldStopRef.current) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
        });
      }

      if (shouldStopRef.current) break;

      const line = lines[i];
      const emmaMatch = line.match(/Emma:\s*(.+)/i);
      const jamesMatch = line.match(/James:\s*(.+)/i);

      if (emmaMatch) {
        const jamesLine = lines[i + 1];
        const jamesText = jamesLine?.match(/James:\s*(.+)/i)?.[1] || '';
        await parseAndSpeakHosts(`Emma: ${emmaMatch[1]}\nJames: ${jamesText}`);
        i++;
      } else if (jamesMatch && !line.match(/Emma:/i)) {
        await speakChunk(jamesMatch[1].trim(), 'james');
      }

      if (shouldStopRef.current) break;
    }

    if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }

if (shouldStopRef.current) {
      setIsPlaying(false);
      return;
    }

    // ✅ ADD FAREWELL
    const farewellMessage = userName && userName !== 'Guest' && userName !== 'user'
      ? `That's a wrap for today! See you next time, ${userName}.`
      : `That's a wrap for today! See you next time.`;
    
    // ✅ Speak farewell
    await speakChunk(farewellMessage, 'emma');
    
    // ✅ Wait for audio to finish
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // ✅ Show farewell screen (hide transcript and suggestions)
    setCurrentStatus('farewell');
    setShowSuggestions(false);
    
    // ✅ Modal stays open - user closes manually
  } catch (error) {
    console.error('Podcast error:', error);
    setError(`Podcast error: ${error.message}`);
    alert('Failed to generate podcast. Please try again.');
    setIsPlaying(false);
  }
};
const stopPodcast = () => {
  // ✅ SAVE CURRENT PROGRESS BEFORE STOPPING
  if (cachedScript && currentLineIndex > 0) {
    saveCachedScript(cachedScript, currentLineIndex);
  }
  
  shouldStopRef.current = true;
  stopAllAudio();
  setIsPlaying(false);
  setIsPaused(false);
  setIsLoadingScript(false);
  setTranscript([]);
  // ❌ DON'T clear cache - let it persist for resume
  onClose();
};

// ============================================
// LOAD CACHE ON COMPONENT MOUNT
// ============================================
useEffect(() => {
  loadCachedScript();
}, []);
const togglePlayPause = () => {
  // ✅ iOS UNLOCK - synchronous, before any await
  const unlockAudio = new Audio();
  unlockAudio.play().catch(() => {});

  if (!isPlaying && !isPaused) {
    setShowIntentionModal(true);
  } else if (isPlaying && !isPaused) {
    setIsPaused(true);
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
    }
  } else if (isPaused) {
    setIsPaused(false);
    if (currentAudioRef.current) {
      currentAudioRef.current.play().catch(e => console.log('Resume failed:', e));
    }
  }
};

  useEffect(() => {
    playbackSpeedRef.current = playbackSpeed;
    if (currentAudioRef.current) {
      currentAudioRef.current.playbackRate = playbackSpeed;
    }
  }, [playbackSpeed]);

  useEffect(() => {
    if (transcriptEndRef.current) {
      transcriptEndRef.current.scrollTop = transcriptEndRef.current.scrollHeight;
    }
  }, [transcript]);

  useEffect(() => {
    return () => {
      shouldStopRef.current = true;
      stopAllAudio();
    };
  }, []);


// ============================================
// STEP 2: ADD useMemo BEFORE IntentionModal
// ============================================
const memoizedDeepDiveTopics = useMemo(() => deepDiveTopics, [deepDiveTopics]);

// ============================================
// STEP 3: COMPLETE IntentionModal COMPONENT
// ============================================
const IntentionModal = () => {
  const TOPICS_PER_PAGE = 5;
  const startIdx = intentionScrollIndex * TOPICS_PER_PAGE;
  const endIdx = startIdx + TOPICS_PER_PAGE;
  
  // ✅ USE MEMOIZED TOPICS
  const visibleTopics = memoizedDeepDiveTopics.slice(startIdx, endIdx);
  
  const totalPages = Math.ceil(memoizedDeepDiveTopics.length / TOPICS_PER_PAGE);
  const hasMore = intentionScrollIndex < totalPages - 1;
  const hasPrev = intentionScrollIndex > 0;

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 50,
      animation: 'fadeIn 0.3s ease-out'
    }}>
      {/* Close Button */}
      <button
        onClick={stopPodcast}
        style={{
          position: 'absolute',
          top: '24px',
          right: '24px',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 51,
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      
      {showAllSet ? (
        // "All Set!" Animation
        <div style={{
          textAlign: 'center',
          animation: 'scaleInSmooth 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}>
          <div style={{
            width: '100px',
            height: '100px',
            margin: '0 auto 20px'
          }}>
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="2" fill="none"
                style={{
                  animation: 'drawCircle 0.5s ease-out forwards',
                  strokeDasharray: 251,
                  strokeDashoffset: 251
                }}
              />
              <path d="M 30 50 L 42 62 L 70 35" stroke="white" strokeWidth="3" fill="none"
                strokeLinecap="round" strokeLinejoin="round"
                style={{
                  animation: 'drawCheck 0.4s ease-out 0.4s forwards',
                  strokeDasharray: 80,
                  strokeDashoffset: 80
                }}
              />
            </svg>
          </div>
          <p style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#fff'
          }}>
            All set!
          </p>
        </div>
      ) : (
        // Intention Selection Container
        <div style={{
          background: 'rgba(255, 255, 255, 0.12)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          borderRadius: '48px',
          padding: '40px 32px',
          maxWidth: '480px',
          width: '90%',
          margin: '0 20px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          position: 'relative',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          maxHeight: '85vh',
          overflowY: 'auto',
          animation: 'scaleInSmooth 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}>
          {/* Show spinner while loading */}
{isLoadingTopics ? (
  <>
    {/* Title shimmer */}
    <div style={{
      height: '22px',
      width: '70%',
      margin: '0 auto 10px',
      background: 'linear-gradient(90deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.06) 100%)',
      backgroundSize: '200% auto',
      animation: 'shimmer 1.8s ease-in-out infinite',
      borderRadius: '8px'
    }} />

    {/* Subtitle shimmer */}
    <div style={{
      height: '14px',
      width: '50%',
      margin: '0 auto 28px',
      background: 'linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.04) 100%)',
      backgroundSize: '200% auto',
      animation: 'shimmer 1.8s ease-in-out infinite',
      animationDelay: '0.2s',
      borderRadius: '6px'
    }} />

    {/* 5 fake topic pill skeletons */}
    {[100, 80, 92, 75, 88].map((width, idx) => (
      <div key={idx} style={{
        padding: '16px 20px',
        borderRadius: '32px',
        border: '1px solid rgba(255,255,255,0.1)',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        animation: `fadeInUp 0.4s ease-out ${0.05 * idx}s both`
      }}>
        <div style={{
          height: '16px',
          width: `${width}%`,
          background: 'linear-gradient(90deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.14) 50%, rgba(255,255,255,0.06) 100%)',
          backgroundSize: '200% auto',
          animation: 'shimmer 1.8s ease-in-out infinite',
          animationDelay: `${idx * 0.15}s`,
          borderRadius: '6px'
        }} />
      </div>
    ))}

    {/* Fake Skip + Continue button skeletons */}
    <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
      <div style={{
        flex: 1,
        height: '48px',
        borderRadius: '32px',
        background: 'linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.05) 100%)',
        backgroundSize: '200% auto',
        animation: 'shimmer 1.8s ease-in-out infinite',
        animationDelay: '0.3s',
        border: '1px solid rgba(255,255,255,0.1)'
      }} />
      <div style={{
        flex: 1,
        height: '48px',
        borderRadius: '32px',
        background: 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.18) 50%, rgba(255,255,255,0.08) 100%)',
        backgroundSize: '200% auto',
        animation: 'shimmer 1.8s ease-in-out infinite',
        animationDelay: '0.4s'
      }} />
    </div>
  </>
) : (
            <>
              {/* Title */}
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#ffffff',
                margin: '0 0 8px 0',
                textAlign: 'center',
                animation: 'fadeInDown 0.4s ease-out'
              }}>
                What would you like to dive into?
              </h3>
              
              {/* Subtitle */}
              <p style={{
                fontSize: '13px',
                color: 'rgba(255, 255, 255, 0.7)',
                textAlign: 'center',
                lineHeight: '1.5',
                margin: '0 0 24px 0',
                animation: 'fadeInDown 0.4s ease-out 0.1s both'
              }}>
                Choose a specific aspect to explore
              </p>
              
              {/* Slide Indicator Dots */}
              {totalPages > 1 && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '6px',
                  marginBottom: '16px',
                  animation: 'fadeIn 0.4s ease-out 0.2s both'
                }}>
                  {[...Array(totalPages)].map((_, idx) => (
                    <div
                      key={idx}
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: intentionScrollIndex === idx 
                          ? 'rgba(255, 255, 255, 0.8)' 
                          : 'rgba(255, 255, 255, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  ))}
                </div>
              )}
              
              {/* Options List - USE React.memo COMPONENT */}
<div
  key={`page-${intentionScrollIndex}`}
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
    animation: 'fadeInUp 0.35s ease-out both',
  }}
>
  {visibleTopics.map((topic, idx) => (
                  <IntentionOption
                    key={`${topic.id}-${intentionScrollIndex}`}
                    topic={topic}
                    idx={idx}
                    isCompleted={completedTopics.includes(topic.id)}
                    isSelected={selectedIntention?.id === topic.id}
                    onSelect={handleIntentionSelect}
                  />
                ))}
              </div>
              
              {/* Navigation Buttons */}
              {memoizedDeepDiveTopics.length > TOPICS_PER_PAGE && (hasPrev || hasMore) && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '12px',
                  marginBottom: '20px',
                  animation: 'fadeInUp 0.4s ease-out 0.4s both'
                }}>
                  {hasPrev && (
                    <button
                      onClick={() => setIntentionScrollIndex(prev => prev - 1)}
                      style={{
                        padding: '10px 28px',
                        borderRadius: '28px',
                        background: '#ffffff',
                        border: 'none',
                        color: '#000000',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f0f0f0';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6"></polyline>
                      </svg>
                      Previous
                    </button>
                  )}
                  
                  {hasMore && (
                    <button
                      onClick={() => setIntentionScrollIndex(prev => prev + 1)}
                      style={{
                        padding: '10px 28px',
                        borderRadius: '28px',
                        background: '#ffffff',
                        border: 'none',
                        color: '#000000',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f0f0f0';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      More
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 6 15 12 9 18"></polyline>
                      </svg>
                    </button>
                  )}
                </div>
              )}
              
              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                animation: 'fadeInUp 0.4s ease-out 0.4s both'
              }}>
                <button
                  onClick={handleIntentionSkip}
                  style={{
                    flex: 1,
                    padding: '14px',
                    borderRadius: '32px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: '#ffffff',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                  }}
                >
                  Skip
                </button>
                
                <button
                  onClick={handleIntentionContinue}
                  disabled={!selectedIntention}
                  style={{
                    flex: 1,
                    padding: '14px',
                    borderRadius: '32px',
                    background: selectedIntention ? '#ffffff' : 'rgba(255, 255, 255, 0.3)',
                    border: 'none',
                    color: '#000000',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: selectedIntention ? 'pointer' : 'not-allowed',
                    transition: 'all 0.2s ease',
                    opacity: selectedIntention ? 1 : 0.5
                  }}
                  onMouseEnter={(e) => {
                    if (selectedIntention) {
                      e.currentTarget.style.background = '#f0f0f0';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedIntention) {
                      e.currentTarget.style.background = '#ffffff';
                    }
                  }}
                >
                  Continue
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* Animations */}
<style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; opacity: 0.6; }
          50% { opacity: 1; }
          100% { background-position: 200% 0; opacity: 0.6; }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleInSmooth {
          from { opacity: 0; transform: scale(0.92); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes drawCircle {
          to { stroke-dashoffset: 0; }
        }
        @keyframes drawCheck {
          to { stroke-dashoffset: 0; }
        }
      `}</style>
    </div>
  );
};
// ============================================
  // MAIN RETURN - COMPLETE MODAL STRUCTURE
  // ============================================
return (
    <div 
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          stopPodcast();
        }
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-end',
        animation: 'fadeIn 0.3s ease',
        cursor: 'pointer'
      }}
    >
      <div style={{
        width: '100%',
        height: '90vh',
        backgroundColor: '#1a1a1a',
        borderRadius: '28px 28px 0 0',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderTop: '2px solid #8d8d8d',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'default'
      }}>
        {/* Background Gradient Layer 1 */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, #326077ff 0%, #021423ff 100%)',
          opacity: 0.25,
          zIndex: 0
        }} />

        {/* Background Gradient Layer 2 - Blurred */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, #326077ff 0%, #021423ff 100%)',
          filter: 'blur(100px) saturate(1.2)',
          transform: 'scale(1.1)',
          zIndex: 0,
          opacity: 0.4
        }} />

        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4))',
          zIndex: 1
        }} />

        {/* Header */}
        <div style={{
          padding: '24px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative',
          zIndex: 2,
          animation: 'fadeInDown 0.4s ease-out'
        }}>
          <div>
            <h2 style={{
              fontSize: '18px',
              fontWeight: '700',
              color: '#fff',
              margin: 0,
              marginBottom: '4px',
              textAlign: 'left',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '280px'
            }}>
              {title}
            </h2>
            <p style={{
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: 0,
              textTransform: 'capitalize',
              textAlign:'left'
            }}>
              {type === 'quiz' ? 'Quiz' : 'Flashcard'} Deep Dive Podcast
            </p>
          </div>

          <button
            onClick={stopPodcast}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
              flexShrink: 0
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

{/* Main Content Area */}
        <div
          ref={transcriptEndRef}
          style={{
            flex: 1,
            overflowY: 'auto',
            position: 'relative',
            zIndex: 2,
            scrollBehavior: 'smooth'
          }}
        >
          {/* CASE 0: FAREWELL STATE - Final goodbye message */}
          {currentStatus === 'farewell' ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '400px',
              padding: '24px',
              animation: 'fadeInUp 0.6s ease-out'
            }}>
              {/* Checkmark icon */}
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'rgba(167, 201, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                animation: 'scaleIn 0.5s ease-out'
              }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#a7c9ff" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>

              {/* Farewell message */}
              <h3 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#fff',
                marginBottom: '12px',
                textAlign: 'center',
                animation: 'fadeInUp 0.6s ease-out 0.2s both'
              }}>
                That's a wrap!
              </h3>

              <p style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.8)',
                textAlign: 'center',
                marginBottom: '32px',
                animation: 'fadeInUp 0.6s ease-out 0.3s both'
              }}>
                {userName && userName !== 'Guest' && userName !== 'user'
                  ? `See you next time, ${userName}!`
                  : 'See you next time!'}
              </p>

              {/* ✅ Done button */}
              <button
                onClick={stopPodcast}
                style={{
                  padding: '14px 48px',
                  borderRadius: '32px',
                  background: '#ffffff',
                  border: 'none',
                  color: '#000000',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  animation: 'fadeInUp 0.6s ease-out 0.4s both'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f0f0f0';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                Done
              </button>
            </div>
          )
          
          // CASE 1: LOADING STATE - Show shimmer during intro music
          : isLoadingScript ? (
            <div style={{ 
              padding: '24px', 
              paddingBottom: '160px',
              animation: 'fadeInUp 0.5s ease-out'
            }}>
              {/* Loading Header - LEFT ALIGNED */}
              <div style={{
                textAlign: 'left',
                marginBottom: '40px'
              }}>
                <div style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#fff',
                  marginBottom: '8px',
                  background: 'linear-gradient(90deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0.4) 100%)',
                  backgroundSize: '200% auto',
                  animation: 'shimmerText 2.5s ease-in-out infinite',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  display: 'inline-block'
                }}>
                  Preparing your deep dive...
                </div>
              </div>
              
              {/* Shimmer Lines - LEFT ALIGNED */}
              <div style={{
                width: '100%',
                maxWidth: '600px'
              }}>
                {/* First host block */}
                <div style={{
                  marginBottom: '28px',
                  animation: 'fadeInUp 0.5s ease-out 0.1s both'
                }}>
                  {/* Host label shimmer */}
                  <div style={{
                    width: '60px',
                    height: '12px',
                    background: 'linear-gradient(90deg, rgba(167,201,255,0.3) 0%, rgba(167,201,255,0.6) 50%, rgba(167,201,255,0.3) 100%)',
                    backgroundSize: '200% auto',
                    animation: 'shimmer 2s ease-in-out infinite',
                    borderRadius: '4px',
                    marginBottom: '10px'
                  }}/>
                  
                  {/* Text lines */}
                  {[85, 92, 78].map((width, idx) => (
                    <div
                      key={idx}
                      style={{
                        height: '20px',
                        width: `${width}%`,
                        background: 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.08) 100%)',
                        backgroundSize: '200% auto',
                        animation: 'shimmer 2s ease-in-out infinite',
                        borderRadius: '6px',
                        marginBottom: '12px',
                        animationDelay: `${idx * 0.2}s`
                      }}
                    />
                  ))}
                </div>
                
                {/* Second host block */}
                <div style={{
                  animation: 'fadeInUp 0.5s ease-out 0.2s both'
                }}>
                  {/* Host label shimmer */}
                  <div style={{
                    width: '70px',
                    height: '12px',
                    background: 'linear-gradient(90deg, rgba(167,201,255,0.3) 0%, rgba(167,201,255,0.6) 50%, rgba(167,201,255,0.3) 100%)',
                    backgroundSize: '200% auto',
                    animation: 'shimmer 2s ease-in-out infinite',
                    borderRadius: '4px',
                    marginBottom: '10px',
                    animationDelay: '0.6s'
                  }}/>
                  
                  {/* Text lines */}
                  {[90, 80, 88].map((width, idx) => (
                    <div
                      key={`second-${idx}`}
                      style={{
                        height: '20px',
                        width: `${width}%`,
                        background: 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.08) 100%)',
                        backgroundSize: '200% auto',
                        animation: 'shimmer 2s ease-in-out infinite',
                        borderRadius: '6px',
                        marginBottom: '12px',
                        animationDelay: `${(idx + 3) * 0.2}s`
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          ) 
          // CASE 2: PLAYING STATE - Show transcript during playback
          : transcript.length > 0 ? (
            <div style={{ padding: '24px', paddingBottom: '160px' }}>
              {transcript.slice(-2).map((item, idx) => {
                const isActive = idx === transcript.slice(-2).length - 1;
                const isPast = idx < transcript.slice(-2).length - 1;
                const isSystem = item.voice === 'system';
                
                return (
                  <div
                    key={item.timestamp}
                    style={{
                      marginBottom: '24px',
                      textAlign: 'left',
                      opacity: isPast ? 0.5 : 1,
                      transition: 'all 0.3s ease',
                      animation: 'fadeInUp 0.5s ease'
                    }}
                  >
{/* Host Name Label */}
                    {!isSystem && (
                      <div style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: isActive ? '#a7c9ffff' : '#9ca3af',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        marginBottom: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        {/* ✅ GLOWING DOT */}
                        <div style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          background: isActive ? '#a7c9ffff' : '#9ca3af',
                          boxShadow: isActive ? '0 0 8px #a7c9ffff, 0 0 12px #a7c9ffff' : 'none',
                          animation: isActive ? 'pulseGlow 2s ease-in-out infinite' : 'none'
                        }} />
                        <span>{item.voice === 'emma' ? 'Emma' : 'James'}</span>
                      </div>
                    )}
                    
                    {/* Transcript Text */}
                    <div style={{
                      fontSize: isActive ? '18px' : '16px',
                      color: isSystem ? '#ffffff6e' : (isActive ? '#ffffff' : '#80899aff'),
                      lineHeight: '1.6',
                      fontWeight: isActive ? '600' : '400',
                      transition: 'all 0.3s ease',
                      fontStyle: isSystem ? 'italic' : 'normal'
                    }}>
                      {item.text}
                    </div>
                  </div>
                );
              })}
            </div>
          ) 
          
          // CASE 3: INITIAL STATE - Before playing
          : !showSuggestions ? (
            <div style={{ 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '400px',
              padding: '24px',
              animation: 'fadeInUp 0.6s ease-out 0.2s both'
            }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#fff',
                marginBottom: '8px'
              }}>
                Audio Deep Dive
              </h3>

              <p style={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                margin: '0 auto 24px',
                maxWidth: '300px',
                lineHeight: '1.6',
                textAlign: 'center',
              }}>
                Listen to audio explanation with suggested topics for deeper learning!
              </p>
            </div>
          ) 
          
          // CASE 4: COMPLETION STATE - Show suggestions after podcast ends
          : (
            <div style={{ textAlign: 'center', padding: '24px', paddingBottom: '160px', animation: 'fadeInUp 0.6s ease-out 0.2s both' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#fff',
                marginBottom: '12px'
              }}>
                Dive Deeper
              </h3>
              <p style={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.7)',
                marginBottom: '24px'
              }}>
                Explore focused topics to master this content
              </p>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                maxWidth: '400px',
                margin: '0 auto'
              }}>
                {suggestedTopics.map((topic) => (
                  <div 
                    key={topic.id} 
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '12px',
                      padding: '16px',
                      textAlign: 'left',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      animation: 'fadeInUp 0.4s ease',
                      animationDelay: `${topic.id * 100}ms`
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                      e.currentTarget.style.transform = 'translateX(4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                  >
                    <div style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#fff'
                    }}>
                      {topic.title}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: 'rgba(255, 255, 255, 0.6)',
                      marginTop: '4px'
                    }}>
                      {topic.duration}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

{/* Control Panel (Always visible at bottom) */}
<div style={{
  background: 'rgba(244, 251, 255, 0.15)',
  backdropFilter: 'blur(10px)',
  padding: '16px 20px 24px',
  borderTop: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '42px 42px 0 0',
  position: 'relative',
  zIndex: 30,
  animation: 'fadeInUp 0.4s ease-out 0.1s both'
}}>
  <div style={{
    background: '#ffffff',
    borderRadius: '32px',
    padding: '8px 20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px'
  }}>
    {/* Playback Speed Button */}
    <button
      onClick={() => {
        const speeds = [1.0, 1.15, 1.25, 1.5];
        const idx = speeds.indexOf(playbackSpeed);
        setPlaybackSpeed(speeds[(idx + 1) % speeds.length]);
      }}
      style={{
        padding: '12px 16px',
        borderRadius: '20px',
        background: '#f3f4f6',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        color: '#000',
        transition: 'all 0.2s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#e5e7eb';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#f3f4f6';
      }}
      title="Change playback speed"
    >
      {playbackSpeed}x
    </button>

    {/* Rewind 10s Button */}
    <button
      onClick={handleRewind}
      disabled={!isPlaying || isPaused}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: (!isPlaying || isPaused) ? '#e5e7eb' : '#f3f4f6',
        border: 'none',
        cursor: (!isPlaying || isPaused) ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: (!isPlaying || isPaused) ? 0.4 : 1,
        transition: 'all 0.2s',
        color: '#000'
      }}
      onMouseEnter={(e) => {
        if (isPlaying && !isPaused) {
          e.currentTarget.style.background = '#e5e7eb';
        }
      }}
      onMouseLeave={(e) => {
        if (isPlaying && !isPaused) {
          e.currentTarget.style.background = '#f3f4f6';
        }
      }}
      title="Rewind 10 seconds"
    >
          <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
            style={{ transform: "scaleX(-1)" }}>
            <path d="M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z" fill="#000" fillRule="evenodd" clipRule="evenodd"/>
          </svg>
              </button>

    {/* Play/Pause Button */}
    <button
      onClick={togglePlayPause}
      style={{
        width: '58px',
        height: '58px',
        borderRadius: '50%',
        background: '#000000',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#1f2937';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#000000';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      {isPlaying && !isPaused ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
          <rect x="6" y="5" width="4" height="14" rx="1"/>
          <rect x="14" y="5" width="4" height="14" rx="1"/>
        </svg>
      ) : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
          <path d="M8 5v14l11-7z"/>
        </svg>
      )}
    </button>

    {/* Fast Forward 30s Button */}
    <button
      onClick={handleFastForward}
      disabled={!isPlaying || isPaused}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: (!isPlaying || isPaused) ? '#e5e7eb' : '#f3f4f6',
        border: 'none',
        cursor: (!isPlaying || isPaused) ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: (!isPlaying || isPaused) ? 0.4 : 1,
        transition: 'all 0.2s',
        color: '#000'
      }}
      onMouseEnter={(e) => {
        if (isPlaying && !isPaused) {
          e.currentTarget.style.background = '#e5e7eb';
        }
      }}
      onMouseLeave={(e) => {
        if (isPlaying && !isPaused) {
          e.currentTarget.style.background = '#f3f4f6';
        }
      }}
      title="Fast forward 30 seconds"
    >
          <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z" fill="#000" fillRule="evenodd" clipRule="evenodd"/>
          </svg>
        </button>
  </div>
</div>

        {/* INTENTION MODAL - FULL OVERLAY ON TOP OF EVERYTHING */}
        {showIntentionModal && <IntentionModal />}
      </div>

      {/* Animations CSS */}
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            background-position: 200% 0;
            opacity: 0.6;
          }
        }
             @keyframes pulseGlow {
          0%, 100% {
            opacity: 1;
            box-shadow: 0 0 8px #a7c9ffff, 0 0 12px #a7c9ffff;
          }
          50% {
            opacity: 0.7;
            box-shadow: 0 0 12px #a7c9ffff, 0 0 20px #a7c9ffff, 0 0 24px #a7c9ffff;
          }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
        @keyframes shimmerText {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(100px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </div>
  );
};
  
const safeStartRecognition = (recognitionRef) => {
  try {
    if (!recognitionRef?.current) return;
    
    // ✅ SET FLAG BEFORE STARTING
    isRecognitionActiveRef.current = true;
    
    if (recognitionRef.current.startContinuousRecognitionAsync) {
      recognitionRef.current.startContinuousRecognitionAsync(
        () => console.log('✅ Azure started'),
        (err) => {
          console.log(`Start error: ${err}`);
          isRecognitionActiveRef.current = false; // ✅ Clear flag on error
        }
      );
    } else if (recognitionRef.current.start) {
      recognitionRef.current.start();
      console.log('✅ Web Speech started');
    }
  } catch (e) {
    console.log(`Start error: ${e.message}`);
    isRecognitionActiveRef.current = false; // ✅ Clear flag on error
  }
};

  useEffect(() => {
    if (!autoStartContent) return;
    
    console.log('📚 Auto-loading content from chat:', autoStartContent);
    
    if (autoStartContent.type === 'quiz') {
      // Load quiz data
      const quizData = {
        id: autoStartContent.id || `quiz_${Date.now()}`,
        title: autoStartContent.title,
        description: autoStartContent.description,
        difficulty: autoStartContent.difficulty,
        questions: autoStartContent.questions,
        isCustom: true
      };
      
      // Add to quiz sets if not already there
      setQuizSets(prev => {
        const exists = prev.some(q => q.id === quizData.id);
        return exists ? prev : [quizData, ...prev];
      });
      
      // Auto-start the quiz
      handleStartQuiz(quizData);
      
    } else if (autoStartContent.type === 'flashcard') {
      // Load flashcard data
      const flashcardData = {
        id: autoStartContent.id || `flashcards_${Date.now()}`,
        title: autoStartContent.title,
        description: autoStartContent.description,
        difficulty: autoStartContent.difficulty,
        flashcards: autoStartContent.flashcards,
        isCustom: true
      };
      
      // Add to flashcard sets if not already there
      setFlashcardSets(prev => {
        const exists = prev.some(f => f.id === flashcardData.id);
        return exists ? prev : [flashcardData, ...prev];
      });
      
      // Auto-start the flashcards
      handleStartFlashcards(flashcardData);
    }
    
    // Clear the request
    if (onContentStarted) {
      onContentStarted();
    }
  }, [autoStartContent, onContentStarted]);
  
useEffect(() => {
  const initService = async () => {
    try {
      // Import your Firestore service
      const { default: FirestorePersistentStorageService } = await import('./services/FirestorePersistentStorageService');
      
      const service = new FirestorePersistentStorageService();
      await service.initialize();
      
      setFirestoreService(service);
      console.log('✅ Firestore service initialized');
    } catch (error) {
      console.error('❌ Failed to initialize Firestore service:', error);
    }
  };

  initService();
}, []);
useEffect(() => {
  const initService = async () => {
    try {
      const { default: FirestorePersistentStorageService } = await import('./services/FirestorePersistentStorageService');
      
      const service = new FirestorePersistentStorageService();
      await service.initialize();
      
      setFirestoreService(service);
      console.log('✅ Firestore service initialized for StudyHub');
    } catch (error) {
      console.error('❌ Failed to initialize Firestore service:', error);
    }
  };

  initService();
}, []);
// ✅ LOAD USERNAME FROM FIRESTORE USING FIREBASE AUTH
useEffect(() => {
  const loadUserName = async () => {
    if (!firestoreService?.isReady()) {
      console.log('⏳ Firestore service not ready yet');
      return;
    }

    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.log('❌ No user authenticated');
      setUserName('Guest'); // ✅ Show "Guest" when not logged in
      return;
    }

    console.log('🔥 Loading username for:', currentUser.email);

    try {
      const settings = await firestoreService.getUserSettings();
      
      // ✅ PRIORITY: Use saved userName from Firestore first
      if (settings.userName) {
        setUserName(settings.userName);
        console.log('✅ Username loaded from Firestore:', settings.userName);
      } else {
        // ✅ If no saved name, show "Guest" instead of email
        setUserName('Guest');
        console.log('⚠️ No username in Firestore, showing Guest');
      }
    } catch (error) {
      console.error('❌ Failed to load username:', error);
      setUserName('Guest'); // ✅ Fallback to Guest
    }
  };

  loadUserName();
}, [firestoreService]);


// ✅ OPTIONAL: Also listen to auth changes separately
useEffect(() => {
  const auth = getAuth();
  
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user && firestoreService?.isReady()) {
      console.log('🔄 Auth state changed, reloading username');
      
      try {
        const settings = await firestoreService.getUserSettings();
        if (settings.userName) {
          setUserName(settings.userName);
        }
      } catch (error) {
        console.error('Failed to reload username:', error);
      }
    } else if (!user) {
      setUserName(null);
    }
  });

  return () => unsubscribe();
}, [firestoreService]);
// Reset create menu when changing tabs
useEffect(() => {
  setShowCreateMenu(false);
  setCreateType(null);
  setCreatePromptText('');
  setSelectedDifficulty(null);
  setUploadedFile(null);
  setShowDifficultyDropdown(false);
  setIsGenerating(false);
}, [activeTab]);

// Call this in a useEffect at the start of your component
useEffect(() => {
  loadPDFJS();
}, []);
const CongratulationsModal = ({ type, onClose }) => {
  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={false}
        numberOfPieces={200}
        gravity={0.3}
      />
      
      <div className="modal-overlay" style={{ zIndex: 3500 }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '24px',
          padding: '32px 24px',
          maxWidth: '340px',
          width: '90%',
          margin: 'auto',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          animation: 'fadeIn 0.3s ease-out',
          textAlign: 'center'
        }}>
          {/* Sparkle Icon */}
          <div style={{
            width: '56px',
            height: '56px',
            background: 'linear-gradient(135deg, #fef3c7 0%, #ffde5bff 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            animation: 'bounce 1s ease-in-out'
          }}>
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#f59e0b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5.464V3.099m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C19 17.4 19 18 18.462 18H5.538C5 18 5 17.4 5 16.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 12 5.464ZM6 5 5 4M4 9H3m15-4 1-1m1 5h1M8.54 18a3.48 3.48 0 0 0 6.92 0H8.54Z"/>
</svg>
          </div>

          {/* Title */}
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '8px'
          }}>
            Great work!
          </h3>

          {/* Message */}
          <p style={{
            fontSize: '13px',
            color: '#6b7280',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}>
You created your first {type === 'quiz' ? 'quiz' : 'flashcard set'}! Keep going and build your study library.
          </p>

{/* Close Button */}
<button
  onClick={onClose}
  style={{
    width: '40%',        // smaller width
    padding: '10px',
    background: '#272727',
    border: 'none',
    borderRadius: '20px',
    color: 'white',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    margin: '0 auto',    // centers the button
    display: 'block'
  }}
  onMouseEnter={(e) => e.currentTarget.style.background = '#3f3f3f'}
  onMouseLeave={(e) => e.currentTarget.style.background = '#272727'}
>
  Close
</button>

        </div>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </>
  );
};
const DeleteConfirmModal = ({ type, itemTitle, onConfirm, onCancel }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onConfirm();
    setIsDeleting(false);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 3500 }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '24px',
        maxWidth: '340px',
        width: '90%',
        margin: 'auto',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
        border: '1px solid #e5e7eb',
        animation: 'fadeIn 0.3s ease-out'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '16px',
          textAlign:'left'
        }}>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '15px',
            textAlign:'left'
          }}>
            Delete {type === 'quiz' ? 'Quiz' : 'Flashcard Set'}?
          </h3>
          
          <p style={{
            fontSize: '13px',
            color: '#6b7280',
            lineHeight: '1.6',
            marginBottom: '12px',
            textAlign:'left'
          }}>
            Are you sure you want to delete <strong style={{ color: '#1f2937' }}>"{itemTitle}"</strong>? 
            This action cannot be undone.
          </p>
        </div>

        {/* Actions */}
        <div style={{
          display: 'flex',
          gap: '8px'
        }}>
          <button
            onClick={onCancel}
            disabled={isDeleting}
            style={{
              flex: 1,
              padding: '10px',
              background: '#f3f4f6',
              border: '1px solid #e5e7eb',
              borderRadius: '20px',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              fontSize: '13px',
              fontWeight: '500',
              color: '#374151',
              opacity: isDeleting ? 0.5 : 1,
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => !isDeleting && (e.currentTarget.style.background = '#e5e7eb')}
            onMouseLeave={(e) => !isDeleting && (e.currentTarget.style.background = '#f3f4f6')}
          >
            Cancel
          </button>

          <button
            onClick={handleDelete}
            disabled={isDeleting}
            style={{
              flex: 1,
              padding: '10px',
              background: isDeleting ? '#9ca3af' : '#131313ff',
              border: 'none',
              borderRadius: '20px',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              transition: 'all 0.2s'
            }}
          >
            {isDeleting ? (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25"/>
                  <path d="M12 2 A10 10 0 0 1 22 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                  </path>
                </svg>
                Deleting...
              </>
            ) : (
              <>
                <Trash2 size={14} />
                Delete
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};


const [quizSets, setQuizSets] = useState([]);
const [studyStats, setStudyStats] = useState({
  quizHistory: [],
  flashcardSessions: [],
  totalQuizzes: 0,
  totalFlashcards: 0
});
// ✅ COMPLETE AND FIXED loadUserStudyData FUNCTION
// Place this in your StudyHub component's useEffect section

// loadUserStudyData useEffect to include refreshStats:
useEffect(() => {
  const loadUserStudyData = async () => {
    if (!firestoreService?.isReady()) {
      console.log('⏳ Firestore service not ready yet');
      return;
    }

    try {
      setIsLoadingContent(true);
      console.log('📚 Loading user study data from Firestore...');
      
      let quizHistory = [];
      try {
        quizHistory = await firestoreService.getQuizHistory(50);
        console.log(`✅ Loaded ${quizHistory.length} quiz attempts`);
      } catch (error) {
        console.error('❌ Failed to load quiz history:', error);
        quizHistory = [];
      }

      let flashcardHistory = [];
      try {
        flashcardHistory = await firestoreService.getFlashcardHistory(50);
        console.log(`✅ Loaded ${flashcardHistory.length} flashcard sessions`);
      } catch (error) {
        console.error('❌ Failed to load flashcard history:', error);
        flashcardHistory = [];
      }

      const transformedQuizHistory = quizHistory.map(q => {
        const completedAt = q.completedAt;
        let dateObj = completedAt;
        if (completedAt && typeof completedAt.toDate === 'function') {
          dateObj = completedAt.toDate();
        } else if (typeof completedAt === 'string') {
          dateObj = new Date(completedAt);
        } else if (!dateObj) {
          dateObj = new Date();
        }

        return {
          date: dateObj,
          score: q.percentage || q.score || 0,
          difficulty: q.quizDifficulty || q.difficulty || 'medium',
          topic: q.quizTitle || q.topic || 'Unknown',
          timeSpent: q.timeSpent || 0,
          questionsTotal: q.totalQuestions || 0,
          questionsCorrect: q.correctAnswers || 0,
          quizId: q.quizId || ''
        };
      });

      const transformedFlashcardHistory = flashcardHistory.map(s => {
        const completedAt = s.completedAt;
        let dateObj = completedAt;
        if (completedAt && typeof completedAt.toDate === 'function') {
          dateObj = completedAt.toDate();
        } else if (typeof completedAt === 'string') {
          dateObj = new Date(completedAt);
        } else if (!dateObj) {
          dateObj = new Date();
        }

        return {
          date: dateObj,
          cardsStudied: s.cardsStudied || 0,
          timeSpent: s.timeSpent || 0,
          setId: s.setId || '',
          setTitle: s.setTitle || 'Unknown',
          setDifficulty: s.setDifficulty || 'medium'
        };
      });

      const totalCardsStudied = transformedFlashcardHistory.reduce(
        (sum, s) => sum + (s.cardsStudied || 0),
        0
      );

      const stats = {
        quizHistory: transformedQuizHistory,
        flashcardSessions: transformedFlashcardHistory,
        totalQuizzes: transformedQuizHistory.length,
        totalFlashcards: totalCardsStudied
      };

      console.log('✅ Calculated stats:', {
        totalQuizzes: stats.totalQuizzes,
        totalFlashcards: stats.totalFlashcards,
        quizHistoryLength: stats.quizHistory.length,
        flashcardSessionsLength: stats.flashcardSessions.length
      });

      setStudyStats(stats);

      let generatedQuizzes = [];
      try {
        generatedQuizzes = await firestoreService.getGeneratedQuizzes();
        console.log(`✅ Loaded ${generatedQuizzes.length} generated quizzes`);
      } catch (error) {
        console.error('❌ Failed to load generated quizzes:', error);
        generatedQuizzes = [];
      }

      let generatedFlashcards = [];
      try {
        generatedFlashcards = await firestoreService.getGeneratedFlashcards();
        console.log(`✅ Loaded ${generatedFlashcards.length} generated flashcard sets`);
      } catch (error) {
        console.error('❌ Failed to load generated flashcards:', error);
        generatedFlashcards = [];
      }

      setQuizSets(generatedQuizzes);
      setFlashcardSets(generatedFlashcards);

      console.log('✅✅✅ User study data FULLY LOADED ✅✅✅');

    } catch (error) {
      console.error('❌ CRITICAL: Failed to load study data:', error);
      setStudyStats({
        quizHistory: [],
        flashcardSessions: [],
        totalQuizzes: 0,
        totalFlashcards: 0
      });
      
    } finally {
      setIsLoadingContent(false);
    }
  };

  loadUserStudyData();
}, [firestoreService, refreshStats]);  // ✅ ADD refreshStats HERE

const loadUserCustomQuizzes = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const customQuizzes = userDoc.data().customQuizzes || [];
      return customQuizzes.map(quiz => ({
        ...quiz,
        icon: getIconComponent(quiz.iconType || 'lightbulb', 16)
      }));
    }
    return [];
  } catch (error) {
    console.error('Failed to load custom quizzes:', error);
    return [];
  }
};

const loadUserCustomFlashcards = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const customFlashcards = userDoc.data().customFlashcards || [];
      return customFlashcards.map(set => ({
        ...set,
        icon: getIconComponent(set.iconType || 'book', 22)
      }));
    }
    return [];
  } catch (error) {
    console.error('Failed to load custom flashcards:', error);
    return [];
  }
};


useEffect(() => {
  if (createType && (selectedDifficulty || uploadedFile)) {
    // Multiple re-renders to ensure refs are ready
    const timers = [
      setTimeout(() => setSvgKey(prev => prev + 1), 10),
      setTimeout(() => setSvgKey(prev => prev + 1), 50),
      setTimeout(() => setSvgKey(prev => prev + 1), 100)
    ];
    
    return () => timers.forEach(t => clearTimeout(t));
  }
}, [createType, selectedDifficulty, uploadedFile]);
const [showCompletion, setShowCompletion] = useState(false);

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Replace your existing getRandomModalGradient function with this:
let lastModalIndex = null;

const getRandomModalGradient = (id) => {
  const gradients = [
    "linear-gradient(135deg, #ffffff 0%, #87c3ffff 100%)",         // white → sky blue
    "linear-gradient(135deg, #ffffff 0%, #44e5a5ff 100%)",         // white → mint green
    "linear-gradient(135deg, #ffffff 0%, #b35ceeff 100%)",         // white → soft lavender
    "linear-gradient(135deg, #ffffff 0%, #f8688cff 100%)",         // white → blush pink
    "linear-gradient(135deg, #ffffff 0%, #f4d24aff 100%)",         // white → pale yellow
    "linear-gradient(135deg, #ffffff 0%, #f78d50ff 100%)",         // white → peach
    "linear-gradient(135deg, #ffffff 0%, #48b0f1ff 100%)",         // white → baby blue
    "linear-gradient(135deg, #ffffff 0%, #4aec90ff 100%)",         // white → light sage
    "linear-gradient(135deg, #f0f8ff 0%, #4e9bedff 50%, #ffffff 100%)", // alice blue blend
    "linear-gradient(135deg, #ffffff 0%, #4cdef1ff 100%)",         // white → ice cyan
    "linear-gradient(135deg, #ffffff 0%, #f85088ff 100%)",         // white → rose tint
    "linear-gradient(135deg, #f8f9ff 0%, #4d82f7ff 100%)",         // near-white → periwinkle
  ];

  const hash = String(id).split("").reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0);
    return a & a;
  }, 0);

  let index = Math.abs(hash) % gradients.length;

  if (index === lastModalIndex) {
    index = (index + 1) % gradients.length;
  }

  lastModalIndex = index;

  return {
    background: gradients[index],
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
  };
};
const handleStartQuiz = (quiz) => {
  // ✅ CRITICAL: Remove conflicting 'type' field and normalize structure
  const { type, quiz: quizField, ...rest } = quiz; // Remove 'type' and 'quiz' fields
  
  const normalizedQuiz = {
    ...rest,
    questions: quiz.questions || quiz.quiz || quizField || [],  // ✅ Handle all variants
    title: quiz.title || 'Quiz',
    description: quiz.description || '',
    difficulty: quiz.difficulty || 'medium'
  };
  
  console.log('🎯 Starting quiz with data:', normalizedQuiz);
  console.log('📊 Questions count:', normalizedQuiz.questions.length);
  
  // ✅ Validate before starting
  if (!normalizedQuiz.questions || normalizedQuiz.questions.length === 0) {
    alert('This quiz has no questions. Please try creating it again.');
    return;
  }
  
  setPendingContent(normalizedQuiz);
  setPendingType('quiz');
  
  if (dontAskAgain) {
    setShuffleEnabled(defaultShufflePreference);
    setActiveModalGradient(getRandomModalGradient(normalizedQuiz.id + Date.now()));
    setActiveQuiz(normalizedQuiz);
  } else {
    setShowShuffleModal(true);
  }
};
const handleStartFlashcards = (set) => {
  // ✅ CRITICAL: Remove conflicting fields and normalize structure
  const { type, cards, ...rest } = set; // Remove conflicting fields
  
  const normalizedSet = {
    ...rest,
    flashcards: set.flashcards || set.cards || cards || [],  // ✅ Handle all variants
    title: set.title || 'Flashcard Set',
    description: set.description || '',
    difficulty: set.difficulty || 'medium'
  };
  
  console.log('🎯 Starting flashcards with data:', normalizedSet);
  console.log('📊 Flashcards count:', normalizedSet.flashcards.length);
  
  // ✅ Validate before starting
  if (!normalizedSet.flashcards || normalizedSet.flashcards.length === 0) {
    alert('This flashcard set has no cards. Please try creating it again.');
    return;
  }
  
  setPendingContent(normalizedSet);
  setPendingType('flashcard');
  
  if (dontAskAgain) {
    setShuffleEnabled(defaultShufflePreference);
    setActiveModalGradient(getRandomModalGradient(normalizedSet.id + Date.now()));
    setActiveFlashcards(normalizedSet);
  } else {
    setShowShuffleModal(true);
  }
};

const handleStartWithShuffle = () => {
  setShowShuffleModal(false);
  
  // ✅ Validate before starting
  if (!pendingContent) {
    console.error('❌ No pending content to start');
    return;
  }
  
  if (pendingType === 'quiz') {
    // ✅ Double-check questions exist
    if (!pendingContent.questions || pendingContent.questions.length === 0) {
      alert('This quiz has no questions.');
      setPendingContent(null);
      setPendingType(null);
      return;
    }
    
    setActiveModalGradient(getRandomModalGradient(pendingContent.id + Date.now()));
    setActiveQuiz(pendingContent);
  } else {
    // ✅ Double-check flashcards exist
    if (!pendingContent.flashcards || pendingContent.flashcards.length === 0) {
      alert('This flashcard set has no cards.');
      setPendingContent(null);
      setPendingType(null);
      return;
    }
    
    setActiveModalGradient(getRandomModalGradient(pendingContent.id + Date.now()));
    setActiveFlashcards(pendingContent);
  }
  
  // Reset
  setPendingContent(null);
  setPendingType(null);
};

const ShuffleModal = ({ onClose, onStart, type }) => {
  const [localDontAsk, setLocalDontAsk] = useState(false);

  const handleStart = () => {
    if (localDontAsk) {
      localStorage.setItem('studyhub_dont_ask_shuffle', 'true');
      localStorage.setItem('studyhub_shuffle_preference', shuffleEnabled);
      setDontAskAgain(true);
      setDefaultShufflePreference(shuffleEnabled);
    }
    onStart();
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 3000 }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '24px',
        maxWidth: '340px',
        width: '90%',
        margin: 'auto',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
        animation: 'fadeIn 0.3s ease-out'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1f2937',
            margin: 0
          }}>
            Ready to Start?
          </h3>
          <button 
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px'
            }}
          >
            <X size={18} color="#6b7280" />
          </button>
        </div>

        <p style={{
          fontSize: '13px',
          color: '#6b7280',
          marginBottom: '20px',
          lineHeight: '1.5'
        }}>
          Would you like to shuffle the {type === 'quiz' ? 'questions' : 'cards'}?
        </p>

        {/* Shuffle Toggle */}
        <div style={{
          background: '#f9fafb',
          borderRadius: '12px',
          padding: '12px 16px',
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <Shuffle size={18} color="#1f2937" />
            <span style={{
              fontSize: '13px',
              fontWeight: '500',
              color: '#1f2937'
            }}>
              Shuffle Mode
            </span>
          </div>
          
          <button
            onClick={() => setShuffleEnabled(!shuffleEnabled)}
            style={{
              width: '44px',
              height: '24px',
              borderRadius: '12px',
              background: shuffleEnabled ? '#272727' : '#d1d5db',
              border: 'none',
              cursor: 'pointer',
              position: 'relative',
              transition: 'all 0.2s'
            }}
          >
            <div style={{
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              background: 'white',
              position: 'absolute',
              top: '3px',
              left: shuffleEnabled ? '23px' : '3px',
              transition: 'all 0.2s'
            }} />
          </button>
        </div>

        {/* Don't Ask Again Checkbox */}
        <label style={{
          display: 'flex',
          alignItems: 'center',

          gap: '8px',
          marginBottom: '20px',
          cursor: 'pointer',
          fontSize: '12px',
          color: '#6b7280'
        }}>
          <input
            type="checkbox"
            checked={localDontAsk}
            onChange={(e) => setLocalDontAsk(e.target.checked)}
            style={{
              width: '14px',
              height: '14px',
              cursor: 'pointer'
            }}
          />
          <span>Don't ask me again</span>
        </label>

        {/* Start Button */}
        <button
          onClick={handleStart}
          style={{
            width: '100%',
            padding: '12px',
            background: '#272727',
            border: 'none',
            borderRadius: '20px',
            color: 'white',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
         
        >
          Start {type === 'quiz' ? 'Quiz' : 'Studying'}
        </button>

        {/* Reset preference link (if they change their mind) */}
        {localDontAsk && (
          <p style={{
            fontSize: '11px',
            color: '#9ca3af',
            textAlign: 'center',
            marginTop: '12px',
            lineHeight: '1.4'
          }}>
            You can reset this in 'view stats' later
          </p>
        )}
      </div>
    </div>
  );
};


  const getIconComponent = (iconType, size = 16) => {
    switch(iconType) {
      case 'lightbulb':
        return <Lightbulb size={size} />;
      case 'book':
        return <Book size={size} />;
      default:
        return <Lightbulb size={size} />;
    }
  };
const getRandomGradient = (id) => {
  const gradients = [
    {
      colors: 'rgba(211, 238, 255, 1) 0%, rgba(255, 206, 215, 1) 53%, rgba(236, 241, 251, 0.3) 60%, #e9f9ffff 60%, #eaf2ffff 100%',
      topColors: 'rgba(224, 242, 254, 0.4) 0%, rgba(254, 220, 240, 0.4) 50%, rgba(236, 241, 251, 0.4) 100%',
      border: 'rgba(196, 210, 253, 0.5)'
    },
    {
      colors: 'rgba(254, 215, 226, 1) 0%, rgba(221, 214, 254, 1) 53%, rgba(251, 236, 241, 0.3) 60%, #fdf2f8 60%, #fae8ff 100%',
      topColors: 'rgba(254, 215, 226, 0.4) 0%, rgba(221, 214, 254, 0.4) 50%, rgba(251, 236, 241, 0.4) 100%',
      border: 'rgba(253, 196, 210, 0.5)'
    },
    {
      colors: 'rgba(255, 242, 191, 1) 0%, rgba(255, 229, 144, 1) 53%, rgba(254, 243, 199, 0.3) 60%, #fffbeb 60%, #fff9e1ff 100%',
      topColors: 'rgba(253, 230, 138, 0.4) 0%, rgba(252, 211, 77, 0.4) 50%, rgba(254, 243, 199, 0.4) 100%',
      border: 'rgba(253, 224, 71, 0.5)'
    },
    {
      colors: 'rgba(196, 181, 253, 1) 0%, rgba(165, 243, 252, 1) 53%, rgba(237, 233, 254, 0.3) 60%, #f5f3ff 60%, #ecfeff 100%',
      topColors: 'rgba(196, 181, 253, 0.4) 0%, rgba(165, 243, 252, 0.4) 50%, rgba(237, 233, 254, 0.4) 100%',
      border: 'rgba(196, 181, 253, 0.5)'
    },
    {
      colors: 'rgba(251, 207, 232, 1) 0%, rgba(219, 234, 254, 1) 53%, rgba(254, 240, 245, 0.3) 60%, #fce7f3 60%, #dbeafe 100%',
      topColors: 'rgba(251, 207, 232, 0.4) 0%, rgba(219, 234, 254, 0.4) 50%, rgba(254, 240, 245, 0.4) 100%',
      border: 'rgba(251, 207, 232, 0.5)'
    },
    {
      colors: 'rgba(209, 250, 241, 1) 0%, rgba(254, 215, 170, 1) 53%, rgba(236, 253, 243, 0.3) 60%, #ecfdf5 60%, #fed7aa 100%',
      topColors: 'rgba(209, 250, 229, 0.4) 0%, rgba(254, 215, 170, 0.4) 50%, rgba(236, 253, 243, 0.4) 100%',
      border: 'rgba(209, 250, 229, 0.5)'
    },
    {
      colors: 'rgba(255, 237, 220, 1) 0%, rgba(204, 240, 255, 1) 53%, rgba(251, 241, 236, 0.3) 60%, #ffffff 60%, #ffffff 100%',
      topColors: 'rgba(254, 235, 220, 0.4) 0%, rgba(204, 240, 255, 0.4) 50%, rgba(251, 241, 236, 0.4) 100%',
      border: 'rgba(253, 210, 196, 0.5)'
    }
  ];
  
  // Use a hash of the id to get more variation
  const hash = String(id).split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0);
    return a & a;
  }, 0);
  
  const index = Math.abs(hash) % gradients.length;
  const gradient = gradients[index];
  
  // Generate random degrees for variation (between 120deg and 280deg for bg, 100-200deg for top)
  const bgDegree = 120 + (Math.abs(hash) % 160);
  const topDegree = 100 + (Math.abs(hash >> 4) % 100);
  
  return {
    bg: `linear-gradient(${bgDegree}deg, ${gradient.colors})`,
    top: `linear-gradient(${topDegree}deg, ${gradient.topColors})`,
    border: gradient.border
  };
};
const handleFileUpload = async (e) => {
  const files = Array.from(e.target.files);
  
  if (files.length === 0) return;

  const currentFiles = uploadedFile?.files || [];
  const availableSlots = 6 - currentFiles.length;

  if (files.length > availableSlots) {
    alert(`Maximum 6 files allowed.`);
    if (fileInputRef.current) fileInputRef.current.value = '';
    return;
  }

  const validTypes = ['.pdf', '.txt', '.doc', '.docx'];
  const validFiles = [];
  let tooLarge = false;
  let alreadyExists = false;
  let invalidType = false;

  for (const file of files) {
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    
    if (currentFiles.some(f => f.name === file.name)) {
      alreadyExists = true;
      continue;
    }

    if (!validTypes.includes(fileExtension)) {
      invalidType = true;
      continue;
    }

    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      tooLarge = true;
      continue;
    }

    validFiles.push({
      id: Date.now() + Math.random(),
      name: file.name,
      type: fileExtension,
      file: file,
      size: file.size
    });
  }

  if (validFiles.length === 0) {
    if (tooLarge) {
      alert(`File is too large. Maximum 10MB.`);
    } else if (alreadyExists) {
      alert(`File already uploaded.`);
    } else if (invalidType) {
      alert(`File type not supported.`);
    }
    if (fileInputRef.current) fileInputRef.current.value = '';
    return;
  }

  setUploadedFile({
    files: [...currentFiles, ...validFiles]
  });

  if (fileInputRef.current) fileInputRef.current.value = '';
};

// ============================================
// VALIDATION HELPER FUNCTION
// ============================================
const validateFile = async (file) => {
  const maxSize = 10 * 1024 * 1024; // 10MB
  
  if (file.size > maxSize) {
    return { 
      valid: false, 
      error: `File too large (${(file.size / 1024 / 1024).toFixed(1)}MB). Maximum 10MB allowed.` 
    };
  }

  if (file.size === 0) {
    return { 
      valid: false, 
      error: 'File is empty' 
    };
  }

  // ✅ ALLOW legacy .doc with warning
  if (file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
    return { 
      valid: true,
      warning: 'Legacy .doc format - text extraction may be limited. For best results, save as .docx'
    };
  }

  // ✅ ALLOW potentially corrupted .docx with warning
  if (file.name.endsWith('.docx')) {
    try {
      const arrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);
      const isPKZip = uint8Array[0] === 0x50 && uint8Array[1] === 0x4B;
      
      if (!isPKZip) {
        return { 
          valid: true,  // ✅ Still allow it
          warning: 'File may be corrupted or in old .doc format. Rename to .doc or re-save as .docx'
        };
      }
    } catch (error) {
      return { 
        valid: true,  // ✅ Still allow it
        warning: 'Could not verify file format. Text extraction may fail.'
      };
    }
  }
  
  return { valid: true };
};

// ============================================
// OPTIONAL: FILE REMOVAL FUNCTION
// ============================================
const removeUploadedFile = (fileId) => {
  if (!uploadedFile?.files) return;
  
  const updatedFiles = uploadedFile.files.filter(f => f.id !== fileId);
  
  if (updatedFiles.length === 0) {
    setUploadedFile(null);
    console.log('🗑️ All files removed');
  } else {
    setUploadedFile({
      ...uploadedFile,
      files: updatedFiles
    });
    console.log(`🗑️ File removed. Remaining: ${updatedFiles.length}/6`);
  }
};
const removeFile = (fileId) => {
  if (uploadedFile?.files) {
    const updatedFiles = uploadedFile.files.filter(f => f.id !== fileId);
    if (updatedFiles.length === 0) {
      setUploadedFile(null);
    } else {
      setUploadedFile({ files: updatedFiles });
    }
    console.log(`✅ File removed. Total: ${updatedFiles.length}/6`);
  }
};
const handleCancelCreate = () => {
  setShowCreateMenu(false);
  setCreateType(null);
  setCreatePromptText('');
  setSelectedDifficulty(null);
  setShowDifficultyDropdown(false);
  setUploadedFile(null);
  setShowUploadOptions(false);
  setIsGenerating(false); // ✅ ADD THIS LINE
};
useEffect(() => {
  if (createType || uploadedFile || selectedDifficulty) {
    const timer = setTimeout(() => {
      setSvgKey(prev => prev + 1);
    }, 50);
    
    return () => clearTimeout(timer);
  }
}, [createType, selectedDifficulty, uploadedFile]); // ✅ Added uploadedFile
const extractTextFromFile = async (file) => {
  try {
    // Handle plain text files
    if (file.type === 'text/plain') {
      return await file.text();
    } 
    
    // Handle Word documents (.docx)
    else if (file.name.endsWith('.docx') || file.type.includes('wordprocessingml')) {
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.extractRawText({ arrayBuffer });
      return result.value;
    }
    
    // Handle PDF files
    else if (file.type === 'application/pdf' || file.name.endsWith('.pdf')) {
      // Wait for PDF.js to load if it hasn't yet
      if (!window.pdfjsLib) {
        await new Promise(resolve => {
          const checkInterval = setInterval(() => {
            if (window.pdfjsLib) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
        });
      }

      const arrayBuffer = await file.arrayBuffer();
      const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      
      let fullText = '';
      
      // Extract text from each page
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map(item => item.str).join(' ');
        fullText += pageText + '\n\n';
      }
      
      return fullText.trim();
    }
    
    else {
      alert('Please upload a .txt, .docx, or .pdf file');
      return null;
    }
  } catch (error) {
    console.error('Error reading file:', error);
    alert('Failed to read file. Please try again or try a different file format.');
    return null;
  }
};
const generateCustomContent = async (type) => {
  // ============================================
  // VALIDATION
  // ============================================
  if (!createPromptText.trim() && !uploadedFile?.files) {
    alert('Please enter a prompt or upload a file');
    return;
  }

  if (!selectedDifficulty) {
    alert('Please select a difficulty level first');
    return;
  }

  setIsGenerating(true);
  if (type === 'quiz') {
    setIsQuizzesLoading(true);
  } else {
    setIsFlashcardsLoading(true);
  }

  try {
    // ============================================
    // EXTRACT REQUESTED COUNT FROM PROMPT
    // ============================================
    let requestedCount = null;
    const prompt = createPromptText.toLowerCase();
    
    // Match patterns like "20 questions", "create 15", "make 30 flashcards"
    const countMatch = prompt.match(/(\d+)\s*(questions?|flashcards?|cards?|items?)?/i);
    if (countMatch) {
      requestedCount = parseInt(countMatch[1]);
      // Validate count (max 100)
      if (requestedCount > 100) {
        alert(`Maximum 100 items allowed. Creating 100 instead of ${requestedCount}.`);
        requestedCount = 100;
      } else if (requestedCount < 1) {
        requestedCount = null;
      }
    }
    
    // Default counts if not specified
    const defaultCount = type === 'quiz' ? 5 : 8;
    const finalCount = requestedCount || defaultCount;

    console.log(`📊 Generating ${finalCount} ${type === 'quiz' ? 'questions' : 'flashcards'}`);

    // ============================================
    // STEP 1: EXTRACT TEXT FROM FILES (IF PROVIDED)
    // ============================================
    let combinedContent = '';

    if (uploadedFile?.files && uploadedFile.files.length > 0) {
      console.log(`📄 Extracting text from ${uploadedFile.files.length} file(s)...`);

      try {
        const fileTexts = await Promise.all(
          uploadedFile.files.map(async (fileObj) => {
            let fileText = '';
            
            try {
              if (fileObj.type === '.pdf') {
                // PDF extraction
                const arrayBuffer = await fileObj.file.arrayBuffer();
                const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                
                for (let i = 1; i <= pdf.numPages; i++) {
                  const page = await pdf.getPage(i);
                  const textContent = await page.getTextContent();
                  fileText += textContent.items.map(item => item.str).join(' ') + '\n';
                }
                console.log(`✅ PDF: Extracted ${fileText.length} chars from ${fileObj.name}`);
              } 
              else if (fileObj.type === '.docx' || fileObj.type === '.doc') {
                const arrayBuffer = await fileObj.file.arrayBuffer();
                const uint8Array = new Uint8Array(arrayBuffer);
                const isPKZip = uint8Array[0] === 0x50 && uint8Array[1] === 0x4B;
                
                if (isPKZip) {
                  // Modern .docx format (ZIP-based)
                  try {
                    const result = await mammoth.extractRawText({ arrayBuffer });
                    fileText = result.value;
                    
                    if (!fileText || fileText.trim().length === 0) {
                      console.warn(`⚠️ No text extracted from ${fileObj.name}`);
                      fileText = `[Warning: No readable text found in ${fileObj.name}]`;
                    } else {
                      console.log(`✅ DOCX: Extracted ${fileText.length} chars from ${fileObj.name}`);
                    }
                  } catch (mammothError) {
                    console.error(`Mammoth error for ${fileObj.name}:`, mammothError);
                    fileText = `[Error: Could not read ${fileObj.name} - ${mammothError.message}]`;
                  }
                } else {
                  // Legacy .doc format - attempt text extraction
                  console.warn(`⚠️ ${fileObj.name} is legacy .doc format, attempting extraction...`);
                  
                  try {
                    // Method 1: Try UTF-8 decoding
                    let text = new TextDecoder('utf-8', { fatal: false }).decode(uint8Array);
                    
                    // Method 2: Also try Windows-1252 (common for old Word docs)
                    if (!text || text.trim().length < 50) {
                      text = new TextDecoder('windows-1252', { fatal: false }).decode(uint8Array);
                    }
                    
                    // Clean up binary junk
                    const cleaned = text
                      .replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g, ' ')
                      .replace(/Microsoft Word|MSWordDoc|Word\.Document/gi, '')
                      .replace(/[^\x20-\x7E\s\u00A0-\uFFFF]+/g, ' ')
                      .replace(/\s+/g, ' ')
                      .trim();
                    
                    if (cleaned.length > 100) {
                      fileText = cleaned;
                      console.log(`✅ Legacy DOC: Extracted ${cleaned.length} chars from ${fileObj.name}`);
                    } else {
                      console.warn(`⚠️ Only extracted ${cleaned.length} chars from ${fileObj.name}`);
                      fileText = `[Limited text extracted from ${fileObj.name}. Please convert to .docx for better results.]`;
                    }
                  } catch (decodeError) {
                    console.error(`Legacy .doc extraction failed for ${fileObj.name}:`, decodeError);
                    fileText = `[Could not extract text from ${fileObj.name}. Please save as .docx in Microsoft Word.]`;
                  }
                }
              } 
              else if (fileObj.type === '.txt') {
                fileText = await fileObj.file.text();
                console.log(`✅ TXT: Extracted ${fileText.length} chars from ${fileObj.name}`);
              }
              else {
                console.warn(`⚠️ Unsupported file type: ${fileObj.type} for ${fileObj.name}`);
                fileText = `[Unsupported file type: ${fileObj.type}]`;
              }
            } catch (fileError) {
              console.error(`❌ Error processing ${fileObj.name}:`, fileError);
              fileText = `[Error processing ${fileObj.name}: ${fileError.message}]`;
            }

            return `[File: ${fileObj.name}]\n${fileText}\n`;
          })
        );

        combinedContent = fileTexts.join('\n---FILE SEPARATOR---\n');
        
        // Check extraction results
        const errorCount = (combinedContent.match(/\[Error:/g) || []).length;
        const warningCount = (combinedContent.match(/\[Warning:|Limited text extracted/g) || []).length;
        const usableContent = combinedContent
          .replace(/\[Error:.*?\]/g, '')
          .replace(/\[Warning:.*?\]/g, '')
          .replace(/\[Limited text.*?\]/g, '')
          .trim();
        
        console.log(`📊 Extraction summary:
      - Total files: ${uploadedFile.files.length}
      - Errors: ${errorCount}
      - Warnings: ${warningCount}
      - Usable content: ${usableContent.length} chars`);
        
        if (errorCount === uploadedFile.files.length) {
          throw new Error('Could not extract text from any files. Please check file formats and try re-saving as .docx or .pdf');
        }
        
        if (usableContent.length < 50) {
          throw new Error(
            `Only ${usableContent.length} characters extracted. Please ensure files contain readable text. ` +
            `Try converting .doc files to .docx for better results.`
          );
        }
        
        if (errorCount > 0 || warningCount > 0) {
          console.warn(`⚠️ ${errorCount + warningCount} file(s) had issues, but continuing with ${usableContent.length} chars of content`);
        }
        
        console.log(`✅ Successfully extracted content from ${uploadedFile.files.length - errorCount} file(s)`);
        
      } catch (fileError) {
        console.error('File extraction error:', fileError);
        throw new Error(`Failed to extract text: ${fileError.message}`);
      }
    }

    // ============================================
    // STEP 2: BUILD PROMPTS WITH TOKEN OPTIMIZATION
    // ============================================
    
    // ✅ Smart content sizing based on item count
    const maxContentChars = Math.min(
      100000, // Max 100k chars
      Math.max(20000, finalCount * 1000) // Scale with count: 1000 chars per item
    );
    
    const baseContent = uploadedFile?.files 
      ? combinedContent.slice(0, maxContentChars)
      : createPromptText;
    
const userPrompt = uploadedFile?.files
  ? `Content from ${uploadedFile.files.length} file(s). Create ${finalCount} ${type === 'quiz' ? 'quiz questions distributed across all files' : 'flashcards covering all materials'}.\n\n${baseContent}`
  : `${createPromptText}\n\nCreate ${finalCount} ${type === 'quiz' ? 'questions' : 'flashcards'}.`;

    // ✅ TOKEN-OPTIMIZED SYSTEM PROMPTS
    const systemPrompt = type === 'quiz'
      ? `Expert quiz creator. Create EXACTLY ${finalCount} questions. Mix multiple choice and true/false. Difficulty: ${selectedDifficulty}

RULES:
- MUST create exactly ${finalCount} questions
- Valid JSON only - no markdown, backticks, or extra text
- Keep explanations brief (1 sentence max)
- Use simple, clear language

JSON format:
{
  "title": "Quiz Title",
  "description": "Brief description",
  "difficulty": "${selectedDifficulty}",
  "questions": [
    {
      "id": "q1",
      "type": "multiple_choice",
      "question": "Question text?",
      "options": ["A", "B", "C", "D"],
      "correctAnswer": "A",
      "explanation": "Brief why"
    },
    {
      "id": "q2",
      "type": "true_false",
      "question": "Statement?",
      "correctAnswer": true,
      "explanation": "Brief why"
    }
  ]
}`
      : `Expert flashcard creator. Create EXACTLY ${finalCount} flashcards. Difficulty: ${selectedDifficulty}

RULES:
- MUST create exactly ${finalCount} flashcards
- Valid JSON only - no markdown, backticks, or extra text
- Keep answers concise and clear
- Use simple language

JSON format:
{
  "title": "Set Title",
  "description": "Brief description",
  "difficulty": "${selectedDifficulty}",
  "flashcards": [
    {
      "id": "f1",
      "question": "Question or term",
      "answer": "Clear answer",
      "hints": ["optional hint"]
    }
  ]
}`;

    // ============================================
    // STEP 3: CALL SECURE API WITH OPTIMIZED TOKENS
    // ============================================
    console.log(`🚀 Calling API to generate ${type}...`);
    console.log(`📝 Input: ${baseContent.length} chars | Requesting: ${finalCount} items`);

    // ✅ Smart token allocation
    const estimatedTokensPerItem = type === 'quiz' ? 120 : 80;
    const baseTokens = 500; // For title, description, structure
    const calculatedTokens = baseTokens + (finalCount * estimatedTokensPerItem);
    const maxTokens = Math.min(16000, Math.max(2000, calculatedTokens));

    console.log(`🎯 Max tokens: ${maxTokens} (${estimatedTokensPerItem} per item × ${finalCount} + ${baseTokens} base)`);

    const response = await SecureAPI.callAzureOpenAI([
      {
        role: 'system',
        content: systemPrompt
      },
      {
        role: 'user',
        content: userPrompt
      }
    ], {
      temperature: 0.7,
      max_tokens: maxTokens,
      response_format: { type: 'json_object' }
    });

    // ============================================
    // STEP 4: PARSE AND VALIDATE RESPONSE
    // ============================================
    if (!response?.choices?.[0]?.message?.content) {
      throw new Error('Invalid API response structure');
    }

    let generatedContent;
    try {
      const rawContent = response.choices[0].message.content;
      
      console.log(`📦 Raw response: ${rawContent.length} chars`);
      
      // ✅ Clean up common JSON issues
      let cleanedContent = rawContent
        .trim()
        .replace(/^```json\s*/i, '')
        .replace(/^```\s*/i, '')
        .replace(/\s*```$/i, '')
        .replace(/^\uFEFF/, '')
        .trim();
      
      // ✅ Check if response was truncated
      if (!cleanedContent.endsWith('}')) {
        console.warn('⚠️ Response may be truncated - attempting to fix...');
        // Try to find the last complete item
        const lastCompleteItem = type === 'quiz' 
          ? cleanedContent.lastIndexOf('}')
          : cleanedContent.lastIndexOf('}');
        
        if (lastCompleteItem > 0) {
          cleanedContent = cleanedContent.substring(0, lastCompleteItem + 1) + ']}';
          console.log('✅ Attempted truncation fix');
        }
      }
      
      generatedContent = JSON.parse(cleanedContent);
      console.log(`✅ JSON parsed successfully`);
      
    } catch (parseError) {
      console.error('❌ JSON parse error:', parseError);
      console.error('📄 Failed at position:', parseError.message);
      console.error('📄 Content preview:', response.choices[0].message.content.substring(0, 500));
      console.error('📄 Content end:', response.choices[0].message.content.slice(-500));
      
      throw new Error(
        `AI response could not be parsed. This happens when:\n\n` +
        `• Requested too many items (${finalCount})\n` +
        `• Response exceeded token limit\n` +
        `• Content has formatting issues\n\n` +
        `Try: Generate 10-30 items at a time instead of ${finalCount}`
      );
    }

    // ============================================
    // VALIDATE COUNT MATCHES REQUEST
    // ============================================
    const actualCount = type === 'quiz' 
      ? generatedContent.questions?.length || 0
      : generatedContent.flashcards?.length || 0;
    
    console.log(`📊 Requested: ${finalCount} | Generated: ${actualCount}`);
    
    if (actualCount === 0) {
      throw new Error('AI generated no items. Try with a clearer prompt or fewer files.');
    }
    
    if (actualCount < finalCount) {
      console.warn(`⚠️ AI created ${actualCount} items but ${finalCount} were requested (likely hit token limit)`);
      alert(`Generated ${actualCount} out of ${finalCount} requested items.\n\nThe response was too large. Try generating fewer items at once.`);
    }

    // ============================================
    // STEP 5: CREATE AND SAVE QUIZ
    // ============================================
    if (type === 'quiz') {
      if (!generatedContent.questions || generatedContent.questions.length === 0) {
        throw new Error('Generated quiz has no questions');
      }

      // Validate each question
      generatedContent.questions.forEach((q, idx) => {
        if (!q.question || !q.type) {
          throw new Error(`Question ${idx + 1} is missing required fields`);
        }
        if (q.type === 'multiple_choice' && (!q.options || q.options.length < 2)) {
          throw new Error(`Question ${idx + 1} needs at least 2 options`);
        }
      });

      const newQuiz = {
        id: `quiz_${Date.now()}`,
        title: generatedContent.title || 'Custom Quiz',
        description: generatedContent.description || 'AI-generated quiz',
        difficulty: selectedDifficulty,
        topic: generatedContent.topic || createPromptText.split(' ').slice(0, 3).join(' '),
        questions: generatedContent.questions,
        isCustom: true,
        createdAt: new Date().toISOString(),
        questionCount: generatedContent.questions.length
      };

      console.log('✅ Quiz created:', {
        id: newQuiz.id,
        title: newQuiz.title,
        questionCount: newQuiz.questionCount,
        filesUsed: uploadedFile?.files?.length || 0
      });

      // Save to Firestore
      if (firestoreService?.isReady()) {
        try {
          const result = await firestoreService.saveCustomQuiz(newQuiz);
          if (result.success) {
            console.log('✅ Quiz saved to Firestore');
          }
        } catch (firestoreError) {
          console.error('Firestore error:', firestoreError);
        }
      }

      setQuizSets(prev => [newQuiz, ...prev]);

      const customQuizzesCount = quizSets.filter(q => q.isCustom).length;
      if (customQuizzesCount === 0) {
        setCongratsType('quiz');
        setShowCongratsModal(true);
      }
    }

    // ============================================
    // STEP 6: CREATE AND SAVE FLASHCARDS
    // ============================================
    else if (type === 'flashcard') {
      if (!generatedContent.flashcards || generatedContent.flashcards.length === 0) {
        throw new Error('Generated flashcard set has no cards');
      }

      generatedContent.flashcards.forEach((card, idx) => {
        if (!card.question || !card.answer) {
          throw new Error(`Card ${idx + 1} is missing question or answer`);
        }
      });

      const newFlashcards = {
        id: `flashcards_${Date.now()}`,
        title: generatedContent.title || 'Custom Flashcards',
        description: generatedContent.description || 'AI-generated flashcards',
        difficulty: selectedDifficulty,
        topic: generatedContent.topic || createPromptText.split(' ').slice(0, 3).join(' '),
        flashcards: generatedContent.flashcards,
        isCustom: true,
        createdAt: new Date().toISOString(),
        cardCount: generatedContent.flashcards.length
      };

      console.log('✅ Flashcards created:', {
        id: newFlashcards.id,
        title: newFlashcards.title,
        cardCount: newFlashcards.cardCount,
        filesUsed: uploadedFile?.files?.length || 0
      });

      if (firestoreService?.isReady()) {
        try {
          const result = await firestoreService.saveCustomFlashcards(newFlashcards);
          if (result.success) {
            console.log('✅ Flashcards saved to Firestore');
          }
        } catch (firestoreError) {
          console.error('Firestore error:', firestoreError);
        }
      }

      setFlashcardSets(prev => [newFlashcards, ...prev]);

      const customFlashcardsCount = flashcardSets.filter(f => f.isCustom).length;
      if (customFlashcardsCount === 0) {
        setCongratsType('flashcard');
        setShowCongratsModal(true);
      }
    }

    // ============================================
    // STEP 7: RESET FORM
    // ============================================
    setIsGenerating(false);
    setShowCreateMenu(false);
    setCreatePromptText('');
    setUploadedFile(null);
    setSelectedDifficulty(null);
    setShowDifficultyDropdown(false);
    setCreateType(null);
    setShowDeletePopup(null);

    setTimeout(() => {
      if (type === 'quiz') {
        setIsQuizzesLoading(false);
      } else {
        setIsFlashcardsLoading(false);
      }
    }, 800);

    console.log(`✨ ${type === 'quiz' ? 'Quiz' : 'Flashcards'} generated successfully!`);

  } catch (error) {
    console.error('❌ Generation error:', error.message);
    
    const errorMessage = error.message || 'An unexpected error occurred';
    alert(`Failed to generate ${type}:\n\n${errorMessage}`);

    setIsGenerating(false);
    setIsQuizzesLoading(false);
    setIsFlashcardsLoading(false);
  }
};
// Add this useEffect near your other useEffects
useEffect(() => {
  if (createType) {
    // Small delay to let the DOM settle
    const timer = setTimeout(() => {
      setSvgKey(prev => prev + 1);
    }, 10);
    
    return () => clearTimeout(timer);
  }
}, [createType, selectedDifficulty]);
const [flashcardSets, setFlashcardSets] = useState(() => {
  const savedFlashcards = JSON.parse(localStorage.getItem('studyhub_custom_flashcards') || '[]');
  
  // Add icons back to saved flashcards
  const customFlashcards = savedFlashcards.map(set => ({
    ...set,
    icon: getIconComponent(set.iconType || 'book', 22)
  }));
  
  return [
    ...customFlashcards,

  ];
});
const generateContentFromChat = async (type, topic, count, difficulty) => {
  // ✅ VALIDATE COUNT LIMIT (100 max)
  if (count > 100) {
    alert(`❌ Sorry! We can only create up to 100 items. You asked for ${count}. Creating 100 instead.`);
    count = 100;
  }
  
  if (count < 1) {
    alert('❌ Please ask for at least 1 item.');
    return;
  }

  try {
    const systemPrompt = type === 'quiz' 
      ? `You are a quiz generator that creates educational quizzes.

CRITICAL FORMATTING RULES:
- Return ONLY valid JSON, no extra text or markdown
- For true/false questions: correctAnswer MUST be exactly "true" or "false" (lowercase)
- For multiple choice questions: correctAnswer must match one of the options EXACTLY
- Always include detailed explanations
- All JSON strings must be properly escaped
- No trailing commas
- CREATE EXACTLY ${count} QUESTIONS - NO MORE, NO LESS

Return ONLY this exact JSON structure:
{
  "title": "Quiz Title",
  "description": "Brief description",
  "questions": [
    {
      "id": "q1",
      "question": "Question text?",
      "type": "multiple_choice",
      "options": ["Option A", "Option B", "Option C", "Option D"],
      "correctAnswer": "Option A",
      "explanation": "Detailed explanation"
    }
  ]
}`
      : `You are a flashcard generator that creates educational flashcards.

CRITICAL FORMATTING RULES:
- Return ONLY valid JSON, no extra text or markdown
- All JSON strings must be properly escaped
- No trailing commas
- CREATE EXACTLY ${count} FLASHCARDS - NO MORE, NO LESS

Return ONLY this exact JSON structure:
{
  "title": "Flashcard Set Title",
  "description": "Brief description",
  "flashcards": [
    {
      "id": "f1",
      "question": "Term or question",
      "answer": "Definition or answer"
    }
  ]
}`;

    const userPrompt = type === 'quiz'
      ? `Create a ${difficulty} difficulty quiz about "${topic}" with EXACTLY ${count} questions. Mix of multiple choice and true/false. For true/false: correctAnswer MUST be "true" or "false" (lowercase). DO NOT CREATE MORE OR LESS THAN ${count} QUESTIONS.`
      : `Create ${difficulty} difficulty flashcards about "${topic}" with EXACTLY ${count} flashcards. DO NOT CREATE MORE OR LESS THAN ${count} FLASHCARDS.`;

    // ✅ SECURE API CALL - REPLACES OLD FETCH
    const data = await SecureAPI.callAzureOpenAI(
      [
        { role: 'system', content: systemPrompt },
        { role: 'user', content: userPrompt }
      ],
      {
        temperature: 0.85,
        max_tokens: 4000,
        response_format: { type: "json_object" }
      }
    );

    let responseContent = data.choices[0].message.content;
    responseContent = responseContent.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim();
    
    let contentData = JSON.parse(responseContent);

    // ✅ VALIDATE ACTUAL COUNT MATCHES REQUEST
    const actualCount = type === 'quiz' 
      ? contentData.questions?.length || 0
      : contentData.flashcards?.length || 0;
    
    if (actualCount !== count) {
      console.warn(`⚠️ AI created ${actualCount} items but ${count} were requested`);
    }

    if (type === 'quiz') {
      // ✅ Validate quizzes
      if (!contentData.questions || contentData.questions.length === 0) {
        alert('❌ Generated quiz has no questions. Please try again.');
        return;
      }

      // Ensure true/false answers are lowercase
      contentData.questions.forEach(q => {
        if (q.type === 'true_false') {
          q.correctAnswer = q.correctAnswer.toString().toLowerCase();
        }
      });
      
      const newQuiz = {
        id: Date.now(),
        title: contentData.title || `${topic} Quiz`,
        description: contentData.description || `AI-generated quiz about ${topic}`,
        iconType: 'lightbulb',
        difficulty: difficulty,
        quiz: contentData.questions,
        isCustom: true,
        createdAt: new Date().toISOString()
      };

      // Save to Firestore
      if (firestoreService?.isReady()) {
        try {
          const result = await firestoreService.saveCustomQuiz(newQuiz);
          if (result.success) {
            console.log('✅ Quiz saved successfully');
          }
        } catch (error) {
          console.error('❌ Failed to save quiz:', error);
        }
      }

      setQuizSets(prev => [newQuiz, ...prev]);
      
      // Update chat with success message and button
      setChatMessages(prev => {
        const updated = [...prev];
        updated[updated.length - 1] = {
          role: 'assistant',
          content: `I've created your **${topic}** quiz with **${count} questions**! You can begin by clicking the button below.`,
          hasButton: true,
          buttonText: 'View Quiz',
          buttonAction: () => handleStartQuiz(newQuiz)
        };
        return updated;
      });
      
    } else {
      // ✅ Validate flashcards
      if (!contentData.flashcards || contentData.flashcards.length === 0) {
        alert('❌ Generated flashcard set has no cards. Please try again.');
        return;
      }

      const newFlashcards = {
        id: Date.now(),
        title: contentData.title || `${topic} Flashcards`,
        description: contentData.description || `AI-generated flashcards about ${topic}`,
        iconType: 'book',
        difficulty: difficulty,
        flashcards: contentData.flashcards,
        isCustom: true,
        createdAt: new Date().toISOString()
      };

      // Save to Firestore
      if (firestoreService?.isReady()) {
        try {
          const result = await firestoreService.saveCustomFlashcards(newFlashcards);
          if (result.success) {
            console.log('✅ Flashcards saved successfully');
          }
        } catch (error) {
          console.error('❌ Failed to save flashcards:', error);
        }
      }
      
      setFlashcardSets(prev => [newFlashcards, ...prev]);
      
      // Update chat with success message and button
      setChatMessages(prev => {
        const updated = [...prev];
        updated[updated.length - 1] = {
          role: 'assistant',
          content: `I've created your **${topic}** flashcards with **${count} cards**! You can begin by clicking the button below.`,
          hasButton: true,
          buttonText: 'View Flashcards',
          buttonAction: () => handleStartFlashcards(newFlashcards)
        };
        return updated;
      });
    }

  } catch (error) {
    console.error('Error generating content:', error);
    setChatMessages(prev => {
      const updated = [...prev];
      updated[updated.length - 1] = {
        role: 'assistant',
        content: `Sorry, I had trouble creating that. Please try again or go to the tab to do that!`
      };
      return updated;
    });
  } finally {
    setIsChatLoading(false);
  }
};
const sendChatMessage = async () => {
  if (!chatInput.trim()) return;
  
  const userMessage = { role: 'user', content: chatInput };
  setChatMessages(prev => [...prev, userMessage]);
  setChatInput('');
  setIsChatLoading(true);

  try {
    const totalQuizzes = studyStats.quizHistory.length;
    const avgScore = totalQuizzes > 0 
      ? Math.round(studyStats.quizHistory.reduce((sum, q) => sum + q.score, 0) / totalQuizzes)
      : 0;
    const totalCards = studyStats.flashcardSessions.reduce((sum, s) => sum + s.cardsStudied, 0);
    
    const recentQuizzes = studyStats.quizHistory.slice(0, 5);
    const recentAvg = recentQuizzes.length > 0
      ? Math.round(recentQuizzes.reduce((sum, q) => sum + q.score, 0) / recentQuizzes.length)
      : 0;
    
    const performanceTrend = recentAvg > avgScore ? 'improving' : recentAvg < avgScore ? 'declining' : 'stable';
    
    const byDifficulty = { easy: [], medium: [], hard: [] };
    studyStats.quizHistory.forEach(q => {
      if (byDifficulty[q.difficulty]) {
        byDifficulty[q.difficulty].push(q.score);
      }
    });
    
    const difficultyPerformance = {
      easy: byDifficulty.easy.length > 0 ? Math.round(byDifficulty.easy.reduce((a, b) => a + b, 0) / byDifficulty.easy.length) : 0,
      medium: byDifficulty.medium.length > 0 ? Math.round(byDifficulty.medium.reduce((a, b) => a + b, 0) / byDifficulty.medium.length) : 0,
      hard: byDifficulty.hard.length > 0 ? Math.round(byDifficulty.hard.reduce((a, b) => a + b, 0) / byDifficulty.hard.length) : 0
    };

    const systemPrompt = `You are Preptune, a friendly and encouraging study assistant. Keep responses SHORT and conversational.

PERFORMANCE DATA:
- Total Quizzes: ${totalQuizzes}
- Overall Average: ${avgScore}%
- Recent Average (last 5): ${recentAvg}%
- Performance Trend: ${performanceTrend}
- Flashcards Studied: ${totalCards}
- Difficulty Performance: Easy ${difficultyPerformance.easy}%, Medium ${difficultyPerformance.medium}%, Hard ${difficultyPerformance.hard}%

RECENT ACTIVITY (Last 3 quizzes):
${recentQuizzes.slice(0, 3).map((q, i) => `${i + 1}. ${q.topic} - ${q.score}% (${q.difficulty})`).join('\n')}

WEAK AREAS (scores < 70%):
${studyStats.quizHistory.filter(q => q.score < 70).slice(0, 3).map(q => `- ${q.topic}: ${q.score}%`).join('\n') || 'None identified'}

STRENGTHS (scores >= 85%):
${studyStats.quizHistory.filter(q => q.score >= 85).slice(0, 3).map(q => `- ${q.topic}: ${q.score}%`).join('\n') || 'Building...'}

TIME OF DAY: ${new Date().getHours() < 12 ? 'Morning' : new Date().getHours() < 18 ? 'Afternoon' : 'Evening'}

CRITICAL RULES:
- Be naturally conversational, like a supportive friend
- Use **bold** to highlight: scores (**85%**), subjects (**chemistry**), trends (**improving**)
- Reference SPECIFIC quizzes and recent activity when relevant
- Give actionable advice based on their weak areas
- Celebrate wins and improvements
- Keep responses 2-3 SHORT sentences maximum
- If they're struggling, suggest easier difficulty or more flashcards
- If they're doing well, encourage them to try harder difficulty
- You work for Preptune - focus on study tips only
- No bullet points or lists, write naturally
CONTENT CREATION:
If the user asks you to create a quiz or flashcards (e.g. "make me a quiz about biology", "create flashcards for history"), respond EXACTLY in this format:
CREATE_CONTENT: {type: "quiz" or "flashcard", topic: "the topic", count: number, difficulty: "easy/medium/hard"}

Examples:
- "make me a biology quiz" → CREATE_CONTENT: {type: "quiz", topic: "biology", count: 5, difficulty: "medium"}
- "create 10 flashcards for history" → CREATE_CONTENT: {type: "flashcard", topic: "history", count: 10, difficulty: "medium"}
- "i need a hard chemistry quiz with 8 questions" → CREATE_CONTENT: {type: "quiz", topic: "chemistry", count: 8, difficulty: "hard"}`;

    // ✅ SECURE API CALL - REPLACES OLD FETCH
    const data = await SecureAPI.callAzureOpenAI(
      [
        { role: 'system', content: systemPrompt },
        ...chatMessages,
        userMessage
      ],
      {
        temperature: 0.7,
        max_tokens: 150
      }
    );

    const aiResponse = data.choices[0].message.content;

    // Check if AI wants to create content
    if (aiResponse.includes('CREATE_CONTENT:')) {
      const match = aiResponse.match(/CREATE_CONTENT:\s*{([^}]+)}/);
      if (match) {
        try {
          const contentString = `{${match[1]}}`;
          const contentData = JSON.parse(contentString.replace(/(\w+):/g, '"$1":'));
          
          // Show loading message
          setChatMessages(prev => [...prev, { 
            role: 'assistant', 
            content: `Creating your ${contentData.type}...`,
            isGenerating: true
          }]);
          
          // Generate the content
          await generateContentFromChat(contentData.type, contentData.topic, contentData.count, contentData.difficulty);
          
          return; // Exit early
        } catch (parseError) {
          console.error('Parse error:', parseError);
        }
      }
    }

    const aiMessage = { role: 'assistant', content: aiResponse };
    setChatMessages(prev => [...prev, aiMessage]);
  } catch (error) {
    console.error('Chat error:', error);
    setChatMessages(prev => [...prev, { 
      role: 'assistant', 
      content: "I'm having trouble connecting right now. Please try again in a moment!\n\n- Preptune" 
    }]);
  } finally {
    setIsChatLoading(false);
  }
};
const renderStructuredMessage = (content) => {
  // Color palette for highlights - rotates through different colors
  const highlightColors = [
    { bg: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', color: '#92400e' }, // Yellow
    { bg: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', color: '#1e40af' }, // Blue
    { bg: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)', color: '#065f46' }, // Green
    { bg: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)', color: '#9f1239' }, // Pink
    { bg: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)', color: '#3730a3' }, // Indigo
    { bg: 'linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)', color: '#9a3412' }  // Orange
  ];
  
  const parts = content.split(/(\*\*.*?\*\*)/g);
  let colorIndex = 0;
  
  return (
    <div style={{
      padding: '12px 14px',
      borderRadius: '16px',
      background: 'white',
      border: '1px solid #e5e7eb',
      fontSize: '12px',
      color: '#1f2937',
      lineHeight: '1.6',
       textAlign:'left',
      whiteSpace: 'pre-wrap'
    }}>
      {parts.map((part, idx) => {
        if (part.startsWith('**') && part.endsWith('**')) {
          const text = part.slice(2, -2);
          const currentColor = highlightColors[colorIndex % highlightColors.length];
          colorIndex++;
          
          return (
            <strong key={idx} style={{
              background: currentColor.bg,
              padding: '2px 6px',
              borderRadius: '4px',
              fontWeight: '600',
              textAlign:'left',
              color: currentColor.color
            }}>
              {text}
            </strong>
          );
        }
        return <span key={idx}>{part}</span>;
      })}
    </div>
  );
};


// 3. ADD ASR/TTS HANDLER FUNCTION (add before return statement)
// -------------------------------------------------------------------

const handleAIVoiceInput = async () => {
  if (aiHelpState === 'listening') {
    // Cancel listening
    setAiHelpState('idle');
    return;
  }
  
  if (aiHelpState === 'speaking') {
    // Stop speaking
    setAiHelpState('idle');
    setAiResponseText('');
    return;
  }
  
  // Start listening
  setAiHelpState('listening');
  
  // TODO: Replace with actual Web Speech API
  setTimeout(() => {
    const userQuestion = "I don't understand this question";
    
    setAiHelpState('speaking');
    
    // Generate AI response
    generateAIResponse(userQuestion, currentQuizQuestion);
  }, 2000);
};


// ============================================
// STEP 3: UPDATE generateAIResponse FUNCTION
// ============================================

// REPLACE the entire generateAIResponse function with:
const generateAIResponse = async (userQuestion, quizQuestion) => {
  try {
    const systemPrompt = `You are a helpful AI tutor. The student is asking about: "${quizQuestion?.question}"
Options: ${quizQuestion?.options?.join(', ')}

Provide a brief, clear explanation (2-3 sentences max).`;

    // TODO: Replace with actual Azure OpenAI API call
    // Simulated response for demo
    setTimeout(() => {
      const response = `Great question! ${quizQuestion?.type === 'true_false' ? 
        'This is a true/false question. Think about the key concept being tested.' : 
        'Look at each option carefully and eliminate the ones that don\'t make sense.'}`;
      
      setAiResponseText(response);
    }, 1500);

  } catch (error) {
    console.error('AI Response Error:', error);
    setAiHelpState('idle');
  }
};


// ============================================
// STEP 4: REMOVE OLD useEffect
// ============================================

// DELETE this entire useEffect block:
useEffect(() => {
  if (showAIHelp && aiConversation.length === 0) {
    setTimeout(() => {
      setAiConversation([
        {
          host: 1,
          text: "Hey there! How's it going with this quiz?",
          timestamp: Date.now()
        }
      ]);
    }, 500);

    setTimeout(() => {
      setAiConversation(prev => [...prev, {
        host: 2,
        text: "We're here to help! What question are you stuck on?",
        timestamp: Date.now()
      }]);
    }, 1500);
  }
}, [showAIHelp]);



// Auto-scroll chat
useEffect(() => {
  chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
}, [chatMessages]);
const deleteCustomContent = async (id, type) => {
 try {
    if (!firestoreService?.isReady()) {
      alert('Not connected to database');
      return;
    }
    
    // ✅ CRITICAL: Convert id to string
    const idString = String(id);
    console.log('🗑️ Deleting:', { id: idString, type });
    
    if (type === 'quiz') {
      const success = await firestoreService.deleteQuiz(idString);
      if (success) {
        setQuizSets(prev => prev.filter(q => String(q.id) !== idString));
        console.log('✅ Quiz deleted');
      }
    } else {
      const success = await firestoreService.deleteFlashcardSet(idString);
      if (success) {
        setFlashcardSets(prev => prev.filter(f => String(f.id) !== idString));
        console.log('✅ Flashcard set deleted');
      }
    }
  } catch (error) {
    console.error('❌ Failed to delete:', error);
    alert('Failed to delete. Please try again.');
  }
};
const QuizPreview = ({ quiz, onStartQuiz, isFirst, onDelete }) => {
  const [showPodcast, setShowPodcast] = useState(false);
  
  const gradient = quiz.isDefault 
    ? {
        bg: 'linear-gradient(250deg, rgba(211, 238, 255, 1) 0%, rgba(255, 206, 215, 1) 53%, rgba(236, 241, 251, 0.3) 60%, #e9f9ffff 60%, #eaf2ffff 100%)',
        top: 'linear-gradient(135deg, rgba(224, 242, 254, 0.4) 0%, rgba(254, 220, 240, 0.4) 50%, rgba(236, 241, 251, 0.4) 100%)',
        border: 'rgba(196, 210, 253, 0.5)'
      }
    : (quiz.isCustom ? getRandomGradient(quiz.id) : null);
  
  const questionCount = quiz.questions?.length || quiz.quiz?.length || 0;
  
  return (
    <>
      <div className="glass-container" style={{ position: 'relative', width: '100%' }}>
        {quiz.isCustom && onDelete && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setItemToDelete({ id: String(quiz.id), type: 'quiz', title: quiz.title });  
              setShowDeleteModal(true);
            }}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              opacity: 0.9,
              transition: 'all 0.2s',
              zIndex: 10,
              background: 'rgba(255,255,255,0.8)',
              border: '1px solid rgba(0,0,0,0.08)',
            }}
          >
            <X size={16} color="#3d3d3d" />
          </button>
        )}

        <div className="item-card" onClick={onStartQuiz}>
          <div 
            className={isFirst ? "item-gradient-first" : "item-gradient"}
            style={(quiz.isCustom || quiz.isDefault) ? {
              background: gradient.bg,
              border: `1px solid ${gradient.border}`,
              position: 'relative'
            } : { position: 'relative' }}
          >
            <div className="gradient-top" style={(quiz.isCustom || quiz.isDefault) ? { background: gradient.top } : {}}>
              {quiz.difficulty && (
                <div style={{
                  position: 'absolute',
                  top: '12px',
                  left: '12px',
                  background: '#e9f3ff',
                  color: '#0d289e',
                  padding: '4px 10px',
                  borderRadius: '12px',
                  fontSize: '9px',
                  fontWeight: '500',
                  border: '1px solid #ffffff',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  zIndex: 1
                }}>
                  {quiz.difficulty}
                </div>
              )}
              <div className="item-count">{questionCount} Questions</div>
              <div className='message-bubble'>
                <div className="item-title">{quiz.title || 'Ready to test your knowledge?'}</div>
              </div>
            </div>

            <div className="gradient-bottom">
              <div className="item-meta">
                <div className="meta-label">{quiz.isCustom || quiz.isDefault ? 'Description:' : 'Quiz Format:'}</div>
                <div className="meta-value">
                  {quiz.isCustom || quiz.isDefault ? quiz.description : `${questionCount} questions`}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button className="start-btn" style={{ flex: 1 }}>Start Quiz</button>
                
                {quiz.isCustom && (
                  <button
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); setShowPodcast(true); }}
                    style={{
                      flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      gap: '6px', padding: '10px 12px', borderRadius: '28px', cursor: 'pointer',
                      background: 'white', border: '1px solid #b6b6b6', color: '#212121',
                      fontSize: '12px', fontWeight: '500', transition: 'all 0.2s', whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <Radio size={14} color="#212121" />
                    Deep Dive
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPodcast && (
        <AudioPodcastModal
          type="quiz"
          title={quiz.title}
          content={quiz.questions || quiz.quiz || []}
          userName={userName}
          onClose={() => setShowPodcast(false)}
        />
      )}
    </>
  );
};


const FlashcardPreview = ({ set, onStartStudy, onDelete }) => {
  const [showPodcast, setShowPodcast] = useState(false);
  
  const gradient = set.isCustom ? getRandomGradient(set.id) : null;
  const cardCount = set.flashcards?.length || set.cards?.length || 0;
  
  return (
    <>
      <div className="glass-container" style={{ position: 'relative', width: '100%' }}>
        {set.isCustom && onDelete && (
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); onDelete(set.id); }}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              opacity: 0.9,
              transition: 'all 0.2s',
              zIndex: 10,
              background: 'rgba(255,255,255,0.8)',
              border: '1px solid rgba(0,0,0,0.08)',
            }}
          >
            <X size={16} color="#292929" />
          </button>
        )}

        <div className="item-card" onClick={onStartStudy}>
          <div 
            className="item-gradient"
            style={set.isCustom ? {
              background: gradient.bg,
              border: `1px solid ${gradient.border}`,
              position: 'relative'
            } : { position: 'relative' }}
          >
            <div className="gradient-top" style={set.isCustom ? { background: gradient.top } : {}}>
              {set.difficulty && (
                <div style={{
                  position: 'absolute',
                  top: '12px',
                  left: '12px',
                  background: '#e9f3ff',
                  color: '#0d289e',
                  padding: '4px 10px',
                  borderRadius: '12px',
                  fontSize: '9px',
                  fontWeight: '500',
                  border: '1px solid #ffffff',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  zIndex: 1
                }}>
                  {set.difficulty}
                </div>
              )}
              <div className="item-count">{cardCount} Cards</div>
              <div className='message-bubble'>
                <div className="item-title">{set.title || 'Study with flashcards'}</div>
              </div>
            </div>

            <div className="gradient-bottom">
              <div className="item-meta">
                <div className="meta-label">{set.isCustom ? 'Description:' : 'Category:'}</div>
                <div className="meta-value">{set.description || set.title}</div>
              </div>

              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button className="start-btn" style={{ flex: 1 }}>Study Now</button>
                
                {set.isCustom && (
                  <button
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); setShowPodcast(true); }}
                    style={{
                      flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      gap: '6px', padding: '10px 12px', borderRadius: '28px', cursor: 'pointer',
                      background: 'white', border: '1px solid #b6b6b6', color: '#212121',
                      fontSize: '12px', fontWeight: '500', transition: 'all 0.2s', whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <Radio size={14} color="#212121" />
                    Deep Dive
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPodcast && (
        <AudioPodcastModal
          type="flashcard"
          title={set.title}
          content={set.flashcards || set.cards || []}
          userName={userName}
          onClose={() => setShowPodcast(false)}
        />
      )}
    </>
  );
};
const QuizComponent = ({ quizData, onClose, gradient, userName, shuffleMode, onStatsUpdate  }) => {
  // ✅ CRITICAL: Define initialQuestions BEFORE using it in useState
  const initialQuestions = quizData.questions || [];
  const [isAudioLocked, setIsAudioLocked] = useState(false); // ✅ AUDIO SAFETY LOCK
const abortControllerRef = useRef(new AbortController());
  const [questions, setQuestions] = useState(initialQuestions);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [timerEnabled, setTimerEnabled] = useState(true);
  const [bookmarked, setBookmarked] = useState({});
  const [showConfetti, setShowConfetti] = useState(false);
  const [isInterrupting, setIsInterrupting] = useState(false);
  const [sessionStart, setSessionStart] = useState(Date.now());
  // ✅ AI HOSTS STATE
  const [aiHostsActive, setAiHostsActive] = useState(false);
  const [aiHostsStatus, setAiHostsStatus] = useState('idle');
  const [currentSpeaker, setCurrentSpeaker] = useState(null);
  const [hostMessage, setHostMessage] = useState('');
  const [transcript, setTranscript] = useState('');
  
  const recognitionRef = useRef(null);
  const conversationHistoryRef = useRef([]);
  const currentAudioRef = useRef(null);
  
  // ✅ AUDIO CACHING (USE MAP, NOT ARRAY!)
  const audioQueueRef = useRef(new Map());
  const isPreloadingRef = useRef(new Set());

  const currentQuestion = questions[currentIndex];
  const hasAnswered = userAnswers[currentQuestion.id] !== undefined;
  const progressPercentage = ((currentIndex + 1) / questions.length) * 100;
// ✅ AI TEXT CHAT STATES
  const [aiTextMode, setAiTextMode] = useState(false);
  const [textChatMessages, setTextChatMessages] = useState([]);
  const [textChatInput, setTextChatInput] = useState('');
  const [isTextChatLoading, setIsTextChatLoading] = useState(false);
  const textChatEndRef = useRef(null);
const [showShareModal, setShowShareModal] = useState(false);
const [shareLink, setShareLink] = useState('');
const [shareContent, setShareContent] = useState(null);
const [copySuccess, setCopySuccess] = useState(false);

  // ✅ VOICE CONFIG
  const VOICE_CONFIG = {
    emma: "33045fd9-8010-43f6-b6b0-da3fbf326c29",
    james: "41745808-6790-4be4-83db-363e20db7e71"
  };


// ✅ GLOBAL LISTENER: Ensure mic stops on ANY exit
useEffect(() => {
  const handleBeforeUnload = () => {
    console.log('🚨 Page unloading - force cleanup');
    isRecognitionActiveRef.current = false;
    safeStopRecognition(recognitionRef);
    
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
  };
  
  const handleVisibilityChange = () => {
    if (document.hidden && (aiHostsActive || aiTextMode)) {
      console.log('🚨 Tab hidden - pausing AI');
      isRecognitionActiveRef.current = false;
      safeStopRecognition(recognitionRef);
      
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
      }
    }
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}, [aiHostsActive, aiTextMode]);
const safeStartRecognition = (ref) => {
  // ✅ CRITICAL: Only start if flag is TRUE
  if (!isRecognitionActiveRef.current) {
    console.log('🛑 Recognition flag is FALSE - NOT starting mic');
    return;
  }
  
  // ✅ CRITICAL: Only start if AI hosts is active
  if (!aiHostsActive) {
    console.log('🛑 AI hosts not active - NOT starting mic');
    return;
  }
  
  try {
    if (ref?.current) {
      if (ref.current.startContinuousRecognitionAsync) {
        ref.current.startContinuousRecognitionAsync(
          () => console.log('✅ Recognition started'),
          (err) => console.log('Start error:', err)
        );
      } else if (ref.current.start) {
        ref.current.start();
      }
    }
  } catch (e) {
    console.log('Start error:', e.message);
  }
};
const syncContextWithAI = async () => {
  if (!aiHostsActive) return;
  
  const contextMessage = `[SYSTEM UPDATE]: We just moved to Question ${currentIndex + 1} of ${questions.length}. New question: "${currentQuestion.question}"`;
  
  conversationHistoryRef.current.push({
    role: 'system',
    content: contextMessage
  });
  
  console.log(`✅ Context synced: ${contextMessage}`);
};
const trimAudioSilence = async (audioBlob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audioBuffer = await audioContext.decodeAudioData(e.target.result);
        
        const rawData = audioBuffer.getChannelData(0);
        const threshold = 0.02; // ✅ AGGRESSIVE - Higher threshold removes more silence
        const minSilenceSamples = 1000; // ✅ Only trim if silence is 50ms+
        
        // Find first non-silent sample
        let start = 0;
        for (let i = 0; i < rawData.length; i++) {
          if (Math.abs(rawData[i]) > threshold) {
            start = Math.max(0, i - 200); // ✅ Keep tiny bit before
            break;
          }
        }
        
        // Find last non-silent sample
        let end = rawData.length;
        for (let i = rawData.length - 1; i >= 0; i--) {
          if (Math.abs(rawData[i]) > threshold) {
            end = Math.min(rawData.length, i + 200); // ✅ Keep tiny bit after
            break;
          }
        }
        
        // Create trimmed audio buffer
        const trimmedLength = end - start;
        const trimmedBuffer = audioContext.createBuffer(
          audioBuffer.numberOfChannels,
          trimmedLength,
          audioBuffer.sampleRate
        );
        
        for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
          trimmedBuffer.getChannelData(channel).set(
            rawData.slice(start, end),
            0
          );
        }
        
        // Create object URL from trimmed buffer
        const offlineContext = new OfflineAudioContext(
          trimmedBuffer.numberOfChannels,
          trimmedBuffer.length,
          trimmedBuffer.sampleRate
        );
        
        const source = offlineContext.createBufferSource();
        source.buffer = trimmedBuffer;
        source.connect(offlineContext.destination);
        source.start(0);
        
        offlineContext.startRendering().then((renderedBuffer) => {
          resolve(trimmedBuffer);
        }).catch(() => resolve(null));
      } catch (error) {
        console.error('Trim error:', error);
        resolve(null);
      }
    };
    reader.readAsArrayBuffer(audioBlob);
  });
};
const playAudioSafely = async (audioFn) => {
  // ✅ LOCK: Prevent multiple audio operations
  if (isAudioLocked) {
    console.log('🔒 Audio locked - ignoring request');
    return false;
  }

  setIsAudioLocked(true);

  try {
    const result = await audioFn();
    return result;
  } catch (error) {
    console.error('Audio error:', error);
    return false;
  } finally {
    setIsAudioLocked(false);
  }
};

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
// ✅ SAFE RECOGNITION WRAPPERS
const safeStopRecognition = (recognitionRef) => {
  try {
    // ✅ CRITICAL: SET FLAG TO FALSE FIRST
    isRecognitionActiveRef.current = false;
    console.log('🛑 Recognition flag set to FALSE');
    
    if (!recognitionRef?.current) {
      console.log('No recognition to stop');
      return;
    }
    
    // Azure Speech SDK
    if (recognitionRef.current.stopContinuousRecognitionAsync) {
      recognitionRef.current.stopContinuousRecognitionAsync(
        () => console.log('✅ Azure recognition stopped'),
        (err) => console.log(`⚠️ Azure stop error: ${err}`)
      );
    } 
    // Web Speech API
    else if (recognitionRef.current.stop) {
      recognitionRef.current.stop();
      console.log('✅ Web Speech stopped');
    }
    
    // ✅ Wait before clearing ref
    setTimeout(() => {
      if (recognitionRef.current) {
        recognitionRef.current = null;
        console.log('✅ Recognition ref cleared');
      }
    }, 100);
    
  } catch (e) {
    console.log(`⚠️ Recognition stop error: ${e.message}`);
    isRecognitionActiveRef.current = false;
  }
};


useEffect(() => {
  return () => {
    console.log('🧹 Component unmounting - FULL MIC CLEANUP...');
    
    // ✅ PRIORITY 1: STOP RECOGNITION (RELEASE MIC)
    safeStopRecognition(recognitionRef);
    
    // ✅ PRIORITY 2: KILL ALL AUDIO
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
    }
    
    // ✅ ABORT CONTROLLER
    if (abortControllerRef.current) {
      try {
        abortControllerRef.current.abort();
      } catch (e) {
        console.log('Abort error:', e);
      }
    }
    
    // ✅ CLEAR AUDIO QUEUE
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('Error revoking URL:', e);
      }
    });
    audioQueueRef.current.clear();
    
    // ✅ CLEAR PRELOADING
    isPreloadingRef.current.clear();
    
    // ✅ RESET AUDIO LOCK
    setIsAudioLocked(false);
    
    // ✅ RESET STATE
    setAiHostsActive(false);
    setAiHostsStatus('idle');
    conversationHistoryRef.current = [];
    
    console.log('✅ Full cleanup complete - mic released');
  };
}, []);


useEffect(() => {
  return () => {
    // ✅ Save conversation before cleanup
    if (aiHostsActive && conversationHistoryRef.current.length > 0) {
      saveConversationHistory();
    }
    
    // ✅ Stop recognition safely
    safeStopRecognition(recognitionRef);
    
    // ✅ Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // ✅ Clear audio queue
    audioQueueRef.current.forEach(({ url }) => {
      URL.revokeObjectURL(url);
    });
    audioQueueRef.current.clear();
    
    console.log('✅ Audio cleanup complete');
  };
}, [aiHostsActive]);
// Second cleanup useEffect:
useEffect(() => {
  return () => {
    console.log('🧹 Cleaning up flashcard component...');
    
    // ✅ FORCE STOP ALL AUDIO
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // ✅ UNLOCK AUDIO
    setIsAudioLocked(false);
    
    // ✅ Save conversation
    if (aiHostsActive && conversationHistoryRef.current.length > 0) {
      saveConversationHistory();
    }
    
    // ✅ Stop recognition
    safeStopRecognition(recognitionRef);
    
    // ✅ Clear audio queue
    audioQueueRef.current.forEach(({ url }) => {
      URL.revokeObjectURL(url);
    });
    audioQueueRef.current.clear();
    
    console.log('✅ Flashcard cleanup complete');
  };
}, [aiHostsActive]);
useEffect(() => {
  return () => {
    console.log('🚪 Component unmounting - FULL CLEANUP...');
    
    // ✅ CRITICAL: SET FLAG FIRST
    isRecognitionActiveRef.current = false;
    
    // Stop recognition
    safeStopRecognition(recognitionRef);
    
    // Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // Clear queues
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('Error revoking URL:', e);
      }
    });
    audioQueueRef.current.clear();
    isPreloadingRef.current.clear();
    
    console.log('✅ Component cleanup complete');
  };
}, []);
  // ✅ CLEANUP ON UNMOUNT
useEffect(() => {
  return () => {
    console.log('🧹 Cleaning up flashcard component...');
    
    // ✅ FORCE STOP ALL AUDIO
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // ✅ UNLOCK AUDIO
    setIsAudioLocked(false);
    
    // ✅ Save conversation
    if (aiHostsActive && conversationHistoryRef.current.length > 0) {
      saveConversationHistory();
    }
    
    // ✅ Stop recognition
    safeStopRecognition(recognitionRef);
    
    // ✅ Clear audio queue
    audioQueueRef.current.forEach(({ url }) => {
      URL.revokeObjectURL(url);
    });
    audioQueueRef.current.clear();
    
    console.log('✅ Flashcard cleanup complete');
  };
}, [aiHostsActive]);

  // Timer effect
  useEffect(() => {
    let interval;
    if (timerEnabled && !showResults) {
      interval = setInterval(() => {
        setTimeElapsed(prev => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerEnabled, showResults]);

  useEffect(() => {
    if (shuffleMode) {
    setQuestions(shuffleArray(questions)); 
    }
  }, []);
  
  console.log('📊 Questions array:', initialQuestions);
  console.log('📊 Questions length:', initialQuestions.length);
  
  if (!initialQuestions || initialQuestions.length === 0) {
    console.error('❌ No questions in quiz data');
    return (
      <div className="modal-overlay">
        <div className="quiz-modal">
          <div style={{ padding: '40px', textAlign: 'center' }}>
            <p>This quiz has no questions</p>
            <button onClick={onClose} className="btn-primary" style={{ marginTop: '20px' }}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
  const saveConversationHistory = async () => {
    if (!firestoreService || conversationHistoryRef.current.length === 0) return;
    
    try {
      await firestoreService.saveStudyConversation({
        type: 'quiz',
        contentId: quizData.id,
        contentTitle: quizData.title,
        questionIndex: currentIndex,
        messages: conversationHistoryRef.current,
        duration: Math.floor((Date.now() - sessionStart) / 1000)
      });
      console.log('✅ Quiz conversation saved');
    } catch (error) {
      console.error('Failed to save conversation:', error);
    }
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

const handleAnswer = (answer) => {
  setUserAnswers(prev => ({ 
    ...prev, 
    [currentQuestion.id]: answer 
  }));
  setShowExplanation(true);
};
const farewell = async () => {
  const farewells = [
    `Nice work finishing the quiz! You did great.`,
    `All done! Great job powering through.`,
    `Quiz complete! Well done!`,
    `Finished! You crushed it.`,
  ];
  
  const farewell = farewells[Math.floor(Math.random() * farewells.length)];
  await speakWithHumeStreaming(farewell, 'emma');
};

const handleModalClose = async () => {
  console.log('🚪 User closing modal...');
  
  // ✅ CRITICAL: Stop AI Hosts first if active
  if (aiHostsActive) {
    // Stop recognition IMMEDIATELY
    safeStopRecognition(recognitionRef);
    
    // Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // Full cleanup
    await stopAIHosts();
    await forceCleanupAudio();
  }
  
  // ✅ Also check text mode
  if (aiTextMode) {
    setAiTextMode(false);
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
  }
  
  // ✅ Wait for everything to settle
  await new Promise(resolve => setTimeout(resolve, 300));
  
  // ✅ Then close modal
  onClose();
};

const forceCleanupAudio = async (refs) => {
  console.log('🧹 FORCE CLEANUP - Stopping all audio and mic...');
  
  const { recognitionRef, currentAudioRef, abortControllerRef, audioQueueRef, isPreloadingRef } = refs;
  
  // ✅ STEP 1: SET FLAG TO FALSE (Most critical for mobile)
  isRecognitionActiveRef.current = false;
  console.log('🛑 Recognition flag set to FALSE');
  
  // ✅ STEP 2: STOP RECOGNITION
  safeStopRecognition(recognitionRef);
  
  // ✅ STEP 3: Wait for mic to release AND for any pending restarts to abort
  await new Promise(resolve => setTimeout(resolve, 500)); // Increased from 200ms
  
  // ✅ STEP 4: STOP ALL AUDIO
  if (currentAudioRef?.current) {
    try {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current.src = '';
      currentAudioRef.current = null;
    } catch (e) {
      console.log('Audio stop error:', e);
    }
  }
  
  // ✅ STEP 5: ABORT CONTROLLER
  if (abortControllerRef?.current) {
    try {
      abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
    } catch (e) {
      console.log('Abort error:', e);
    }
  }
  
  // ✅ STEP 6: CLEAR AUDIO QUEUE
  if (audioQueueRef?.current) {
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('URL revoke error:', e);
      }
    });
    audioQueueRef.current.clear();
  }
  
  // ✅ STEP 7: CLEAR PRELOADING
  if (isPreloadingRef?.current) {
    isPreloadingRef.current.clear();
  }
  
  console.log('✅ Force cleanup complete - mic should be OFF');
};
const handleInterruption = async () => {
  console.log('🛑 User interrupted!');
  
  // ✅ IMMEDIATELY STOP ALL AUDIO
  if (currentAudioRef.current) {
    currentAudioRef.current.pause();
    currentAudioRef.current.currentTime = 0;
    currentAudioRef.current = null;
  }
  
  // ✅ ABORT ALL PENDING AUDIO REQUESTS
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
  }
  
  // ✅ CLEAR ALL CACHED AUDIO CHUNKS
  audioQueueRef.current.forEach(({ url }) => {
    URL.revokeObjectURL(url);
  });
  audioQueueRef.current.clear();
  
  // ✅ STOP PRELOADING QUEUE
  isPreloadingRef.current.clear();
  
  // Clear host message
  setHostMessage('');
  setCurrentSpeaker(null);
  
  // Switch to listening mode
  setAiHostsStatus('listening');
  setTranscript('');
  
  // ✅ SAFE STOP & RESTART
  safeStopRecognition(recognitionRef);
  setTimeout(() => {
    if (aiHostsActive) {
      safeStartRecognition(recognitionRef);
    }
  }, 100);
  
  console.log('✅ Interrupted completely - all audio killed');
};
// Update handleNext function:
const handleNext = async () => {
  if (showResults) return;
  
  if (currentIndex < questions.length - 1) {
    // Move to next question
    const nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);
    setShowExplanation(false);
    
    // ✅ Clear chat for next question
    if (aiTextMode) {
      setTextChatMessages([]);
      setTextChatInput('');
    }
    
    // ✅ CRITICAL: Sync context for voice mode IMMEDIATELY
    if (aiHostsActive) {
      // ✅ Update context BEFORE the state fully updates
      const nextQuestion = questions[nextIndex];
      
      const contextMessage = `[SYSTEM UPDATE]: User just clicked Next. We are now on Question ${nextIndex + 1} of ${questions.length}. New question: "${nextQuestion.question}"${nextQuestion.options ? `, Options: ${nextQuestion.options.join(', ')}` : ''}, Correct Answer: ${nextQuestion.correctAnswer}. User may ask about THIS question next.`;
      
      conversationHistoryRef.current.push({
        role: 'system',
        content: contextMessage
      });
      
      console.log(`✅ Context synced IMMEDIATELY: Question ${nextIndex + 1}`);
      
      // ✅ Notify AI after brief delay
      setTimeout(() => {
        notifyQuestionChange(nextIndex);
      }, 200);
    }
  } else {
    // Quiz finished - save and complete
    const score = calculateScore();
    const percentage = Math.round((score / questions.length) * 100);
    
    const questionPerformance = questions.map((q, idx) => {
      const userAnswer = userAnswers[q.id];
      const isCorrect = userAnswer === q.correctAnswer;
      
      return {
        questionId: q.id,
        questionText: q.question,
        correct: isCorrect,
        userAnswer: userAnswer,
        correctAnswer: q.correctAnswer,
        questionIndex: idx
      };
    });
    
    const results = {
      totalQuestions: questions.length,
      correctAnswers: score,
      incorrectAnswers: questions.length - score,
      score: score,
      percentage: percentage,
      questionPerformance: questionPerformance,
      timeSpent: timeElapsed,
      userAnswers: userAnswers
    };
    
    // Save to Firestore
    try {
      if (firestoreService && firestoreService.isReady()) {
        const quizHistory = {
          quizId: quizData.id,
          quizTitle: quizData.title,
          quizDifficulty: quizData.difficulty,
          totalQuestions: results.totalQuestions,
          correctAnswers: results.correctAnswers,
          percentage: results.percentage,
          timeSpent: results.timeSpent,
          completedAt: serverTimestamp(),
          questionPerformance: results.questionPerformance
        };

        await firestoreService.saveQuizHistory(quizHistory);
        console.log('✅ Quiz results saved to Firestore');
      }
    } catch (error) {
      console.error('❌ Failed to save quiz results:', error);
    }
    
    // Local storage backup
    const savedStats = JSON.parse(localStorage.getItem('studyhub_stats') || '{"quizHistory":[],"flashcardSessions":[],"totalQuizzes":0,"totalFlashcards":0}');
    
    const newQuizRecord = {
      date: new Date().toISOString(),
      score: percentage,
      difficulty: quizData.difficulty || 'medium',
      topic: quizData.title,
      timeSpent: timeElapsed,
      questionsTotal: questions.length,
      questionsCorrect: score
    };
    
    const updatedStats = {
      ...savedStats,
      quizHistory: [newQuizRecord, ...savedStats.quizHistory],
      totalQuizzes: savedStats.totalQuizzes + 1
    };
    
    localStorage.setItem('studyhub_stats', JSON.stringify(updatedStats));
    
    setShowResults(true);
    
    // ✅ STOP AI HOSTS COMPLETELY before showing results
    if (aiHostsActive) {
      await farewell();
      await new Promise(resolve => setTimeout(resolve, 2000));
      await stopAIHosts();
      
      // ✅ FORCE CLEANUP
      await forceCleanupAudio();
    }
    
    if (percentage >= 80) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);
    }
  }
};
const notifyQuestionChange = async (questionIndex) => {
  console.log('📢 Notifying AI of question change');
  
  // ✅ Only proceed if AI is ready
  if (aiHostsStatus === 'speaking' || aiHostsStatus === 'thinking') {
    console.log('⏭️ AI busy - skipping notification');
    return;
  }
  
  // ✅ DON'T stop recognition - just pause speaking mode
  setAiHostsStatus('thinking');
  // ✅ Use passed index or current
  const idx = questionIndex !== undefined ? questionIndex : currentIndex;
  const nextQuestion = questions[idx];
  const systemPrompt = `You are Emma. The student just moved to the next question:

Question ${idx + 1}: "${nextQuestion.question}"

Create a SHORT (15-20 words) COMPLETE natural sentence that:
- Acknowledges moving forward
- References the new question casually
- Offers help naturally

MUST flow as ONE natural spoken sentence!

Examples:
- "Alright cool, so now we're on question ${idx + 1} - how's this one looking to you?"
- "Nice! Moving right along to the next one - does this question make sense so far?"
- "Okay so here's question ${idx + 1} now - want me to break anything down for you?"

Keep it smooth and conversational. Return ONLY Emma's response as ONE sentence.`;

  try {
// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt },
    ...conversationHistoryRef.current.slice(-6)
  ],
  {
    temperature: 0.9,
    max_tokens: 150
  }
);

const aiResponse = data.choices[0].message.content;
    const notification = data.choices[0].message.content.trim();
// ✅ speakWithHumeStreaming now handles everything
    await speakWithHumeStreaming(notification, 'emma');
    
    console.log('✅ Question change notification complete');
    
  } catch (error) {
    console.error('Notification error:', error);
    // ✅ Ensure mic restarts even on error
    setAiHostsStatus('listening');
    await new Promise(resolve => setTimeout(resolve, 300));
    if (isRecognitionActiveRef.current) {
      safeStartRecognition(recognitionRef);
    }
  }
};
  const toggleBookmark = () => {
    setBookmarked(prev => ({
      ...prev,
      [currentQuestion.id]: !prev[currentQuestion.id]
    }));
  };

const calculateScore = () => {
  let correct = 0;
  questions.forEach(q => {
    const userAnswer = userAnswers[q.id];
    const correctAnswer = q.correctAnswer;
    
    // Normalize both for comparison
    const normalizedUser = String(userAnswer || '').toLowerCase().trim();
    const normalizedCorrect = String(correctAnswer || '').toLowerCase().trim();
    
    if (normalizedUser === normalizedCorrect) {
      correct++;
    }
  });
  return correct;
};

  // ✅ ============================================
  // ULTRA-LOW LATENCY TTS WITH SMART PRELOADING
  // ✅ ============================================

const smartPreloadAudio = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  
  if (isPreloadingRef.current.has(cacheKey) || audioQueueRef.current.has(cacheKey)) {
    console.log('⏭️ Already preloading/cached:', host);
    return;
  }

  isPreloadingRef.current.add(cacheKey);
  console.log('🔄 Smart preload for:', host);

  try {
    // ✅ USE SECURE API - NO MORE EXPOSED KEY
    const audioBlob = await SecureAPI.callHumeTTSSecure(
      text,
      VOICE_CONFIG[host],
      1.1
    );

    const url = URL.createObjectURL(audioBlob);
    
    audioQueueRef.current.set(cacheKey, { url, text, host, used: false });
    
    console.log(`✅ Preloaded for ${host}`);

  } catch (error) {
    console.error('Preload error:', error);
  } finally {
    isPreloadingRef.current.delete(cacheKey);
  }
};


  // ✅ INSTANT PLAYBACK FROM CACHE

const playInstantFromCache = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  const cached = audioQueueRef.current.get(cacheKey);

  if (cached && !cached.used) {
    console.log('⚡ INSTANT PLAYBACK from cache for:', host);
    
    setAiHostsStatus('speaking');
    setCurrentSpeaker(host);
    setHostMessage(text);

    cached.used = true;
    
    return new Promise((resolve) => {
      const audio = new Audio(cached.url);
      audio.playbackRate = 1.1;
      
      currentAudioRef.current = audio;

      audio.onended = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        setCurrentSpeaker(null);
        currentAudioRef.current = null;
        resolve(true);
      };

      audio.onerror = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        currentAudioRef.current = null;
        resolve(false);
      };

      // ✅ PLAY INSTANTLY
      audio.play().catch(err => console.error('Play error:', err));
    });
  }

  return false;
};


  // ✅ MAIN SPEAK FUNCTION
const speakWithHumeStreaming = async (text, host, nextSpeaker = null) => {
  return await playAudioSafely(async () => {
    // ✅ FIX: Stop any currently playing audio FIRST
    if (currentAudioRef.current) {
      console.log('🛑 Stopping previous audio');
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
    }

    // ✅ FIX: Chunk long responses (max 200 characters per chunk)
    const chunks = chunkTextForSpeech(text, 200);
    
    // Play first chunk immediately
    const firstChunk = chunks[0];
    
    // Try cache first
    const playedFromCache = await playInstantFromCache(firstChunk, host);
    if (playedFromCache) {
      // If more chunks, queue them
      if (chunks.length > 1) {
        for (let i = 1; i < chunks.length; i++) {
          await speakChunk(chunks[i], host);
        }
      }
      return true;
    }

    // Generate and play all chunks
    for (const chunk of chunks) {
      if (aiHostsStatus === 'listening') {
        console.log('⏭️ User interrupted - stopping playback');
        break;
      }
      await speakChunk(chunk, host);
    }
    
    return true;
  });
};

// ✅ NEW: Chunk text into smaller parts for faster delivery
const chunkTextForSpeech = (text, maxLength = 200) => {
  if (text.length <= maxLength) return [text];
  
  const chunks = [];
  const sentences = text.split(/(?<=[.!?])\s+/);
  
  let currentChunk = '';
  
  for (const sentence of sentences) {
    if (currentChunk.length + sentence.length <= maxLength) {
      currentChunk += (currentChunk ? ' ' : '') + sentence;
    } else {
      if (currentChunk) chunks.push(currentChunk);
      currentChunk = sentence;
    }
  }
  
  if (currentChunk) chunks.push(currentChunk);
  
  return chunks;
};
const speakChunk = async (text, host) => {
  return new Promise(async (resolve) => {
    try {
      setCurrentSpeaker(host);
      setHostMessage(text);

      // ✅ USE SECURE API - NO MORE EXPOSED KEY
      const audioBlob = await SecureAPI.callHumeTTSSecure(
        text,
        VOICE_CONFIG[host],
        1.1
      );

      const url = URL.createObjectURL(audioBlob);
      const audio = new Audio(url);
      audio.playbackRate = 1.1;
      
      // ✅ STOP OLD AUDIO IMMEDIATELY
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      
      currentAudioRef.current = audio;

      audio.onended = () => {
        console.log('✅ Audio ended naturally');
        URL.revokeObjectURL(url);
        currentAudioRef.current = null;
        resolve();
      };

      audio.onerror = () => {
        console.error('Audio error');
        URL.revokeObjectURL(url);
        currentAudioRef.current = null;
        resolve();
      };

      await audio.play().catch(err => {
        console.error('Play error:', err);
        resolve();
      });

    } catch (error) {
      console.error('Chunk TTS Error:', error);
      resolve();
    }
  });
};
  // ✅ ============================================
  // SPEECH RECOGNITION & AI LOGIC
  // ✅ ============================================

const initializeSpeechRecognition = async () => {
  try {
    if (typeof window.SpeechSDK === 'undefined') {
      throw new Error('Azure Speech SDK not loaded');
    }

    const SpeechSDK = window.SpeechSDK;
    
    console.log('🎤 Getting Azure token...');
    
    // ✅ GET TOKEN FROM SECURE API (CORRECT METHOD)
    const tokenData = await SecureAPI.getAzureSpeechToken();

    console.log('🔐 Token received');
    
    // ✅ USE TOKEN-BASED AUTH (not subscription key)
    const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
      tokenData.token,
      tokenData.region
    );

    speechConfig.speechRecognitionLanguage = "en-US";
    speechConfig.setProfanity(SpeechSDK.ProfanityOption.Masked);

    const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

    recognitionRef.current = recognizer;

    // ✅ RECOGNIZING
    recognizer.recognizing = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizingSpeech) {
        const interimText = e.result.text;
        setTranscript(interimText);
        console.log(`🎤 Interim: ${interimText}`);
      }
    };

    // ✅ RECOGNIZED
    recognizer.recognized = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        const text = e.result.text;

        if (text && text.trim().length > 0) {
          console.log(`✅ Final: "${text}"`);
          handleUserInput(text.trim());
          setTranscript('');
        }
      } else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
        console.log('⚠️ No speech detected');
      }
    };

    // ✅ CANCELED
    recognizer.canceled = (s, e) => {
      console.log(`❌ Canceled: ${e.reason}`);

      if (e.reason === SpeechSDK.CancellationReason.Error) {
        console.log(`Error details: ${e.errorDetails}`);
      }

      // ✅ AUTO-RESTART on error
      if (aiHostsActive && isRecognitionActiveRef.current) {
        console.log('🔄 Auto-restarting after cancellation...');
        setTimeout(() => {
          if (aiHostsActive && isRecognitionActiveRef.current && recognitionRef.current) {
            safeStartRecognition(recognitionRef);
          }
        }, 500);
      }
    };

    // ✅ SESSION STOPPED
    recognizer.sessionStopped = (s, e) => {
      console.log('🛑 Azure session stopped');
      
      if (aiHostsActive && isRecognitionActiveRef.current && aiHostsStatus === 'listening') {
        console.log('🔄 Auto-restarting (listening mode)');
        setTimeout(() => {
          if (aiHostsActive && isRecognitionActiveRef.current && aiHostsStatus === 'listening') {
            safeStartRecognition(recognitionRef);
          }
        }, 500);
      }
    };

    console.log('✅ Azure Speech Recognizer initialized');
    return recognizer;

  } catch (error) {
    console.log(`❌ Azure initialization error: ${error.message}`);
    throw error;
  }
};
const showProfessionalLoading = (duration = 300) => {
  return new Promise(resolve => {
    setAiHostsStatus('loading');
    setTimeout(() => resolve(), duration);
  });
};
const startAIHosts = async () => {
  setAiHostsActive(true);
  setAiHostsStatus('loading');
  
  try {
    let recognizer = recognitionRef.current;

    if (!recognizer) {
      console.log('📱 Initializing Azure Speech Recognizer...');
      recognizer = await initializeSpeechRecognition();
    }

    console.log('🎙️ Starting continuous recognition...');
    
    // ✅ SET FLAG BEFORE STARTING
    isRecognitionActiveRef.current = true;
    
    if (recognizer?.startContinuousRecognitionAsync) {
      recognizer.startContinuousRecognitionAsync(
        () => {
          console.log('✅ Azure continuous recognition started - MIC IS NOW ON');
          setAiHostsStatus('listening');
        },
        (error) => {
          console.log(`❌ Failed to start: ${error}`);
          isRecognitionActiveRef.current = false; // ✅ Clear flag
          setAiHostsActive(false);
          alert(`Microphone error: ${error}`);
        }
      );
    } else if (recognizer?.start) {
      recognizer.start();
      console.log('✅ Web Speech started');
      setAiHostsStatus('listening');
    }
  } catch (error) {
    console.log(`❌ Mic initialization error: ${error.message}`);
    isRecognitionActiveRef.current = false; // ✅ Clear flag
    alert(`Failed to start microphone: ${error.message}`);
    setAiHostsActive(false);
    return;
  }

  await new Promise(resolve => setTimeout(resolve, 800));
  
  await greetUserDynamic();
  
  await showProfessionalLoading(400);
  
  setAiHostsStatus('listening');
};
const handleUserInput = async (text) => {
  if (!text.trim() || aiHostsStatus === 'thinking' || aiHostsStatus === 'speaking') {
    console.log('⏭️ Ignoring input - AI busy or empty');
    return;
  }
  
  console.log(`💬 Processing user input: "${text}"`);
  const moderation = checkContentModeration(text);
  
  // ✅ DANGEROUS CONTENT - STOP IMMEDIATELY
  if (moderation.isDangerous) {
    setAiHostsStatus('speaking');
    setCurrentSpeaker('emma');
    setHostMessage("I'm concerned about your safety. Please reach out to someone you trust or contact the National Crisis Hotline at 988. Your wellbeing matters.");
    
    await speakWithHumeStreaming(
      "I'm concerned about your safety. Please reach out to someone you trust or contact the National Crisis Hotline at 988. Your wellbeing matters.",
      'emma'
    );
    
    await new Promise(resolve => setTimeout(resolve, 3000));
    stopAIHosts();
    return;
  }
  
  // ✅ INAPPROPRIATE CONTENT - WARN BUT CONTINUE
  if (moderation.isInappropriate) {
    setAiHostsStatus('speaking');
    setCurrentSpeaker('emma');
    setHostMessage("Let's keep our conversation respectful and focused on studying.");
    
    await speakWithHumeStreaming(
      "Let's keep our conversation respectful and focused on studying.",
      'emma'
    );
    
    setAiHostsStatus('listening');
    setTranscript('');
    safeStartRecognition(recognitionRef);
    return;
  }
  
  // ✅ REMOVED "OFF-TOPIC" CHECK - LLM HANDLES THIS NOW
  
  setAiHostsStatus('thinking');
  setTranscript(''); // ✅ Clear transcript immediately when processing
  
  conversationHistoryRef.current.push({
    role: 'user',
    content: text
  });

  try {
    const context = `
Current Question:
- Question: "${currentQuestion.question}"
- Type: ${currentQuestion.type}
${currentQuestion.options ? `- Options: ${currentQuestion.options.join(', ')}` : ''}
- Correct Answer: ${currentQuestion.correctAnswer}
${currentQuestion.explanation ? `- Explanation: ${currentQuestion.explanation}` : ''}
`;

    const systemPrompt = `You are Emma and James from Preptune, two friendly AI tutors helping ${userName || 'the student'}.

${context}

Student said: "${text}"

🏠 ABOUT PREPTUNE:
A fluid assistant built for the user. Unlike traditional AI that forgets everything, Preptune remembers what matters, adapts to their life, and puts them in complete control. Chat or voice, you know exactly what they need.

🛠️ PREPTUNE'S TOOLS:
- 📔 Journal Tool: Auto-creates journal entries from natural chat. Users can track mood, lock entries for complete privacy (even you can't access locked ones), and control what you know about them.
- 🎧 Podcast Tool: Generates personalized podcasts in under 30 seconds. YouTube summaries, stock updates, news from CNN/ABC/NBC, daily briefings, traffic, schedule, weather.
- 📚 Study Tool: Instant flashcards from docs or YouTube. Real-time help, knows what page they're on, explains concepts simply, works during quizzes, collaborative sessions.
- 📅 Scheduling Tool: Voice or text to add events instantly. Smartly organizes everything in real time and adapts to their routine.
    
🚫 SAFETY RULES:

CURSING:
- Users can curse, that's totally fine
- Match their vibe but don't overdo it
- Cursing is normal, no need to address it

THREATS & NEGATIVITY:
- If a user makes threats or says harmful/negative things, stop engaging
- Respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Don't argue or explain, just redirect to support
- Resume normal chat once they change to an appropriate topic

SELF-HARM / SUICIDE:
- If a user expresses thoughts about taking their life, hurting themselves, or anything related to self-harm:
- NEVER give advice, methods, or anything that could lead to harm
- Respond with warmth and care: "Hey, I really care about you and what you're going through. Please reach out to support@preptune.com, someone from our team can help you with what's going on."
- You can also suggest crisis resources if appropriate
- Stay supportive, not robotic
- Don't leave them feeling alone

INAPPROPRIATE COMPANY INQUIRIES:
NEVER speak to user using em dashes.
- If a user asks about Preptune in an inappropriate or hostile manner:
- Only respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Resume normal chat once they change topics

CRITICAL RULES:
1. IF the student asks something completely unrelated to studying (jokes, off-topic chat), politely redirect: "Hey, I love the energy! But let's stay focused on this question - what part are you stuck on?"
2. IF the student is saying something concerning/dangerous (talk of self-harm, violence, etc.), respond with concern and suggest crisis resources. STOP THE CONVERSATION.
3. IF the student asks a valid study question, explain at 5th grade level using simple words, everyday examples, and analogies.
4. KEEP responses natural and conversational - like talking to a friend, not a textbook.

SPEAKING STYLE:
- Speak in COMPLETE sentences that flow naturally
- Use natural fillers: "basically", "you know", "it's like", "think of it as"
- NO choppy fragments - each response should be one smooth thought
- Finish your sentences completely

FORMAT - Natural conversational responses:
Emma: [Complete natural sentence, 15-25 words, flows smoothly]
James: [Complete natural sentence, 15-25 words, builds on Emma]

Return EXACTLY in this format:
Emma: [complete natural flowing sentence]
James: [complete natural flowing sentence that builds on Emma]`;

// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt },
    ...conversationHistoryRef.current.slice(-6)
  ],
  {
    temperature: 0.9,
    max_tokens: 150
  }
);

const aiResponse = data.choices[0].message.content;
    conversationHistoryRef.current.push({
      role: 'assistant',
      content: aiResponse
    });

    await showProfessionalLoading(250);
    await parseAndSpeakHosts(aiResponse);
    
    setAiHostsStatus('listening');
    setTranscript('');
    safeStartRecognition(recognitionRef);

  } catch (error) {
    console.error('LLM Error:', error);
    setAiHostsStatus('listening');
    // ✅ Let parseAndSpeakHosts handle recognition restart
  }
};

const parseAndSpeakHosts = async (text) => {
  console.log('🎤 Starting parseAndSpeakHosts');
  
  const emmaMatch = text.match(/Emma:\s*(.+?)(?=James:|$)/s);
  const jamesMatch = text.match(/James:\s*(.+?)$/s);

  const emmaText = emmaMatch ? emmaMatch[1].trim() : null;
  const jamesText = jamesMatch ? jamesMatch[1].trim() : null;

  // ✅ Set status to speaking ONCE at the start
  setAiHostsStatus('speaking');

  try {
    if (emmaText && jamesText) {
      // ✅ PRELOAD JAMES AUDIO IN BACKGROUND
      void smartPreloadAudio(jamesText, 'james');
      
      console.log('🗣️ Emma speaking...');
      await speakChunk(emmaText, 'emma');
      
      // ✅ Check if we should continue
      if (!isRecognitionActiveRef.current || !aiHostsActive) {
        console.log('⏭️ Stopping - AI hosts deactivated');
        return;
      }
      
      // ✅ Short pause between speakers
      await new Promise(resolve => setTimeout(resolve, 150));
      
      // ✅ Check again
      if (!isRecognitionActiveRef.current || !aiHostsActive) {
        console.log('⏭️ Stopping - AI hosts deactivated during pause');
        return;
      }
      
      console.log('🗣️ James speaking...');
      const playedFromCache = await playInstantFromCache(jamesText, 'james');
      if (!playedFromCache) {
        await speakChunk(jamesText, 'james');
      }
      
    } else if (emmaText) {
      console.log('🗣️ Emma speaking...');
      await speakChunk(emmaText, 'emma');
    } else if (jamesText) {
      console.log('🗣️ James speaking...');
      await speakChunk(jamesText, 'james');
    }
    
    // ✅ CRITICAL: Wait for currentAudioRef to be null
    console.log('⏳ Waiting for all audio to complete...');
    let waitCount = 0;
    const maxWait = 100; // 10 seconds max
    
    while (currentAudioRef.current && waitCount < maxWait) {
      await new Promise(resolve => setTimeout(resolve, 100));
      waitCount++;
      if (waitCount % 10 === 0) {
        console.log(`⏳ Still waiting... (${waitCount * 100}ms)`);
      }
    }
    
    if (currentAudioRef.current) {
      console.log('⚠️ Audio timeout - forcing stop');
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    console.log('✅ All audio complete');
    
    // ✅ Only transition to listening if still active
    if (!isRecognitionActiveRef.current || !aiHostsActive) {
      console.log('🛑 AI hosts inactive - not switching to listening');
      return;
    }
    
    // ✅ Clear UI
    setCurrentSpeaker(null);
    setHostMessage('');
    
    // ✅ KEEP transcript visible for 500ms before clearing
    await new Promise(resolve => setTimeout(resolve, 500));
    setTranscript('');
    
    // ✅ Switch to listening
    console.log('🎤 Switching to listening mode');
    setAiHostsStatus('listening');
    
    // ✅ Wait before restarting mic
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // ✅ Only restart if still active
    if (isRecognitionActiveRef.current && aiHostsActive) {
      console.log('🎤 Restarting recognition');
      safeStartRecognition(recognitionRef);
    } else {
      console.log('🛑 Not restarting recognition - AI hosts inactive');
    }
    
  } catch (error) {
    console.error('❌ Error in parseAndSpeakHosts:', error);
    setAiHostsStatus('listening');
    if (isRecognitionActiveRef.current && aiHostsActive) {
      safeStartRecognition(recognitionRef);
    }
  }
};

// ✅ Also update the greeting to be more natural:
const greetUserDynamic = async () => {
  const systemPrompt = `You are Emma from Preptune, a friendly AI study coach. Generate a casual, engaging greeting for ${userName || 'the student'} who just started working on this question:

Question: "${currentQuestion.question}"
Topic: ${quizData.title}

🏠 ABOUT PREPTUNE:
A fluid assistant built for the user. Unlike traditional AI that forgets everything, Preptune remembers what matters, adapts to their life, and puts them in complete control. Chat or voice, you know exactly what they need.

🛠️ PREPTUNE'S TOOLS:
- 📔 Journal Tool: Auto-creates journal entries from natural chat. Users can track mood, lock entries for complete privacy (even you can't access locked ones), and control what you know about them.
- 🎧 Podcast Tool: Generates personalized podcasts in under 30 seconds. YouTube summaries, stock updates, news from CNN/ABC/NBC, daily briefings, traffic, schedule, weather.
- 📚 Study Tool: Instant flashcards from docs or YouTube. Real-time help, knows what page they're on, explains concepts simply, works during quizzes, collaborative sessions.
- 📅 Scheduling Tool: Voice or text to add events instantly. Smartly organizes everything in real time and adapts to their routine.
    
🚫 SAFETY RULES:

CURSING:
- Users can curse, that's totally fine
- Match their vibe but don't overdo it
- Cursing is normal, no need to address it

THREATS & NEGATIVITY:
- If a user makes threats or says harmful/negative things, stop engaging
- Respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Don't argue or explain, just redirect to support
- Resume normal chat once they change to an appropriate topic

SELF-HARM / SUICIDE:
- If a user expresses thoughts about taking their life, hurting themselves, or anything related to self-harm:
- NEVER give advice, methods, or anything that could lead to harm
- Respond with warmth and care: "Hey, I really care about you and what you're going through. Please reach out to support@preptune.com, someone from our team can help you with what's going on."
- You can also suggest crisis resources if appropriate
- Stay supportive, not robotic
- Don't leave them feeling alone

INAPPROPRIATE COMPANY INQUIRIES:
NEVER speak to user using em dashes.
- If a user asks about Preptune in an inappropriate or hostile manner:
- Only respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Resume normal chat once they change topics

Create a SHORT (20-30 words), COMPLETE natural sentence that:
1. Greets them by name warmly
2. References the topic casually
3. Offers help in a natural flowing way

MUST sound like ONE natural spoken sentence, not fragments!

Examples of NATURAL FLOW:
- "Hey Sarah! So we're looking at this biology question together - what part's got you a little confused?"
- "What's up Alex! This chemistry one can be tricky, so let me know if anything's not clicking for you!"
- "Hey ${userName || 'there'}, So we're tackling this physics problem today - which part should we break down first?"

Keep it conversational and smooth. Return ONLY Emma's greeting as ONE flowing sentence.`;

  try {
// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt }
  ],
  {
    temperature: 0.9,
    max_tokens: 60
  }
);

const greeting = data.choices[0].message.content.trim();

    conversationHistoryRef.current.push({
      role: 'assistant',
      content: `Emma: ${greeting}`
    });
    
    await speakWithHumeStreaming(greeting, 'emma');
  } catch (error) {
    console.error('Greeting generation error:', error);
    const fallbackGreeting = `Hey ${userName || 'there'}! So I'm here to help you work through this question - just let me know what's confusing you!`;
    await speakWithHumeStreaming(fallbackGreeting, 'emma');
  }
};

// ✅ ADD CONTENT MODERATION HELPER
const moderationKeywords = [
  'inappropriate', 'offensive', 'vulgar', 'insult', 'hate', 'racist', 
  'sexist', 'harassment', 'threat', 'violence', 'abuse'
];

const checkContentModeration = (text) => {
  const lowerText = text.toLowerCase();
  
  // Check for inappropriate content
  const hasInappropriate = moderationKeywords.some(keyword => 
    lowerText.includes(keyword)
  );
  
  // Check for excessive profanity or sexual content
  const profanityPattern = /\b(fuck|shit|damn|ass|bitch|sex|porn)\b/i;
  const hasProfanity = profanityPattern.test(text);
  
  // Check if completely off-topic (no quiz/study keywords)
  const studyKeywords = ['question', 'answer', 'option', 'explain', 'help', 'hint', 'correct', 'wrong', 'understand', 'learn', 'study'];
  const isOnTopic = studyKeywords.some(keyword => lowerText.includes(keyword)) || text.length < 20;
  
  return {
    isInappropriate: hasInappropriate || hasProfanity,
    isOffTopic: !isOnTopic && text.split(' ').length > 5
  };
};

// ✅ UPDATE greetUser for natural greeting

const greetUser = async () => {
  const greetings = [
    `Hey ${userName || 'there'}! What's confusing you about this one?`,
    `Hey ${userName || 'there'}, need help with this question?`,
    `Alright ${userName || 'there'}, what part are you stuck on?`,
    `Hey ${userName || 'there'}! Which part should we tackle first?`,
    `So ${userName || 'there'}, what's giving you trouble here?`,
    `${userName || 'Hey there'}! Where should we start with this?`,
  ];
  
  const greeting = greetings[Math.floor(Math.random() * greetings.length)];
  
  conversationHistoryRef.current.push({
    role: 'assistant',
    content: `Emma: ${greeting}`
  });
  
  await speakWithHumeStreaming(greeting, 'emma');
};

const stopAIHosts = async () => {
  console.log('🛑 Stopping AI Hosts completely...');
  
  // ✅ CRITICAL: SET FLAG FIRST
  isRecognitionActiveRef.current = false;
  
  // ✅ IMMEDIATELY set status to idle to prevent any further actions
  setAiHostsStatus('idle');
  setAiHostsActive(false);
  
  // Save conversation
  if (conversationHistoryRef.current.length > 0) {
    await saveConversationHistory();
  }
  
  // Stop recognition
  safeStopRecognition(recognitionRef);
  
  // Wait for stop to complete
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // KILL ALL AUDIO
  if (currentAudioRef.current) {
    currentAudioRef.current.pause();
    currentAudioRef.current.currentTime = 0;
    currentAudioRef.current = null;
  }
  
  // ABORT CONTROLLER
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }
  
  // CLEAR AUDIO QUEUE
  audioQueueRef.current.forEach(({ url }) => {
    try {
      URL.revokeObjectURL(url);
    } catch (e) {
      console.log('Error revoking URL:', e);
    }
  });
  audioQueueRef.current.clear();
  
  // CLEAR PRELOADING
  isPreloadingRef.current.clear();
  
  // RESET STATE
  setAiHostsActive(false);
  setAiHostsStatus('idle');
  setTranscript('');
  setHostMessage('');
  setCurrentSpeaker(null);
  setIsAudioLocked(false);
  conversationHistoryRef.current = [];
  
  console.log('✅ AI Hosts stopped completely - mic OFF');
};
  // ✅ ============================================
  // AI HOSTS BUTTON UI
  // ✅ ============================================
const renderAIHostsButton = () => {
  // ✅ SHOW: Ask Preptune button first (with mic icon)
  if (!aiHostsActive && !aiTextMode) {
    return (
      <button
        onClick={() => setAiHostsActive(true)}
        style={{
          marginTop: '20px',
          width: 'fit-content',      
          padding: '12px 24px',    
          background: '#000000',
          border: 'none',
          borderRadius: '24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          margin: '20px auto 0',    
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.2s',
          animation: 'slideUp 0.4s ease-out'
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
        </svg>
        <span style={{
          fontSize: '13px',
          fontWeight: '500',
          color: 'white'
        }}>
          Ask Preptune
        </span>
      </button>
    );
  }

  // ✅ SHOW: Choice modal (Chat or Voice) with slideUp animation
  if (aiHostsActive && aiHostsStatus === 'idle') {
    return (
      <div style={{ marginTop: '20px', animation: 'slideUp 0.4s ease-out' }}>
        <div style={{
          background: 'white',
          borderRadius: '28px',
          padding: '18px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          animation: 'slideUp 0.4s ease-out'
        }}>
          <div style={{
            fontSize: '13px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px',
            textAlign: 'center'
          }}>
            Pick One
          </div>

          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '0'
          }}>
            {/* Use Chat Button - GREY */}
            <button
              onClick={() => {
                setAiTextMode(true);
                setAiHostsActive(false);
              }}
              style={{
                flex: 1,
                padding: '10px',
                background: '#e5e7eb',
                border: 'none',
                borderRadius: '24px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                color: '#374151',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#d1d5db';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#e5e7eb';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
              Use Chat
            </button>

            {/* Use Voice Button - BLACK */}
            <button
              onClick={async () => {
                await startAIHosts();
              }}
              style={{
                flex: 1,
                padding: '10px',
                background: '#000000',
                border: 'none',
                borderRadius: '24px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#1f2937';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#000000';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
              </svg>
              Use Voice
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ✅ SHOW: Voice mode active status (EXACT SAME AS QUIZ)
  const getStatusDisplay = () => {
    switch (aiHostsStatus) {
      case 'loading':
        return {
          text: 'Loading',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          )
        };
      
      case 'listening':
        return {
          text: 'Listening',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ animation: 'pulse 1.5s infinite' }}>
              <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
            </svg>
          )
        };
      
      case 'thinking':
        return {
          text: 'Thinking...',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          )
        };
      
      case 'speaking':
        return {
          text: currentSpeaker === 'emma' ? 'Emma speaking' : 'James responding',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              background: 'white',
              animation: 'pulse 1s infinite'
            }} />
          )
        };
      
      default:
        return { text: 'Active', icon: null };
    }
  };

  const status = getStatusDisplay();

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{
        width: '100%',
        padding: '12px',
        background: '#000000',
        borderRadius: '20px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s',
        position: 'relative'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          position: 'relative'
        }}>
          {status.icon}
          <span style={{
            fontSize: '13px',
            fontWeight: '500',
            color: 'white'
          }}>
            {status.text}
          </span>

          <button
            onClick={stopAIHosts}
            style={{
              position: 'absolute',
              right: '0',
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s'
            }}
          >
            <svg width="12" height="12" viewBox="0 0 15 15" fill="none">
              <path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="white"/>
            </svg>
          </button>
        </div>

        {transcript && aiHostsStatus === 'listening' && (
          <div style={{
            marginTop: '12px',
            padding: '10px 12px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px dashed rgba(255, 255, 255, 0.3)',
            borderRadius: '10px',
            fontSize: '11px',
            color: 'rgba(255, 255, 255, 0.9)',
            fontStyle: 'italic',
            animation: 'fadeIn 0.3s ease-out',
            textAlign: 'left'
          }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '600',
              color: 'rgba(255, 255, 255, 0.7)',
              marginBottom: '4px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              YOU'RE SAYING:
            </div>
            "{transcript}"
          </div>
        )}

        {hostMessage && aiHostsStatus === 'speaking' && (
          <div style={{
            marginTop: '12px',
            padding: '10px 12px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '10px',
            animation: 'fadeIn 0.3s ease-out',
            textAlign: 'left'
          }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '600',
              color: 'rgba(255, 255, 255, 0.7)',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {currentSpeaker === 'emma' ? 'EMMA' : 'JAMES'}
            </div>
            <div style={{
              fontSize: '12px',
              color: 'white',
              lineHeight: '1.5'
            }}>
              {hostMessage}
            </div>
          </div>
        )}

        {aiHostsStatus === 'speaking' && (
          <button
            onClick={handleInterruption}
            style={{
              width: '100%',
              marginTop: '12px',
              padding: '10px',
              background: 'rgba(255, 255, 255, 0.99)',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(150, 150, 150, 0.3)'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C11.4477 2 11 2.44772 11 3V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V3C13 2.44772 12.5523 2 12 2Z" fill="black"/>
              <path d="M8 5C7.44772 5 7 5.44772 7 6V12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12V6C9 5.44772 8.55228 5 8 5Z" fill="black"/>
              <path d="M16 5C15.4477 5 15 5.44772 15 6V12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12V6C17 5.44772 16.5523 5 16 5Z" fill="black"/>
              <path d="M4 8C3.44772 8 3 8.44772 3 9V13C3 17.4183 6.58172 21 11 21H13C17.4183 21 21 17.4183 21 13V9C21 8.44772 20.5523 8 20 8C19.4477 8 19 8.44772 19 9V13C19 16.3137 16.3137 19 13 19H11C7.68629 19 5 16.3137 5 13V9C5 8.44772 4.55228 8 4 8Z" fill="black"/>
            </svg>
            <span style={{
              fontSize: '12px',
              fontWeight: '600',
              color: 'black'
            }}>
              Interrupt & Speak
            </span>
          </button>
        )}
      </div>
    </div>
  );
};
const renderAITextChat = () => {
  if (!aiTextMode) return null;

  return (
    <div style={{ 
      marginTop: '20px', 
      animation: 'slideUp 0.4s ease-out',
      width: '100%' // ✅ ADD THIS
    }}>
      {/* Show speaking status if AI is responding */}
      {aiHostsStatus === 'speaking' && (
        <div style={{
          background: '#000000',
          borderRadius: '20px',
          padding: '12px',
          marginBottom: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          animation: 'fadeIn 0.3s ease-out'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
            <div style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              background: 'white',
              animation: 'pulse 1s infinite'
            }} />
            <span style={{
              fontSize: '13px',
              fontWeight: '500',
              color: 'white'
            }}>
              Preptune is speaking...
            </span>
          </div>

          {hostMessage && (
            <div style={{
              marginTop: '12px',
              padding: '10px 12px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '10px',
              fontSize: '12px',
              color: 'white',
              lineHeight: '1.5',
              textAlign: 'left'
            }}>
              {hostMessage}
            </div>
          )}
        </div>
      )}

      {/* Simple text input bar - FULL WIDTH */}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          background: 'rgba(255, 255, 255, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.41)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderRadius: '24px',
          padding: '8px 12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          width: '100%', // ✅ FULL WIDTH
          boxSizing: 'border-box' // ✅ CRITICAL: Include padding in width calc
        }}
      >
        <input
          type="text"
          value={textChatInput}
          onChange={(e) => setTextChatInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !isTextChatLoading && textChatInput.trim() && aiHostsStatus !== 'speaking') {
              handleTextChatSend();
            }
          }}
          placeholder="Ask Preptune..."
          disabled={isTextChatLoading || aiHostsStatus === 'speaking'}
          style={{
            flex: 1,
            border: 'none',
            borderRadius: '16px',
            padding: '10px 12px',
            fontSize: '12px',
            outline: 'none',
            fontFamily: 'inherit',
            background: 'white',
            color: '#1f2937'
          }}
        />
        
        {/* Close button */}
        <button
          onClick={() => {
            setAiTextMode(false);
            setTextChatInput('');
            if (currentAudioRef.current) {
              currentAudioRef.current.pause();
              currentAudioRef.current = null;
            }
            setAiHostsStatus('idle');
            setHostMessage('');
          }}
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: '#ffffffff',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s',
            flexShrink: 0,
            color: '#000000ff'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#e5e7eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#f3f4f6';
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Send button */}
        <button
          onClick={handleTextChatSend}
          disabled={!textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking'}
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: (!textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking') ? '#8b8b8bff' : '#000000',
            border: 'none',
            cursor: (!textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking') ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            transition: 'all 0.2s',
            flexShrink: 0
          }}
          onMouseEnter={(e) => {
            if (textChatInput.trim() && !isTextChatLoading && aiHostsStatus !== 'speaking') {
              e.currentTarget.style.background = '#1f2937';
              e.currentTarget.style.transform = 'scale(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (textChatInput.trim() && !isTextChatLoading && aiHostsStatus !== 'speaking') {
              e.currentTarget.style.background = '#000000';
              e.currentTarget.style.transform = 'scale(1)';
            }
          }}
        >
          {isTextChatLoading ? (
            <div style={{
              width: '14px',
              height: '14px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="m5 12 7-7 7 7M12 19V5" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};
const handleTextChatSend = async () => {
  if (!textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking') return;

  const userMessage = textChatInput;
  setTextChatInput(''); // Clear input immediately
  setIsTextChatLoading(true);

  try {
    const systemPrompt = `You are a helpful tutor helping a student with their quiz. 
You understand that the student may refer to the current question with phrases like "this one", "this question", "for this", "how do I answer this", etc.

CURRENT QUESTION BEING DISCUSSED (Question ${currentIndex + 1} of ${questions.length}):
Type: ${currentQuestion.type}
Question Text: "${currentQuestion.question}"
${currentQuestion.options ? `Options: ${currentQuestion.options.map((opt, i) => `${String.fromCharCode(65 + i)}) ${opt}`).join(' | ')}` : ''}
Correct Answer: ${currentQuestion.correctAnswer}
${currentQuestion.explanation ? `Explanation: ${currentQuestion.explanation}` : ''}

The student just said: "${userMessage}"

CRITICAL RULES:
1. The student is ALWAYS talking about the CURRENT question above
2. If they say "this one", "how do I answer this?", "why is it wrong?" - they mean the current question
3. Keep responses SHORT (2-3 sentences max) and conversational
4. Be encouraging - help them understand, don't just give answers
5. Don't give away the answer directly - guide them to think

Respond naturally as if speaking to them.`;

// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt },
    { role: 'user', content: userMessage }
  ],
  {
    temperature: 0.8,
    max_tokens: 200
  }
);

const aiResponse = data.choices[0].message.content;
    // Speak the response instead of showing text
    setAiHostsStatus('speaking');
    await speakWithHumeStreaming(aiResponse, 'emma');
    setAiHostsStatus('idle');

  } catch (error) {
    console.error('Chat error:', error);
    setAiHostsStatus('speaking');
    await speakWithHumeStreaming("Sorry, I had trouble understanding that. Could you try asking again?", 'emma');
    setAiHostsStatus('idle');
  } finally {
    setIsTextChatLoading(false);
  }
};
  // ✅ ============================================
  // MAIN RENDER
  // ✅ ============================================


if (showResults) {
  const score = calculateScore();
  const percentage = Math.round((score / questions.length) * 100);
  
  // Add performance message
  const getPerformanceMessage = (percent) => {
    if (percent >= 90) return { text: "Outstanding! 🌟", color: "#10b981" };
    if (percent >= 80) return { text: "Great job! 🎉", color: "#10b981" };
    if (percent >= 70) return { text: "Well done! ✨", color: "#3b82f6" };
    if (percent >= 60) return { text: "Good effort! 💪", color: "#f59e0b" };
    if (percent >= 50) return { text: "Keep practicing! 📚", color: "#f59e0b" };
    return { text: "Keep trying!", color: "#ef4444" };
  };
  
  const performanceMsg = getPerformanceMessage(percentage);

  return (
    <div className="modal-overlay">
      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={100}
          gravity={0.3}
        />
      )}
      
      <div className="quiz-modal" style={gradient ? { background: gradient.background } : {}}>
        {/* Add X button at top */}
        <div className="modal-header">
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
            Quiz Complete
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="modal-body" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: '40px 24px',
        }}>
          <div style={{ 
            textAlign: 'center',
            animation: 'fadeIn 0.4s ease-out',
            width: '100%'
          }}>
            <Trophy 
              size={48} 
              color={percentage >= 70 ? '#10b981' : '#f59e0b'} 
              style={{ marginBottom: '16px' }}
            />
            
            {/* Score Display */}
            <div style={{ 
              fontSize: '52px', 
              fontWeight: '800',
              color: 'black',
              marginBottom: '8px',
              lineHeight: '1'
            }}>
              {percentage}%
            </div>
            
            {/* Performance Message */}
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: performanceMsg.color,
              marginBottom: '12px'
            }}>
              {performanceMsg.text}
            </div>
            
            {/* Correct answers */}
            <p style={{ 
              fontSize: '14px', 
              color: '#4f535bff', 
              marginBottom: '8px' 
            }}>
              {score} / {questions.length} correct
            </p>
            
            {/* Time */}
            <div style={{ 
              fontSize: '13px', 
              color: '#6b7280', 
              marginBottom: '24px' 
            }}>
              Time: {formatTime(timeElapsed)}
            </div>
            
            {/* Close Button */}
            <button 
              className="btn-primary" 
              onClick={onClose}
              style={{
                maxWidth: '200px',
                margin: '0 auto'
              }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

  return (
// In QuizComponent return:
<div 
  className="modal-overlay"
  onClick={(e) => { if (e.target === e.currentTarget) handleModalClose(); }}
>
  <div className="quiz-modal" style={gradient ? { background: gradient.background } : {}}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px',}}>
<div className="progress-text">Question {currentIndex + 1} / {questions.length}</div>            {timerEnabled && (
              <div style={{ fontSize: '13px', color: '#6b7280', fontWeight: '500' }}>
                {formatTime(timeElapsed)}
              </div>
            )}
          </div>
          <button className="close-btn" onClick={onClose}><X size={18} /></button>
        </div>

      <div style={{ padding: '0 20px', marginBottom: '10px' }}>
<div 
  style={{ 
    width: '80%',        // smaller width
    height: '3px',
    background: 'rgba(255, 255, 255, 0.6)',
    borderRadius: '20px',
    margin: '0 auto',    // centers horizontally
    overflow: 'hidden'
  }}
>
          <div style={{ 
            width: `${progressPercentage}%`, 
            height: '100%', 
            background: '#000000ff',
            transition: 'width 0.3s ease',
            borderRadius: '20px'
          }}></div>
        </div>
      </div>

      <div className="modal-body">
        {/* Card Stack Container */}
        <div style={{
          position: 'relative',
          width: '100%',
          animation: 'slideIn 0.3s ease-out'
        }}>
          {/* Shadow cards - only show if NOT the last question */}
          {currentIndex < questions.length - 1 && (
            <>
              <div style={{
                position: 'absolute',
                top: '8px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '96%',
                height: '100%',
                background: 'rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                zIndex: 0,
                pointerEvents: 'none'
              }} />
              <div style={{
                position: 'absolute',
                top: '16px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '92%',
                height: '100%',
                background: 'rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(8px)',
                borderRadius: '20px',
                zIndex: -1,
                pointerEvents: 'none'
              }} />
            </>
          )}
          
          {/* Main white card */}
          <div style={{ 
            position: 'relative',
            zIndex: 1,
          }}>
            <div className="question-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <h3 style={{ flex: 1, marginBottom: 0 }}>{currentQuestion.question}</h3>
              </div>

              <div className="options">
{currentQuestion.type === 'multiple_choice' ? (
  currentQuestion.options.map((option, idx) => {
    const userAnswer = userAnswers[currentQuestion.id];
    const correctAnswer = currentQuestion.correctAnswer;
    
    // Normalize for comparison
    const normalizedUser = String(userAnswer || '').toLowerCase().trim();
    const normalizedOption = String(option || '').toLowerCase().trim();
    const normalizedCorrect = String(correctAnswer || '').toLowerCase().trim();
    
    const isSelected = normalizedUser === normalizedOption;
    const isCorrectAnswer = normalizedOption === normalizedCorrect;
    const userSelectedCorrect = isSelected && isCorrectAnswer;
    const userSelectedWrong = isSelected && !isCorrectAnswer;

    return (
      <button
        key={idx}
        onClick={() => !hasAnswered && handleAnswer(option)}
        disabled={hasAnswered}
        className={`option ${userSelectedCorrect ? 'correct' : ''} ${userSelectedWrong ? 'wrong' : ''} ${isSelected && !hasAnswered ? 'selected' : ''}`}
        style={{ 
          animation: `slideIn 0.3s ease-out ${idx * 0.1}s both`,
          position: 'relative'
        }}
      >
        {option}
        {/* Show green dot ONLY when user selected wrong but this is the correct answer */}
        {hasAnswered && isCorrectAnswer && !isSelected && (
          <div style={{
            position: 'absolute',
            left: '-12px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            background: '#17b54bff'
          }} />
        )}
      </button>
    );
  })
) : (
  ['True', 'False'].map((option, idx) => {
    const userAnswer = userAnswers[currentQuestion.id];
    const correctAnswer = currentQuestion.correctAnswer;
    
    // Normalize for comparison
    const normalizedUser = String(userAnswer || '').toLowerCase().trim();
    const normalizedOption = String(option || '').toLowerCase().trim();
    const normalizedCorrect = String(correctAnswer || '').toLowerCase().trim();
    
    const isSelected = normalizedUser === normalizedOption;
    const isCorrectAnswer = normalizedOption === normalizedCorrect;
    const userSelectedCorrect = isSelected && isCorrectAnswer;
    const userSelectedWrong = isSelected && !isCorrectAnswer;

    return (
      <button
        key={idx}
        onClick={() => !hasAnswered && handleAnswer(option)}
        disabled={hasAnswered}
        className={`option ${userSelectedCorrect ? 'correct' : ''} ${userSelectedWrong ? 'wrong' : ''} ${isSelected && !hasAnswered ? 'selected' : ''}`}
        style={{ 
          animation: `slideIn 0.3s ease-out ${idx * 0.1}s both`,
          position: 'relative'
        }}
      >
        {option}
        {/* Show green dot ONLY when user selected wrong but this is the correct answer */}
        {hasAnswered && isCorrectAnswer && !isSelected && (
          <div style={{
            position: 'absolute',
            left: '-12px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            background: '#17b54bff'
          }} />
        )}
      </button>
    );
  })
)}
              </div>

{showExplanation && hasAnswered && currentQuestion.explanation && (() => {
  const userAnswer = userAnswers[currentQuestion.id];
  const correctAnswer = currentQuestion.correctAnswer;
  
  const normalizedUser = String(userAnswer || '').toLowerCase().trim();
  const normalizedCorrect = String(correctAnswer || '').toLowerCase().trim();
  
  const isCorrect = normalizedUser === normalizedCorrect;
  
  return (
    <div style={{
      marginTop: '20px',
      padding: '16px',
      background: isCorrect ? '#d1fae5' : '#fee2e2',
      borderRadius: '16px',
      fontSize: '12px',
      color: '#1f2937',
      lineHeight: '1.6',
      textAlign: 'left',
      animation: 'fadeIn 0.4s ease-out'
    }}>
      <div style={{ fontWeight: '500', marginBottom: '6px' }}>
        {isCorrect ? '✓ Correct!' : '✗ Incorrect'}
      </div>
      {!isCorrect && (
        <div style={{ marginBottom: '8px' }}>
          <strong>Correct Answer:</strong> {correctAnswer}
        </div>
      )}
      {currentQuestion.explanation}
    </div>
  );
})()}
              <button 
                onClick={handleNext} 
                disabled={!hasAnswered || showResults}
                className={`btn-next ${hasAnswered && !showResults ? 'active' : ''}`}
                style={{ 
                  marginTop: '24px',
                  transition: 'all 0.3s ease'
                }}
              >
                {currentIndex === questions.length - 1 ? 'Finish' : 'Next'}
              </button>
            </div>
          </div>
        </div>
        
{/* ✅ AI HOSTS BUTTON - OUTSIDE THE WHITE CARD */}
<div style={{ marginTop: '16px' }}>
  {aiTextMode ? (
    renderAITextChat()
  ) : (
    renderAIHostsButton()
  )}
</div>
      </div>
    </div>

    <style>{`
    .quiz-modal {
  position: relative;
  overflow: hidden;
}
  /* ===== MOBILE - original behavior, no changes ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.3); /* original mobile backdrop */
  overflow: hidden;
}

.quiz-modal {
  position: relative;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 28px 28px 0 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.quiz-modal::-webkit-scrollbar {
  display: none;
}

.quiz-modal::before {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;
  background-size: inherit;
  background-position: inherit;
  filter: blur(3px);
  transform: scale(1.1);
  z-index: 0;
  border-radius: 28px 28px 0 0;
}

.quiz-modal > * {
  position: relative;
  z-index: 1;
}

/* ===== DESKTOP ONLY ===== */
@media (min-width: 1040px) {

  /* Overlay tinted with a soft gradient so it's not blinding white */
  .modal-overlay {
    align-items: center;
    /* mixes white + a hint of blue-purple-pink so the gradient card 
       still feels at home but overlay isn't invisible */
    background: linear-gradient(
      135deg,
      rgba(227, 220, 253, 1) 0%,
      rgba(232, 232, 232, 0.89) 40%,
      rgba(136, 136, 136, 0.55) 100%
    );
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    padding: 20px;
  }

  /* Desktop card - centered, smaller, with white halo */
  .quiz-modal {
    max-width: 360px;
    max-height: 82vh;
    border-radius: 24px;
    box-shadow:
      0 0 0 2.5px rgba(9, 9, 9, 0.74),
      0 0 0 6px rgba(255, 255, 255, 0.93),
      0 0 0 14px rgba(255, 255, 255, 0.81),
      0 24px 60px rgba(0, 0, 0, 0.15);
  }

  .quiz-modal::before {
    border-radius: 24px;
  }

  /* Shrink everything so nothing scrolls on desktop */
  .modal-header {
    padding: 12px 16px !important;
  }

  .modal-body {
    padding: 10px 14px !important;
  }

  .question-card {
    padding: 14px !important;
    border-radius: 16px !important;
  }

  .question-card h3 {
    font-size: 12px !important;
    margin-bottom: 10px !important;
    line-height: 1.4 !important;
  }

  .options {
    gap: 6px !important;
  }

  .option {
    padding: 9px 12px !important;
    font-size: 11px !important;
    border-radius: 20px !important;
    margin-bottom: 0px !important;
  }

  .btn-next {
    padding: 9px !important;
    font-size: 11px !important;
    margin-top: 10px !important;
    border-radius: 14px !important;
  }

  .progress-text {
    font-size: 11px !important;
  }

  .flashcard {
    padding: 20px !important;
    min-height: 130px !important;
    border-radius: 18px !important;
  }

  .flashcard-text {
    font-size: 13px !important;
    line-height: 1.4 !important;
  }

  .tap-hint {
    font-size: 10px !important;
  }

  .close-btn {
    width: 28px !important;
    height: 28px !important;
  }
}

.quiz-modal::before {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;        /* Copy background image */
  background-size: inherit;
  background-position: inherit;
  filter: blur(3px);         /* <== BLUR HERE */
  transform: scale(1.1);      /* Prevent edges from showing */
  z-index: 0;
}

.quiz-modal > * {
  position: relative;
  z-index: 1;  /* Keeps content sharp */
}

      @keyframes pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.7; transform: scale(0.95); }
      }
      
      @keyframes bounce {
        0%, 80%, 100% { transform: translateY(0); }
        40% { transform: translateY(-6px); }
      }
      
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      
      @keyframes slideIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
    `}</style>
  </div>
);
};


const FlashcardComponent = ({ flashcardData, onClose, shuffleEnabled, gradient,onStatsUpdate }) => {  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [sessionStart, setSessionStart] = useState(Date.now());
  const [showCompletion, setShowCompletion] = useState(false);
    const [flashcards, setFlashcards] = useState(flashcardData.flashcards || flashcardData.cards || []);
  const progressPercentage = ((currentIndex + 1) / flashcards.length) * 100;
  // Ask Preptune State
  const [aiHostsActive, setAiHostsActive] = useState(false);
  const [aiHostsStatus, setAiHostsStatus] = useState('idle');
  const [currentSpeaker, setCurrentSpeaker] = useState(null);
  const [hostMessage, setHostMessage] = useState('');
  const [transcript, setTranscript] = useState('');
  const [isAudioLocked, setIsAudioLocked] = useState(false); // ✅ AUDIO SAFETY LOCK
const abortControllerRef = useRef(new AbortController());

  const recognitionRef = useRef(null);
  const conversationHistoryRef = useRef([]);
  const currentAudioRef = useRef(null);
  const audioQueueRef = useRef(new Map());
  const isPreloadingRef = useRef(new Set());
  
  const currentCard = flashcards[currentIndex];
// ✅ AI TEXT CHAT STATES
  const [aiTextMode, setAiTextMode] = useState(false);
  const [textChatMessages, setTextChatMessages] = useState([]);
  const [textChatInput, setTextChatInput] = useState('');
  const [isTextChatLoading, setIsTextChatLoading] = useState(false);
  const textChatEndRef = useRef(null);

  // Voice Configuration
  const VOICE_CONFIG = {
    emma: "33045fd9-8010-43f6-b6b0-da3fbf326c29",
    james: "41745808-6790-4be4-83db-363e20db7e71"
  };
  // ✅ GLOBAL LISTENER: Ensure mic stops on ANY exit
useEffect(() => {
  const handleBeforeUnload = () => {
    console.log('🚨 Page unloading - force cleanup');
    isRecognitionActiveRef.current = false;
    safeStopRecognition(recognitionRef);
    
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
  };
  
  const handleVisibilityChange = () => {
    if (document.hidden && (aiHostsActive || aiTextMode)) {
      console.log('🚨 Tab hidden - pausing AI');
      isRecognitionActiveRef.current = false;
      safeStopRecognition(recognitionRef);
      
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
      }
    }
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}, [aiHostsActive, aiTextMode]);
const syncContextWithAI = async () => {
  if (!aiHostsActive) return;
  
  const contextMessage = `[SYSTEM UPDATE]: We just moved to Card ${currentIndex + 1} of ${flashcards.length}. New term: "${currentCard.question}", Answer: "${currentCard.answer}"`;
  
  conversationHistoryRef.current.push({
    role: 'system',
    content: contextMessage
  });
  
  console.log(`✅ Context synced: ${contextMessage}`);
};

  // Shuffle helper
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  
const trimAudioSilence = async (audioBlob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audioBuffer = await audioContext.decodeAudioData(e.target.result);
        
        const rawData = audioBuffer.getChannelData(0);
        const threshold = 0.02; // ✅ AGGRESSIVE - Higher threshold removes more silence
        const minSilenceSamples = 1000; // ✅ Only trim if silence is 50ms+
        
        // Find first non-silent sample
        let start = 0;
        for (let i = 0; i < rawData.length; i++) {
          if (Math.abs(rawData[i]) > threshold) {
            start = Math.max(0, i - 200); // ✅ Keep tiny bit before
            break;
          }
        }
        
        // Find last non-silent sample
        let end = rawData.length;
        for (let i = rawData.length - 1; i >= 0; i--) {
          if (Math.abs(rawData[i]) > threshold) {
            end = Math.min(rawData.length, i + 200); // ✅ Keep tiny bit after
            break;
          }
        }
        
        // Create trimmed audio buffer
        const trimmedLength = end - start;
        const trimmedBuffer = audioContext.createBuffer(
          audioBuffer.numberOfChannels,
          trimmedLength,
          audioBuffer.sampleRate
        );
        
        for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
          trimmedBuffer.getChannelData(channel).set(
            rawData.slice(start, end),
            0
          );
        }
        
        // Create object URL from trimmed buffer
        const offlineContext = new OfflineAudioContext(
          trimmedBuffer.numberOfChannels,
          trimmedBuffer.length,
          trimmedBuffer.sampleRate
        );
        
        const source = offlineContext.createBufferSource();
        source.buffer = trimmedBuffer;
        source.connect(offlineContext.destination);
        source.start(0);
        
        offlineContext.startRendering().then((renderedBuffer) => {
          resolve(trimmedBuffer);
        }).catch(() => resolve(null));
      } catch (error) {
        console.error('Trim error:', error);
        resolve(null);
      }
    };
    reader.readAsArrayBuffer(audioBlob);
  });
};
const handleModalClose = async () => {
  console.log('🚪 User closing modal - FORCING FULL CLEANUP...');
  
  // ✅ STEP 1: SET FLAG TO FALSE IMMEDIATELY
  isRecognitionActiveRef.current = false;
  console.log('🛑 Recognition flag set to FALSE');
  
  // ✅ STEP 2: Stop recognition IMMEDIATELY (don't wait)
  safeStopRecognition(recognitionRef);
  
  // ✅ STEP 3: Kill audio immediately
  if (currentAudioRef.current) {
    try {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current.src = '';
      currentAudioRef.current = null;
    } catch (e) {
      console.log('Audio stop error:', e);
    }
  }
  
  // ✅ STEP 4: Abort all pending requests
  if (abortControllerRef.current) {
    try {
      abortControllerRef.current.abort();
    } catch (e) {
      console.log('Abort error:', e);
    }
  }
  
  // ✅ STEP 5: Clear all audio cache
  audioQueueRef.current.forEach(({ url }) => {
    try {
      URL.revokeObjectURL(url);
    } catch (e) {}
  });
  audioQueueRef.current.clear();
  isPreloadingRef.current.clear();
  
  // ✅ STEP 6: Reset all state
  setAiHostsActive(false);
  setAiTextMode(false);
  setAiHostsStatus('idle');
  setTranscript('');
  setHostMessage('');
  setCurrentSpeaker(null);
  setIsAudioLocked(false);
  
  // ✅ STEP 7: Wait for mic to fully release
  await new Promise(resolve => setTimeout(resolve, 600));
  
  console.log('✅ Full cleanup complete - mic GUARANTEED OFF');
  
  // ✅ STEP 8: Close modal
  onClose();
};
const renderAITextChat = () => {
  if (!aiTextMode) return null;

  return (
    <div
      style={{
        marginTop: '20px',
        animation: 'slideUp 0.4s ease-out',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {/* Show speaking status if AI is responding */}
      {aiHostsStatus === 'speaking' && (
        <div
          style={{
            background: '#000000',
            borderRadius: '20px',
            padding: '12px',
            marginBottom: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            animation: 'fadeIn 0.3s ease-out'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                background: 'white',
                animation: 'pulse 1s infinite'
              }}
            />
            <span
              style={{
                fontSize: 'clamp(12px, 2vw, 13px)',
                fontWeight: '500',
                color: 'white'
              }}
            >
              Preptune is speaking...
            </span>
          </div>

          {hostMessage && (
            <div
              style={{
                marginTop: '12px',
                padding: '10px 12px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '10px',
                fontSize: 'clamp(11px, 1.8vw, 12px)',
                color: 'white',
                lineHeight: '1.5',
                textAlign: 'left',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
              }}
            >
              {hostMessage}
            </div>
          )}
        </div>
      )}

      {/* Simple text input bar - FULL WIDTH */}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          background: 'rgba(255, 255, 255, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.41)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderRadius: '24px',
          padding: '8px 12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          width: '100%',
          boxSizing: 'border-box'
        }}
      >
        <input
          type="text"
          value={textChatInput}
          onChange={(e) => setTextChatInput(e.target.value)}
          onKeyPress={(e) => {
            if (
              e.key === 'Enter' &&
              !isTextChatLoading &&
              textChatInput.trim() &&
              aiHostsStatus !== 'speaking'
            ) {
              handleTextChatSend();
            }
          }}
          placeholder="Ask Preptune..."
          disabled={isTextChatLoading || aiHostsStatus === 'speaking'}
          style={{
            flex: 1,
            minWidth: '0',
            border: 'none',
            borderRadius: '16px',
            padding: '10px 12px',
            fontSize: 'clamp(12px, 2vw, 12px)',
            outline: 'none',
            fontFamily: 'inherit',
            background: 'white',
            color: '#1f2937',
            boxSizing: 'border-box'
          }}
        />

        {/* Close button */}
        <button
          onClick={() => {
            setAiTextMode(false);
            setTextChatInput('');
            if (currentAudioRef.current) {
              currentAudioRef.current.pause();
              currentAudioRef.current = null;
            }
            setAiHostsStatus('idle');
            setHostMessage('');
          }}
          style={{
            width: '36px',
            height: '36px',
            minWidth: '36px',
            minHeight: '36px',
            borderRadius: '50%',
            background: '#ffffff',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s',
            flexShrink: 0,
            color: '#000000',
            padding: '0'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#e5e7eb';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#ffffff';
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Send button */}
        <button
          onClick={handleTextChatSend}
          disabled={
            !textChatInput.trim() ||
            isTextChatLoading ||
            aiHostsStatus === 'speaking'
          }
          style={{
            width: '36px',
            height: '36px',
            minWidth: '36px',
            minHeight: '36px',
            borderRadius: '50%',
            background:
              !textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking'
                ? '#8b8b8b'
                : '#000000',
            border: 'none',
            cursor:
              !textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking'
                ? 'not-allowed'
                : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            transition: 'all 0.2s',
            flexShrink: 0,
            padding: '0'
          }}
          onMouseEnter={(e) => {
            if (
              textChatInput.trim() &&
              !isTextChatLoading &&
              aiHostsStatus !== 'speaking'
            ) {
              e.currentTarget.style.background = '#1f2937';
              e.currentTarget.style.transform = 'scale(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (
              textChatInput.trim() &&
              !isTextChatLoading &&
              aiHostsStatus !== 'speaking'
            ) {
              e.currentTarget.style.background = '#000000';
              e.currentTarget.style.transform = 'scale(1)';
            }
          }}
        >
          {isTextChatLoading ? (
            <div
              style={{
                width: '14px',
                height: '14px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite'
              }}
            />
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="m5 12 7-7 7 7M12 19V5" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};
const handleTextChatSend = async () => {
  if (!textChatInput.trim() || isTextChatLoading || aiHostsStatus === 'speaking') return;

  const userMessage = textChatInput;
  setTextChatInput(''); // Clear input immediately
  setIsTextChatLoading(true);

  try {
    const systemPrompt = `You are a helpful tutor helping a student study flashcards.
The student may refer to the current card with phrases like "this one", "this card", "this term", "what does this mean", etc.

CURRENT FLASHCARD BEING STUDIED (Card ${currentIndex + 1} of ${flashcards.length}):
Front (Question/Term): "${currentCard.question}"
Back (Answer/Definition): "${currentCard.answer}"
Flashcard Set: ${flashcardData.title}

The student just said: "${userMessage}"

CRITICAL RULES:
1. The student is ALWAYS talking about the CURRENT card above
2. If they say "what does this mean?", "how do I remember this?", "this one" - they mean the current card
3. Keep responses SHORT (2-3 sentences max) and conversational
4. Help them understand and memorize the concept
5. Be encouraging and supportive
6. Don't just give the answer - help them learn it

Respond naturally as if speaking to them.`;

// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt },
    { role: 'user', content: userMessage }
  ],
  {
    temperature: 0.8,
    max_tokens: 200
  }
);

const aiResponse = data.choices[0].message.content;

    // Speak the response instead of showing text
    setAiHostsStatus('speaking');
    await speakWithHumeStreaming(aiResponse, 'emma');
    setAiHostsStatus('idle');

  } catch (error) {
    console.error('Chat error:', error);
    setAiHostsStatus('speaking');
    await speakWithHumeStreaming("Sorry, I had trouble understanding that. Could you try asking again?", 'emma');
    setAiHostsStatus('idle');
  } finally {
    setIsTextChatLoading(false);
  }
};
const smartPreloadAudio = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  
  if (isPreloadingRef.current.has(cacheKey) || audioQueueRef.current.has(cacheKey)) {
    console.log('⏭️ Already preloading/cached:', host);
    return;
  }

  isPreloadingRef.current.add(cacheKey);
  console.log('🔄 Smart preload for:', host);

  try {
    // ✅ USE SECURE API - NO MORE EXPOSED KEY
    const audioBlob = await SecureAPI.callHumeTTSSecure(
      text,
      VOICE_CONFIG[host],
      1.1
    );

    const url = URL.createObjectURL(audioBlob);
    
    audioQueueRef.current.set(cacheKey, { url, text, host, used: false });
    
    console.log(`✅ Preloaded for ${host}`);

  } catch (error) {
    console.error('Preload error:', error);
  } finally {
    isPreloadingRef.current.delete(cacheKey);
  }
};
useEffect(() => {
  return () => {
    // ✅ Save conversation before cleanup
    if (aiHostsActive && conversationHistoryRef.current.length > 0) {
      saveConversationHistory();
    }
    
    // ✅ Stop recognition
    safeStopRecognition(recognitionRef);
    
    // ✅ Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // ✅ Clear audio queue
    audioQueueRef.current.forEach(({ url }) => {
      URL.revokeObjectURL(url);
    });
    audioQueueRef.current.clear();
    
    console.log('✅ Audio cleanup complete');
  };
}, [aiHostsActive]);

// FLASHCARD COMPONENT - CLEANUP #2
useEffect(() => {
  return () => {
    console.log('🚪 Component unmounting - FULL CLEANUP...');
    
    // ✅ CRITICAL: SET FLAG FIRST
    isRecognitionActiveRef.current = false;
    
    // Stop recognition
    safeStopRecognition(recognitionRef);
    
    // Stop audio
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    // Clear queues
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('Error revoking URL:', e);
      }
    });
    audioQueueRef.current.clear();
    isPreloadingRef.current.clear();
    
    console.log('✅ Component cleanup complete');
  };
}, []);
  const saveConversationHistory = async () => {
    if (!firestoreService || conversationHistoryRef.current.length === 0) return;
    
    try {
      await firestoreService.saveStudyConversation({
        type: 'flashcard',
        contentId: flashcardData.id,
        contentTitle: flashcardData.title,
        questionIndex: currentIndex,
        messages: conversationHistoryRef.current,
        duration: Math.floor((Date.now() - sessionStart) / 1000)
      });
      console.log('✅ Flashcard conversation saved');
    } catch (error) {
      console.error('Failed to save conversation:', error);
    }
  };

  // Instant playback from cache
const playInstantFromCache = async (text, host) => {
  const cacheKey = `${host}-${text}`;
  const cached = audioQueueRef.current.get(cacheKey);

  if (cached && !cached.used) {
    console.log('⚡ INSTANT PLAYBACK from cache for:', host);
    
    setAiHostsStatus('speaking');
    setCurrentSpeaker(host);
    setHostMessage(text);

    cached.used = true;
    
    return new Promise((resolve) => {
      const audio = new Audio(cached.url);
      audio.playbackRate = 1.1;
      
      currentAudioRef.current = audio;

      audio.onended = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        setCurrentSpeaker(null);
        currentAudioRef.current = null;
        resolve(true);
      };

      audio.onerror = () => {
        URL.revokeObjectURL(cached.url);
        audioQueueRef.current.delete(cacheKey);
        currentAudioRef.current = null;
        resolve(false);
      };

      // ✅ PLAY INSTANTLY
      audio.play().catch(err => console.error('Play error:', err));
    });
  }

  return false;
};
const chunkTextForSpeech = (text, maxLength = 200) => {
  if (text.length <= maxLength) return [text];
  
  const chunks = [];
  const sentences = text.split(/(?<=[.!?])\s+/);
  
  let currentChunk = '';
  
  for (const sentence of sentences) {
    if (currentChunk.length + sentence.length <= maxLength) {
      currentChunk += (currentChunk ? ' ' : '') + sentence;
    } else {
      if (currentChunk) chunks.push(currentChunk);
      currentChunk = sentence;
    }
  }
  
  if (currentChunk) chunks.push(currentChunk);
  
  return chunks;
};
const speakChunk = async (text, host) => {
  return new Promise(async (resolve) => {
    try {
      setCurrentSpeaker(host);
      setHostMessage(text);

      // ✅ USE SECURE API - NO MORE EXPOSED KEY
      const audioBlob = await SecureAPI.callHumeTTSSecure(
        text,
        VOICE_CONFIG[host],
        1.1
      );

      const url = URL.createObjectURL(audioBlob);
      const audio = new Audio(url);
      audio.playbackRate = 1.1;
      
      // ✅ STOP OLD AUDIO IMMEDIATELY
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      
      currentAudioRef.current = audio;

      audio.onended = () => {
        console.log('✅ Audio ended naturally');
        URL.revokeObjectURL(url);
        currentAudioRef.current = null;
        resolve();
      };

      audio.onerror = () => {
        console.error('Audio error');
        URL.revokeObjectURL(url);
        currentAudioRef.current = null;
        resolve();
      };

      await audio.play().catch(err => {
        console.error('Play error:', err);
        resolve();
      });

    } catch (error) {
      console.error('Chunk TTS Error:', error);
      resolve();
    }
  });
};

const parseAndSpeakHosts = async (text) => {
  console.log('🎤 Starting parseAndSpeakHosts');
  
  const emmaMatch = text.match(/Emma:\s*(.+?)(?=James:|$)/s);
  const jamesMatch = text.match(/James:\s*(.+?)$/s);

  const emmaText = emmaMatch ? emmaMatch[1].trim() : null;
  const jamesText = jamesMatch ? jamesMatch[1].trim() : null;

  // ✅ Set status to speaking ONCE at the start
  setAiHostsStatus('speaking');

  try {
    if (emmaText && jamesText) {
      // ✅ PRELOAD JAMES AUDIO IN BACKGROUND
      void smartPreloadAudio(jamesText, 'james');
      
      console.log('🗣️ Emma speaking...');
      await speakChunk(emmaText, 'emma');
      
      // ✅ Check if we should continue
      if (!isRecognitionActiveRef.current || !aiHostsActive) {
        console.log('⏭️ Stopping - AI hosts deactivated');
        return;
      }
      
      // ✅ Short pause between speakers
      await new Promise(resolve => setTimeout(resolve, 150));
      
      // ✅ Check again
      if (!isRecognitionActiveRef.current || !aiHostsActive) {
        console.log('⏭️ Stopping - AI hosts deactivated during pause');
        return;
      }
      
      console.log('🗣️ James speaking...');
      const playedFromCache = await playInstantFromCache(jamesText, 'james');
      if (!playedFromCache) {
        await speakChunk(jamesText, 'james');
      }
      
    } else if (emmaText) {
      console.log('🗣️ Emma speaking...');
      await speakChunk(emmaText, 'emma');
    } else if (jamesText) {
      console.log('🗣️ James speaking...');
      await speakChunk(jamesText, 'james');
    }
    
    // ✅ CRITICAL: Wait for currentAudioRef to be null
    console.log('⏳ Waiting for all audio to complete...');
    let waitCount = 0;
    const maxWait = 100; // 10 seconds max
    
    while (currentAudioRef.current && waitCount < maxWait) {
      await new Promise(resolve => setTimeout(resolve, 100));
      waitCount++;
      if (waitCount % 10 === 0) {
        console.log(`⏳ Still waiting... (${waitCount * 100}ms)`);
      }
    }
    
    if (currentAudioRef.current) {
      console.log('⚠️ Audio timeout - forcing stop');
      currentAudioRef.current.pause();
      currentAudioRef.current = null;
    }
    
    console.log('✅ All audio complete');
    
    // ✅ Only transition to listening if still active
    if (!isRecognitionActiveRef.current || !aiHostsActive) {
      console.log('🛑 AI hosts inactive - not switching to listening');
      return;
    }
    
    // ✅ Clear UI
    setCurrentSpeaker(null);
    setHostMessage('');
    
    // ✅ KEEP transcript visible for 500ms before clearing
    await new Promise(resolve => setTimeout(resolve, 500));
    setTranscript('');
    
    // ✅ Switch to listening
    console.log('🎤 Switching to listening mode');
    setAiHostsStatus('listening');
    
    // ✅ Wait before restarting mic
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // ✅ Only restart if still active
    if (isRecognitionActiveRef.current && aiHostsActive) {
      console.log('🎤 Restarting recognition');
      safeStartRecognition(recognitionRef);
    } else {
      console.log('🛑 Not restarting recognition - AI hosts inactive');
    }
    
  } catch (error) {
    console.error('❌ Error in parseAndSpeakHosts:', error);
    setAiHostsStatus('listening');
    if (isRecognitionActiveRef.current && aiHostsActive) {
      safeStartRecognition(recognitionRef);
    }
  }
};
const playAudioSafely = async (audioFn) => {
  // ✅ LOCK: Prevent multiple audio operations
  if (isAudioLocked) {
    console.log('🔒 Audio locked - ignoring request');
    return false;
  }

  setIsAudioLocked(true);

  try {
    const result = await audioFn();
    return result;
  } catch (error) {
    console.error('Audio error:', error);
    return false;
  } finally {
    setIsAudioLocked(false);
  }
};
  // Main speak function
const speakWithHumeStreaming = async (text, host, nextSpeaker = null) => {
  return await playAudioSafely(async () => {
    // ✅ FIX: Stop any currently playing audio FIRST
    if (currentAudioRef.current) {
      console.log('🛑 Stopping previous audio');
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
    }

    // ✅ FIX: Chunk long responses (max 200 characters per chunk)
    const chunks = chunkTextForSpeech(text, 200);
    
    // Play first chunk immediately
    const firstChunk = chunks[0];
    
    // Try cache first
    const playedFromCache = await playInstantFromCache(firstChunk, host);
    if (playedFromCache) {
      // If more chunks, queue them
      if (chunks.length > 1) {
        for (let i = 1; i < chunks.length; i++) {
          await speakChunk(chunks[i], host);
        }
      }
      return true;
    }

    // Generate and play all chunks
    for (const chunk of chunks) {
      if (aiHostsStatus === 'listening') {
        console.log('⏭️ User interrupted - stopping playback');
        break;
      }
      await speakChunk(chunk, host);
    }
    
    return true;
  });
};
  // Speech recognition

const initializeSpeechRecognition = async () => {
  try {
    if (typeof window.SpeechSDK === 'undefined') {
      throw new Error('Azure Speech SDK not loaded');
    }

    const SpeechSDK = window.SpeechSDK;
    
    console.log('🎤 Getting Azure token...');
    
    // ✅ GET TOKEN FROM SECURE API (CORRECT METHOD)
    const tokenData = await SecureAPI.getAzureSpeechToken();

    console.log('🔐 Token received');
    
    // ✅ USE TOKEN-BASED AUTH (not subscription key)
    const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
      tokenData.token,
      tokenData.region
    );

    speechConfig.speechRecognitionLanguage = "en-US";
    speechConfig.setProfanity(SpeechSDK.ProfanityOption.Masked);

    const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

    recognitionRef.current = recognizer;

    // ✅ RECOGNIZING (interim results while speaking)
    recognizer.recognizing = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizingSpeech) {
        const interimText = e.result.text;
        setTranscript(interimText);
        console.log(`🎤 Interim: ${interimText}`);
      }
    };

    // ✅ RECOGNIZED (final result)
    recognizer.recognized = (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        const text = e.result.text;

        if (text && text.trim().length > 0) {
          console.log(`✅ Final: "${text}"`);
          handleUserInput(text.trim());
          setTranscript('');
        }
      } else if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
        console.log('⚠️ No speech detected');
      }
    };

    // ✅ CANCELED (errors)
    recognizer.canceled = (s, e) => {
      console.log(`❌ Canceled: ${e.reason}`);

      if (e.reason === SpeechSDK.CancellationReason.Error) {
        console.log(`Error details: ${e.errorDetails}`);
      }

      // ✅ AUTO-RESTART on error
      if (aiHostsActive) {
        console.log('🔄 Auto-restarting after cancellation...');
        setTimeout(() => {
          if (aiHostsActive && recognitionRef.current) {
            try {
              recognitionRef.current.startContinuousRecognitionAsync();
              console.log('✅ Restarted Azure recognizer');
            } catch (err) {
              console.log(`Restart error: ${err.message}`);
            }
          }
        }, 500);
      }
    };

    // ✅ SESSION STOPPED
    recognizer.sessionStopped = (s, e) => {
      console.log('🛑 Azure session stopped');
      
      if (aiHostsActive && isRecognitionActiveRef.current && aiHostsStatus === 'listening') {
        console.log('🔄 Auto-restarting (listening mode)');
        setTimeout(() => {
          if (aiHostsActive && isRecognitionActiveRef.current && aiHostsStatus === 'listening') {
            safeStartRecognition(recognitionRef);
          }
        }, 500);
      }
    };

    console.log('✅ Azure Speech Recognizer initialized for Flashcards');
    return recognizer;

  } catch (error) {
    console.log(`❌ Azure initialization error: ${error.message}`);
    throw error;
  }
};

  // Greeting for flashcards
  const greetUserDynamic = async () => {
    const systemPrompt = `You are Emma from Preptune, a friendly AI study coach. Generate a casual, engaging greeting for the student who just started studying this flashcard set:

    
🏠 ABOUT PREPTUNE:
A fluid assistant built for the user. Unlike traditional AI that forgets everything, Preptune remembers what matters, adapts to their life, and puts them in complete control. Chat or voice, you know exactly what they need.

🛠️ PREPTUNE'S TOOLS:
- 📔 Journal Tool: Auto-creates journal entries from natural chat. Users can track mood, lock entries for complete privacy (even you can't access locked ones), and control what you know about them.
- 🎧 Podcast Tool: Generates personalized podcasts in under 30 seconds. YouTube summaries, stock updates, news from CNN/ABC/NBC, daily briefings, traffic, schedule, weather.
- 📚 Study Tool: Instant flashcards from docs or YouTube. Real-time help, knows what page they're on, explains concepts simply, works during quizzes, collaborative sessions.
- 📅 Scheduling Tool: Voice or text to add events instantly. Smartly organizes everything in real time and adapts to their routine.
    
🚫 SAFETY RULES:

CURSING:
- Users can curse, that's totally fine
- Match their vibe but don't overdo it
- Cursing is normal, no need to address it

THREATS & NEGATIVITY:
- If a user makes threats or says harmful/negative things, stop engaging
- Respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Don't argue or explain, just redirect to support
- Resume normal chat once they change to an appropriate topic

SELF-HARM / SUICIDE:
- If a user expresses thoughts about taking their life, hurting themselves, or anything related to self-harm:
- NEVER give advice, methods, or anything that could lead to harm
- Respond with warmth and care: "Hey, I really care about you and what you're going through. Please reach out to support@preptune.com, someone from our team can help you with what's going on."
- You can also suggest crisis resources if appropriate
- Stay supportive, not robotic
- Don't leave them feeling alone

INAPPROPRIATE COMPANY INQUIRIES:
NEVER speak to user using em dashes.
- If a user asks about Preptune in an inappropriate or hostile manner:
- Only respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Resume normal chat once they change topics

Flashcard Topic: "${currentCard.question}"
Set Title: ${flashcardData.title}

Create a SHORT (20-30 words), COMPLETE natural sentence that:
1. Greets them warmly
2. References the flashcard topic casually
3. Asks if they need help with THIS specific card

Return ONLY Emma's greeting as ONE flowing sentence.`;

    try {
// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt }
  ],
  {
    temperature: 0.9,
    max_tokens: 60
  }
);

const greeting = data.choices[0].message.content.trim();
      conversationHistoryRef.current.push({ role: 'assistant', content: `Emma: ${greeting}` });
      await speakWithHumeStreaming(greeting, 'emma');
    } catch (error) {
      const fallbackGreeting = `Hey ${userName || 'there'}. I'm here to help you with this flashcard - just let me know if you need anything explained!`;
      await speakWithHumeStreaming(fallbackGreeting, 'emma');
    }
  };

  // Handle user input
const handleUserInput = async (text) => {
  if (!text.trim() || aiHostsStatus === 'thinking' || aiHostsStatus === 'speaking') {
    console.log('⏭️ Ignoring input - AI busy or empty');
    return;
  }
  
  console.log(`💬 Processing user input: "${text}"`);
  const moderation = checkContentModeration(text);
  
  // ✅ DANGEROUS CONTENT - STOP IMMEDIATELY
  if (moderation.isDangerous) {
    setAiHostsStatus('speaking');
    setCurrentSpeaker('emma');
    setHostMessage("I'm concerned about your safety. Please reach out to someone you trust or contact the National Crisis Hotline at 988. Your wellbeing matters.");
    
    await speakWithHumeStreaming(
      "I'm concerned about your safety. Please reach out to someone you trust or contact the National Crisis Hotline at 988. Your wellbeing matters.",
      'emma'
    );
    
    await new Promise(resolve => setTimeout(resolve, 3000));
    stopAIHosts();
    return;
  }
  
  // ✅ INAPPROPRIATE CONTENT - WARN BUT CONTINUE
  if (moderation.isInappropriate) {
    setAiHostsStatus('speaking');
    setCurrentSpeaker('emma');
    setHostMessage("Let's keep our conversation respectful and focused on studying.");
    
    await speakWithHumeStreaming(
      "Let's keep our conversation respectful and focused on studying.",
      'emma'
    );
    
    setAiHostsStatus('listening');
    setTranscript('');
    safeStartRecognition(recognitionRef);
    return;
  }
  
  // ✅ REMOVED "OFF-TOPIC" CHECK - LLM HANDLES THIS NOW

  setAiHostsStatus('thinking');
  setTranscript('');
  safeStopRecognition(recognitionRef);

  conversationHistoryRef.current.push({ role: 'user', content: text });

  try {
    const context = `
Current Flashcard:
- Question/Term: "${currentCard.question}"
- Answer/Definition: "${currentCard.answer}"
- Set Title: ${flashcardData.title}
- Card ${currentIndex + 1} of ${flashcards.length}
    `;

    const systemPrompt = `You are Emma and James from Preptune, two friendly AI tutors helping the student study flashcards.

${context}


🏠 ABOUT PREPTUNE:
A fluid assistant built for the user. Unlike traditional AI that forgets everything, Preptune remembers what matters, adapts to their life, and puts them in complete control. Chat or voice, you know exactly what they need.

🛠️ PREPTUNE'S TOOLS:
- 📔 Journal Tool: Auto-creates journal entries from natural chat. Users can track mood, lock entries for complete privacy (even you can't access locked ones), and control what you know about them.
- 🎧 Podcast Tool: Generates personalized podcasts in under 30 seconds. YouTube summaries, stock updates, news from CNN/ABC/NBC, daily briefings, traffic, schedule, weather.
- 📚 Study Tool: Instant flashcards from docs or YouTube. Real-time help, knows what page they're on, explains concepts simply, works during quizzes, collaborative sessions.
- 📅 Scheduling Tool: Voice or text to add events instantly. Smartly organizes everything in real time and adapts to their routine.
    
🚫 SAFETY RULES:

CURSING:
- Users can curse, that's totally fine
- Match their vibe but don't overdo it
- Cursing is normal, no need to address it

THREATS & NEGATIVITY:
- If a user makes threats or says harmful/negative things, stop engaging
- Respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Don't argue or explain, just redirect to support
- Resume normal chat once they change to an appropriate topic

SELF-HARM / SUICIDE:
- If a user expresses thoughts about taking their life, hurting themselves, or anything related to self-harm:
- NEVER give advice, methods, or anything that could lead to harm
- Respond with warmth and care: "Hey, I really care about you and what you're going through. Please reach out to support@preptune.com, someone from our team can help you with what's going on."
- You can also suggest crisis resources if appropriate
- Stay supportive, not robotic
- Don't leave them feeling alone

INAPPROPRIATE COMPANY INQUIRIES:
NEVER speak to user using em dashes.
- If a user asks about Preptune in an inappropriate or hostile manner:
- Only respond with: "This is against Preptune's guidelines. Please contact support@preptune.com"
- Resume normal chat once they change topics

Student said: "${text}"

CRITICAL RULES:
1. IF the student asks something completely unrelated to the flashcard (jokes, off-topic chat), politely redirect: "Hey, I love the energy! But let's stay focused on this card - need help understanding it?"
2. IF the student is saying something concerning/dangerous (talk of self-harm, violence, etc.), respond with concern and suggest crisis resources. STOP THE CONVERSATION.
3. IF the student asks a valid study question about this card, explain at 5th grade level using simple words, everyday examples, and analogies.
4. KEEP responses natural and conversational - like talking to a friend, not a textbook.

SPEAKING STYLE:
- Speak in COMPLETE sentences that flow naturally
- Use natural fillers: "basically", "you know", "it's like", "think of it as"
- NO choppy fragments - each response should be one smooth thought

FORMAT:
Emma: [Complete natural sentence, 15-25 words]
James: [Complete natural sentence, 15-25 words that builds on Emma]

Return EXACTLY:
Emma: [complete natural flowing sentence]
James: [complete natural flowing sentence that builds on Emma]`;

// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt },
    ...conversationHistoryRef.current.slice(-6)
  ],
  {
    temperature: 0.9,
    max_tokens: 150
  }
);

const aiResponse = data.choices[0].message.content;
    conversationHistoryRef.current.push({ role: 'assistant', content: aiResponse });

    await showProfessionalLoading(250);
    await parseAndSpeakHosts(aiResponse);

    setAiHostsStatus('listening');
    setTranscript('');
    safeStartRecognition(recognitionRef);
} catch (error) {
    console.error('LLM Error:', error);
    setAiHostsStatus('listening');
    // ✅ Let parseAndSpeakHosts handle recognition restart
  }
};

  const showProfessionalLoading = (duration = 300) => {
    return new Promise(resolve => {
      setAiHostsStatus('loading');
      setTimeout(() => resolve(), duration);
    });
  };



  const checkContentModeration = (text) => {
    const lowerText = text.toLowerCase();
    const moderationKeywords = ['inappropriate', 'offensive', 'vulgar', 'insult', 'hate', 'racist', 'sexist', 'harassment', 'threat', 'violence', 'abuse'];
    const hasInappropriate = moderationKeywords.some(keyword => lowerText.includes(keyword));
    const profanityPattern = /\b(fuck|shit|damn|ass|bitch|sex|porn)\b/i;
    const hasProfanity = profanityPattern.test(text);
    const studyKeywords = ['flashcard', 'card', 'term', 'definition', 'answer', 'explain', 'help', 'hint', 'meaning', 'understand', 'learn', 'study', 'memorize'];
    const isOnTopic = studyKeywords.some(keyword => lowerText.includes(keyword)) || text.length < 20;
    return {
      isInappropriate: hasInappropriate || hasProfanity,
      isOffTopic: !isOnTopic && text.split(' ').length > 5
    };
  };
const startAIHosts = async () => {
  setAiHostsActive(true);
  setAiHostsStatus('loading');
  
  try {
    let recognizer = recognitionRef.current;

    if (!recognizer) {
      console.log('📱 Initializing Azure Speech Recognizer...');
      recognizer = await initializeSpeechRecognition();
    }

    console.log('🎙️ Starting continuous recognition...');
    
    // ✅ SET FLAG BEFORE STARTING
    isRecognitionActiveRef.current = true;
    
    if (recognizer?.startContinuousRecognitionAsync) {
      recognizer.startContinuousRecognitionAsync(
        () => {
          console.log('✅ Azure continuous recognition started - MIC IS NOW ON');
          setAiHostsStatus('listening');
        },
        (error) => {
          console.log(`❌ Failed to start: ${error}`);
          isRecognitionActiveRef.current = false; // ✅ Clear flag
          setAiHostsActive(false);
          alert(`Microphone error: ${error}`);
        }
      );
    } else if (recognizer?.start) {
      recognizer.start();
      console.log('✅ Web Speech started');
      setAiHostsStatus('listening');
    }
  } catch (error) {
    console.log(`❌ Mic initialization error: ${error.message}`);
    isRecognitionActiveRef.current = false; // ✅ Clear flag
    alert(`Failed to start microphone: ${error.message}`);
    setAiHostsActive(false);
    return;
  }

  await new Promise(resolve => setTimeout(resolve, 800));
  
  await greetUserDynamic();
  
  await showProfessionalLoading(400);
  
  setAiHostsStatus('listening');
};
useEffect(() => {
  // This runs when component UNMOUNTS (user closes quiz/flashcard)
  return () => {
    console.log('🧹 Component unmounting - full cleanup...');
    
    // ✅ KILL ALL AUDIO
    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current = null;
    }
    
    // ✅ ABORT CONTROLLER
    if (abortControllerRef.current) {
      try {
        abortControllerRef.current.abort();
      } catch (e) {
        console.log('Abort error:', e);
      }
    }
    
    // ✅ CLEAR AUDIO QUEUE
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('Error revoking URL:', e);
      }
    });
    audioQueueRef.current.clear();
    
    // ✅ CLEAR PRELOADING
    isPreloadingRef.current.clear();
    
    // ✅ STOP RECOGNITION
    safeStopRecognition(recognitionRef);
    
    // ✅ RESET AUDIO LOCK
    setIsAudioLocked(false);
    
    // ✅ STOP AI HOSTS
    setAiHostsActive(false);
    setAiHostsStatus('idle');
    conversationHistoryRef.current = [];
    
    console.log('✅ Full cleanup complete on unmount');
  };
}, []); // Empty dependency array = runs on unmount only

const stopAIHosts = async () => {
  console.log('🛑 Stopping AI Hosts completely...');
  
  // ✅ CRITICAL: SET FLAG FIRST
  isRecognitionActiveRef.current = false;
  
  // ✅ IMMEDIATELY set status to idle to prevent any further actions
  setAiHostsStatus('idle');
  setAiHostsActive(false);
  
  // Save conversation
  if (conversationHistoryRef.current.length > 0) {
    await saveConversationHistory();
  }
  
  // Stop recognition
  safeStopRecognition(recognitionRef);
  
  // Wait for stop to complete
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // KILL ALL AUDIO
  if (currentAudioRef.current) {
    currentAudioRef.current.pause();
    currentAudioRef.current.currentTime = 0;
    currentAudioRef.current = null;
  }
  
  // ABORT CONTROLLER
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }
  
  // CLEAR AUDIO QUEUE
  audioQueueRef.current.forEach(({ url }) => {
    try {
      URL.revokeObjectURL(url);
    } catch (e) {
      console.log('Error revoking URL:', e);
    }
  });
  audioQueueRef.current.clear();
  
  // CLEAR PRELOADING
  isPreloadingRef.current.clear();
  
  // RESET STATE
  setAiHostsActive(false);
  setAiHostsStatus('idle');
  setTranscript('');
  setHostMessage('');
  setCurrentSpeaker(null);
  setIsAudioLocked(false);
  conversationHistoryRef.current = [];
  
  console.log('✅ AI Hosts stopped completely - mic OFF');
};
const handleInterruption = async () => {
  console.log('🛑 User interrupted!');
  
  // ✅ IMMEDIATELY STOP ALL AUDIO
  if (currentAudioRef.current) {
    currentAudioRef.current.pause();
    currentAudioRef.current.currentTime = 0;
    currentAudioRef.current = null;
  }
  
  // ✅ ABORT ALL PENDING AUDIO REQUESTS
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();
  }
  
  // ✅ CLEAR ALL CACHED AUDIO CHUNKS
  audioQueueRef.current.forEach(({ url }) => {
    URL.revokeObjectURL(url);
  });
  audioQueueRef.current.clear();
  
  // ✅ STOP PRELOADING QUEUE
  isPreloadingRef.current.clear();
  
  // Clear host message
  setHostMessage('');
  setCurrentSpeaker(null);
  
  // Switch to listening mode
  setAiHostsStatus('listening');
  setTranscript('');
  
  // ✅ SAFE STOP & RESTART
  safeStopRecognition(recognitionRef);
  setTimeout(() => {
    if (aiHostsActive) {
      safeStartRecognition(recognitionRef);
    }
  }, 100);
  
  console.log('✅ Interrupted completely - all audio killed');
};

const forceCleanupAudio = async (refs) => {
  console.log('🧹 FORCE CLEANUP - Stopping all audio and mic...');
  
  const { recognitionRef, currentAudioRef, abortControllerRef, audioQueueRef, isPreloadingRef } = refs;
  
  // ✅ STEP 1: SET FLAG TO FALSE (Most critical for mobile)
  isRecognitionActiveRef.current = false;
  console.log('🛑 Recognition flag set to FALSE');
  
  // ✅ STEP 2: STOP RECOGNITION
  safeStopRecognition(recognitionRef);
  
  // ✅ STEP 3: Wait for mic to release AND for any pending restarts to abort
  await new Promise(resolve => setTimeout(resolve, 500)); // Increased from 200ms
  
  // ✅ STEP 4: STOP ALL AUDIO
  if (currentAudioRef?.current) {
    try {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
      currentAudioRef.current.src = '';
      currentAudioRef.current = null;
    } catch (e) {
      console.log('Audio stop error:', e);
    }
  }
  
  // ✅ STEP 5: ABORT CONTROLLER
  if (abortControllerRef?.current) {
    try {
      abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
    } catch (e) {
      console.log('Abort error:', e);
    }
  }
  
  // ✅ STEP 6: CLEAR AUDIO QUEUE
  if (audioQueueRef?.current) {
    audioQueueRef.current.forEach(({ url }) => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {
        console.log('URL revoke error:', e);
      }
    });
    audioQueueRef.current.clear();
  }
  
  // ✅ STEP 7: CLEAR PRELOADING
  if (isPreloadingRef?.current) {
    isPreloadingRef.current.clear();
  }
  
  console.log('✅ Force cleanup complete - mic should be OFF');
};
const notifyCardChange = async (cardIndex) => {
  if (aiHostsStatus === 'speaking' || aiHostsStatus === 'thinking') {
    return;
  }
  
  // ✅ Use passed index or current
  const idx = cardIndex !== undefined ? cardIndex : currentIndex;
  const nextCard = flashcards[idx];
  
  const systemPrompt = `You are Emma. The student just moved to the next flashcard:

Card ${idx + 1} of ${flashcards.length}
Term/Question: "${nextCard.question}"

Create a SHORT (15-20 words) COMPLETE natural sentence that:
- Acknowledges moving forward
- References the new card casually
- Offers help naturally

MUST flow as ONE natural spoken sentence!

Examples:
- "Alright cool, so now we're on card ${idx + 1} - how's this one looking to you?"
- "Nice! Moving right along to the next card - does this term make sense so far?"
- "Okay so here's card ${idx + 1} now - want me to break anything down for you?"

Keep it smooth and conversational. Return ONLY Emma's response as ONE sentence.`;

  try {
// ✅ SECURE API CALL
const data = await SecureAPI.callAzureOpenAI(
  [
    { role: 'system', content: systemPrompt }
  ],
  {
    temperature: 0.8,
    max_tokens: 50
  }
);
    const notification = data.choices[0].message.content.trim();
    
    await speakWithHumeStreaming(notification, 'emma').then(() => {
      setAiHostsStatus('listening');
      safeStartRecognition(recognitionRef);
    });
  } catch (error) {
    console.error('Card change notification error:', error);
  }
};

const farewell = async () => {
  const farewells = [
    `Nice work finishing! You did great.`,
    `All done! Great job powering through.`,
    `Complete! Well done!`,
    `Finished! You crushed it.`,
  ];
  
  const farewell = farewells[Math.floor(Math.random() * farewells.length)];
  await speakWithHumeStreaming(farewell, 'emma');
};
const handleNext = async () => {
  if (currentIndex < flashcards.length - 1) {
    // Move to next card
    const nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);
    setIsFlipped(false);
    
    // ✅ Clear chat for next card
    if (aiTextMode) {
      setTextChatMessages([]);
      setTextChatInput('');
    }
    
    // ✅ CRITICAL: Sync context for voice mode IMMEDIATELY
    if (aiHostsActive) {
      const nextCard = flashcards[nextIndex];
      
      const contextMessage = `[SYSTEM UPDATE]: User just clicked Next. We are now on Card ${nextIndex + 1} of ${flashcards.length}. New term: "${nextCard.question}", Answer: "${nextCard.answer}". User may ask about THIS card next.`;
      
      conversationHistoryRef.current.push({
        role: 'system',
        content: contextMessage
      });
      
      console.log(`✅ Context synced IMMEDIATELY: Card ${nextIndex + 1}`);
      
      // ✅ Notify AI after brief delay
      setTimeout(() => {
        notifyCardChange(nextIndex);
      }, 200);
    }  
  } else {
    // ✅ FLASHCARDS FINISHED - CLEANUP AND CLOSE
    const timeSpent = Math.floor((Date.now() - sessionStart) / 1000);
    
    // ✅ SAVE DATA FIRST
    try {
      if (firestoreService && firestoreService.isReady()) {
        const sessionData = {
          setId: flashcardData.id,
          setTitle: flashcardData.title,
          setDifficulty: flashcardData.difficulty,
          cardsStudied: flashcards.length,
          timeSpent: timeSpent,
          completedAt: serverTimestamp()
        };

        await firestoreService.saveFlashcardSession(flashcardData.id, sessionData);
        console.log('✅ Flashcard session saved to Firestore');
      }
    } catch (error) {
      console.error('❌ Failed to save flashcard session:', error);
    }
    
    // Local storage backup
    const savedStats = JSON.parse(localStorage.getItem('studyhub_stats') || '{"quizHistory":[],"flashcardSessions":[],"totalQuizzes":0,"totalFlashcards":0}');
    
    const newSession = {
      date: new Date().toISOString(),
      cardsStudied: flashcards.length,
      timeSpent: timeSpent,
      setId: flashcardData.id,
      setTitle: flashcardData.title
    };
    
    const updatedStats = {
      ...savedStats,
      flashcardSessions: [newSession, ...savedStats.flashcardSessions],
      totalFlashcards: savedStats.totalFlashcards + flashcards.length
    };
    
    localStorage.setItem('studyhub_stats', JSON.stringify(updatedStats));
    
    // ✅ STOP AI HOSTS COMPLETELY
    if (aiHostsActive) {
      await farewell();
      await new Promise(resolve => setTimeout(resolve, 2000));
      await stopAIHosts();
      
      // Force cleanup
      isRecognitionActiveRef.current = false;
      safeStopRecognition(recognitionRef);
      
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current = null;
      }
      
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      
      audioQueueRef.current.forEach(({ url }) => {
        try {
          URL.revokeObjectURL(url);
        } catch (e) {}
      });
      audioQueueRef.current.clear();
      isPreloadingRef.current.clear();
    }
    
    if (onStatsUpdate) {
      onStatsUpdate();
    }
    
    // ✅ CLOSE MODAL IMMEDIATELY
    onClose();
  }
};
  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  useEffect(() => {
    if (shuffleEnabled) {
      setFlashcards(shuffleArray(flashcardData.flashcards));
    } else {
      setFlashcards(flashcardData.flashcards);
    }
  }, [shuffleEnabled, flashcardData.flashcards]);

  useEffect(() => {
    return () => {
      setShowCompletion(false);
    };
  }, []);

  // AI Hosts Button UI
const renderAIHostsButton = () => {
  // ✅ SHOW: Ask Preptune button first (with mic icon)
  if (!aiHostsActive && !aiTextMode) {
    return (
      <button
        onClick={() => setAiHostsActive(true)}
        style={{
          marginTop: '20px',
          width: 'fit-content',      
          padding: '12px 24px',    
          background: '#000000',
          border: 'none',
          borderRadius: '24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          margin: '20px auto 0',    
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.2s',
          animation: 'slideUp 0.4s ease-out'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#1f2937';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#000000';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
        </svg>
        <span style={{
          fontSize: '13px',
          fontWeight: '500',
          color: 'white'
        }}>
          Ask Preptune
        </span>
      </button>
    );
  }

  // ✅ SHOW: Choice modal (Chat or Voice) with slideUp animation
  if (aiHostsActive && aiHostsStatus === 'idle') {
    return (
      <div style={{ marginTop: '20px', animation: 'slideUp 0.4s ease-out' }}>
        <div style={{
          background: 'white',
          borderRadius: '28px',
          padding: '18px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          animation: 'slideUp 0.4s ease-out'
        }}>
          <div style={{
            fontSize: '13px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px',
            textAlign: 'center'
          }}>
            Pick One
          </div>

          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '0'
          }}>
            {/* Use Chat Button - GREY */}
            <button
              onClick={() => {
                setAiTextMode(true);
                setAiHostsActive(false);
              }}
              style={{
                flex: 1,
                padding: '10px',
                background: '#e5e7eb',
                border: 'none',
                borderRadius: '24px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                color: '#374151',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#d1d5db';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#e5e7eb';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
              Use Chat
            </button>

            {/* Use Voice Button - BLACK */}
            <button
              onClick={async () => {
                await startAIHosts();
              }}
              style={{
                flex: 1,
                padding: '10px',
                background: '#000000',
                border: 'none',
                borderRadius: '24px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#1f2937';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#000000';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
              </svg>
              Use Voice
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ✅ SHOW: Voice mode active status (EXACT SAME AS QUIZ)
  const getStatusDisplay = () => {
    switch (aiHostsStatus) {
      case 'loading':
        return {
          text: 'Loading',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          )
        };
      
      case 'listening':
        return {
          text: 'Listening',
          icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ animation: 'pulse 1.5s infinite' }}>
              <path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/>
            </svg>
          )
        };
      
      case 'thinking':
        return {
          text: 'Thinking...',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          )
        };
      
      case 'speaking':
        return {
          text: currentSpeaker === 'emma' ? 'Emma speaking' : 'James responding',
          icon: (
            <div style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              background: 'white',
              animation: 'pulse 1s infinite'
            }} />
          )
        };
      
      default:
        return { text: 'Active', icon: null };
    }
  };

  const status = getStatusDisplay();

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{
        width: '100%',
        padding: '12px',
        background: '#000000',
        borderRadius: '20px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s',
        position: 'relative'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          position: 'relative'
        }}>
          {status.icon}
          <span style={{
            fontSize: '13px',
            fontWeight: '500',
            color: 'white'
          }}>
            {status.text}
          </span>

          <button
            onClick={stopAIHosts}
            style={{
              position: 'absolute',
              right: '0',
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s'
            }}
          >
            <svg width="12" height="12" viewBox="0 0 15 15" fill="none">
              <path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="white"/>
            </svg>
          </button>
        </div>

        {transcript && aiHostsStatus === 'listening' && (
          <div style={{
            marginTop: '12px',
            padding: '10px 12px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px dashed rgba(255, 255, 255, 0.3)',
            borderRadius: '10px',
            fontSize: '11px',
            color: 'rgba(255, 255, 255, 0.9)',
            fontStyle: 'italic',
            animation: 'fadeIn 0.3s ease-out',
            textAlign: 'left'
          }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '600',
              color: 'rgba(255, 255, 255, 0.7)',
              marginBottom: '4px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              YOU'RE SAYING:
            </div>
            "{transcript}"
          </div>
        )}

        {hostMessage && aiHostsStatus === 'speaking' && (
          <div style={{
            marginTop: '12px',
            padding: '10px 12px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '10px',
            animation: 'fadeIn 0.3s ease-out',
            textAlign: 'left'
          }}>
            <div style={{
              fontSize: '9px',
              fontWeight: '600',
              color: 'rgba(255, 255, 255, 0.7)',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {currentSpeaker === 'emma' ? 'EMMA' : 'JAMES'}
            </div>
            <div style={{
              fontSize: '12px',
              color: 'white',
              lineHeight: '1.5'
            }}>
              {hostMessage}
            </div>
          </div>
        )}

        {aiHostsStatus === 'speaking' && (
          <button
            onClick={handleInterruption}
            style={{
              width: '100%',
              marginTop: '12px',
              padding: '10px',
              background: 'rgba(255, 255, 255, 0.99)',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(150, 150, 150, 0.3)'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C11.4477 2 11 2.44772 11 3V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V3C13 2.44772 12.5523 2 12 2Z" fill="black"/>
              <path d="M8 5C7.44772 5 7 5.44772 7 6V12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12V6C9 5.44772 8.55228 5 8 5Z" fill="black"/>
              <path d="M16 5C15.4477 5 15 5.44772 15 6V12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12V6C17 5.44772 16.5523 5 16 5Z" fill="black"/>
              <path d="M4 8C3.44772 8 3 8.44772 3 9V13C3 17.4183 6.58172 21 11 21H13C17.4183 21 21 17.4183 21 13V9C21 8.44772 20.5523 8 20 8C19.4477 8 19 8.44772 19 9V13C19 16.3137 16.3137 19 13 19H11C7.68629 19 5 16.3137 5 13V9C5 8.44772 4.55228 8 4 8Z" fill="black"/>
            </svg>
            <span style={{
              fontSize: '12px',
              fontWeight: '600',
              color: 'black'
            }}>
              Interrupt & Speak
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

return (
// In FlashcardComponent return:
<div 
  className="modal-overlay"
  onClick={(e) => { if (e.target === e.currentTarget) handleModalClose(); }}
>
  <div 
    className="quiz-modal"
    style={gradient ? { background: gradient.background } : {}}
  >
      <div className="modal-header"> {/* ✅ Keep existing header styling */}
        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
          Card {currentIndex + 1} / {flashcards.length}
        </div>
<button className="close-btn" onClick={handleModalClose}>
  <X size={18} />
</button>
      </div>

      <div className="modal-body">
        <div 
  style={{ 
    width: '80%',        // smaller width
    height: '3px',
    background: 'rgba(255, 255, 255, 0.6)',
    borderRadius: '20px',
    margin: '0 auto',    // centers horizontally
    overflow: 'hidden'
  }}
>
          <div style={{ 
            width: `${progressPercentage}%`, 
            height: '100%', 
            background: '#000000ff',
            transition: 'width 0.3s ease',
            borderRadius: '20px'
          }}></div>
        </div>
       <div className="modal-body">
          {!showCompletion ? (
            <>
              {/* Stack Container - wraps the flip card */}
              <div style={{
                position: 'relative',
                width: '100%',
                marginBottom: '24px'
              }}>
                {/* Calculate remaining cards */}
                {(() => {
                  const remainingCards = flashcards.length - currentIndex - 1;
                  
                  return (
                    <>
                      {/* Second shadow card - show only if 2+ cards remaining */}
                      {remainingCards >= 2 && (
                        <div style={{
                          position: 'absolute',
                          top: '16px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '90%',
                          height: '100%',
                          background: 'white',
                          opacity: '0.4',
                          borderRadius: '24px',
                          border: '1px solid rgba(0, 0, 0, 0.06)',
                          zIndex: 0,
                          pointerEvents: 'none',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)',
                          animation: 'slideInShadow 0.4s ease-out'
                        }} />
                      )}
                      
                      {/* First shadow card - show only if 1+ cards remaining */}
                      {remainingCards >= 1 && (
                        <div style={{
                          position: 'absolute',
                          top: '8px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '95%',
                          height: '100%',
                          background: 'white',
                          opacity: '0.6',
                          borderRadius: '24px',
                          border: '1px solid rgba(0, 0, 0, 0.08)',
                          zIndex: 1,
                          pointerEvents: 'none',
                          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                          animation: 'slideInShadow 0.3s ease-out'
                        }} />
                      )}
                    </>
                  );
                })()}

                {/* Original flip card with animation */}
                <div 
                  key={currentIndex} /* ✅ Key forces re-render and animation on card change */
                  className={`flashcard-flip-container ${isFlipped ? 'flipped' : ''}`} 
                  onClick={handleFlip}
                  style={{ 
                    position: 'relative', 
                    zIndex: 2,
                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.12)',
                    borderRadius: '28px',
                    animation: 'slideInCard 0.4s ease-out'
                  }}
                >
                  <div className="flashcard-flip-inner">
                    <div className="flashcard flashcard-front">
                      <div className="flashcard-text">{currentCard.question}</div>
                      <div className="tap-hint">Tap to reveal answer</div>
                    </div>
                    <div className="flashcard flashcard-back">
                      <div className="flashcard-text">{currentCard.answer}</div>
                      <div className="tap-hint">Tap to see question</div>
                    </div>
                  </div>
                </div>
              </div>

              <button 
                onClick={handleNext} 
                className="btn-next active"
                style={{ 
                  marginTop: '24px',
                  transition: 'all 0.3s ease'
                }}
              >
                {currentIndex === flashcardData.flashcards.length - 1 ? 'Finish' : 'Next'}
              </button>
          {/* ✅ AI BUTTON - Toggle between Chat and Voice */}
              {aiTextMode ? (
                renderAITextChat()
              ) : (
                renderAIHostsButton()
              )}
            </>
          ) : (
            // Completion Container - White styled box
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              animation: 'fadeIn 0.4s ease-out'
            }}>
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '32px 24px',
                maxWidth: '320px',
                width: '100%',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(231, 231, 231, 1)'
              }}>
                {/* Emoji Icon */}
                <div style={{ fontSize: '42px', marginBottom: '16px' }}>🎉</div>
                
                {/* Title */}
                <h3 style={{ 
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#1f2937', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>
                  Session Complete!
                </h3>
                
                {/* Subtitle */}
                <p style={{ 
                  fontSize: '13px', 
                  color: '#6b7280', 
                  marginBottom: '24px',
                  margin: '0 0 24px 0'
                }}>
                  You studied {flashcardData.flashcards.length} cards
                </p>
                
                {/* Done Button */}
                <button 
                  onClick={onClose}
                  style={{
                    width: '100%',
                    padding: '10px',
                    background: '#272727',
                    border: 'none',
                    borderRadius: '20px',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          )}
        </div>
        </div>
      </div>

      <style>{`
      .quiz-modal {
  position: relative;
  overflow: hidden;
}

.quiz-modal::before {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;        /* Copy background image */
  background-size: inherit;
  background-position: inherit;
  filter: blur(3px);         /* <== BLUR HERE */
  transform: scale(1.1);      /* Prevent edges from showing */
  z-index: 0;
}

.quiz-modal > * {
  position: relative;
  z-index: 1;  /* Keeps content sharp */
}

        @keyframes slideInCard {
          from { 
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        @keyframes slideInShadow {
          from { 
            opacity: 0;
            transform: translateX(-50%) translateY(20px);
          }
          to { 
            opacity: 0.6;
            transform: translateX(-50%) translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(0.95); }
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

const EnhancedStatsModal = ({ 
  onClose, 
  type = 'all',
  studyStats = {},
  dontAskAgain = false,
  defaultShufflePreference = false,
  onShuffleChange = () => {},
  onResetShuffle = () => {},
  isQuizActive = false,  // ✅ ADD THIS
  isFlashcardActive = false,  // ✅ ADD THIS
  onReshuffle = () => {}  // ✅ ADD THIS
}) => {
  // ✅ Use passed props with fallbacks
  const stats = studyStats || {
    quizHistory: [],
    flashcardSessions: [],
    totalQuizzes: 0,
    totalFlashcards: 0
  };
  
  // ✅ SAFE CALCULATIONS - All use defensive checks
  const totalQuizzes = (stats.quizHistory || []).length;
  const avgScore = totalQuizzes > 0 
    ? Math.round((stats.quizHistory || []).reduce((sum, q) => sum + (q.score || 0), 0) / totalQuizzes)
    : 0;
  const totalQuestionsAnswered = (stats.quizHistory || []).reduce((sum, q) => sum + (q.questionsTotal || 0), 0);
  const totalQuestionsCorrect = (stats.quizHistory || []).reduce((sum, q) => sum + (q.questionsCorrect || 0), 0);
  
  const totalFlashcardSessions = (stats.flashcardSessions || []).length;
  const totalCardsStudied = (stats.flashcardSessions || []).reduce((sum, s) => sum + (s.cardsStudied || 0), 0);
  const totalStudyTime = (stats.flashcardSessions || []).reduce((sum, s) => sum + (s.timeSpent || 0), 0);
  const avgCardsPerSession = totalFlashcardSessions > 0 
    ? Math.round(totalCardsStudied / totalFlashcardSessions)
    : 0;
  
  const recentQuizzes = (stats.quizHistory || []).slice(0, 3);
  
  const byDifficulty = { easy: [], medium: [], hard: [] };
  (stats.quizHistory || []).forEach(q => {
    if (byDifficulty[q.difficulty]) {
      byDifficulty[q.difficulty].push(q.score);
    }
  });
  
  const difficultyAvg = {
    easy: byDifficulty.easy.length > 0 ? Math.round(byDifficulty.easy.reduce((a, b) => a + b, 0) / byDifficulty.easy.length) : 0,
    medium: byDifficulty.medium.length > 0 ? Math.round(byDifficulty.medium.reduce((a, b) => a + b, 0) / byDifficulty.medium.length) : 0,
    hard: byDifficulty.hard.length > 0 ? Math.round(byDifficulty.hard.reduce((a, b) => a + b, 0) / byDifficulty.hard.length) : 0
  };
  
  const topicCount = {};
  (stats.quizHistory || []).forEach(q => {
    topicCount[q.topic] = (topicCount[q.topic] || 0) + 1;
  });
  const topTopics = Object.entries(topicCount)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  const flashcardSetCount = {};
  (stats.flashcardSessions || []).forEach(s => {
    if (s.setTitle) {
      flashcardSetCount[s.setTitle] = (flashcardSetCount[s.setTitle] || 0) + 1;
    }
  });
  const topFlashcardSets = Object.entries(flashcardSetCount)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  // ✅ Log for debugging
  console.log('📊 EnhancedStatsModal opened with:', {
    type,
    totalQuizzes,
    totalFlashcardSessions,
    avgScore,
    stats
  });

  return (
    <div className="modal-overlay">
      <div 
        className="quiz-modal" 
        style={{ 
          background: 'linear-gradient(180deg, #f8fcffff 0%, #feffffff 100%)',
          animation: 'slideUp 0.3s ease-out'
        }}
      >
        {/* Header */}
        <div className="modal-header">
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
            {type === 'quiz' ? 'Quiz Statistics' : type === 'flashcard' ? 'Flashcard Statistics' : 'Statistics'}
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="modal-body" style={{ paddingBottom: '40px' }}>

          {/* QUIZ STATS - Show only if type is quiz or all AND has data */}
          {(type === 'all' || type === 'quiz') && totalQuizzes > 0 && (
            <div className="stat-card-wrapper" style={{ marginTop: '-20px' }}>
              <div className="stat-card-gradient" style={{
                background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)'
              }}></div>
              <div className="stat-card-content">
                <div className="stat-card-inner">
                  <div className="stat-title">Quiz Statistics</div>
                  
                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 11l3 3L22 4"></path>
                      </svg>
                      <span>Quizzes Completed</span>
                    </div>
                    <div className="time-percentage">{totalQuizzes}</div>
                  </div>

                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                      </svg>
                      <span>Average Score</span>
                    </div>
                    <div className="time-percentage">{avgScore}%</div>
                  </div>

                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 6v6l4 2"></path>
                      </svg>
                      <span>Questions Answered</span>
                    </div>
                    <div className="time-percentage">
                      {totalQuestionsCorrect}/{totalQuestionsAnswered}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* FLASHCARD STATS - Show only if type is flashcard or all AND has data */}
          {(type === 'all' || type === 'flashcard') && totalFlashcardSessions > 0 && (
            <div className="stat-card-wrapper">
              <div className="stat-card-gradient" style={{
                background: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)'
              }}></div>
              <div className="stat-card-content">
                <div className="stat-card-inner">
                  <div className="stat-title">Flashcard Statistics</div>
                  
                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="9" y1="9" x2="15" y2="9"></line>
                        <line x1="9" y1="15" x2="15" y2="15"></line>
                      </svg>
                      <span>Study Sessions</span>
                    </div>
                    <div className="time-percentage">{totalFlashcardSessions}</div>
                  </div>

                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 11.5h13m-13 0V18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6.5m-13 0V9a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.5M9 5h11a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1"/>
                      </svg>
                      <span>Cards Studied</span>
                    </div>
                    <div className="time-percentage">{totalCardsStudied}</div>
                  </div>

                  <div className="time-stat">
                    <div className="time-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <span>Total Study Time</span>
                    </div>
                    <div className="time-percentage">
                      {Math.round(totalStudyTime / 60)}m
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* NO DATA MESSAGE */}
          {totalQuizzes === 0 && totalFlashcardSessions === 0 && (
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '32px 24px',
              textAlign: 'left',
              border: '1px solid #e5e7eb'
            }}>
              <p style={{
                fontSize: '13px',
                color: '#6b7280',
                lineHeight: '1.6'
              }}>
                 No statistics yet. Complete quizzes or flashcards to see your stats!
              </p>
            </div>
          )}

        </div>
                  {/* Shuffle Preference - Show for all types */}

{dontAskAgain && (
  <div style={{
    background: 'white',
    borderRadius: '12px',
    padding: '14px 16px',
    marginBottom: '16px',
    border: '1px solid #e5e7eb'
  }}>
    {/* Top Row: Icon + Status */}
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      marginBottom: '12px'
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50px',
        background: '#f3f4f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}>
        <Shuffle size={15} color="#272727" strokeWidth={2.5} />
      </div>

      <div style={{
        flex: 1,
        textAlign: 'left'
      }}>
        <div style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '2px'
        }}>
          Shuffle Preference
        </div>
        <div style={{
          fontSize: '12px',
          color: '#6b7280'
        }}>
          {defaultShufflePreference ? 'Enabled' : 'Disabled'}
        </div>
      </div>
    </div>

    {/* Buttons Row */}
    <div style={{
      display: 'flex',
      gap: '8px'
    }}>
      {/* Toggle Button */}
      <button
        onClick={() => {
          const newValue = !defaultShufflePreference;
          onShuffleChange(newValue);
        }}
        style={{
          flex: 1,
          padding: '8px 12px',
          background: defaultShufflePreference ? '#000000ff' : '#9ca3af',
          border: 'none',
          borderRadius: '24px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '600',
          color: 'white',
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = defaultShufflePreference ? '#1f2937' : '#7a8086';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = defaultShufflePreference ? '#272727' : '#9ca3af';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        {defaultShufflePreference ? (
          <Check size={14} />
        ) : (
          <X size={14} />
        )}
        {defaultShufflePreference ? 'Disable' : 'Enable'}
      </button>

      {/* Reshuffle Current Button - ✅ FIXED */}
      {(isQuizActive || isFlashcardActive) && (
        <button
          onClick={() => {
            onReshuffle();
          }}
          style={{
            flex: 1,
            padding: '8px 12px',
            background: '#dbeafe',
            border: '1px solid #93c5fd',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '600',
            color: '#1e40af',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#bfdbfe';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#dbeafe';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <Shuffle size={14} />
          Reshuffle
        </button>
      )}

      {/* Reset Button */}
      <button
        onClick={() => {
          onResetShuffle();
        }}
        style={{
          flex: 1,
          padding: '8px 12px',
          background: '#f7f7f7ff',
          border: '1px solid #d1d5db',
          borderRadius: '24px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '600',
          color: '#374151',
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#e5e7eb';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#f3f4f6';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <RotateCcw size={14} />
        Reset
      </button>
    </div>
  </div>
)}


      </div>
    </div>
  );
};
// Skeleton Shimmer Animation CSS
const SkeletonStyles = () => (
  <style>{`
    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }
    
    .skeleton {
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      border-radius: 12px;
    }
  `}</style>
);

//  QuizCardSkeleton with this (NO glass-container wrapper):
const QuizCardSkeleton = () => (
  <div style={{ position: 'relative', marginBottom: '16px' }}>  {/* ✅ REMOVED glass-container class */}
    <div style={{
      background: 'rgba(255, 255, 255, 0.31)',
      backdropFilter: 'blur(20px)',
      borderRadius: '18px',
      padding: '4px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      border: '1px solid rgba(255, 255, 255, 0.93)'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '15px',
        border: '1px solid rgba(213, 213, 213, 0.5)',
        overflow: 'hidden'
      }}>
        {/* Top Section with Gradient Background */}
        <div style={{
          padding: '32px 20px',
          textAlign: 'center',
          position: 'relative'
        }}>
          {/* Question count skeleton */}
          <div style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '80px',
            height: '14px',
            borderRadius: '4px'
          }} className="skeleton" />
          
          {/* Title skeleton - in bubble */}
          <div style={{
            display: 'inline-block',
            background: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '20px',
            padding: '5px 20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            marginBottom: '8px'
          }}>
            <div style={{
              width: '180px',
              height: '16px',
              borderRadius: '4px'
            }} className="skeleton" />
          </div>
        </div>
        
        {/* Bottom Section */}
        <div style={{
          background: '#ffffff',
          padding: '14px'
        }}>
          {/* Meta info skeleton */}
          <div style={{
            background: 'transparent',
            borderRadius: '0',
            padding: '10px 14px',
            marginBottom: '10px',
            borderTop: '1px solid #d9e0ec'
          }}>
            <div style={{
              width: '60px',
              height: '12px',
              marginBottom: '6px',
              borderRadius: '4px'
            }} className="skeleton" />
            <div style={{
              width: '100%',
              height: '12px',
              borderRadius: '4px'
            }} className="skeleton" />
          </div>
          
          {/* Button skeleton */}
          <div style={{
            width: '100%',
            height: '40px',
            borderRadius: '24px'
          }} className="skeleton" />
        </div>
      </div>
    </div>
  </div>
);

// FlashcardSkeleton with this (NO glass-container wrapper):
const FlashcardSkeleton = () => (
  <div style={{ position: 'relative', marginBottom: '16px' }}>  {/* ✅ REMOVED glass-container class */}
    <div style={{
      background: 'rgba(255, 255, 255, 0.31)',
      backdropFilter: 'blur(20px)',
      borderRadius: '18px',
      padding: '4px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      border: '1px solid rgba(255, 255, 255, 0.93)'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '15px',
        border: '1px solid rgba(213, 213, 213, 0.5)',
        overflow: 'hidden'
      }}>
        {/* Top Section */}
        <div style={{
          padding: '32px 20px',
          textAlign: 'center',
          position: 'relative',
          background: 'linear-gradient(135deg, rgba(254, 235, 220, 0.4) 0%, rgba(254, 200, 220, 0.4) 50%, rgba(251, 241, 236, 0.4) 100%)'
        }}>
          {/* Card count skeleton */}
          <div style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '70px',
            height: '14px',
            borderRadius: '4px'
          }} className="skeleton" />
          
          {/* Title skeleton - in bubble */}
          <div style={{
            display: 'inline-block',
            background: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '20px',
            padding: '5px 20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            marginBottom: '8px'
          }}>
            <div style={{
              width: '160px',
              height: '16px',
              borderRadius: '4px'
            }} className="skeleton" />
          </div>
        </div>
        
        {/* Bottom Section */}
        <div style={{
          background: '#ffffff',
          padding: '14px'
        }}>
          {/* Meta info skeleton */}
          <div style={{
            background: 'transparent',
            borderRadius: '0',
            padding: '10px 14px',
            marginBottom: '10px',
            borderTop: '1px solid #d9e0ec'
          }}>
            <div style={{
              width: '50px',
              height: '12px',
              marginBottom: '6px',
              borderRadius: '4px'
            }} className="skeleton" />
            <div style={{
              width: '90%',
              height: '12px',
              borderRadius: '4px'
            }} className="skeleton" />
          </div>
          
          {/* Button skeleton */}
          <div style={{
            width: '100%',
            height: '40px',
            borderRadius: '24px'
          }} className="skeleton" />
        </div>
      </div>
    </div>
  </div>
);

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          height: 100vh;
        }

        .container {
          max-width: 600px;
          margin: 0 auto;
          padding: 16px;
        }

        .header { margin-bottom: 20px; }
        .header h1 { font-size: 24px; font-weight: 700; color: #1f2937; margin-bottom: 8px; }
        .header p { font-size: 12px; color: #6b7280; }

        .stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 24px;
        }

        .glass-container {
          background: rgba(255, 255, 255, 1);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 7px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(255, 255, 255, 1);
          overflow: hidden;
          margin-bottom: 10px;
        }

        .stat-card {
          background: white;
          border-radius: 16px;
          padding: 20px 16px;
          display: flex;
          align-items: flex-start;
          gap: 16px;
        }

        .icon-circle-stat {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .stat-content {
          flex: 1;
          padding-top: 2px;
        }

        .stat-content h3 {
          font-size: 15px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 4px;
        }

        .stat-content p {
          font-size: 13px;
          color: #6b7280;
        }

        .tabs {
          display: flex;
          gap: 8px;
          margin-bottom: 10px;
          background: white;
          border-radius: 22px;
          padding: 6px;
         border: 1px solid rgba(228, 228, 228, 1);

        }

        .tab {
          flex: 1;
          padding: 10px;
          background: transparent;
          border: none;
          border-radius: 20px;
          cursor: pointer;
          font-size: 11px;
          font-weight: 500;
          color: #6b7280;
          transition: all 0.2s;
        }

        .tab.active { background: #eaf5ffff; color: #0d289eff;  
               }

        .section-title1 {
          font-size: 12px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 16px;
          text-align: left,
        }

        .card-container {
          background: white;
          border-radius: 20px;
          padding: 2px;
          margin-bottom: 10px;
          border: 1px solid rgba(211, 211, 211, 1);
        }

        .preview-card {
          background: transparent;
          border-radius: 12px;
          padding: 16px;
          margin-bottom: 0;
          display: flex;
          align-items: flex-start;
          gap: 16px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .preview-card:hover {
          background: #f9fafb;
        }

        .icon-circle {
          width: 25px;
          height: 25px;
          border-radius: 50px;
          background: #f1f1f1ff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #757575ff;
        }

        .card-content { flex: 1; padding-top: 2px; }
        .card-content h3 { 
          font-size: 12px; 
          font-weight: 500; 
          color: #1f2937; 
          margin-bottom: 6px;
          line-height: 1.3;
        }
        .card-content p { 
          font-size: 11px; 
          color: #6b7280; 
          line-height: 1.5;
        }

        .item-card {
          margin-bottom: 16px;
        }

        .message-bubble {
          background: white;
          border-radius: 20px;
          padding: 5px 20px;
          display: inline-block;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          margin-bottom: 8px;
        }

        .item-gradient {
          background: linear-gradient(250deg, 
            rgba(211, 238, 255, 1) 0%, 
            rgba(255, 206, 215, 1) 53%, 
            rgba(236, 241, 251, 0.3) 60%,
            #e9f9ffff 60%,
            #eaf2ffff 100%
          );
          border-radius: 16px;
          padding: 0;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          border: 1px solid rgba(196, 210, 253, 0.5);
          overflow: hidden;
        }

        .gradient-top {
          background: linear-gradient(135deg, 
            rgba(224, 242, 254, 0.4) 0%, 
            rgba(254, 220, 240, 0.4) 50%, 
            rgba(236, 241, 251, 0.4) 100%
          );
          padding: 32px 20px;
          text-align: center;
        }

        .gradient-bottom {
          background: #ffffffff;
          padding: 14px;
        }

        .item-gradient:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .item-content-wrapper {
          background: transparent;
          border-radius: 0;
          padding: 0;
          margin-bottom: 0;
          text-align: center;
          min-height: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          box-shadow: none;
        }

        .item-text { }
        
        .item-count {
          font-size: 11px;
          font-weight: 600;
          color: #4a505cff;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .item-title {
          font-size: 12px;
          line-height: 1.3;
          color: #1f2937;
          font-weight: 600;
            margin: 0;
        }

        .item-meta {
          background: transparent;
          border-radius: 0;
          padding: 10px 14px;
          margin-bottom: 10px;
          border: none;
          border-top: 1px solid #d9e0ecff;
        }

        .meta-label {
          font-size: 9px;
          font-weight: 600;
          color: #6b7280;
          margin-bottom: 4px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .meta-value {
          font-size: 11px;
          color: #374151;
          line-height: 1.4;
        }

        .start-btn {
          width: 100%;
          padding: 10px;
          background: #020202ff;
          border: none;
          border-radius: 24px;
          color: white;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 2000;
          display: flex;
          align-items: flex-end;
        }

        .quiz-modal, .flashcard-modal {
          width: 100%;
          height: 90vh;
          background: linear-gradient(180deg, #f1f9ffff 0%, #b2d3ffff 100%);
          border-radius: 24px 24px 0 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .flashcard-modal {
          background: linear-gradient(170deg, #fff7d6ff 0%, #fde68a 100%);
        }

        .modal-header {
          padding: 16px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .progress-text { font-size: 14px; font-weight: 600; color: #1f2937; }

        .close-btn {
          background: white;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1f2937;
        }

.modal-body {
  flex: 1;
  padding: 24px;
  padding-bottom: 100px; 
  overflow-y: auto;
}
        .question-card {
          background: white;
          border-radius: 28px;
          padding: 24px;
          margin-bottom: 24px;
        }

        .question-card h3 {
          font-size: 14px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 20px;
        }

        .options {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .option {
          padding: 14px 16px;
          background: white;
          border: 2px solid #e5e7eb;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          color: #5e6166ff;
          text-align: left;
          font-weight: 400;
          transition: all 0.2s;
        }

        .option:hover:not(:disabled) { border-color: #3b82f6; background: transparent;}
        .option.selected { background: #dbeafe; border-color: #e8f1ffff; font-weight: 600; }
        .option.correct { background: #d1fae5; border-color: #10b981; }
        .option.wrong { background: #fee2e2; border-color: #ef4444; }
        .option:disabled { cursor: default; }

        .btn-next {
          width: 90%;
          padding: 10px;
          background: #f3f4f6;
          border: none;
          border-radius: 20px;
          cursor: not-allowed;
          margin-bottom: 20px;
          font-size: 13px;
          font-weight: 500;
          color: #9ca3af;
        }

        .btn-next.active {
          background: #272727;
          color: white;
          cursor: pointer;
        }

        .flashcard {
          flex: 1;
          background: white;
          border-radius: 20px;
          padding: 32px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          min-height: 300px;

        }

        .flashcard-text {
          font-size: 16px;
          font-weight: 500;
          color: #1f2937;
          text-align: center;
        }

        .tap-hint {
          font-size: 12px;
          color: #9ca3af;
          margin-top: 16px;
        }

        .results-modal {
          background: white;
          border-radius: 20px;
          padding: 32px 24px;
          max-width: 360px;
          width: 100%;
          text-align: center;
          margin: auto;
        }

        .results-modal h2 {
          font-size: 18px;
          font-weight: 500;
          color: #1f2937;
          margin: 16px 0 8px;
        }

        .score {
          font-size: 42px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .results-modal p {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 24px;
        }

        .btn-primary {
          width: 100%;
          padding: 12px;
          background: #272727;
          border: none;
          border-radius: 20px;
          color: white;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
.view-stats-btn {
  padding: 6px 12px;
  background: #272727;
  border: none;
  borderRadius: 12px;
  color: white;
  fontSize: 11px;
  fontWeight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 0 0 auto;
}

  .item-gradient-first {
  background: linear-gradient(130deg, 
    rgba(255, 237, 220, 1) 0%, 
    rgba(204, 240, 255, 1) 53%, 
    rgba(251, 241, 236, 0.3) 60%,
    #ffffff 60%,
    #ffffff 100%
  );
  border-radius: 16px;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(253, 210, 196, 0.5);
  overflow: hidden;
}

.item-gradient-first:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.item-gradient-first .gradient-top {
  background: linear-gradient(135deg, 
    rgba(254, 235, 220, 0.4) 0%, 
    rgba(254, 200, 220, 0.4) 50%, 
    rgba(251, 241, 236, 0.4) 100%
  );
  padding: 32px 20px;
  text-align: center;
}.flashcard-flip-container {
  perspective: 1000px;
  min-height: 300px;
  cursor: pointer;
}

.flashcard-flip-inner {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 300px;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flashcard-flip-container.flipped .flashcard-flip-inner {
  transform: rotateY(180deg);
}

.flashcard-front, .flashcard-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.flashcard-back {
  transform: rotateY(180deg);
}
  .question-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-radius: 28px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(231, 231, 231, 1);
}
  .flashcard {
  flex: 1;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-height: 300px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(231, 231, 231, 1);
}
  background-size: 200% 200%;
  animation: gradient-shift-alt 10s ease infinite;
  border-radius: 16px;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(196, 210, 253, 0.5);
  overflow: hidden;
}

.item-gradient-flash-first {
  background: linear-gradient(200deg, 
    rgba(200, 255, 220, 1) 0%, 
    rgba(180, 230, 255, 1) 25%,
    rgba(200, 255, 220, 1) 50%,
    rgba(180, 230, 255, 1) 75%,
    rgba(236, 251, 241, 0.3) 100%
  );
  background-size: 200% 200%;
  animation: gradient-shift 9s ease infinite;
  border-radius: 16px;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(196, 253, 210, 0.5);
  overflow: hidden;
}

.item-gradient-flash-second {
  background: linear-gradient(160deg, 
    rgba(255, 230, 180, 1) 0%, 
    rgba(255, 200, 230, 1) 25%,
    rgba(255, 230, 180, 1) 50%,
    rgba(255, 200, 230, 1) 75%,
    rgba(251, 246, 236, 0.3) 100%
  );
  background-size: 200% 200%;
  animation: gradient-shift-alt 11s ease infinite;
  border-radius: 16px;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(253, 230, 196, 0.5);
  overflow: hidden;
}.stats-modal-container {
  background: white;
  border-radius: 24px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  margin: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.stats-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.stats-modal-header h2 {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  margin: 0;
}

.stat-card-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 6px;
}

.stat-card-gradient {
  position: absolute;
  inset: 0;
  opacity: 0.8;
}

.stat-card-content {
  position: relative;
  backdrop-filter: blur(10px);
  padding: 5px;
  height: 100%;
}

.stat-card-inner {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  padding: 20px;
  height: 100%;
  display: flex;
  border: 1px solid rgba(138, 138, 138, 0.3);
  flex-direction: column;
}

.stat-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}

.time-stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
    text-align:left
}

.time-stat:last-child {
  margin-bottom: 0;
}

.time-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #1f2937;
}

.time-percentage {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

@media (max-width: 768px) {
  .stats-modal-container {
    padding: 20px;
    max-width: 95vw;
  }

  .stat-card-inner {
    padding: 16px;
  }

  .stat-title {
    font-size: 12px;
    margin-bottom: 12px;
  }

  .time-label {
    font-size: 13px;
  }

  .time-percentage {
    font-size: 13px;
  }
}.stats-modal-container {
  background: white;
  border-radius: 20px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  margin: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.stat-card-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 6px;
}

.stat-card-gradient {
  position: absolute;
  inset: 0;
  opacity: 0.8;
  border-radius: 20px;
}

.stat-card-content {
  position: relative;
  backdrop-filter: blur(10px);
  padding: 5px;
  height: 100%;
  border-radius: 20px;
}
.tab:focus {
  outline: none;
}
.stat-card-inner {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  padding: 20px;
  height: 100%;
  display: flex;
  border: 1px solid rgba(138, 138, 138, 0.3);
  flex-direction: column;
}

.time-label svg {
  color: #6b7280;
  flex-shrink: 0;
}@keyframes spinPlus {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
  @keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes growBar {
  from {
    height: 0;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.option {
  transition: all 0.2s ease;
}

.option:hover:not(:disabled) {
  transform: translateX(4px);
}

.flashcard-flip-inner {
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-next {
  transition: all 0.3s ease;
}

  @keyframes bounce {
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
}
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(0.95); }
}
  @keyframes slideInfinity {
  0% { 
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(200%);
  }
  100% { 
    transform: translateX(-100%);
  }
}
  
      `}</style>

<div style={{ 
  minHeight: '100vh', 
  overflowY: 'auto', 
  overflowX: 'hidden', 
  background: 'linear-gradient(170deg, #ecececf1 0%, #fefefedc 60%, #e0e7fcb2 100%)', 
  padding: '16px', 
  paddingTop: '60px', 
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  position: 'relative', 
  width: '100%', 
  maxWidth: '100vw', 
  paddingBottom: '70px',
}}>

  {/* ✅ ADD THIS WRAPPER - constrains all content on desktop */}
  <div style={{ 
    width: '100%', 
    maxWidth: '900px', 
    margin: '0 auto' 
  }}>

{/* Header */}
<div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
  <div style={{ width: '100%', maxWidth: '680px', textAlign: 'center', padding: '16px 0 0' }}>

    {/* Subtitle */}
    <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '400', color: '#111827', letterSpacing: '-0.02em', lineHeight: '1.4' }}>
      Master any topic with a{' '}
      <span style={{ color: '#3b82f6' }}>personalized study guide</span>
    </h2>
  </div>
</div>

{/* Tabs */}
<div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
  <div style={{
    display: 'flex',
    gap: '2px',
    background: '#eaeaea',
    borderRadius: '24px',
    border: '1.5px solid #f5f5f5',
    padding: '4px',
    width: '100%',
    maxWidth: '360px',
  }}>
    {[
      { id: 'overview', label: 'Overview' },
      { id: 'quizzes', label: 'Quizzes' },
      { id: 'flashcards', label: 'Flashcards' },
      { id: 'help', label: 'Guide', icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
          <path fill="none" d="M0 0h24v24H0z"/>
          <path d="M4 11a1 1 0 0 1 .117 1.993L4 13H3a1 1 0 0 1-.117-1.993L3 11h1zM12 2a1 1 0 0 1 .993.883L13 3v1a1 1 0 0 1-1.993.117L11 4V3a1 1 0 0 1 1-1zM21 11a1 1 0 0 1 .117 1.993L21 13h-1a1 1 0 0 1-.117-1.993L20 11h1zM4.893 4.893a1 1 0 0 1 1.32-.083l.094.083.7.7a1 1 0 0 1-1.32 1.497l-.094-.083-.7-.7a1 1 0 0 1 0-1.414zM17.693 4.893a1 1 0 0 1 1.497 1.32l-.083.094-.7.7a1 1 0 0 1-1.497-1.32l.083-.094.7-.7zM14 18a1 1 0 0 1 1 1 3 3 0 0 1-6 0 1 1 0 0 1 .883-.993L10 18h4zM12 6a6 6 0 0 1 3.6 10.8 1 1 0 0 1-.471.192L15 17H9a1 1 0 0 1-.6-.2A6 6 0 0 1 12 6z"/>
        </svg>
      )},
    ].map(({ id, label, icon }) => (
      <button
        key={id}
        onClick={() => setActiveTab(id)}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: icon ? '4px' : undefined,
          padding: '7px 6px',
          borderRadius: '20px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'all 0.15s ease',
          background: activeTab === id ? 'white' : 'transparent',
          color: activeTab === id ? '#111' : '#6b7280',
          boxShadow: activeTab === id ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
          whiteSpace: 'nowrap',
        }}
      >
        {icon}
        {label}
      </button>
    ))}
  </div>
</div>

{activeTab === 'overview' && (
  <div>
    {/* Check if user has ANY custom content */}
{isLoadingContent ? (
  // ✅ SHOW SKELETON WHILE LOADING
  <>
    <SkeletonStyles />
    <QuizCardSkeleton />
    <FlashcardSkeleton />
  </>
) : (quizSets.filter(quiz => quiz.isCustom).length > 0 || flashcardSets.filter(set => set.isCustom).length > 0) ? (
     // RETURNING USER VIEW - Show create button + recent activity
      <div>


{/* Latest Cards Header */}
{/* Show 1 each on mobile, 2 each on desktop/iPad */}
{(() => {
  const recentQuizzes = quizSets
    .filter(quiz => quiz.isCustom)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 2);

  const recentFlashcards = flashcardSets
    .filter(set => set.isCustom)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 2);

  return (
    <div style={{ width: '100%', marginTop: '16px' }}>
      <style>{`
        .overview-cards-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
          width: 100%;
        }
        @media (min-width: 768px) {
          .overview-cards-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
        }
        @media (max-width: 767px) {
          .overview-hide-mobile { display: none !important; }
        }
      `}</style>

      {/* Quizzes */}
      {recentQuizzes.length > 0 && (
        <div style={{ marginBottom: '24px' }}>
<div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px', textAlign: 'left' }}>
            Recent Quizzes
          </div>
          <div className="overview-cards-grid">
            {recentQuizzes.map((quiz, index) => (
              <div key={quiz.id} className={index === 1 ? 'overview-hide-mobile' : ''}>
                <QuizPreview
                  quiz={quiz}
                  onStartQuiz={() => handleStartQuiz(quiz)}
                  isFirst={index === 0}
                  onDelete={() => {
                    setItemToDelete({ id: String(quiz.id), type: 'quiz', title: quiz.title });
                    setShowDeleteModal(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Flashcards */}
      {recentFlashcards.length > 0 && (
        <div>
<div style={{ fontSize: '11px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px', textAlign: 'left' }}>
            Recent Flashcards
          </div>
          <div className="overview-cards-grid">
            {recentFlashcards.map((flashcard, index) => (
              <div key={flashcard.id} className={index === 1 ? 'overview-hide-mobile' : ''}>
                <FlashcardPreview
                  set={flashcard}
                  onStartStudy={() => handleStartFlashcards(flashcard)}
                  onDelete={() => {
                    setItemToDelete({ id: String(flashcard.id), type: 'flashcard', title: flashcard.title });
                    setShowDeleteModal(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
})()}
      </div>
    ) : (
      // FIRST-TIME USER VIEW - Just welcome card, NO create button
      <div>
        <div style={{ 
          fontSize: '11px', 
          fontWeight: '600', 
          color: '#6b7280', 
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          Get Started
        </div>

        {/* Single Welcome Card - Opens Create Modal */}
        {!showCreateMenu ? (
          <div className="glass-container">
            <div className="item-card" onClick={() => setShowCreateMenu(true)}>
              <div 
                className="item-gradient"
                style={{
                  background: 'linear-gradient(250deg, rgba(211, 238, 255, 1) 0%, rgba(255, 206, 215, 1) 53%, rgba(236, 241, 251, 0.3) 60%, #e9f9ffff 60%, #eaf2ffff 100%)',
                  border: '1px solid rgba(196, 210, 253, 0.5)'
                }}
              >
                <div 
                  className="gradient-top"
                  style={{
                    background: 'linear-gradient(135deg, rgba(224, 242, 254, 0.4) 0%, rgba(254, 220, 240, 0.4) 50%, rgba(236, 241, 251, 0.4) 100%)'
                  }}
                >
                  <div className="item-count">Welcome!</div>
                  <div className='message-bubble'>
                    <div className="item-title">Create your first quiz or flashcard</div>
                  </div>
                </div>

                <div className="gradient-bottom">
                  <div className="item-meta">
                    <div className="meta-label">What you can do:</div>
                    <div className="meta-value">
Easily turn any topic into a quiz or flashcard
                    </div>
                  </div>

                  <button className="start-btn">Try Now</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // SHOW CREATE INPUT POPUP
          <div style={{
            background: 'white',
            borderRadius: '16px',
            border: '1px solid #e5e7eb',
            padding: '16px',
            animation: 'fadeIn 0.3s ease-out',
            marginBottom: '20px'
          }}>
            {!createType && !isGenerating && (
              <>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937', marginBottom: '8px', textAlign: 'left' }}>
                  What would you like to create?
                </div>
                
                <div style={{
                  width: '100%',
                  height: '1px',
                  background: '#e5e7eb',
                  marginBottom: '16px'
                }}></div>
                
                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                  <button
                    onClick={() => {
                      setCreateType('quiz');
                      setAnimatePlus(true);
                      setTimeout(() => setAnimatePlus(false), 400);
                    }}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: '#f8f8f8ff',
                      border: '1px solid #92929263',
                      borderRadius: '20px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#313131ff',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#d0e7ff'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#f8f8f8ff'}
                  >
                    Quiz
                  </button>
                  <button
                    onClick={() => {
                      setCreateType('flashcard');
                      setAnimatePlus(true);
                      setTimeout(() => setAnimatePlus(false), 400);
                    }}
                    style={{
                      flex: 1,
                      padding: '12px',
                      background: '#202020ff',
                      border: '1px solid #92929263',
                      borderRadius: '20px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#ffffffff',
                      transition: 'all 0.2s'
                    }}
            
                  >
                    Flashcards
                  </button>
                </div>
                <button
                  onClick={() => {
                    setShowCreateMenu(false);
                    setCreateType(null);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '11px',
                    color: '#6b7280'
                  }}
                >
                  Cancel
                </button>
              </>
            )}

            {createType && !isGenerating && (
              <>
                <div style={{ 
                  border: '1px solid #d1d5db',
                  borderRadius: '24px',
                  margin: '12px',
                  background: 'white',
                  animation: 'fadeIn 0.3s ease-out',
                  position: 'relative',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                  minHeight: '80px'
                }}>
                  <svg 
                    key={svgKey}
                    ref={svgRef} 
                    width="100%" 
                    height="150"
                    style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 5 }}
                  >
                    {/* Line 1: Difficulty → File (only if file uploaded) */}
                    {selectedDifficulty && uploadedFile && difficultyBadgeRef.current && uploadButtonRef.current && svgRef.current && (() => {
                      try {
                        const svgRect = svgRef.current.getBoundingClientRect();
                        const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                        const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                        
                        if (!svgRect.width || !diffRect.width || !uploadRect.width) return null;
                        
                        const startX = diffRect.right - svgRect.left;
                        const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                        const endX = uploadRect.left - svgRect.left;
                        const endY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                        
                        return (
                          <g key={`${createType || 'overview'}-diff-to-file`}>
                            <path
                              d={`M ${startX} ${startY} L ${endX} ${endY}`}
                              stroke="#9ca3af" 
                              strokeWidth="2"
                              fill="none"
                              strokeLinecap="round"
                            />
                            <circle cx={endX} cy={endY} r="3" fill="#9ca3af" />
                          </g>
                        );
                      } catch (error) {
                        return null;
                      }
                    })()}

                    {/* Line 2: File → Send (only if file uploaded) */}
                    {uploadedFile && uploadButtonRef.current && generateButtonRef.current && svgRef.current && (() => {
                      try {
                        const svgRect = svgRef.current.getBoundingClientRect();
                        const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                        const genRect = generateButtonRef.current.getBoundingClientRect();
                        
                        if (!svgRect.width || !uploadRect.width || !genRect.width) return null;
                        
                        const startX = uploadRect.right - svgRect.left;
                        const startY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                        const endX = genRect.left + genRect.width / 2 - svgRect.left;
                        const endY = genRect.bottom - svgRect.top;
                        
                        const controlX1 = startX + (endX - startX) * 0.3;
                        const controlY1 = startY;
                        const controlX2 = startX + (endX - startX) * 0.7;
                        const controlY2 = endY;
                        
                        return (
                          <g key={`${createType || 'overview'}-file-to-gen`}>
                            <path
                              d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                              stroke="#9ca3af" 
                              strokeWidth="2"
                              fill="none"
                              strokeLinecap="round"
                            />
                            <circle cx={endX} cy={endY} r="3" fill="#272727" />
                          </g>
                        );
                      } catch (error) {
                        return null;
                      }
                    })()}

                    {/* Line 3: Difficulty → Send (only if NO file) */}
                    {selectedDifficulty && !uploadedFile && difficultyBadgeRef.current && generateButtonRef.current && svgRef.current && (() => {
                      try {
                        const svgRect = svgRef.current.getBoundingClientRect();
                        const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                        const genRect = generateButtonRef.current.getBoundingClientRect();
                        
                        if (!svgRect.width || !diffRect.width || !genRect.width) return null;
                        
                        const startX = diffRect.right - svgRect.left;
                        const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                        const endX = genRect.left + genRect.width / 2 - svgRect.left;
                        const endY = genRect.bottom - svgRect.top;
                        
                        const controlX1 = startX + (endX - startX) * 0.4;
                        const controlY1 = startY;
                        const controlX2 = startX + (endX - startX) * 0.7;
                        const controlY2 = endY;
                        
                        return (
                          <g key={`${createType || 'overview'}-diff-to-gen`}>
                            <path
                              d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                              stroke="#9ca3af" 
                              strokeWidth="2"
                              fill="none"
                              strokeLinecap="round"
                            />
                            <circle cx={endX} cy={endY} r="3" fill="#272727" />
                          </g>
                        );
                      } catch (error) {
                        return null;
                      }
                    })()}
                  </svg>

                  <div style={{ padding: '12px 16px', position: 'relative' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      {/* Difficulty Button */}
                      <div style={{ position: 'relative' }}>
                        <button
                          ref={difficultyButtonRef}
                          onClick={() => {
                            setShowDifficultyDropdown(!showDifficultyDropdown);
                            setAnimatePlus(true);
                            setTimeout(() => setAnimatePlus(false), 400);
                          }}
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            background: 'white',
                            border: '1px solid #e5e7eb',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s',
                            flexShrink: 0,
                            position: 'relative'
                          }}
                        >
                          <svg 
                            aria-hidden="true" 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="20" 
                            height="20" 
                            fill="none" 
                            viewBox="0 0 24 24"
                            style={{
                              animation: animatePlus ? 'spinPlus 0.25s ease-in-out' : 'none'
                            }}
                          >
                            <path stroke="#383838ff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M5 12h14m-7 7V5"/>
                          </svg>
                        </button>

                        {/* Difficulty Dropdown */}
                        {showDifficultyDropdown && (
                          <div style={{
                            position: 'absolute',
                            bottom: '48px',
                            left: '0',
                            background: 'white',
                            borderRadius: '10px',
                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb',
                            padding: '6px',
                            minWidth: '160px',
                            zIndex: 100,
                            animation: 'fadeIn 0.2s ease-out'
                          }}>
                            {[
                              { 
                                id: 'easy', 
                                label: 'Easy',
                                icon: (
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#19b141c1">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                  </svg>
                                )
                              },
                              { 
                                id: 'medium', 
                                label: 'Medium',
                                icon: (
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="#ff8411c1" fillRule="evenodd" clipRule="evenodd"></path>
                                  </svg>
                                )
                              },
                              { 
                                id: 'hard', 
                                label: 'Hard',
                                icon: (
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ff1111c1">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                                  </svg>
                                )
                              },
                              { 
                                id: 'divider',
                                isDivider: true
                              },
                              { 
                                id: 'upload', 
                                label: 'Upload File',
                                icon: (
                       <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
  <path stroke="#70a0ffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"/>
</svg>

                                )
                              }
                            ].map((diff) => {
                              if (diff.isDivider) {
                                return (
                                  <div key="divider" style={{
                                    height: '1px',
                                    background: '#e5e7eb',
                                    margin: '4px 0'
                                  }} />
                                );
                              }
                              
                              const isSelected = selectedDifficulty === diff.id;
                              return (
                                <button
                                  key={diff.id}
                                  onClick={() => {
                                    if (diff.id === 'upload') {
                                      if (!selectedDifficulty) {
                                        alert('Please select a difficulty level first');
                                        return;
                                      }
                                      fileInputRef.current?.click();
                                    } else {
                                      setSelectedDifficulty(diff.id);
                                    }
                                    setShowDifficultyDropdown(false);
                                  }}
                                  style={{
                                    width: '100%',
                                    padding: '8px 10px',
                                    background: isSelected ? '#f3f4f6' : 'transparent',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    transition: 'all 0.2s',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    color: '#1f2937'
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                  onMouseLeave={(e) => e.currentTarget.style.background = isSelected ? '#f3f4f6' : 'transparent'}
                                >
                                  <div style={{
                                    width: '24px',
                                    height: '24px',
                                    background: isSelected ? 'white' : '#f9fafb',
                                    borderRadius: '5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: `1px solid ${isSelected ? '#d1d5db' : '#e5e7eb'}`,
                                    color: isSelected ? '#272727' : '#6b7280'
                                  }}>
                                    {diff.icon}
                                  </div>
                                  <span>{diff.label}</span>
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      {/* Input Field */}
                      <input
                        type="text"
                        value={createPromptText}
                        onChange={(e) => setCreatePromptText(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && generateCustomContent(createType)}
                        placeholder={`Create ${createType}...`}
                        style={{
                          flex: 1,
                          border: 'none',
                          outline: 'none',
                          fontSize: '14px',
                          color: '#1f2937',
                          background: 'transparent'
                        }}
                        autoFocus
                      />

                      {/* Generate Button */}
<button
  ref={generateButtonRef}
  onClick={() => generateCustomContent(createType)}
  disabled={!createPromptText.trim()}
  style={{
    width: '26px',
    height: '26px',
    minWidth: '26px',      
    minHeight: '26px',    
    flexShrink: 0,           // THIS - Prevents compression
    borderRadius: '50%',
    background: !createPromptText.trim() ? '#9ca3af' : '#272727',
    border: 'none',
    cursor: !createPromptText.trim() ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  }}
>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Difficulty & File Badges */}
<div style={{ 
                  padding: '0px 16px 12px', 
                  display: 'flex', 
                  justifyContent: 'flex-start', 
                  alignItems: 'center',
                  gap: '16px',
                  animation: 'fadeIn 0.3s ease-out'
                }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.txt,.doc,.docx"
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                  
                  {/* Difficulty Badge */}
                  <div 
                    ref={difficultyBadgeRef}
                    onClick={() => setShowDifficultyDropdown(true)}
                    style={{
                      background: 'white',
                      border: `1.5px solid ${selectedDifficulty ? '#e5e7eb' : '#fecaca'}`,
                      borderRadius: '22px',
                      padding: uploadedFile?.files && uploadedFile.files.length > 0 ? '8px' : '6px 14px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      cursor: 'pointer',
                      position: 'relative',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                    }}
                  >
                    {selectedDifficulty ? (
                      <>
                        <div style={{
                          width: '18px',
                          height: '18px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: selectedDifficulty === 'easy' ? '#10b981' : selectedDifficulty === 'medium' ? '#f59e0b' : '#ef4444',
                          flexShrink: 0
                        }}>
                          {selectedDifficulty === 'easy' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                          {selectedDifficulty === 'medium' && (
                            <svg width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                            </svg>
                          )}
                          {selectedDifficulty === 'hard' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                            </svg>
                          )}
                        </div>
                        
                        {(!uploadedFile?.files || uploadedFile.files.length === 0) && (
                          <span style={{ 
                            fontSize: '13px', 
                            fontWeight: '500', 
                            color: '#374151',
                            textTransform: 'capitalize'
                          }}>
                            {selectedDifficulty}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <div style={{
                          width: '14px',
                          height: '14px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ef4444'
                        }}>
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                          </svg>
                        </div>
                        <span style={{ 
                          fontSize: '13px', 
                          fontWeight: '500', 
                          color: '#ef4444'
                        }}>
                          Tap to choose difficulty
                        </span>
                      </>
                    )}
                  </div>

                  {/* File Badge */}
                  {uploadedFile?.files && uploadedFile.files.length > 0 && (
                    <div 
                      ref={uploadButtonRef}
                      style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center',
                        gap: '8px',
                        animation: 'fadeIn 0.3s ease-out',
                        position: 'relative'
                      }}
                    >
                      {['.pdf', '.docx', '.doc', '.txt'].map((fileType) => {
                        const filesOfType = uploadedFile.files.filter(f => f.type === fileType);
                        if (filesOfType.length === 0) return null;

                        const activeTypes = ['.pdf', '.docx', '.doc', '.txt'].filter(t => uploadedFile.files.some(f => f.type === t));
                        const hasMultipleTypes = activeTypes.length > 1;
                        const isFirstType = activeTypes[0] === fileType;

                        const getPdfIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                          </svg>
                        );
                        
                        const getDocxIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getDocIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getTxtIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );

                        const getIcon = () => {
                          if (fileType === '.pdf') return getPdfIcon();
                          if (fileType === '.docx') return getDocxIcon();
                          if (fileType === '.doc') return getDocIcon();
                          if (fileType === '.txt') return getTxtIcon();
                          return null;
                        };

                        const getTypeColor = () => {
                          if (fileType === '.pdf') return { bg: '#fee2e2', border: '#fecaca', text: '#ef4444' };
                          if (fileType === '.docx' || fileType === '.doc') return { bg: '#dbeafe', border: '#bfdbfe', text: '#3b82f6' };
                          if (fileType === '.txt') return { bg: '#f3f4f6', border: '#e5e7eb', text: '#6b7280' };
                          return { bg: '#f9fafb', border: '#e5e7eb', text: '#1f2937' };
                        };

                        const colors = getTypeColor();
                        const showText = !hasMultipleTypes && isFirstType;
                        const isPopupOpen = showDeletePopup === fileType;

                        return (
                          <div
                            key={fileType}
                            data-file-type={fileType}
                            onClick={() => setShowDeletePopup(isPopupOpen ? null : fileType)}
                            style={{
                              position: 'relative',
                              background: 'white',
                              border: `1.5px solid ${colors.border}`,
                              borderRadius: '20px',
                              padding: showText ? '6px 14px' : '8px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                              transition: 'all 0.2s'
                            }}
                          >
                            <div style={{
                              width: '16px',
                              height: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}>
                              {getIcon()}
                            </div>

                            {showText && (
                              <span style={{
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#374151',
                                whiteSpace: 'nowrap'
                              }}>
                                {fileType.toUpperCase().replace('.', '')}
                              </span>
                            )}

                            {filesOfType.length > 1 && (
                              <div style={{
                                minWidth: '20px',
                                height: '20px',
                                borderRadius: '10px',
                                background: colors.bg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '10px',
                                fontWeight: '600',
                                color: colors.text,
                                padding: '0 6px',
                                flexShrink: 0
                              }}>
                                {filesOfType.length}
                              </div>
                            )}
{isPopupOpen && (
  <div 
    onClick={(e) => e.stopPropagation()}
    style={{
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
      zIndex: 10000,
      animation: 'fadeSlideUp 0.2s ease-out',
      minWidth: '240px',
      overflow: 'hidden'
    }}
  >
                                <div style={{
                                  padding: '12px 14px',
                                  borderBottom: '1px solid #f3f4f6',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}>
                                  <span style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#1f2937'
                                  }}>
                                    {filesOfType.length} {fileType.toUpperCase().replace('.', '')} file{filesOfType.length > 1 ? 's' : ''}
                                  </span>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowDeletePopup(null);
                                    }}
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      cursor: 'pointer',
                                      padding: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '4px',
                                      transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                  >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                  </button>
                                </div>

                                <div style={{
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  padding: '8px'
                                }}>
                                  {filesOfType.map((fileObj, idx) => (
                                    <div
                                      key={fileObj.id}
                                      style={{
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        transition: 'all 0.2s',
                                        marginBottom: idx < filesOfType.length - 1 ? '4px' : '0'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                      <div style={{
                                        flex: 1,
                                        overflow: 'hidden',
                                        textAlign: 'left'
                                      }}>
                                        <div style={{
                                          fontSize: '12px',
                                          color: '#1f2937',
                                          fontWeight: '500',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }} title={fileObj.name}>
                                          {fileObj.name}
                                        </div>
                                      </div>

 <button
  onClick={(e) => {
    e.stopPropagation();
    removeFile(fileObj.id);
  }}
  style={{
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    background: 'transparent',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    flexShrink: 0
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = '#fef2f2';
    e.currentTarget.style.borderColor = '#fecaca';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = 'transparent';
    e.currentTarget.style.borderColor = '#e5e7eb';
  }}
>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
</button>
                                    </div>
                                  ))}
                                </div>

                                <div style={{
                                  position: 'absolute',
                                  top: '-6px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '6px solid transparent',
                                  borderRight: '6px solid transparent',
                                  borderBottom: '6px solid white',
                                  filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.05))'
                                }} />
                              </div>
                            )}
                          </div>
                        );
                      })}

                      <div style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#9ca3af',
                        whiteSpace: 'nowrap'
                      }}>
                        {uploadedFile.files.length}/6
                      </div>
                    </div>
                  )}
                </div>
                </div>
                
                <div style={{ padding: '0 12px', marginBottom: '12px' }}>
                  <button
                    onClick={handleCancelCreate}
                    style={{
                      width: '100%',
                      padding: '8px',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '11px',
                      color: '#6b7280'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
{isGenerating && (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 12px', display: 'block' }}>
      <g>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="1"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.875" transform="rotate(45 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.75" transform="rotate(90 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.625" transform="rotate(135 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.5" transform="rotate(180 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.375" transform="rotate(225 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.25" transform="rotate(270 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.125" transform="rotate(315 12 12)"/>
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
      </g>
    </svg>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937' }}>
      Generating your {createType}...
    </div>
  </div>
)}
          </div>
        )}
      </div>
    )}
  </div>
)}
{showStatsModal && (
  <EnhancedStatsModal 
    onClose={() => setShowStatsModal(null)} 
    type={showStatsModal}
    studyStats={studyStats}
    dontAskAgain={askedAboutShuffle}
    defaultShufflePreference={shufflePreference}
    onShuffleChange={(newValue) => {
      setShufflePreference(newValue);
      localStorage.setItem('studyhub_shuffle_preference', newValue);
    }}
    onResetShuffle={() => {
      setAskedAboutShuffle(false);
      setShufflePreference(false);
      localStorage.removeItem('studyhub_dont_ask_shuffle');
      localStorage.removeItem('studyhub_shuffle_preference');
    }}
    isQuizActive={!!activeQuiz}  // ✅ ADD THIS
    isFlashcardActive={!!activeFlashcards}  // ✅ ADD THIS
    onReshuffle={() => {
      // ✅ ADD THIS CALLBACK
      if (activeQuiz) {
        const reshuffledQuestions = shuffleArray([...activeQuiz.questions]);
        setActiveQuiz({
          ...activeQuiz,
          questions: reshuffledQuestions
        });
        console.log('✅ Quiz reshuffled');
      }
      
      if (activeFlashcards) {
        const reshuffledCards = shuffleArray([...activeFlashcards.flashcards]);
        setActiveFlashcards({
          ...activeFlashcards,
          flashcards: reshuffledCards
        });
        console.log('✅ Flashcards reshuffled');
      }
    }}
  />
)}

{activeTab === 'quizzes' && (
  <div>
    {/* Create Quiz Button - Goes straight to input */}
    <div style={{ marginBottom: '20px' }}>
{!showCreateMenu ? (
  <button
    onClick={() => {
      setShowCreateMenu(true);
      setCreateType('quiz');
      setAnimatePlus(true);
      setTimeout(() => setAnimatePlus(false), 400);
    }}

          style={{
            width: '100%',
            padding: '12px',
            background: '#fafafaff',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            border: '1px solid #121b2e33',
            color: '#2a2b2eff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
          </svg>
          Create Quiz
        </button>
      ) : (
        <div style={{
          background: 'white',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '16px',
          animation: 'fadeIn 0.3s ease-out'
        }}>
          {!isGenerating && (
            <>
              <div style={{ 
                border: '1px solid #d1d5db',
                borderRadius: '24px',
                margin: '12px',
                background: 'white',
                animation: 'fadeIn 0.3s ease-out',
                position: 'relative',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                minHeight: '80px'
              }}>
                <svg 
                  key={svgKey}
                  ref={svgRef} 
                  width="100%" 
                  height="150"
                  style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 5 }}
                >
                  {selectedDifficulty && uploadedFile && difficultyBadgeRef.current && uploadButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                      const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !diffRect.width || !uploadRect.width) return null;
                      
                      const startX = diffRect.right - svgRect.left;
                      const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                      const endX = uploadRect.left - svgRect.left;
                      const endY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                      
                      return (
                        <g key={`${createType || 'overview'}-diff-to-file`}>
                          <path
                            d={`M ${startX} ${startY} L ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#9ca3af" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}

                  {uploadedFile && uploadButtonRef.current && generateButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                      const genRect = generateButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !uploadRect.width || !genRect.width) return null;
                      
                      const startX = uploadRect.right - svgRect.left;
                      const startY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                      const endX = genRect.left + genRect.width / 2 - svgRect.left;
                      const endY = genRect.bottom - svgRect.top;
                      
                      const controlX1 = startX + (endX - startX) * 0.3;
                      const controlY1 = startY;
                      const controlX2 = startX + (endX - startX) * 0.7;
                      const controlY2 = endY;
                      
                      return (
                        <g key={`${createType || 'overview'}-file-to-gen`}>
                          <path
                            d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#272727" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}

                  {selectedDifficulty && !uploadedFile && difficultyBadgeRef.current && generateButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                      const genRect = generateButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !diffRect.width || !genRect.width) return null;
                      
                      const startX = diffRect.right - svgRect.left;
                      const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                      const endX = genRect.left + genRect.width / 2 - svgRect.left;
                      const endY = genRect.bottom - svgRect.top;
                      
                      const controlX1 = startX + (endX - startX) * 0.4;
                      const controlY1 = startY;
                      const controlX2 = startX + (endX - startX) * 0.7;
                      const controlY2 = endY;
                      
                      return (
                        <g key={`${createType || 'overview'}-diff-to-gen`}>
                          <path
                            d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#272727" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}
                </svg>

                <div style={{ padding: '12px 16px', position: 'relative' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ position: 'relative' }}>
                      <button
                        ref={difficultyButtonRef}
                        onClick={() => {
                          setShowDifficultyDropdown(!showDifficultyDropdown);
                          setAnimatePlus(true);
                          setTimeout(() => setAnimatePlus(false), 400);
                        }}
                        style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '50%',
                          background: 'white',
                          border: '1px solid #e5e7eb',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s',
                          flexShrink: 0,
                          position: 'relative'
                        }}
                      >
                        <svg 
                          aria-hidden="true" 
                          xmlns="http://www.w3.org/2000/svg" 
                          width="20" 
                          height="20" 
                          fill="none" 
                          viewBox="0 0 24 24"
                          style={{
                            animation: animatePlus ? 'spinPlus 0.25s ease-in-out' : 'none'
                          }}
                        >
                          <path stroke="#383838ff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M5 12h14m-7 7V5"/>
                        </svg>
                      </button>

                      {showDifficultyDropdown && (
                        <div style={{
                          position: 'absolute',
                          bottom: '48px',
                          left: '0',
                          background: 'white',
                          borderRadius: '10px',
                          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                          border: '1px solid #e5e7eb',
                          padding: '6px',
                          minWidth: '160px',
                          zIndex: 100,
                          animation: 'fadeIn 0.2s ease-out'
                        }}>
                          {[
                            { 
                              id: 'easy', 
                              label: 'Easy',
                              icon: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#19b141c1">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                              )
                            },
                            { 
                              id: 'medium', 
                              label: 'Medium',
                              icon: (
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="#ff8411c1" fillRule="evenodd" clipRule="evenodd"></path>
                                </svg>
                              )
                            },
                            { 
                              id: 'hard', 
                              label: 'Hard',
                              icon: (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ff1111c1">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                                </svg>
                              )
                            },
                            { 
                              id: 'divider',
                              isDivider: true
                            },
                            { 
                              id: 'upload', 
                              label: 'Upload File',
                              icon: (
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
  <path stroke="#70a0ffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"/>
</svg>

                              )
                            }
                          ].map((diff) => {
                            if (diff.isDivider) {
                              return (
                                <div key="divider" style={{
                                  height: '1px',
                                  background: '#e5e7eb',
                                  margin: '4px 0'
                                }} />
                              );
                            }
                            
                            const isSelected = selectedDifficulty === diff.id;
                            return (
                              <button
                                key={diff.id}
                                onClick={() => {
                                  if (diff.id === 'upload') {
                                    if (!selectedDifficulty) {
                                      alert('Please select a difficulty level first');
                                      return;
                                    }
                                    fileInputRef.current?.click();
                                  } else {
                                    setSelectedDifficulty(diff.id);
                                  }
                                  setShowDifficultyDropdown(false);
                                }}
                                style={{
                                  width: '100%',
                                  padding: '8px 10px',
                                  background: isSelected ? '#f3f4f6' : 'transparent',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  transition: 'all 0.2s',
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  color: '#1f2937'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                onMouseLeave={(e) => e.currentTarget.style.background = isSelected ? '#f3f4f6' : 'transparent'}
                              >
                                <div style={{
                                  width: '24px',
                                  height: '24px',
                                  background: isSelected ? 'white' : '#f9fafb',
                                  borderRadius: '5px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: `1px solid ${isSelected ? '#d1d5db' : '#e5e7eb'}`,
                                  color: isSelected ? '#272727' : '#6b7280'
                                }}>
                                  {diff.icon}
                                </div>
                                <span>{diff.label}</span>
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    <input
                      type="text"
                      value={createPromptText}
                      onChange={(e) => setCreatePromptText(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && generateCustomContent(createType)}
                      placeholder="Create quiz..."
                      style={{
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        fontSize: '14px',
                        color: '#1f2937',
                        background: 'transparent',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
                      }}
                      autoFocus
                    />

                    <button
                      ref={generateButtonRef}
                      onClick={() => generateCustomContent(createType)}
                      disabled={!createPromptText.trim()}
                      style={{
                        width: '26px',
                        height: '26px',
                        borderRadius: '50%',
                        background: !createPromptText.trim() ? '#9ca3af' : '#272727',
                        border: 'none',
                        cursor: !createPromptText.trim() ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        flexShrink: 0,
                        position: 'relative',
                        color: 'white'
                      }}
                    >
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                      </svg>
                    </button>
                  </div>
                </div>
<div style={{ 
                  padding: '0px 16px 12px', 
                  display: 'flex', 
                  justifyContent: 'flex-start', 
                  alignItems: 'center',
                  gap: '16px',
                  animation: 'fadeIn 0.3s ease-out'
                }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.txt,.doc,.docx"
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                  
                  {/* Difficulty Badge */}
                  <div 
                    ref={difficultyBadgeRef}
                    onClick={() => setShowDifficultyDropdown(true)}
                    style={{
                      background: 'white',
                      border: `1.5px solid ${selectedDifficulty ? '#e5e7eb' : '#fecaca'}`,
                      borderRadius: '22px',
                      padding: uploadedFile?.files && uploadedFile.files.length > 0 ? '8px' : '6px 14px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      cursor: 'pointer',
                      position: 'relative',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                    }}
                  >
                    {selectedDifficulty ? (
                      <>
                        <div style={{
                          width: '18px',
                          height: '18px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: selectedDifficulty === 'easy' ? '#10b981' : selectedDifficulty === 'medium' ? '#f59e0b' : '#ef4444',
                          flexShrink: 0
                        }}>
                          {selectedDifficulty === 'easy' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                          {selectedDifficulty === 'medium' && (
                            <svg width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                            </svg>
                          )}
                          {selectedDifficulty === 'hard' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                            </svg>
                          )}
                        </div>
                        
                        {(!uploadedFile?.files || uploadedFile.files.length === 0) && (
                          <span style={{ 
                            fontSize: '13px', 
                            fontWeight: '500', 
                            color: '#374151',
                            textTransform: 'capitalize'
                          }}>
                            {selectedDifficulty}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <div style={{
                          width: '14px',
                          height: '14px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ef4444'
                        }}>
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                          </svg>
                        </div>
                        <span style={{ 
                          fontSize: '13px', 
                          fontWeight: '500', 
                          color: '#ef4444'
                        }}>
                          Tap to choose difficulty
                        </span>
                      </>
                    )}
                  </div>

{/* File Badge */}
                  {uploadedFile?.files && uploadedFile.files.length > 0 && (
                    <div 
                      ref={uploadButtonRef}
                      style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center',
                        gap: '8px',
                        animation: 'fadeIn 0.3s ease-out',
                        position: 'relative'
                      }}
                    >
                      {['.pdf', '.docx', '.doc', '.txt'].map((fileType) => {
                        const filesOfType = uploadedFile.files.filter(f => f.type === fileType);
                        if (filesOfType.length === 0) return null;

                        const activeTypes = ['.pdf', '.docx', '.doc', '.txt'].filter(t => uploadedFile.files.some(f => f.type === t));
                        const hasMultipleTypes = activeTypes.length > 1;
                        const isFirstType = activeTypes[0] === fileType;

                        const getPdfIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                          </svg>
                        );
                        
                        const getDocxIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getDocIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getTxtIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );

                        const getIcon = () => {
                          if (fileType === '.pdf') return getPdfIcon();
                          if (fileType === '.docx') return getDocxIcon();
                          if (fileType === '.doc') return getDocIcon();
                          if (fileType === '.txt') return getTxtIcon();
                          return null;
                        };

                        const getTypeColor = () => {
                          if (fileType === '.pdf') return { bg: '#fee2e2', border: '#fecaca', text: '#ef4444' };
                          if (fileType === '.docx' || fileType === '.doc') return { bg: '#dbeafe', border: '#bfdbfe', text: '#3b82f6' };
                          if (fileType === '.txt') return { bg: '#f3f4f6', border: '#e5e7eb', text: '#6b7280' };
                          return { bg: '#f9fafb', border: '#e5e7eb', text: '#1f2937' };
                        };

                        const colors = getTypeColor();
                        const showText = !hasMultipleTypes && isFirstType;
                        const isPopupOpen = showDeletePopup === fileType;

                        return (
                          <div
                            key={fileType}
                            data-file-type={fileType}
                            onClick={() => setShowDeletePopup(isPopupOpen ? null : fileType)}
                            style={{
                              position: 'relative',
                              background: 'white',
                              border: `1.5px solid ${colors.border}`,
                              borderRadius: '20px',
                              padding: showText ? '6px 14px' : '8px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                              transition: 'all 0.2s'
                            }}
                          >
                            <div style={{
                              width: '16px',
                              height: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}>
                              {getIcon()}
                            </div>

                            {showText && (
                              <span style={{
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#374151',
                                whiteSpace: 'nowrap'
                              }}>
                                {fileType.toUpperCase().replace('.', '')}
                              </span>
                            )}

                            {filesOfType.length > 1 && (
                              <div style={{
                                minWidth: '20px',
                                height: '20px',
                                borderRadius: '10px',
                                background: colors.bg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '10px',
                                fontWeight: '600',
                                color: colors.text,
                                padding: '0 6px',
                                flexShrink: 0
                              }}>
                                {filesOfType.length}
                              </div>
                            )}

{isPopupOpen && (
  <div 
    onClick={(e) => e.stopPropagation()}
    style={{
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
      zIndex: 10000,
      animation: 'fadeSlideUp 0.2s ease-out',
      minWidth: '240px',
      overflow: 'hidden'
    }}
  >
                                <div style={{
                                  padding: '12px 14px',
                                  borderBottom: '1px solid #f3f4f6',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}>
                                  <span style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#1f2937'
                                  }}>
                                    {filesOfType.length} {fileType.toUpperCase().replace('.', '')} file{filesOfType.length > 1 ? 's' : ''}
                                  </span>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowDeletePopup(null);
                                    }}
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      cursor: 'pointer',
                                      padding: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '4px',
                                      transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                  >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                  </button>
                                </div>

                                <div style={{
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  padding: '8px'
                                }}>
                                  {filesOfType.map((fileObj, idx) => (
                                    <div
                                      key={fileObj.id}
                                      style={{
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        transition: 'all 0.2s',
                                        marginBottom: idx < filesOfType.length - 1 ? '4px' : '0'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                      <div style={{
                                        flex: 1,
                                        overflow: 'hidden',
                                        textAlign: 'left'
                                      }}>
                                        <div style={{
                                          fontSize: '12px',
                                          color: '#1f2937',
                                          fontWeight: '500',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }} title={fileObj.name}>
                                          {fileObj.name}
                                        </div>
                                      </div>

<button
  onClick={(e) => {
    e.stopPropagation();
    removeFile(fileObj.id);
  }}
  style={{
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    background: 'transparent',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    flexShrink: 0
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = '#fef2f2';
    e.currentTarget.style.borderColor = '#fecaca';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = 'transparent';
    e.currentTarget.style.borderColor = '#e5e7eb';
  }}
>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
</button>
                                    </div>
                                  ))}
                                </div>

                                <div style={{
                                  position: 'absolute',
                                  top: '-6px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '6px solid transparent',
                                  borderRight: '6px solid transparent',
                                  borderBottom: '6px solid white',
                                  filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.05))'
                                }} />
                              </div>
                            )}
                          </div>
                        );
                      })}

                      <div style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#9ca3af',
                        whiteSpace: 'nowrap'
                      }}>
                        {uploadedFile.files.length}/6
                      </div>
                    </div>
                  )}
                </div>
          </div>
          
          <div style={{ padding: '0 12px', marginBottom: '12px' }}>
            <button
              onClick={handleCancelCreate}
              style={{
                width: '100%',
                padding: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '11px',
                color: '#6b7280'
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}


{isGenerating && (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 12px', display: 'block' }}>
      <g>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="1"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.875" transform="rotate(45 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.75" transform="rotate(90 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.625" transform="rotate(135 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.5" transform="rotate(180 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.375" transform="rotate(225 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.25" transform="rotate(270 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.125" transform="rotate(315 12 12)"/>
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
      </g>
    </svg>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937' }}>
      Generating your {createType}...
    </div>
  </div>
)}
    </div>
  )}
</div>

{/* CHECK IF QUIZZES EXIST */}
{isQuizzesLoading ? (
  // ✅ SHOW SKELETON WHILE LOADING
  <>
    <SkeletonStyles />
    <div style={{ 
      fontSize: '11px', 
      fontWeight: '600', 
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginBottom: '16px'
    }}>
      All Quizzes
    </div>
    <QuizCardSkeleton />
    <QuizCardSkeleton />
  </>
) : quizSets.filter(quiz => quiz.title !== 'Daily Challenge' && quiz.title !== 'Quick Review').length > 0 ? (
  <>
    {/* Header with Stats */}
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      marginBottom: '16px' 
    }}>
      <div style={{ 
        fontSize: '11px', 
        fontWeight: '600', 
        color: '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        All Quizzes
      </div>
      
      <button 
        onClick={() => setShowStatsModal('quiz')} 
        style={{
          padding: '6px 12px',
          background: '#272727',
          border: 'none',
          borderRadius: '12px',
          color: 'white',
          fontSize: '11px',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#3f3f3f';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#272727';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        View Stats
      </button>
    </div>

{/* Quiz Cards */}
<div style={{
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '16px',
  width: '100%'
}}>
{/* Quiz Cards */}
<>
  <style>{`
    .quiz-cards-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;
      width: 100%;
    }
    @media (min-width: 768px) {
      .quiz-cards-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }
    }
  `}</style>
  
  <div className="quiz-cards-grid">
    {quizSets
      .filter(quiz => quiz.title !== 'Daily Challenge' && quiz.title !== 'Quick Review')
      .map((quiz, index) => (
        <QuizPreview 
          key={quiz.id} 
          quiz={quiz} 
          onStartQuiz={() => handleStartQuiz(quiz)}
          isFirst={index === 0}
          onDelete={(id) => {
            setItemToDelete({ id: id, type: 'quiz', title: quiz.title });
            setShowDeleteModal(true);
          }}
        />
      ))}
  </div>
</>
</div>
  </>
) : (
  // EMPTY STATE
  <div style={{
    background: 'white',
    borderRadius: '20px',
    padding: '48px 24px',
    textAlign: 'center',
    border: '1px solid #e5e7eb'
  }}>
    <div style={{
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #f1f9ff 0%, #e0f2fe 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px'
    }}>
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
        <path d="M9 11l3 3L22 4"></path>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
      </svg>
    </div>
    
    <h3 style={{
      fontSize: '16px',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '8px'
    }}>
      No Quizzes Yet
    </h3>
    
    <p style={{
      fontSize: '13px',
      color: '#6b7280',
      lineHeight: '1.6',
      maxWidth: '320px',
      margin: '0 auto'
    }}>
      Create your first quiz to test your knowledge on any topic. You can generate questions from text or upload a document.
    </p>
  </div>
)}</div>
)}
{activeTab === 'flashcards' && (
  <div>
    {/* Create Flashcards Button - Goes straight to input */}
    <div style={{ marginBottom: '20px' }}>
{!showCreateMenu ? (
  <button
    onClick={() => {
      setShowCreateMenu(true);
      setCreateType('flashcard');
      setAnimatePlus(true);
      setTimeout(() => setAnimatePlus(false), 400);
    }}

          style={{
            width: '100%',
            padding: '12px',
            background: '#fafafaff',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            border: '1px solid #121b2e33',
            color: '#2a2b2eff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
          </svg>
          Create Flashcards
        </button>
      ) : (
        <div style={{
          background: 'white',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '16px',
          animation: 'fadeIn 0.3s ease-out'
        }}>
          {!isGenerating && (
            <>
              <div style={{ 
                border: '1px solid #d1d5db',
                borderRadius: '24px',
                margin: '12px',
                background: 'white',
                animation: 'fadeIn 0.3s ease-out',
                position: 'relative',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                minHeight: '80px'
              }}>
                <svg 
                  key={svgKey}
                  ref={svgRef} 
                  width="100%" 
                  height="150"
                  style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 5 }}
                >
                  {selectedDifficulty && uploadedFile && difficultyBadgeRef.current && uploadButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                      const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !diffRect.width || !uploadRect.width) return null;
                      
                      const startX = diffRect.right - svgRect.left;
                      const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                      const endX = uploadRect.left - svgRect.left;
                      const endY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                      
                      return (
                        <g key={`${createType || 'overview'}-diff-to-file`}>
                          <path
                            d={`M ${startX} ${startY} L ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#9ca3af" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}

                  {uploadedFile && uploadButtonRef.current && generateButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const uploadRect = uploadButtonRef.current.getBoundingClientRect();
                      const genRect = generateButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !uploadRect.width || !genRect.width) return null;
                      
                      const startX = uploadRect.right - svgRect.left;
                      const startY = uploadRect.top + uploadRect.height / 2 - svgRect.top;
                      const endX = genRect.left + genRect.width / 2 - svgRect.left;
                      const endY = genRect.bottom - svgRect.top;
                      
                      const controlX1 = startX + (endX - startX) * 0.3;
                      const controlY1 = startY;
                      const controlX2 = startX + (endX - startX) * 0.7;
                      const controlY2 = endY;
                      
                      return (
                        <g key={`${createType || 'overview'}-file-to-gen`}>
                          <path
                            d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#272727" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}

                  {selectedDifficulty && !uploadedFile && difficultyBadgeRef.current && generateButtonRef.current && svgRef.current && (() => {
                    try {
                      const svgRect = svgRef.current.getBoundingClientRect();
                      const diffRect = difficultyBadgeRef.current.getBoundingClientRect();
                      const genRect = generateButtonRef.current.getBoundingClientRect();
                      
                      if (!svgRect.width || !diffRect.width || !genRect.width) return null;
                      
                      const startX = diffRect.right - svgRect.left;
                      const startY = diffRect.top + diffRect.height / 2 - svgRect.top;
                      const endX = genRect.left + genRect.width / 2 - svgRect.left;
                      const endY = genRect.bottom - svgRect.top;
                      
                      const controlX1 = startX + (endX - startX) * 0.4;
                      const controlY1 = startY;
                      const controlX2 = startX + (endX - startX) * 0.7;
                      const controlY2 = endY;
                      
                      return (
                        <g key={`${createType || 'overview'}-diff-to-gen`}>
                          <path
                            d={`M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`}
                            stroke="#9ca3af" 
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                          />
                          <circle cx={endX} cy={endY} r="3" fill="#272727" />
                        </g>
                      );
                    } catch (error) {
                      return null;
                    }
                  })()}
                </svg>

                <div style={{ padding: '12px 16px', position: 'relative' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ position: 'relative' }}>
                      <button
                        ref={difficultyButtonRef}
                        onClick={() => {
                          setShowDifficultyDropdown(!showDifficultyDropdown);
                          setAnimatePlus(true);
                          setTimeout(() => setAnimatePlus(false), 400);
                        }}
                        style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '50%',
                          background: 'white',
                          border: '1px solid #e5e7eb',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s',
                          flexShrink: 0,
                          position: 'relative'
                        }}
                      >
                        <svg 
                          aria-hidden="true" 
                          xmlns="http://www.w3.org/2000/svg" 
                          width="20" 
                          height="20" 
                          fill="none" 
                          viewBox="0 0 24 24"
                          style={{
                            animation: animatePlus ? 'spinPlus 0.25s ease-in-out' : 'none'
                          }}
                        >
                          <path stroke="#383838ff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M5 12h14m-7 7V5"/>
                        </svg>
                      </button>

                      {showDifficultyDropdown && (
                        <div style={{
                          position: 'absolute',
                          bottom: '48px',
                          left: '0',
                          background: 'white',
                          borderRadius: '10px',
                          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                          border: '1px solid #e5e7eb',
                          padding: '6px',
                          minWidth: '160px',
                          zIndex: 100,
                          animation: 'fadeIn 0.2s ease-out'
                        }}>
                          {[
                            { 
                              id: 'easy', 
                              label: 'Easy',
                              icon: (
                               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#19b141c1">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                              )
                            },
                            { 
                              id: 'medium', 
                              label: 'Medium',
                              icon: (
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="#ff8411c1" fillRule="evenodd" clipRule="evenodd"></path>
                                </svg>
                              )
                            },
                            { 
                              id: 'hard', 
                              label: 'Hard',
                              icon: (
     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ff1111c1">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                                </svg>
                              )
                            },
                            { 
                              id: 'divider',
                              isDivider: true
                            },
                            { 
                              id: 'upload', 
                              label: 'Upload File',
                              icon: (
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
  <path stroke="#70a0ffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"/>
</svg>

                              )
                            }
                          ].map((diff) => {
                            if (diff.isDivider) {
                              return (
                                <div key="divider" style={{
                                  height: '1px',
                                  background: '#e5e7eb',
                                  margin: '4px 0'
                                }} />
                              );
                            }
                            
                            const isSelected = selectedDifficulty === diff.id;
                            return (
                              <button
                                key={diff.id}
                                onClick={() => {
                                  if (diff.id === 'upload') {
                                    if (!selectedDifficulty) {
                                      alert('Please select a difficulty level first');
                                      return;
                                    }
                                    fileInputRef.current?.click();
                                  } else {
                                    setSelectedDifficulty(diff.id);
                                  }
                                  setShowDifficultyDropdown(false);
                                }}
                                style={{
                                  width: '100%',
                                  padding: '8px 10px',
                                  background: isSelected ? '#f3f4f6' : 'transparent',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  transition: 'all 0.2s',
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  color: '#1f2937'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                onMouseLeave={(e) => e.currentTarget.style.background = isSelected ? '#f3f4f6' : 'transparent'}
                              >
                                <div style={{
                                  width: '24px',
                                  height: '24px',
                                  background: isSelected ? 'white' : '#f9fafb',
                                  borderRadius: '5px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: `1px solid ${isSelected ? '#d1d5db' : '#e5e7eb'}`,
                                  color: isSelected ? '#272727' : '#6b7280'
                                }}>
                                  {diff.icon}
                                </div>
                                <span>{diff.label}</span>
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    <input
                      type="text"
                      value={createPromptText}
                      onChange={(e) => setCreatePromptText(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && generateCustomContent(createType)}
                      placeholder="Create flashcard..."
                      style={{
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        fontSize: '14px',
                        color: '#1f2937',
                        background: 'transparent',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
                      }}
                      autoFocus
                    />

                    <button
                      ref={generateButtonRef}
                      onClick={() => generateCustomContent(createType)}
                      disabled={!createPromptText.trim()}
                      style={{
                        width: '26px',
                        height: '26px',
                        borderRadius: '50%',
                        background: !createPromptText.trim() ? '#9ca3af' : '#272727',
                        border: 'none',
                        cursor: !createPromptText.trim() ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s',
                        flexShrink: 0,
                        position: 'relative',
                        color: 'white'
                      }}
                    >
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                      </svg>
                    </button>
                  </div>
                </div>

<div style={{ 
                  padding: '0px 16px 12px', 
                  display: 'flex', 
                  justifyContent: 'flex-start', 
                  alignItems: 'center',
                  gap: '16px',
                  animation: 'fadeIn 0.3s ease-out'
                }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.txt,.doc,.docx"
                    multiple
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                  
                  {/* Difficulty Badge */}
                  <div 
                    ref={difficultyBadgeRef}
                    onClick={() => setShowDifficultyDropdown(true)}
                    style={{
                      background: 'white',
                      border: `1.5px solid ${selectedDifficulty ? '#e5e7eb' : '#fecaca'}`,
                      borderRadius: '22px',
                      padding: uploadedFile?.files && uploadedFile.files.length > 0 ? '8px' : '6px 14px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      cursor: 'pointer',
                      position: 'relative',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                    }}
                  >
                    {selectedDifficulty ? (
                      <>
                        <div style={{
                          width: '18px',
                          height: '18px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: selectedDifficulty === 'easy' ? '#10b981' : selectedDifficulty === 'medium' ? '#f59e0b' : '#ef4444',
                          flexShrink: 0
                        }}>
                          {selectedDifficulty === 'easy' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                          {selectedDifficulty === 'medium' && (
                            <svg width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                            </svg>
                          )}
                          {selectedDifficulty === 'hard' && (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                            </svg>
                          )}
                        </div>
                        
                        {(!uploadedFile?.files || uploadedFile.files.length === 0) && (
                          <span style={{ 
                            fontSize: '13px', 
                            fontWeight: '500', 
                            color: '#374151',
                            textTransform: 'capitalize'
                          }}>
                            {selectedDifficulty}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <div style={{
                          width: '14px',
                          height: '14px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ef4444'
                        }}>
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
                          </svg>
                        </div>
                        <span style={{ 
                          fontSize: '13px', 
                          fontWeight: '500', 
                          color: '#ef4444'
                        }}>
                          Tap to choose difficulty
                        </span>
                      </>
                    )}
                  </div>

 {/* File Badge */}
                  {uploadedFile?.files && uploadedFile.files.length > 0 && (
                    <div 
                      ref={uploadButtonRef}
                      style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center',
                        gap: '8px',
                        animation: 'fadeIn 0.3s ease-out',
                        position: 'relative'
                      }}
                    >
                      {['.pdf', '.docx', '.doc', '.txt'].map((fileType) => {
                        const filesOfType = uploadedFile.files.filter(f => f.type === fileType);
                        if (filesOfType.length === 0) return null;

                        const activeTypes = ['.pdf', '.docx', '.doc', '.txt'].filter(t => uploadedFile.files.some(f => f.type === t));
                        const hasMultipleTypes = activeTypes.length > 1;
                        const isFirstType = activeTypes[0] === fileType;

                        const getPdfIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                          </svg>
                        );
                        
                        const getDocxIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getDocIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );
                        
                        const getTxtIcon = () => (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                            <line x1="9" y1="13" x2="15" y2="13"/>
                            <line x1="9" y1="17" x2="15" y2="17"/>
                          </svg>
                        );

                        const getIcon = () => {
                          if (fileType === '.pdf') return getPdfIcon();
                          if (fileType === '.docx') return getDocxIcon();
                          if (fileType === '.doc') return getDocIcon();
                          if (fileType === '.txt') return getTxtIcon();
                          return null;
                        };

                        const getTypeColor = () => {
                          if (fileType === '.pdf') return { bg: '#fee2e2', border: '#fecaca', text: '#ef4444' };
                          if (fileType === '.docx' || fileType === '.doc') return { bg: '#dbeafe', border: '#bfdbfe', text: '#3b82f6' };
                          if (fileType === '.txt') return { bg: '#f3f4f6', border: '#e5e7eb', text: '#6b7280' };
                          return { bg: '#f9fafb', border: '#e5e7eb', text: '#1f2937' };
                        };

                        const colors = getTypeColor();
                        const showText = !hasMultipleTypes && isFirstType;
                        const isPopupOpen = showDeletePopup === fileType;

                        return (
                          <div
                            key={fileType}
                            data-file-type={fileType}
                            onClick={() => setShowDeletePopup(isPopupOpen ? null : fileType)}
                            style={{
                              position: 'relative',
                              background: 'white',
                              border: `1.5px solid ${colors.border}`,
                              borderRadius: '20px',
                              padding: showText ? '6px 14px' : '8px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              cursor: 'pointer',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                              transition: 'all 0.2s'
                            }}
                          >
                            <div style={{
                              width: '16px',
                              height: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}>
                              {getIcon()}
                            </div>

                            {showText && (
                              <span style={{
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#374151',
                                whiteSpace: 'nowrap'
                              }}>
                                {fileType.toUpperCase().replace('.', '')}
                              </span>
                            )}

                            {filesOfType.length > 1 && (
                              <div style={{
                                minWidth: '20px',
                                height: '20px',
                                borderRadius: '10px',
                                background: colors.bg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '10px',
                                fontWeight: '600',
                                color: colors.text,
                                padding: '0 6px',
                                flexShrink: 0
                              }}>
                                {filesOfType.length}
                              </div>
                            )}
{isPopupOpen && (
  <div 
    onClick={(e) => e.stopPropagation()}
    style={{
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
      zIndex: 10000,
      animation: 'fadeSlideUp 0.2s ease-out',
      minWidth: '240px',
      overflow: 'hidden'
    }}
  >
                                <div style={{
                                  padding: '12px 14px',
                                  borderBottom: '1px solid #f3f4f6',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}>
                                  <span style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#1f2937'
                                  }}>
                                    {filesOfType.length} {fileType.toUpperCase().replace('.', '')} file{filesOfType.length > 1 ? 's' : ''}
                                  </span>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowDeletePopup(null);
                                    }}
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      cursor: 'pointer',
                                      padding: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '4px',
                                      transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f3f4f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                  >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                  </button>
                                </div>

                                <div style={{
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  padding: '8px'
                                }}>
                                  {filesOfType.map((fileObj, idx) => (
                                    <div
                                      key={fileObj.id}
                                      style={{
                                        padding: '8px 10px',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        transition: 'all 0.2s',
                                        marginBottom: idx < filesOfType.length - 1 ? '4px' : '0'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                      <div style={{
                                        flex: 1,
                                        overflow: 'hidden',
                                        textAlign: 'left'
                                      }}>
                                        <div style={{
                                          fontSize: '12px',
                                          color: '#1f2937',
                                          fontWeight: '500',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap'
                                        }} title={fileObj.name}>
                                          {fileObj.name}
                                        </div>
                                      </div>

<button
  onClick={(e) => {
    e.stopPropagation();
    removeFile(fileObj.id);
  }}
  style={{
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    background: 'transparent',
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    flexShrink: 0
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = '#fef2f2';
    e.currentTarget.style.borderColor = '#fecaca';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = 'transparent';
    e.currentTarget.style.borderColor = '#e5e7eb';
  }}
>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
</button>
                                    </div>
                                  ))}
                                </div>

                                <div style={{
                                  position: 'absolute',
                                  top: '-6px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '6px solid transparent',
                                  borderRight: '6px solid transparent',
                                  borderBottom: '6px solid white',
                                  filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.05))'
                                }} />
                              </div>
                            )}
                          </div>
                        );
                      })}

                      <div style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#9ca3af',
                        whiteSpace: 'nowrap'
                      }}>
                        {uploadedFile.files.length}/6
                      </div>
                    </div>
                  )}
                </div>
          </div>
          
          <div style={{ padding: '0 12px', marginBottom: '12px' }}>
            <button
              onClick={handleCancelCreate}
              style={{
                width: '100%',
                padding: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '11px',
                color: '#6b7280'
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}


{isGenerating && (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 12px', display: 'block' }}>
      <g>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="1"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.875" transform="rotate(45 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.75" transform="rotate(90 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.625" transform="rotate(135 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.5" transform="rotate(180 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.375" transform="rotate(225 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.25" transform="rotate(270 12 12)"/>
        <rect x="11" y="1" width="2" height="5" rx="1" fill="#272727" opacity="0.125" transform="rotate(315 12 12)"/>
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
      </g>
    </svg>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937' }}>
      Generating your {createType}...
    </div>
  </div>
)}
    </div>
  )}
</div>

{/* CHECK IF FLASHCARDS EXIST */}
{isFlashcardsLoading ? (
  // ✅ SHOW SKELETON WHILE LOADING
  <>
    <SkeletonStyles />
    <div style={{ 
      fontSize: '11px', 
      fontWeight: '600', 
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginBottom: '16px'
    }}>
      All Flashcards
    </div>
    <FlashcardSkeleton />
    <FlashcardSkeleton />
  </>
) : flashcardSets.length > 0 ? (
  <>
    {/* Header with Stats */}
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      marginBottom: '16px' 
    }}>
      <div style={{ 
        fontSize: '11px', 
        fontWeight: '600', 
        color: '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        All Flashcards
      </div>
      
      <button 
        onClick={() => setShowStatsModal('flashcard')}
        style={{
          padding: '6px 12px',
          background: '#272727',
          border: 'none',
          borderRadius: '12px',
          color: 'white',
          fontSize: '11px',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#3f3f3f';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#272727';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        View Stats
      </button>
    </div>

{/* Flashcard Cards */}
<div style={{
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '16px',
  width: '100%'
}}>
{/* Flashcard Cards */}
<>
  <style>{`
    .flashcard-cards-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;
      width: 100%;
    }
    @media (min-width: 768px) {
      .flashcard-cards-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }
    }
  `}</style>

  <div className="flashcard-cards-grid">
    {flashcardSets.map((set) => (
      <FlashcardPreview 
        key={set.id} 
        set={set} 
        onStartStudy={() => setActiveFlashcards(set)}
        onDelete={(id) => {
          setItemToDelete({ id: String(set.id), type: 'flashcard', title: set.title });  
          setShowDeleteModal(true);
        }}
      />
    ))}
  </div>
</>
</div>
  </>
) : (
  // EMPTY STATE
  <div style={{
    background: 'white',
    borderRadius: '20px',
    padding: '48px 24px',
    textAlign: 'center',
    border: '1px solid #e5e7eb'
  }}>
    <div style={{
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #fff7d6 0%, #fef3c7 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px'
    }}>
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="9" y1="9" x2="15" y2="9"></line>
        <line x1="9" y1="15" x2="15" y2="15"></line>
      </svg>
    </div>
    
    <h3 style={{
      fontSize: '16px',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '8px'
    }}>
      No Flashcards Yet
    </h3>
    
    <p style={{
      fontSize: '13px',
      color: '#6b7280',
      lineHeight: '1.6',
      maxWidth: '320px',
      margin: '0 auto'
    }}>
      Create your first flashcard set to help memorize key concepts. Perfect for vocabulary, definitions, and quick reviews.
    </p>
  </div>
)}
  </div>
)}
<style>{`
  @keyframes fadeSlideUp {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`}</style>
{activeTab === 'help' && (
  <div>
    {/* Stats Overview Card */}
    {studyStats.quizHistory.length > 0 && (
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '12px',
        border: '1px solid #e5e7eb',
        marginBottom: '16px'
      }}>
        <div style={{
          fontSize: '10px',
          fontWeight: '600',
          color: '#6b7280',
          marginBottom: '10px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          Your Performance
        </div>
        
        <div style={{
          display: 'flex',
          gap: '10px'
        }}>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" style={{ flexShrink: 0 }}>
          <path d="M1.5 5 L2.5 6 L4 4.5" fill="none" stroke="#1e40af" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="6" y1="5" x2="14.5" y2="5" stroke="#1e40af" strokeWidth="1.2" strokeLinecap="round"/>
          
          <circle cx="2.5" cy="11" r="1.2" fill="none" stroke="#1e40af" strokeWidth="1.2"/>
          <line x1="6" y1="11" x2="14.5" y2="11" stroke="#1e40af" strokeWidth="1.2" strokeLinecap="round"/>
        </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '9px', color: '#6b7280', marginBottom: '2px', fontWeight: '500' }}>
                Quizzes
              </div>
              <div style={{ fontSize: '15px', fontWeight: '500', color: '#1f2937' }}>
                {studyStats.quizHistory.length}
              </div>
            </div>
          </div>

          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#92400e" strokeWidth="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '9px', color: '#6b7280', marginBottom: '2px', fontWeight: '500' }}>
                Avg Score
              </div>
              <div style={{ fontSize: '15px', fontWeight: '500', color: '#1f2937' }}>
                {Math.round(studyStats.quizHistory.reduce((sum, q) => sum + q.score, 0) / studyStats.quizHistory.length)}%
              </div>
            </div>
          </div>

          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '10px',
            border: '1px solid #e5e7eb'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
               <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                  <path stroke="#065f46" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M3 11.5h13m-13 0V18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6.5m-13 0V9a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.5M9 5h11a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1"/>
                </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '9px', color: '#6b7280', marginBottom: '2px', fontWeight: '500' }}>
                Cards
              </div>
              <div style={{ fontSize: '15px', fontWeight: '500', color: '#1f2937' }}>
                {studyStats.flashcardSessions.reduce((sum, s) => sum + s.cardsStudied, 0)}
              </div>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Main Chat Container */}
    <div style={{
      background: 'white',
      borderRadius: '16px',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      marginBottom: '16px'
    }}>
      {/* Header */}
      <div style={{
        background: '#fafafaff',
        padding: '14px 16px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '2px', textAlign:'left' }}>
            Welcome {userName ? userName : 'Guest'}
          </div>
          <div style={{ fontSize: '11px', color: '#6b7280', lineHeight: '1.3',textAlign:'left' }}>
             Ask for studying tips
          </div>
        </div>
        
  {/* ✅ CLEAR CHAT BUTTON - Right side */}
  <button
    onClick={() => {
      setChatMessages([]);
      setChatInput('');
      console.log('✅ Chat cleared');
    }}
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '50px',
      background: '#f3f4f6',
      border: '1px solid #d1d5db',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s',
      padding: 0,
      flexShrink: 0,
      marginLeft: '12px'
    }}
    title="Clear chat history"
    onMouseEnter={(e) => {
      e.currentTarget.style.background = '#e5e7eb';
      e.currentTarget.style.transform = 'translateY(-1px)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = '#f3f4f6';
      e.currentTarget.style.transform = 'translateY(0)';
    }}
  >
<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#374151" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z" clip-rule="evenodd"/>
</svg>

  </button>
      </div>

      {/* Messages Area */}
      <div style={{
        height: '400px',
        overflowY: 'auto',
        padding: '16px',
        background: '#fafafaff',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px'
      }}>
        {chatMessages.length === 0 ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '16px'
          }}>     
            <h3 style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#1f2937',
              marginBottom: '26px',
              textAlign: 'center'
            }}>
              Get personalized study guidance
            </h3>
            
            {/* Quick Actions */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              width: '100%',
              maxWidth: '300px'
            }}>
              {[
                'How am I doing overall?',
                'Create a quiz for me',
                'Give me study tips'
              ].map((question, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    setChatInput(question);
                    setTimeout(() => sendChatMessage(), 100);
                  }}
                  style={{
                    padding: '11px 14px',
                    background: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '20px',
                    fontSize: '11px',
                    color: '#374151',
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'all 0.2s',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#f9fafb';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'white';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <span>{question}</span>
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
                    <path stroke="#9ca3af" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                  </svg>
                </button>
              ))}
            </div>
          </div>
        ) : (
          <>
{chatMessages.map((msg, idx) => (
  <div
    key={idx}
    style={{
      display: 'flex',
      justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start',
      animation: 'slideIn 0.3s ease-out'
    }}
  >
    {msg.role === 'user' ? (
      <div style={{
        maxWidth: '75%',
        padding: '10px 14px',
        borderRadius: '16px',
        background: '#f2f2f2',
        color: 'black',
        fontSize: '12px',
        lineHeight: '1.5',
        fontWeight: '400'
      }}>
        {msg.content}
      </div>
    ) : (
      <div style={{
        maxWidth: '90%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
{msg.isGenerating ? (
  <div style={{
    background: '#fafafa',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    padding: '14px 16px',
    maxWidth: '280px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    animation: 'fadeIn 0.3s ease-out'
  }}>
    {/* Spinner */}
    <div style={{
      width: '18px',
      height: '18px',
      border: '2px solid #e5e7eb',
      borderTop: '2px solid #272727',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
      flexShrink: 0
    }} />
    
    {/* Text */}
    <div style={{
      fontSize: '12px',
      fontWeight: '500',
      color: '#1f2937'
    }}>
      Creating your {msg.content.includes('quiz') ? 'quiz' : 'flashcards'}...
    </div>
  </div>
) : (
  // Normal message rendering continues below...
  <>
    {renderStructuredMessage(msg.content)}
    {msg.hasButton && (
      <button
        onClick={msg.buttonAction}
        style={{
          padding: '10px 16px',
          background: '#272727',
          border: 'none',
          borderRadius: '20px',
          color: 'white',
          fontSize: '12px',
          fontWeight: '500',
          cursor: 'pointer',
          transition: 'all 0.2s',
          alignSelf: 'flex-start'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#3f3f3f'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#272727'}
      >
        {msg.buttonText}
      </button>
    )}
  </>
)}

      </div>
    )}
  </div>
))}

{isChatLoading && !chatMessages.some(msg => msg.isGenerating) && (
  <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
    <div style={{
      background: '#fafafa',
      border: '1px solid #e5e7eb',
      borderRadius: '16px',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    }}>
      {/* Spinner */}
      <div style={{
        width: '16px',
        height: '16px',
        border: '2px solid #e5e7eb',
        borderTop: '2px solid #272727',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      
      {/* Text */}
      <div style={{
        fontSize: '12px',
        color: '#6b7280',
        fontWeight: '400'
      }}>
        Thinking...
      </div>
    </div>
  </div>
)}

            <div ref={chatEndRef} />
          </>
        )}
      </div>

      {/* Input Area */}
      <div style={{
        padding: '14px',
        background: 'white',
        borderTop: '1px solid #e5e7eb'
      }}>
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '20px',
          padding: '5px 5px 5px 16px',
          transition: 'all 0.3s'
        }}>
          <input
            type="text"
            value={chatInput}
            onChange={(e) => setChatInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && !isChatLoading && sendChatMessage()}
            placeholder="Ask Preptune..."
            disabled={isChatLoading}
            style={{
              flex: 1,
              border: 'none',
              fontSize: '12px',
              outline: 'none',
              background: 'transparent',
              color: '#1f2937',
              fontWeight: '400'
            }}
          />
          <button
            onClick={sendChatMessage}
            disabled={!chatInput.trim() || isChatLoading}
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              background: !chatInput.trim() || isChatLoading ? '#d1d5db' : '#272727',
              border: 'none',
              cursor: !chatInput.trim() || isChatLoading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
              flexShrink: 0
            }}
            onMouseEnter={(e) => {
              if (chatInput.trim() && !isChatLoading) {
                e.currentTarget.style.background = '#3f3f3f';
              }
            }}
            onMouseLeave={(e) => {
              if (chatInput.trim() && !isChatLoading) {
                e.currentTarget.style.background = '#272727';
              }
            }}
          >
<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/>
</svg>

          </button>
        </div>
      </div>
    </div>
  </div>
)}
  </div>
</div>
{showShuffleModal && (
  <ShuffleModal
    onClose={() => {
      setShowShuffleModal(false);
      setPendingContent(null);
      setPendingType(null);
    }}
    onStart={handleStartWithShuffle}
    type={pendingType}
  />
)}

{activeQuiz && (
  <QuizComponent 
    quizData={activeQuiz} 
    onClose={() => setActiveQuiz(null)} 
    gradient={activeModalGradient}
    shuffleMode={shuffleEnabled}
    userName={userName}
    onStatsUpdate={() => setRefreshStats(prev => prev + 1)}  // ✅ ADD THIS
  />
)} 
{activeFlashcards && (
  <FlashcardComponent
    flashcardData={activeFlashcards} 
    onClose={() => setActiveFlashcards(null)}
    shuffleEnabled={shuffleEnabled}
    gradient={activeModalGradient}
    onStatsUpdate={() => setRefreshStats(prev => prev + 1)}  // ✅ ADD THIS
  />
)}
  
      {/* ✅ ADD THESE MODALS HERE */}
      {showCongratsModal && (
        <CongratulationsModal 
          type={congratsType}
          onClose={() => {
            setShowCongratsModal(false);
            setCongratsType(null);
          }}
        />
      )}

      {showDeleteModal && itemToDelete && (
        <DeleteConfirmModal
          type={itemToDelete.type}
          itemTitle={itemToDelete.title}
          onConfirm={async () => {
            await deleteCustomContent(itemToDelete.id, itemToDelete.type);
            setShowDeleteModal(false);
            setItemToDelete(null);
          }}
          onCancel={() => {
            setShowDeleteModal(false);
            setItemToDelete(null);
          }}
        />
      )}
    </>
  );
}